
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jhcFr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


const $d8b18ba521bd2fb8$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("4CvW9")));
const $d8b18ba521bd2fb8$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $d8b18ba521bd2fb8$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $d8b18ba521bd2fb8$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $d8b18ba521bd2fb8$export$5057fa778edd8de9 = (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const WrapperComponent = (0, $42omo.useMemo)(()=>(props)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($d8b18ba521bd2fb8$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props,
                config: config
            });
        }, [
        config
    ]);
    return (0, $42omo.useMemo)(()=>{
        return {
            ...props ?? {},
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: $d8b18ba521bd2fb8$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props
    ]);
};
module.exports["useLinkPickerEditorProps"] = $d8b18ba521bd2fb8$export$5057fa778edd8de9;

});

parcelRegister("4CvW9", function(module, exports) {

let $35d37c0fa037ce4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $35d37c0fa037ce4d$var$load("bGpE6"),
    $35d37c0fa037ce4d$var$load("6wr18"),
    $35d37c0fa037ce4d$var$load("4RbVd"),
    $35d37c0fa037ce4d$var$load("jg5LT"),
    $35d37c0fa037ce4d$var$load("ffEVr"),
    $35d37c0fa037ce4d$var$load("7f9Fz"),
    $35d37c0fa037ce4d$var$load("9S9Mz"),
    $35d37c0fa037ce4d$var$load("6iF9L")
]).then(()=>parcelRequire('hyBPw'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("agrUc", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3RxtY = parcelRequire("3RxtY");


var $3pLGZ = parcelRequire("3pLGZ");


var $16GCc = parcelRequire("16GCc");


var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");


var $dh538 = parcelRequire("dh538");


var $aGTRk = parcelRequire("aGTRk");


var $24P9d = parcelRequire("24P9d");





var $6fnsQ = parcelRequire("6fnsQ");

const $c63be1b8be1ad0fa$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $aGTRk.blockCardWithLocalId) : (0, $aGTRk.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};


/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $cfHGv = parcelRequire("cfHGv");





var $aFUXX = parcelRequire("aFUXX");







// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $f774c65213d94fad$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $f774c65213d94fad$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $f774c65213d94fad$var$LINE_LENGTH = 760;
const $f774c65213d94fad$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $cfHGv.embedCardWithLocalId) : (0, $cfHGv.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $24P9d.convertToInlineCss)({
                    margin: $f774c65213d94fad$var$calcMargin(layout),
                    width: `${Math.ceil($f774c65213d94fad$var$calcPxFromPct(width / 100, $f774c65213d94fad$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $f774c65213d94fad$var$float(layout)
                }),
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};



var $aqHdD = parcelRequire("aqHdD");










const $5e2feeed1fe88326$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $aqHdD.inlineCardWithLocalId) : (0, $aqHdD.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $24P9d.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};



var $9AGwg = parcelRequire("9AGwg");


var $btzjy = parcelRequire("btzjy");


var $d7ZU3 = parcelRequire("d7ZU3");


var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $1oCLl = parcelRequire("1oCLl");

const $c11f6b33b827655c$var$lookupPixel = 10;
const $c11f6b33b827655c$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $8m4tT.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $c11f6b33b827655c$var$lookupPixel : coord.bottom + $c11f6b33b827655c$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $8m4tT.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $c11f6b33b827655c$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $c11f6b33b827655c$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $ks2lK.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $c11f6b33b827655c$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveUp).common, $c11f6b33b827655c$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, $c11f6b33b827655c$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $dus6D.keymap)(list);
}



var $2P8Ax = parcelRequire("2P8Ax");


var $bT1qC = parcelRequire("bT1qC");


var $1S4f7 = parcelRequire("1S4f7");


var $0vvte = parcelRequire("0vvte");








var $hBNGD = parcelRequire("hBNGD");


var $4enQ2 = parcelRequire("4enQ2");


var $ftpVl = parcelRequire("ftpVl");


var $iu6m9 = parcelRequire("iu6m9");


var $6JHzw = parcelRequire("6JHzw");


const $2e63a2a02cf8ecda$export$7da1e5b9c509a0c1 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $6JHzw.blockCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("6JHzw"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};









var $7IyZf = parcelRequire("7IyZf");


const $96a8f130dedf8a71$export$eb946eb841dd1469 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $7IyZf.embedCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("7IyZf"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};















const $db3cf41c83217b98$export$cd3f6a9b84ab8435 = (props)=>{
    const { isPageSSRed: isPageSSRed = false } = props;
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false) || (0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) || isPageSSRed) return (0, $4enQ2.inlineCardNodeView)(props);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("4enQ2"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};



var $8EkET = parcelRequire("8EkET");


var $cCTpf = parcelRequire("cCTpf");


var $d925B = parcelRequire("d925B");


var $doRn8 = parcelRequire("doRn8");


var $7iE7T = parcelRequire("7iE7T");

var $l9G9n = parcelRequire("l9G9n");


var $aXG5V = parcelRequire("aXG5V");


var $6SJAP = parcelRequire("6SJAP");


var $22wcR = parcelRequire("22wcR");


var $h92Fd = parcelRequire("h92Fd");


var $5YZhQ = parcelRequire("5YZhQ");

const $4dddc73ca76bf0aa$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $4dddc73ca76bf0aa$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $4dddc73ca76bf0aa$var$isTransactionResolveReplace(tr);
    // History
    const historyMeta = tr.getMeta((0, $l9G9n.pmHistoryPluginKey));
    const isUndo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $4dddc73ca76bf0aa$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $aXG5V.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $7iE7T.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $5YZhQ.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $aXG5V.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $7iE7T.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $5YZhQ.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $5YZhQ.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $5YZhQ.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $5YZhQ.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $5YZhQ.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $4dddc73ca76bf0aa$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet
		 */ if (!isResolveReplace) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $4dddc73ca76bf0aa$var$getResolvePositions(tr, state);
        inserted.push(...(0, $5YZhQ.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $doRn8.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $5YZhQ.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $4dddc73ca76bf0aa$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $5YZhQ.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $5YZhQ.getNodeSubject)(inserted[i].node);
            if ($4dddc73ca76bf0aa$var$isDatasourceUpgrade(previousSubject, currentSubject) || $4dddc73ca76bf0aa$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $4dddc73ca76bf0aa$var$UPDATE_ACTIONS = [
    (0, $d925B.ACTION).CHANGED_TYPE,
    (0, $d925B.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $4dddc73ca76bf0aa$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $8EkET.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $4dddc73ca76bf0aa$var$UPDATE_ACTIONS.includes(action);
    });
};
const $4dddc73ca76bf0aa$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $4dddc73ca76bf0aa$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    return $4dddc73ca76bf0aa$var$isMetadataQueue(pluginMeta);
};
const $4dddc73ca76bf0aa$var$isMetadataQueue = (metaData)=>{
    return $4dddc73ca76bf0aa$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $4dddc73ca76bf0aa$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    return $4dddc73ca76bf0aa$var$isMetadataResolve(pluginMeta);
};
const $4dddc73ca76bf0aa$var$isMetadataResolve = (metaData)=>{
    return $4dddc73ca76bf0aa$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $4dddc73ca76bf0aa$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $4dddc73ca76bf0aa$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    if (!$4dddc73ca76bf0aa$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $4dddc73ca76bf0aa$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $22wcR.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $6SJAP.pluginKey));
    if (!$4dddc73ca76bf0aa$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $4dddc73ca76bf0aa$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $22wcR.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $4dddc73ca76bf0aa$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $h92Fd.EVENT_SUBJECT).LINK;
const $4dddc73ca76bf0aa$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $h92Fd.EVENT_SUBJECT).LINK && currentSubject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE;
function $4dddc73ca76bf0aa$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $cCTpf.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $l9G9n.pmHistoryPluginKey));
        const isUndo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $4dddc73ca76bf0aa$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $doRn8.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $4dddc73ca76bf0aa$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $5YZhQ.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $5YZhQ.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $h92Fd.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $5YZhQ.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $h92Fd.EVENT).DELETED);
        pushEvents(inserted, (0, $h92Fd.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}






var $hrFA1 = parcelRequire("hrFA1");

const $63afa27de13e413f$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];


const $6d7703230e08f307$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $8m4tT.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $hrFA1.isDatasourceNode)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $6d7703230e08f307$export$8467cbb601c13bfc = (layout)=>{
    return (0, $63afa27de13e413f$export$3f155c85880510c8).some((l)=>l === layout);
};



var $5v798 = parcelRequire("5v798");







const $a2739f0c627e4901$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $a2739f0c627e4901$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $a2739f0c627e4901$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $a2739f0c627e4901$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $a2739f0c627e4901$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $a2739f0c627e4901$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $a2739f0c627e4901$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $a2739f0c627e4901$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $a2739f0c627e4901$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $a2739f0c627e4901$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $a2739f0c627e4901$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $a2739f0c627e4901$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $a2739f0c627e4901$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $a2739f0c627e4901$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $a2739f0c627e4901$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $a2739f0c627e4901$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $a2739f0c627e4901$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $a2739f0c627e4901$var$queue(state, action);
        case 'SET_PROVIDER':
            return $a2739f0c627e4901$var$setProvider(state, action);
        case 'RESOLVE':
            return $a2739f0c627e4901$var$resolve(state, action);
        case 'REGISTER':
            return $a2739f0c627e4901$var$register(state, action);
        case 'REMOVE_CARD':
            return $a2739f0c627e4901$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $a2739f0c627e4901$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $a2739f0c627e4901$var$setDatasourceTableRef(state, action);
        case 'SET_CARD_LAYOUT':
            return $a2739f0c627e4901$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $a2739f0c627e4901$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $a2739f0c627e4901$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $a2739f0c627e4901$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $a2739f0c627e4901$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $a2739f0c627e4901$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $a2739f0c627e4901$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $a2739f0c627e4901$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $a2739f0c627e4901$var$removeDatasourceStash(state, action);
    }
};













const $61e05dab6ab021e0$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $l9G9n.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $61e05dab6ab021e0$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent)=>{
    const isEmbedFriendlyLocation = $61e05dab6ab021e0$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($61e05dab6ab021e0$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options), $61e05dab6ab021e0$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $61e05dab6ab021e0$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $16GCc.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $61e05dab6ab021e0$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options)=>(resolvedCard)=>{
        $61e05dab6ab021e0$var$updateCardType(resolvedCard, options);
        (0, $btzjy.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent)(view.state, view.dispatch);
        return resolvedCard;
    };
const $61e05dab6ab021e0$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $btzjy.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $61e05dab6ab021e0$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $9AGwg.setProvider)(cardProvider)(state.tr));
    });
};








const $3bd04be2ce29553e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
const $3bd04be2ce29553e$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $22wcR.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $9AGwg.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $3bd04be2ce29553e$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt } = options;
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $bT1qC.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $4enQ2.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: CompetitorPrompt
            }
        });
        return new (0, $1S4f7.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $22wcR.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $6SJAP.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $4dddc73ca76bf0aa$export$c985b35883eaea59)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $ks2lK.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    if (!enableInlineUpgradeFeatures) return (0, $a2739f0c627e4901$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    const newState = (0, $a2739f0c627e4901$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $5v798.isLocalStorageKeyDiscovered)($3bd04be2ce29553e$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $hrFA1.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $hrFA1.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $61e05dab6ab021e0$export$96766f42428c9e7f)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $22wcR.getPluginState)(view.state);
                        const oldState = (0, $22wcR.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $ks2lK.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $8m4tT.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $0vvte.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $6d7703230e08f307$export$8467cbb601c13bfc)(node.attrs.layout) ? node.attrs.layout : (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $9AGwg.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $9AGwg.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $22wcR.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $2P8Ax.default)(()=>(0, $61e05dab6ab021e0$export$2007d0af08977743)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $db3cf41c83217b98$export$cd3f6a9b84ab8435)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $2e63a2a02cf8ecda$export$7da1e5b9c509a0c1)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: options.CompetitorPrompt
                    }),
                    embedCard: (0, $96a8f130dedf8a71$export$eb946eb841dd1469)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: options.CompetitorPrompt
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $3bd04be2ce29553e$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $3bd04be2ce29553e$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $6SJAP.pluginKey)
        });
    };








const $c083b4a75648c16a$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};






var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");






var $iB8ko = parcelRequire("iB8ko");


var $eIleF = parcelRequire("eIleF");


var $dQwlz = parcelRequire("dQwlz");

















var $8dcLZ = parcelRequire("8dcLZ");

const $4cc15576004509ff$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $4cc15576004509ff$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $42omo.useCallback)(()=>{
        dispatch((0, $9AGwg.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $4cc15576004509ff$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $4cc15576004509ff$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $4cc15576004509ff$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $42omo.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $btzjy.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $btzjy.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $4cc15576004509ff$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $4cc15576004509ff$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};


const $7be576037a301bd0$var$selector = (states)=>{
    return {
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $7be576037a301bd0$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $7be576037a301bd0$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $7be576037a301bd0$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dQwlz.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4cc15576004509ff$export$95702e90d329951a), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $7be576037a301bd0$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($7be576037a301bd0$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $7be576037a301bd0$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $iB8ko.default),
        datasourceId: (0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $jPEjP.default),
        datasourceId: (0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $bEi27.default),
        datasourceId: (0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $7be576037a301bd0$export$2e2bcd8739ae039 = $7be576037a301bd0$var$SafeModalWithState;















var $aJdNi = parcelRequire("aJdNi");





var $6v6KC = parcelRequire("6v6KC");


var $7pxpu = parcelRequire("7pxpu");










/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $6aa09a6deac4dd46$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $6aa09a6deac4dd46$export$8793fab959da70d1 = $6aa09a6deac4dd46$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $d925B.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $d925B.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $d925B.INPUT_METHOD).AUTO_DETECT:
        case (0, $d925B.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $d925B.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $d925B.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $d925B.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $6aa09a6deac4dd46$export$df2aa842dc5172b0 = $6aa09a6deac4dd46$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $d925B.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $d925B.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $6aa09a6deac4dd46$export$1cf3d8365b174bde = $6aa09a6deac4dd46$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $d925B.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $6aa09a6deac4dd46$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $6v6KC.default) ? metadata.sourceEvent : null;
};


function $4601a5dc005fe120$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $4601a5dc005fe120$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $4601a5dc005fe120$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $6v6KC.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $4601a5dc005fe120$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $4601a5dc005fe120$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $6v6KC.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $4601a5dc005fe120$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $4601a5dc005fe120$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $4601a5dc005fe120$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $7pxpu.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $42omo.useMemo)(()=>{
        return {
            [(0, $h92Fd.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $h92Fd.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $h92Fd.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $4601a5dc005fe120$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
	 * Subscribe to datasource events
	 */ (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $h92Fd.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};















/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $19091767794a90ac$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $19091767794a90ac$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
	 * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
	 * to defer any heavy operations involving network
	 *
	 * The callbacks themselves should not be deferred, they should be called syncronously the moment
	 * the events take place.
	 */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $7pxpu.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $42omo.useMemo)(()=>{
        return {
            [(0, $h92Fd.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const creationMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $h92Fd.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const updateMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                const updateType = (0, $6aa09a6deac4dd46$export$df2aa842dc5172b0)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $h92Fd.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $5YZhQ.getUrl)(node);
                if (!url) return;
                const display = (0, $5YZhQ.appearanceForLink)(node);
                const displayCategory = $19091767794a90ac$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $6aa09a6deac4dd46$export$b3b4df0d75d4c011)(metadata);
                const deleteMethod = (0, $6aa09a6deac4dd46$export$8793fab959da70d1)(metadata);
                const deleteType = (0, $6aa09a6deac4dd46$export$1cf3d8365b174bde)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
	 * Subscribe to link events
	 */ (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $h92Fd.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};


class $1e937672f72cb9a7$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !this.props.editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aJdNi.EditorAnalyticsContext), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $19091767794a90ac$export$aa142efb89c75ed5), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $4601a5dc005fe120$export$bddcbec746c26287), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}






var $dLAsE = parcelRequire("dLAsE");







const $881bfe26507459bc$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $dLAsE.useSmartLinkEvents)();
    (0, $42omo.useEffect)(()=>{
        if (!events || (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return;
        editorView.dispatch((0, $9AGwg.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");





var $jwWgu = parcelRequire("jwWgu");


var $a4eZN = parcelRequire("a4eZN");


var $fJNzZ = parcelRequire("fJNzZ");


var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");














const $3de0a05ef0adcbab$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    background: `${`var(--ds-background-neutral, ${(0, $6fnsQ.N20A)})`}`,
    color: `${`var(--ds-icon, ${(0, $6fnsQ.N300)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${`var(--ds-background-neutral-hovered, ${(0, $6fnsQ.B300)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, white)"} !important`
    }
});
const $3de0a05ef0adcbab$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $fJNzZ.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        return formatMessage((0, $fJNzZ.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        testId: testId,
        css: $3de0a05ef0adcbab$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
            label: title
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            label: title
        })
    }));
};
const $3de0a05ef0adcbab$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $3de0a05ef0adcbab$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $6d7703230e08f307$export$32844f9f273856e4)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $3de0a05ef0adcbab$var$selector);
    const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $6d7703230e08f307$export$32844f9f273856e4)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $9AGwg.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3de0a05ef0adcbab$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $6d7703230e08f307$export$8467cbb601c13bfc)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
var $3de0a05ef0adcbab$export$2e2bcd8739ae039 = (0, $gmMgo.default)($3de0a05ef0adcbab$var$LayoutButtonWrapper);



var $9Rg2N = parcelRequire("9Rg2N");

const $10220c45d3a290e4$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $c083b4a75648c16a$export$5115a388c364848d)();
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $6SJAP.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $5e2feeed1fe88326$export$290edac762b9f37c)()
                },
                {
                    name: 'blockCard',
                    node: (0, $c63be1b8be1ad0fa$export$f664dd11022c8749)()
                }
            ];
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $f774c65213d94fad$export$f8faabd3267a007e)()
            });
            return nodes;
        },
        pmPlugins () {
            const allowBlockCards = options.allowBlockCards ?? true;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $3bd04be2ce29553e$export$ae829ec7b2625219)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $c11f6b33b827655c$export$fc7a7a088775f35d)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $881bfe26507459bc$export$e7d7ea2bc9a806d9), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1e937672f72cb9a7$export$c083a9ed3df8f5ac), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $3de0a05ef0adcbab$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7be576037a301bd0$export$2e2bcd8739ae039), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $9AGwg.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $9AGwg.hideLinkToolbar,
            queueCardsFromChangedTr: $btzjy.queueCardsFromChangedTr,
            getStartingToolbarItems: (0, $9Rg2N.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $9Rg2N.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $9Rg2N.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $3RxtY.messages).datasourceJiraIssueIssueTermRefresh : (0, $3RxtY.messages).datasourceJiraIssue),
                    description: formatMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $3RxtY.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $3RxtY.messages).datasourceJiraIssueDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceJiraIssue), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $16GCc.canRenderDatasource)((0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $3RxtY.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $3RxtY.messages).datasourceAssetsObjectsDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceAssetsObjects), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $hrFA1.isDatasourceConfigEditable)((0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $3RxtY.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $3RxtY.messages).datasourceConfluenceSearchDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDatasourceConfluenceSearch), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $9AGwg.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};
module.exports["cardPlugin"] = $10220c45d3a290e4$export$2a6748328f902e16;

});

parcelRegister("eKaDU", function(module, exports) {
var $5234cdfb9b29e9d1$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $5234cdfb9b29e9d1$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});
module.exports["LAYOUT_TYPE"] = $5234cdfb9b29e9d1$export$9710eda883ce7be2;
module.exports["SMART_LINK_TYPE"] = $5234cdfb9b29e9d1$export$804a928ffc86c02c;

});

parcelRegister("4enQ2", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");


var $7YjFd = parcelRequire("7YjFd");

var $gndLe = parcelRequire("gndLe");


var $hpUsb = parcelRequire("hpUsb");


var $hrK3E = parcelRequire("hrK3E");


var $9CM6e = parcelRequire("9CM6e");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");


var $hrFA1 = parcelRequire("hrFA1");


var $9Rg2N = parcelRequire("9Rg2N");


var $cOfDZ = parcelRequire("cOfDZ");














var $7FiWH = parcelRequire("7FiWH");


var $ks2lK = parcelRequire("ks2lK");


var $79vw2 = parcelRequire("79vw2");


var $7ee1w = parcelRequire("7ee1w");


var $226XV = parcelRequire("226XV");











var $6SJAP = parcelRequire("6SJAP");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $bYRk6 = parcelRequire("bYRk6");











var $5v798 = parcelRequire("5v798");

const $19cfbef4ec1a2073$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $42omo.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $42omo.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $42omo.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $42omo.useMemo)(()=>isPulseEnabled && !(0, $5v798.isLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $19cfbef4ec1a2073$export$2e2bcd8739ae039 = $19cfbef4ec1a2073$var$useLinkUpgradeDiscoverability;


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $jSnXV = parcelRequire("jSnXV");


var $8C5kA = parcelRequire("8C5kA");


var $3RxtY = parcelRequire("3RxtY");


var $TfRUG = parcelRequire("TfRUG");


var $isYda = parcelRequire("isYda");


var $6fnsQ = parcelRequire("6fnsQ");

const $5a27629e4ec16f4d$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $5a27629e4ec16f4d$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $5a27629e4ec16f4d$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $5a27629e4ec16f4d$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $5a27629e4ec16f4d$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};


function $c2c8d7917d524ff5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c2c8d7917d524ff5$var$DEBOUNCE_IN_MS = 5;
const $c2c8d7917d524ff5$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $c2c8d7917d524ff5$var$PADDING_IN_PX = 4;
const $c2c8d7917d524ff5$var$ICON_WIDTH_IN_PX = 14;
const $c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $c2c8d7917d524ff5$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR = `var(--ds-surface-raised, ${(0, $6fnsQ.N0)})`;
const $c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR = `var(--ds-background-selected, ${(0, $6fnsQ.B100)})`;
const $c2c8d7917d524ff5$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $c2c8d7917d524ff5$var$containerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $c2c8d7917d524ff5$var$getGradientWithColor($c2c8d7917d524ff5$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $c2c8d7917d524ff5$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $c2c8d7917d524ff5$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $c2c8d7917d524ff5$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $c2c8d7917d524ff5$var$labelStyles = {
    name: "1x9ph6u",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $c2c8d7917d524ff5$var$iconAndLabelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR,
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N700)})`
});
const $c2c8d7917d524ff5$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $c2c8d7917d524ff5$var$gradientStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $c2c8d7917d524ff5$var$getGradientWithColor($c2c8d7917d524ff5$var$SMART_LINK_BACKGROUND_COLOR)
});
const $c2c8d7917d524ff5$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $42omo.useState)(false);
    const [showLabel, setShowLabel] = (0, $42omo.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $42omo.useState)(undefined);
    const maxOverlayWidth = (0, $42omo.useRef)(0);
    const minOverlayWidth = (0, $42omo.useRef)($c2c8d7917d524ff5$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $42omo.useRef)(0);
    const containerRef = (0, $42omo.useRef)(null);
    const setVisibility = (0, $42omo.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $5a27629e4ec16f4d$export$be02a7fcf666d65d)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $5a27629e4ec16f4d$export$ce3ffcce447cf028)(containerRef.current, marker) - $c2c8d7917d524ff5$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $c2c8d7917d524ff5$var$ICON_WIDTH_IN_PX + $c2c8d7917d524ff5$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $5a27629e4ec16f4d$export$a0e2858e1d1976ea)(containerRef, `.${$c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $5a27629e4ec16f4d$export$bdfd7a9bf7c62c86)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $42omo.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($c2c8d7917d524ff5$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $c2c8d7917d524ff5$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const intl = (0, $8C5kA.default)();
    const label = intl.formatMessage((0, $3RxtY.messages).inlineOverlay);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ...props,
        css: $c2c8d7917d524ff5$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "aria-hidden": "true",
        className: $c2c8d7917d524ff5$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $TfRUG.ZERO_WIDTH_JOINER)), /*#__PURE__*/ (0, $9K4OG.jsx)("a", {
        css: [
            $c2c8d7917d524ff5$var$overlayStyles,
            showOverlay && $c2c8d7917d524ff5$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$iconStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
        label: label,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c2c8d7917d524ff5$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c2c8d7917d524ff5$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    }))))));
};
var $c2c8d7917d524ff5$export$2e2bcd8739ae039 = $c2c8d7917d524ff5$var$InlineCardOverlay;






var $jqKkl = parcelRequire("jqKkl");

function $9f76f5a8f109fd7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $9f76f5a8f109fd7b$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $9f76f5a8f109fd7b$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const linkPosition = (0, $42omo.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $19cfbef4ec1a2073$export$2e2bcd8739ae039)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $5v798.isLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $5v798.markLocalStorageKeyDiscovered)((0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $42omo.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $42omo.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $42omo.useMemo)(()=>{
        if (shouldShowLinkOverlay && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c2c8d7917d524ff5$export$2e2bcd8739ae039), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            onMouseEnter: ()=>handleOverlayChange(true),
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: shouldShowLinkPulse && $9f76f5a8f109fd7b$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
            data: {
                attributes: (0, $hrFA1.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jqKkl.DiscoveryPulse), {
            localStorageKey: (0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $5v798.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay,
        isInline,
        placeholderUniqId
    ]);
};









var $h8cpw = parcelRequire("h8cpw");

const $c168e1c9482bc793$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $h8cpw.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $42omo.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $42omo.useCallback)(()=>{
        try {
            preview?.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children({
            canPreview: !!preview,
            invokePreview: invokePreview
        })
    });
};



var $4enQ2 = parcelRequire("4enQ2");

const $ab634df7485d5085$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $ab634df7485d5085$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $42omo.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isInserted, setIsInserted] = (0, $42omo.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $42omo.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const onResolve = (0, $42omo.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $6SJAP.pluginKey));
        if (metadata && metadata.type === 'REGISTER') (0, $9AGwg.registerRemoveOverlay)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $9AGwg.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $42omo.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $42omo.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $ab634df7485d5085$var$selector);
    const floatingToolbarNode = selection instanceof (0, $ks2lK.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    });
    const innerCardWithOpenButtonOverlay = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7FiWH.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                provider: provider,
                pluginInjectionApi: pluginInjectionApi,
                disablePreviewPanel: true
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const innerCardOriginal = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $42omo.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return (mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless) && ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') || (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        }));
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view' && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    })) {
        const url = node.attrs.url;
        const cardState = cardContext?.value?.store?.getState()[url];
        if (cardState) {
            const ari = (0, $226XV.getObjectAri)(cardState.details);
            const name = (0, $226XV.getObjectName)(cardState.details);
            const iconUrl = (0, $226XV.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
                ari: ari
            });
            const openPreviewPanel = cardContext?.value?.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                const store = cardContext?.value?.store;
                const urlState = store?.getState()[url || ''];
                if (pluginInjectionApi?.analytics?.actions) pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HOVER_LABEL,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        previewType: previewType,
                        destinationProduct: urlState?.details?.meta?.product ?? null,
                        destinationSubproduct: urlState?.details?.meta?.subproduct ?? null
                    }
                });
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, $l998X.jsx)((0, $c168e1c9482bc793$export$a43fddf3dfb4c066), {
                url: url,
                appearance: "inline",
                children: ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                    const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                    // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                    // otherwise a use can click on smartlink itself to open the link in a new tab.
                    const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                    // When inside preview panel iframe, hide the overlay button
                    const isInPreviewPanel = (0, $7ee1w.isWithinPreviewPanelIFrame)();
                    const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                    if (isPreviewAvailable) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7FiWH.default), {
                        isVisible: isResolvedViewRendered,
                        url: url,
                        compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
                        view: view,
                        showPanelButton: showPanelButton,
                        showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                        onClick: (event)=>{
                            if (isPreviewPanelAvailable) {
                                event.preventDefault();
                                openPreviewPanel?.({
                                    url: url,
                                    ari: ari || '',
                                    name: name || '',
                                    iconUrl: iconUrl,
                                    panelData: {
                                        embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                                    }
                                });
                                firePreviewPanelClickEvent({
                                    previewType: 'panel'
                                });
                            } else if (isPreviewModalAvailable) {
                                event.preventDefault();
                                invokePreview?.();
                                firePreviewPanelClickEvent({
                                    previewType: 'modal'
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                            node: node,
                            view: view,
                            getPos: getPos,
                            useAlternativePreloader: useAlternativePreloader,
                            actionOptions: actionOptions,
                            onResolve: onResolve,
                            onClick: onClick,
                            cardContext: cardContext,
                            isHovered: isHovered,
                            isPageSSRed: isPageSSRed,
                            provider: provider,
                            pluginInjectionApi: pluginInjectionApi,
                            showHoverPreview: mode === 'view' && showHoverPreview,
                            disablePreviewPanel: true
                        })
                    });
                    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $4enQ2.InlineCard), {
                        node: node,
                        view: view,
                        getPos: getPos,
                        useAlternativePreloader: useAlternativePreloader,
                        actionOptions: actionOptions,
                        onResolve: onResolve,
                        onClick: onClick,
                        cardContext: cardContext,
                        isHovered: isHovered,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        pluginInjectionApi: pluginInjectionApi,
                        showHoverPreview: mode === 'view' && showHoverPreview
                    });
                }
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9f76f5a8f109fd7b$export$cc11bcf19366e14b), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});


const $e09bacbe103226ef$export$aff6291803939b05 = /*#__PURE__*/ (0, $42omo.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const reload = (0, $hrK3E.useSmartLinkReload)({
        url: url
    });
    (0, $42omo.useEffect)(()=>{
        const id = refId.current;
        return ()=>{
            const { tr: tr } = view.state;
            (0, $9AGwg.removeCard)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    (0, $42omo.useEffect)(()=>{
        // if we render from cache, we want to make sure we reload the data in the background
        const cardState = cardContext?.value?.store?.getState()[url || ''];
        if ((0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) && !isPageSSRed && cardState?.status === 'resolved') reload();
    });
    const scrollContainer = (0, $42omo.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $7YjFd.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $42omo.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $2P8Ax.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $9AGwg.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $42omo.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $42omo.useCallback)((event)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $9Rg2N.visitCardLinkAnalytics)(editorAnalyticsApi, (0, $d925B.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open(url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $42omo.useMemo)(()=>{
        const cardState = cardContext?.value?.store?.getState()[url || ''];
        if ((isPageSSRed || (0, $1oCLl.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) && cardState) && url) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        }, url);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardContext?.value?.store
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $l998X.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});
const $e09bacbe103226ef$var$WrappedInlineCardWithAwareness = (0, $cOfDZ.Card)((0, $ab634df7485d5085$export$2b341c5236b55a2), (0, $gndLe.default));
const $e09bacbe103226ef$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode
    };
};
function $e09bacbe103226ef$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt } = props;
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], $e09bacbe103226ef$var$selector);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $l998X.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($e09bacbe103226ef$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $hrFA1.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            CompetitorPromptComponent
        ]
    });
}
const $e09bacbe103226ef$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };
module.exports["InlineCard"] = $e09bacbe103226ef$export$aff6291803939b05;
module.exports["InlineCardNodeView"] = $e09bacbe103226ef$export$2626b4e17577ac62;
module.exports["inlineCardNodeView"] = $e09bacbe103226ef$export$ebfb9e1798b8aa0e;

});

parcelRegister("6xEOh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $dxgIg = parcelRequire("dxgIg");


var $1dusJ = parcelRequire("1dusJ");


var $9Y9Mx = parcelRequire("9Y9Mx");


var $kiZiu = parcelRequire("kiZiu");


var $6bJyJ = parcelRequire("6bJyJ");


var $cOZT3 = parcelRequire("cOZT3");


var $kDG8M = parcelRequire("kDG8M");


var $9Ctkw = parcelRequire("9Ctkw");


var $kVA9C = parcelRequire("kVA9C");


var $gzsfl = parcelRequire("gzsfl");


var $1oCLl = parcelRequire("1oCLl");


var $d925B = parcelRequire("d925B");


var $4KOFJ = parcelRequire("4KOFJ");


var $hgeg8 = parcelRequire("hgeg8");


var $61p3e = parcelRequire("61p3e");

var $gVDfZ = parcelRequire("gVDfZ");


var $807Mc = parcelRequire("807Mc");


var $lqWNh = parcelRequire("lqWNh");

var $kTbzR = parcelRequire("kTbzR");

const $dc9639f396c30a74$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dusJ))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dxgIg))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Y9Mx))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $dc9639f396c30a74$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kiZiu))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOZT3))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $hgeg8.alignRight)
    }
];
const $dc9639f396c30a74$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ctkw))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kVA9C))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $dc9639f396c30a74$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl)))
    }
];
const $dc9639f396c30a74$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $gVDfZ.toolbarMessages).wrapLeft,
    center: (0, $61p3e.default).alignImageCenter,
    'wrap-right': (0, $gVDfZ.toolbarMessages).wrapRight,
    wide: (0, $61p3e.default).layoutWide,
    'full-width': (0, $61p3e.default).layoutFullWidth,
    'align-end': (0, $61p3e.default).alignImageRight,
    'align-start': (0, $61p3e.default).alignImageLeft
};
const $dc9639f396c30a74$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $dc9639f396c30a74$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $dc9639f396c30a74$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $lqWNh.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $4KOFJ.insideTable)(state) || (0, $kTbzR.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: (0, $d925B.ACTION).SELECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $dc9639f396c30a74$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $lqWNh.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $dc9639f396c30a74$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[value]),
            selected: $dc9639f396c30a74$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $dc9639f396c30a74$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $dc9639f396c30a74$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[value]),
            selected: $dc9639f396c30a74$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $dc9639f396c30a74$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $807Mc.Shortcut), null, (0, $hgeg8.tooltip)(layoutOption.keyboardShortcut))
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $dc9639f396c30a74$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $8m4tT.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $1oCLl.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $dc9639f396c30a74$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || !selection.node || !nodeType || $dc9639f396c30a74$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $dc9639f396c30a74$var$mapIconsToToolbarItem($dc9639f396c30a74$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$dc9639f396c30a74$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$dc9639f396c30a74$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $dc9639f396c30a74$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.NodeSelection)) || !selection.node || !nodeType || $dc9639f396c30a74$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$dc9639f396c30a74$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$dc9639f396c30a74$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$dc9639f396c30a74$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $dc9639f396c30a74$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $dc9639f396c30a74$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($dc9639f396c30a74$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $dc9639f396c30a74$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $lqWNh.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $dc9639f396c30a74$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $dc9639f396c30a74$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var $dc9639f396c30a74$export$2e2bcd8739ae039 = $dc9639f396c30a74$var$buildLayoutButtons;
module.exports["alignmentIcons"] = $dc9639f396c30a74$export$45400139bf999022;
module.exports["wrappingIcons"] = $dc9639f396c30a74$export$88511ca1ca567d46;
module.exports["layoutToMessages"] = $dc9639f396c30a74$export$b978ceeb25a89f87;
module.exports["buildLayoutDropdown"] = $dc9639f396c30a74$export$31e29507a90f6f72;
module.exports["default"] = $dc9639f396c30a74$export$2e2bcd8739ae039;

});

parcelRegister("6JHzw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $d7ZU3 = parcelRequire("d7ZU3");


var $2gkmX = parcelRequire("2gkmX");


var $7YjFd = parcelRequire("7YjFd");

var $iq4lN = parcelRequire("iq4lN");


var $16GCc = parcelRequire("16GCc");


var $hpUsb = parcelRequire("hpUsb");


var $9CM6e = parcelRequire("9CM6e");


var $1oCLl = parcelRequire("1oCLl");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $0vvte = parcelRequire("0vvte");

var $cV5SN = parcelRequire("cV5SN");


var $gndLe = parcelRequire("gndLe");


var $fJNzZ = parcelRequire("fJNzZ");


var $eLQM6 = parcelRequire("eLQM6");


var $eIleF = parcelRequire("eIleF");


var $hBNGD = parcelRequire("hBNGD");


var $dQwlz = parcelRequire("dQwlz");


var $aJdNi = parcelRequire("aJdNi");

const $e18b52ae184c6660$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $e18b52ae184c6660$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $e18b52ae184c6660$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIleF.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aJdNi.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eIleF.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eLQM6.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
class $e18b52ae184c6660$export$9dd55813d0ee0514 extends (0, $2gkmX.default) {
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dQwlz.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $gndLe.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $0vvte.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fJNzZ.calcBreakoutWidth)(attrs.layout || (0, $hBNGD.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($e18b52ae184c6660$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.tableWidth = void 0;
        this.isNodeNested = void 0;
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
}



var $9AGwg = parcelRequire("9AGwg");


var $hrFA1 = parcelRequire("hrFA1");


var $cOfDZ = parcelRequire("cOfDZ");

class $008ad79e547fbc00$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $9AGwg.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt,
                    hideIconLoadingSkeleton: true
                }, url),
                this.gapCursorSpan()
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $l998X.jsx)(cardContext.Provider, {
                value: cardContext.value,
                children: cardInner
            }) : data ? cardInner : null
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $2P8Ax.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $9AGwg.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        };
        this.removeCardDispatched = false;
        this.gapCursorSpan = ()=>{
            const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $7YjFd.findOverflowScrollParent)(props.view.dom) || undefined;
    }
}
const $008ad79e547fbc00$var$WrappedBlockCard = (0, $cOfDZ.Card)($008ad79e547fbc00$export$780882fb750d3c8d, (0, $iq4lN.default));
class $008ad79e547fbc00$export$d18ccd25c0d2c6b0 extends (0, $2gkmX.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $hrFA1.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $hrFA1.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)($008ad79e547fbc00$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        });
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $008ad79e547fbc00$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        };
        const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $16GCc.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $e18b52ae184c6660$export$9dd55813d0ee0514)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $008ad79e547fbc00$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };
module.exports["BlockCardComponent"] = $008ad79e547fbc00$export$780882fb750d3c8d;
module.exports["blockCardNodeView"] = $008ad79e547fbc00$export$8c11099266e71f4;

});

parcelRegister("7IyZf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2P8Ax = parcelRequire("2P8Ax");


var $cUcZ5 = parcelRequire("cUcZ5");


var $9YoeD = parcelRequire("9YoeD");


var $eiA8Z = parcelRequire("eiA8Z");


var $2gkmX = parcelRequire("2gkmX");


var $7YjFd = parcelRequire("7YjFd");

var $6CRn4 = parcelRequire("6CRn4");

var $iq4lN = parcelRequire("iq4lN");


var $b3YrF = parcelRequire("b3YrF");


var $lqWNh = parcelRequire("lqWNh");


var $aFUXX = parcelRequire("aFUXX");


var $9JpPs = parcelRequire("9JpPs");


var $hpUsb = parcelRequire("hpUsb");

var $9ISlX = parcelRequire("9ISlX");


var $9CM6e = parcelRequire("9CM6e");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $3UbBx = parcelRequire("3UbBx");

var $7U0RE = parcelRequire("7U0RE");

var $5dl3F = parcelRequire("5dl3F");
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $1OLls = parcelRequire("1OLls");

const $326b55d93a1eda54$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $9K4OG.css)("&>div{", (0, $1OLls.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");



var $8m4tT = parcelRequire("8m4tT");





var $kVnOi = parcelRequire("kVnOi");




class $a50b525d2ced3713$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $3UbBx.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
        else return 0, $aFUXX.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $3UbBx.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $3UbBx.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $kVnOi.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $aFUXX.akEditorMediaResizeHandlerPadding)
        };
        const enable = {};
        (0, $7U0RE.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $7U0RE.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $326b55d93a1eda54$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dl3F.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $3UbBx.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $3UbBx.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $3UbBx.calcMediaPxWidth)({
                origWidth: (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $7U0RE.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)(this.$pos, (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ] : [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $3UbBx.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}
$a50b525d2ced3713$export$2e2bcd8739ae039.defaultProps = {
    aspectRatio: (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT)
};



var $6JHzw = parcelRequire("6JHzw");


var $cOfDZ = parcelRequire("cOfDZ");

const $8daf0367de43e367$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $8daf0367de43e367$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $8daf0367de43e367$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $aFUXX.DEFAULT_EMBED_CARD_WIDTH) / (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6CRn4.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a50b525d2ced3713$export$2e2bcd8739ae039), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $8daf0367de43e367$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $9AGwg.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }, url) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9ISlX.EmbedResizeMessageListener), {
            embedIframeRef: this.embedIframeRef,
            onHeightUpdate: this.onHeightUpdate,
            children: /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$var$CardInner, {
                pluginInjectionApi: pluginInjectionApi,
                smartCard: smartCard,
                hasPreview: hasPreview,
                getPosSafely: this.getPosSafely,
                view: view,
                getLineLength: this.getLineLength,
                eventDispatcher: this.props.eventDispatcher,
                updateSize: this.updateSize,
                getPos: getPos,
                aspectRatio: aspectRatio,
                allowResizing: allowResizing,
                heightAlone: heightAlone,
                cardProps: cardProps,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            })
        });
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.state = void 0;
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: aspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT), (0, $aFUXX.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $2P8Ax.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $9AGwg.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        /**
     * Defers line-length measurement until the embed card DOM has fully rendered.
     *
     * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
     * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
     * Measuring at that moment would cache the bogus width and break resize calculations.
     * Scheduling a measurement on the next animation frame ensures layout has
     * settled. We then force the node view to re-render so `getLineLength`
     * re-runs and captures the correct width.
     */ this.scheduleLineLengthRemeasureRaf = (0, $2P8Ax.default)((view)=>{
            if (view) this.forceUpdate();
        });
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $lqWNh.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $lqWNh.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1 && (0, $1oCLl.expValEquals)('editor_fix_embed_width_expand', 'isEnabled', true)) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        };
        /**
     * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
     * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
     * we will show embed window of appropriate size and avoid unnecessary content jumping.
     */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $2P8Ax.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $9YoeD.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.removeCardDispatched = false;
        this.scrollContainer = (0, $7YjFd.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
}
const $8daf0367de43e367$export$a2e44368c194a658 = (props)=>{
    const width = (0, $b3YrF.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $aFUXX.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6JHzw.BlockCardComponent), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $8daf0367de43e367$var$WrappedEmbedCardWithCondition = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $8daf0367de43e367$export$a2e44368c194a658, $8daf0367de43e367$export$61b2782f78272a37);
const $8daf0367de43e367$var$WrappedEmbedCard = (0, $cOfDZ.Card)($8daf0367de43e367$var$WrappedEmbedCardWithCondition, (0, $iq4lN.default));
class $8daf0367de43e367$export$6789d7ecdc77631b extends (0, $2gkmX.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)($8daf0367de43e367$var$WrappedEmbedCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        });
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $8daf0367de43e367$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        };
        return new $8daf0367de43e367$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };
module.exports["embedCardNodeView"] = $8daf0367de43e367$export$86904605fa83de6c;

});

parcelRegister("9YoeD", function(module, exports) {

var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");


var $5SAOw = parcelRequire("5SAOw");

class $93b3b1d5c7149b50$export$8cfd0a0bfa522949 extends (0, $cO9ey.Step) {
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $aXG5V.StepResult).fail('No node at given position');
        if (target.isText) return (0, $aXG5V.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $5SAOw.Fragment).empty, target.marks);
        const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $aXG5V.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $93b3b1d5c7149b50$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
    constructor(pos, attrs){
        super();
        this.pos = void 0;
        this.attrs = void 0;
        this.pos = pos;
        this.attrs = attrs;
    }
}
(0, $cO9ey.Step).jsonID('setAttrs', $93b3b1d5c7149b50$export$8cfd0a0bfa522949);
module.exports["SetAttrsStep"] = $93b3b1d5c7149b50$export$8cfd0a0bfa522949;

});

parcelRegister("7U0RE", function(module, exports) {
const $9d1645e455818659$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
const $9d1645e455818659$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
const $9d1645e455818659$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};
module.exports["snapTo"] = $9d1645e455818659$export$ce5a040a76868800;
module.exports["handleSides"] = $9d1645e455818659$export$8ee741c8b9b43371;
module.exports["imageAlignmentMap"] = $9d1645e455818659$export$9aaf3d5fbdfcf5c5;

});

parcelRegister("5dl3F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $9MZd8 = parcelRequire("9MZd8");


var $aFUXX = parcelRequire("aFUXX");


var $d925B = parcelRequire("d925B");


var $gnMzP = parcelRequire("gnMzP");


var $eYlm5 = parcelRequire("eYlm5");


var $7U0RE = parcelRequire("7U0RE");

const $34afeecf093fc962$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $d925B.ACTION_SUBJECT).EMBEDS : (0, $d925B.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $d925B.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $d925B.EVENT_TYPE).UI
    };
};
const $34afeecf093fc962$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $34afeecf093fc962$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $7U0RE.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $aFUXX.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $gnMzP.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
            ref: this.resizable,
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart
        }, children);
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $34afeecf093fc962$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $34afeecf093fc962$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $7U0RE.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($34afeecf093fc962$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $eYlm5.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $eYlm5.gridTypeForLayout)(layout), []);
            });
        };
    }
}
module.exports["default"] = $34afeecf093fc962$export$2e2bcd8739ae039;

});

parcelRegister("hdx2V", function(module, exports) {
//
// Main
//
function $c88d48d30306f53a$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $c88d48d30306f53a$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c88d48d30306f53a$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c88d48d30306f53a$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c88d48d30306f53a$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $c88d48d30306f53a$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c88d48d30306f53a$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c88d48d30306f53a$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c88d48d30306f53a$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c88d48d30306f53a$var$monadic : $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyVariadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$variadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c88d48d30306f53a$var$strategyMonadic(fn, options) {
    var strategy = $c88d48d30306f53a$var$monadic;
    return $c88d48d30306f53a$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $c88d48d30306f53a$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $c88d48d30306f53a$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c88d48d30306f53a$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c88d48d30306f53a$var$cacheDefault = {
    create: function create() {
        return new $c88d48d30306f53a$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $c88d48d30306f53a$var$memoize;
module.exports.strategies = {
    variadic: $c88d48d30306f53a$var$strategyVariadic,
    monadic: $c88d48d30306f53a$var$strategyMonadic
};

});

parcelRegister("cCTpf", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

var $cO9ey = parcelRequire("cO9ey");

const $e04235b8f81a60dd$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $e04235b8f81a60dd$export$c1b7e6427b2a2113 extends (0, $cO9ey.Step) {
    invert() {
        return new $e04235b8f81a60dd$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $e04235b8f81a60dd$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(pos, prev, next){
        super();
        this.prev = void 0;
        this.next = void 0;
        this.pos = void 0;
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $cO9ey.Step).jsonID($e04235b8f81a60dd$export$3f33e36adb7672cc, $e04235b8f81a60dd$export$c1b7e6427b2a2113);
module.exports["TableSortStep"] = $e04235b8f81a60dd$export$c1b7e6427b2a2113;

});

parcelRegister("eyggb", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $2xxP6 = parcelRequire("2xxP6");

var $aotp7 = parcelRequire("aotp7");

var $u6ZFj = parcelRequire("u6ZFj");


var $1S4f7 = parcelRequire("1S4f7");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");
var $e458bc4b0a17a20d$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $e458bc4b0a17a20d$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});



var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $jqXx5 = parcelRequire("jqXx5");





var $7iE7T = parcelRequire("7iE7T");


var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");








var $1oCLl = parcelRequire("1oCLl");





var $5GR8v = parcelRequire("5GR8v");








var $lkJUe = parcelRequire("lkJUe");




const $c9b341a736aaedb1$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('extensionPlugin');


function $c6b622e1ab00ec41$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}


const $7c3916ff30296215$var$factory = (0, $lkJUe.pluginFactory)((0, $c9b341a736aaedb1$export$18d4026d1ea86bb1), (0, $c6b622e1ab00ec41$export$2e2bcd8739ae039), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $7c3916ff30296215$export$656c7661095efe2e = $7c3916ff30296215$var$factory.createPluginState;
const $7c3916ff30296215$export$8d4021544bdece00 = $7c3916ff30296215$var$factory.createCommand;
const $7c3916ff30296215$export$f05434c51e3762e = $7c3916ff30296215$var$factory.getPluginState;






var $cMZNY = parcelRequire("cMZNY");


var $4vlwG = parcelRequire("4vlwG");

var $2bi6l = parcelRequire("2bi6l");







const $1aea8836743878dc$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $8m4tT.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $8m4tT.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $1aea8836743878dc$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $1aea8836743878dc$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $1aea8836743878dc$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $8m4tT.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $4vlwG.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $1aea8836743878dc$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $1aea8836743878dc$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $2bi6l.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $1aea8836743878dc$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $2bi6l.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
const $1aea8836743878dc$export$9defe25170de6263 = ({ schema: schema, unsupportedContent: unsupportedContent })=>{
    try {
        if (!unsupportedContent) return new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $h9yJL.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        const text = pmNode.textBetween(0, pmNode.content.size, '\n\n');
        (0, $cMZNY.copyToClipboard)(text);
    } catch (error) {
        return error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $1aea8836743878dc$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    const nodeWithPos = $1aea8836743878dc$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi?.analytics?.actions.fireAnalyticsEvent({
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        action: (0, $d925B.ACTION).COPY_FAILED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};


function $d61ca718ec6d02a8$export$4971331372cec95a(state) {
    return (0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $d61ca718ec6d02a8$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $d61ca718ec6d02a8$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $d61ca718ec6d02a8$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $7c3916ff30296215$export$8d4021544bdece00)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $d61ca718ec6d02a8$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).UPDATED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $e458bc4b0a17a20d$export$b9401faa25e39d87).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $d61ca718ec6d02a8$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state)) return $d61ca718ec6d02a8$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $d61ca718ec6d02a8$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $d61ca718ec6d02a8$export$fa79c3ccfdddfece = (sourceNode)=>(0, $7c3916ff30296215$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $5GR8v.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $d61ca718ec6d02a8$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $8m4tT.removeSelectedNode)(tr);
};
const $d61ca718ec6d02a8$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $8m4tT.removeParentNodeOfType)(nodeType)(tr);
};



var $9ir1r = parcelRequire("9ir1r");





var $zT4ZO = parcelRequire("zT4ZO");


var $bSXAs = parcelRequire("bSXAs");











const $2ffaec345eb6ed9f$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('macroPlugin');


const $b35d6c52d15b10f4$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $b35d6c52d15b10f4$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $8m4tT.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $8m4tT.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
                let targetSelectionSource = (0, $e458bc4b0a17a20d$export$b9401faa25e39d87).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $8m4tT.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $8m4tT.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $e458bc4b0a17a20d$export$b9401faa25e39d87).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).UPDATED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $d925B.INPUT_METHOD).MACRO_BROWSER : (0, $d925B.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $b35d6c52d15b10f4$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $bSXAs.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $zT4ZO.normaliseNestedLayout)(state, node);
};
const $b35d6c52d15b10f4$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $b35d6c52d15b10f4$export$87074dfcaea41da3(macroAttributes, state);
};
const $b35d6c52d15b10f4$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($9ir1r)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1), {
            macroProvider: resolvedProvider
        }));
        return true;
    };




const $96bd81a1f1e3494f$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $b35d6c52d15b10f4$export$4ec44b2939e261e2)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $96bd81a1f1e3494f$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $d925B.ACTION).INVOKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
const $96bd81a1f1e3494f$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $1aea8836743878dc$export$bb057d1dfc5c8b1b)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $5SAOw.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $5SAOw.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $1aea8836743878dc$export$cd9967958db163fc)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $1aea8836743878dc$export$1004a88e790d2d21)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $d925B.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $8m4tT.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                content: (0, $7iE7T.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $5SAOw.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = node.type.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $h9yJL.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                tr.replaceWith(pos, pos + node.nodeSize, newNode);
                // Keep selection if content does not change
                if (newContent === node.content) tr.setSelection((0, $ks2lK.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $96bd81a1f1e3494f$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof opts?.scrollIntoView === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $d61ca718ec6d02a8$export$845f8c516a847983)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1).getState(editorView.state);
                editInLegacy = $96bd81a1f1e3494f$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};




const $5d025507818a1091$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5d025507818a1091$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5d025507818a1091$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $8m4tT.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $8m4tT.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $e458bc4b0a17a20d$export$b9401faa25e39d87).CURRENT_SELECTION;
            let action = (0, $d925B.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $8m4tT.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $8m4tT.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $e458bc4b0a17a20d$export$b9401faa25e39d87).HTML_ELEMENT;
                } else action = (0, $d925B.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $d925B.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5d025507818a1091$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5d025507818a1091$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5d025507818a1091$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
        const nodeWithPos = (0, $1aea8836743878dc$export$b003700b6d25caa7)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $96bd81a1f1e3494f$export$5c24840493a9fa44)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $96bd81a1f1e3494f$export$5c70dcf0377b6800)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5d025507818a1091$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5d025507818a1091$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $7c3916ff30296215$export$f05434c51e3762e)(view.state);
        return $5d025507818a1091$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5d025507818a1091$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5d025507818a1091$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};





var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");



function $391952836eb8b15d$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.escape).common, (state, dispatch)=>{
        const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $d61ca718ec6d02a8$export$81748740fe20ba64)(applyChange)(state, dispatch);
    }, list);
    return (0, $dus6D.keymap)(list);
}








const $e83e7d9c02de9f75$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $b35d6c52d15b10f4$export$e45aff648def0591)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });






var $3tffm = parcelRequire("3tffm");

var $adhil = parcelRequire("adhil");

var $l6okE = parcelRequire("l6okE");









var $gjBRE = parcelRequire("gjBRE");


var $ftpVl = parcelRequire("ftpVl");


var $iu6m9 = parcelRequire("iu6m9");


function $aa818765dc2dc945$export$18f6e24b34cb523d(nodeName, ...params) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $gjBRE.default)(...params);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: nodeName,
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("8y1DS")).then(({ ExtensionNodeView: ExtensionNodeView })=>{
                return ExtensionNodeView(...params);
            });
            return result;
        }
    });
}





var $heH5c = parcelRequire("heH5c");



const $2e6603bf3390fe53$var$maybeGetUpdateMethodFromExtensionProvider = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $heH5c.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode.update;
};
const $2e6603bf3390fe53$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const updateMethod = await $2e6603bf3390fe53$var$maybeGetUpdateMethodFromExtensionProvider(view, extensionProvider);
        (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
            showEditButton: !!updateMethod,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};



const $9c14eded2e96d0e7$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $9c14eded2e96d0e7$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $2e6603bf3390fe53$export$1e25f457f2ade11e)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $9c14eded2e96d0e7$export$21b8c38408ff6d69 = (view)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $2e6603bf3390fe53$export$1e25f457f2ade11e)(view, extensionProvider);
        } catch  {
            (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $9c14eded2e96d0e7$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $d61ca718ec6d02a8$export$81748740fe20ba64)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $1aea8836743878dc$export$f1c79f28529bfc9a)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $1aea8836743878dc$export$cdb701fa2b3c99df)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $d61ca718ec6d02a8$export$81748740fe20ba64)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $9c14eded2e96d0e7$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $9c14eded2e96d0e7$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $9c14eded2e96d0e7$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions)=>{
    const state = (0, $7c3916ff30296215$export$656c7661095efe2e)(dispatch, {
        showEditButton: false,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $9c14eded2e96d0e7$export$21b8c38408ff6d69(editorView);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $9c14eded2e96d0e7$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $c9b341a736aaedb1$export$18d4026d1ea86bb1),
        props: {
            handleDOMEvents: {
                /**
				 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
				 * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
				 * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
				 */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $ks2lK.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $ks2lK.TextSelection) ? (0, $8m4tT.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $8m4tT.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $l6okE.isSelectionAtStartOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $l6okE.isSelectionAtEndOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $adhil.GapCursorSelection) || selection instanceof (0, $ks2lK.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
								 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
								 */ const previousPositionDecrement = selection instanceof (0, $adhil.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $ks2lK.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $aa818765dc2dc945$export$18f6e24b34cb523d)('extension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $aa818765dc2dc945$export$18f6e24b34cb523d)('bodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $aa818765dc2dc945$export$18f6e24b34cb523d)('inlineExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags),
                multiBodiedExtension: (0, $aa818765dc2dc945$export$18f6e24b34cb523d)('multiBodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $ks2lK.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $ks2lK.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize);
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};




var $4sfnB = parcelRequire("4sfnB");


var $24P9d = parcelRequire("24P9d");


var $6fnsQ = parcelRequire("6fnsQ");

const $dba54e90a92c69fe$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $dba54e90a92c69fe$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $4sfnB.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $24P9d.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $24P9d.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $dba54e90a92c69fe$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $24P9d.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${`var(--ds-border, ${(0, $6fnsQ.N30)})`}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};



var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $5pF33 = parcelRequire("5pF33");

var $3jQ9y = parcelRequire("3jQ9y");


var $61p3e = parcelRequire("61p3e");


var $5Ev1b = parcelRequire("5Ev1b");


var $iHzeA = parcelRequire("iHzeA");





var $91bcx = parcelRequire("91bcx");





var $3uQ0E = parcelRequire("3uQ0E");


var $kDG8M = parcelRequire("kDG8M");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $gzsfl = parcelRequire("gzsfl");












// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $cbbd6680b3b391a3$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    return selectedExtNode.node.type === extension && (0, $8m4tT.hasParentNodeOfType)([
        panel,
        blockquote,
        listItem
    ].filter(Boolean))(selection);
};
const $cbbd6680b3b391a3$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $8m4tT.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $8m4tT.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $8m4tT.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $cbbd6680b3b391a3$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $cbbd6680b3b391a3$var$isLayoutSupported(state, nodeWithPos) && !$cbbd6680b3b391a3$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))), {
                        label: formatMessage((0, $61p3e.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))),
                onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $61p3e.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))), {
                        label: formatMessage((0, $61p3e.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))),
                onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $61p3e.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))), {
                        label: formatMessage((0, $61p3e.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))),
                onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $61p3e.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $cbbd6680b3b391a3$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$cbbd6680b3b391a3$var$isLayoutSupported(state, nodeWithPos) || $cbbd6680b3b391a3$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $61p3e.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($kDG8M)));
            break;
        case 'full-width':
            title = formatMessage((0, $61p3e.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gzsfl)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $61p3e.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $61p3e.default).layoutFixedWidth),
            onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uQ0E))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $61p3e.default).layoutWide),
            onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG8M))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $61p3e.default).layoutFullWidth),
            onClick: (0, $d61ca718ec6d02a8$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzsfl))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $61p3e.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $cbbd6680b3b391a3$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? $cbbd6680b3b391a3$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $cbbd6680b3b391a3$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $cbbd6680b3b391a3$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $2ffaec345eb6ed9f$export$18d4026d1ea86bb1).getState(state);
                const { updateExtension: updateExtension } = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
                (0, $5d025507818a1091$export$f45ebaf24963f4bb)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $5pF33.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? false : undefined
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $cbbd6680b3b391a3$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $8m4tT.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $5Ev1b.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $cbbd6680b3b391a3$export$7652656d91146fb9 = ({ extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent?.(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        const error = (0, $1aea8836743878dc$export$9defe25170de6263)({
            unsupportedContent: adf,
            schema: state.schema
        });
        if (error) {
            (0, $1aea8836743878dc$export$67e8f2a5d4f25de0)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
            return false;
        }
        return true;
    };
};
const $cbbd6680b3b391a3$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        const { formatMessage: formatMessage } = intl;
        const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi?.decorations?.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi?.contextPanel?.actions.applyChange;
        const editorAnalyticsAPI = extensionApi?.analytics?.actions;
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $cbbd6680b3b391a3$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $91bcx.isOfflineMode)(extensionApi?.connectivity?.sharedState?.currentState()?.mode), extensionApi);
        const breakoutItems = $cbbd6680b3b391a3$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if (extensionObj?.node.attrs.extensionType === (0, $3jQ9y.NATIVE_EMBED_EXTENSION_TYPE)) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $5GR8v.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $5pF33.messages).unnamedSource);
            return {
                title: formatMessage((0, $5pF33.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $5pF33.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $5pF33.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $5GR8v.getNodeName)(state, extensionObj?.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $5GR8v.getChildrenInfo)(state, extensionObj?.node),
                checkboxLabel: formatMessage((0, $5pF33.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$cbbd6680b3b391a3$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
            };
        };
        // disable copy button for legacy content macro
        const isLegacyContentMacro = extensionObj?.node.attrs.extensionType === 'com.atlassian.confluence.migration' && extensionObj?.node.attrs.extensionKey === 'legacy-content';
        const shouldHideCopyButton = isLegacyContentMacro && (0, $1oCLl.expValEquals)('platform_editor_disable_lcm_copy_button', 'isEnabled', true);
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$cbbd6680b3b391a3$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: (0, $1oCLl.expValEquals)('platform_editor_ai_edit_unsupported_content', 'isEnabled', true) ? $cbbd6680b3b391a3$export$7652656d91146fb9({
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state
                            }) : undefined
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                {
                    type: 'separator'
                },
                {
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    appearance: 'danger',
                    onClick: (0, $d61ca718ec6d02a8$export$366c74c25333cf63)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $61p3e.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $cbbd6680b3b391a3$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $d61ca718ec6d02a8$export$366c74c25333cf63)()(state, dispatch);
        else (0, $d61ca718ec6d02a8$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };



var $fO7hX = parcelRequire("fO7hX");


var $9YoeD = parcelRequire("9YoeD");





var $kTbzR = parcelRequire("kTbzR");




const $901577c8e6386978$var$pluginKey = new (0, $ks2lK.PluginKey)('extensionUniqueIdPlugin');
const $901577c8e6386978$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $kTbzR.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $9YoeD.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    step.attrs?.localId === null);
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $fO7hX.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $901577c8e6386978$var$pluginKey
    });



var $7NMV8 = parcelRequire("7NMV8");




parcelRequire("42omo");











var $7XFGZ = parcelRequire("7XFGZ");






var $4wH3g = parcelRequire("4wH3g");


var $1ux1Z = parcelRequire("1ux1Z");


var $94f53d3f64228b83$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "qIe90",
    name: "platform.packages.editor.editor-plugin-extension.src.ui.ConfigPanel.ConfigPanelLoader",
    loader: ()=>(parcelRequire("cSDQf")).then((module)=>module.default),
    loading: (0, $1ux1Z.default)
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gtD4K = parcelRequire("gtD4K");





var $3sFtD = parcelRequire("3sFtD");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");




function $edcdc351883ee8ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edcdc351883ee8ae$var$noop = ()=>{};
const $edcdc351883ee8ae$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $edcdc351883ee8ae$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`,
    /* E300 */ boxShadow: `var(--ds-shadow-overlay, ${`0px 8px 12px rgba(9, 30, 66, 0.15), 0px 0px 1px rgba(9, 30, 66, 0.31)`})`,
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $edcdc351883ee8ae$var$saveIndicatorTextStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $edcdc351883ee8ae$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $42omo.useState)(false);
    const shown = (0, $42omo.useRef)(false);
    const onSaveStarted = (0, $42omo.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $edcdc351883ee8ae$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $edcdc351883ee8ae$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $edcdc351883ee8ae$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "Saving",
        color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`,
        spacing: "none"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $edcdc351883ee8ae$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $5pF33.messages).saveIndicator))))));
};


const $ab33982f3ff76825$var$areParametersEqual = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
firstParameters, // eslint-disable-next-line @typescript-eslint/no-explicit-any
secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $ab33982f3ff76825$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $ks2lK.NodeSelection)) return (0, $ks2lK.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $ks2lK.TextSelection)) return (0, $ks2lK.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $adhil.GapCursorSelection)) return new (0, $adhil.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $7XFGZ.CellSelection)) return new (0, $7XFGZ.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $ab33982f3ff76825$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $edcdc351883ee8ae$export$7ceebdb305e167df), {
                    duration: 5000,
                    visible: true,
                    children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                        const editorView = getEditorView?.();
                        if (!editorView) return null;
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $94f53d3f64228b83$export$2e2bcd8739ae039), {
                            api: api,
                            showHeader: true,
                            closeOnEsc: true,
                            extensionType: extensionType,
                            extensionKey: extKey,
                            nodeKey: nodeKey,
                            extensionParameters: parameters,
                            parameters: configParams,
                            extensionProvider: extensionProvider,
                            autoSaveTrigger: autoSaveResolve,
                            autoSaveReject: autoSaveReject,
                            onChange: async (updatedParameters)=>{
                                await $ab33982f3ff76825$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                                onSaveEnded();
                                if (autoSaveResolve) autoSaveResolve();
                            },
                            onCancel: async ()=>{
                                try {
                                    await new Promise((resolve, reject)=>{
                                        (0, $d61ca718ec6d02a8$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                    });
                                } catch (e) {
                                    // Even if the save failed, we should proceed with closing the panel
                                    // eslint-disable-next-line no-console
                                    console.error(`Autosave failed with error`, e);
                                }
                                (0, $d61ca718ec6d02a8$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
                            },
                            featureFlags: featureFlags
                        });
                    }
                });
            }
        };
async function $ab33982f3ff76825$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $7c3916ff30296215$export$f05434c51e3762e)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($ab33982f3ff76825$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $7c3916ff30296215$export$f05434c51e3762e)(editorView.state);
    await (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $7c3916ff30296215$export$f05434c51e3762e)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $5d025507818a1091$export$5e06148a47ef53c2)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $ab33982f3ff76825$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $7c3916ff30296215$export$f05434c51e3762e)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $d61ca718ec6d02a8$export$4971331372cec95a)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}












var $eiA8Z = parcelRequire("eiA8Z");


var $gdv5Z = parcelRequire("gdv5Z");











parcelRequire("42omo");




var $bUlM5 = parcelRequire("bUlM5");






parcelRequire("42omo");


var $1eYoq = parcelRequire("1eYoq");

function $db52d1799ba5ba81$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $1eYoq.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}


const $a037f4da29032475$var$itemBodyStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $a037f4da29032475$var$itemTextStyles = (0, $ecnYn.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $a037f4da29032475$var$summaryStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $a037f4da29032475$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $a037f4da29032475$var$itemBodyStyles,
        children: summary ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $a037f4da29032475$var$itemTextStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    id: "context-panel-title",
                    "data-testid": "context-panel-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $a037f4da29032475$var$summaryStyles,
                    children: summary
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            direction: "column",
            alignItems: "center",
            testId: "context-panel-title",
            children: title
        })
    });
}
var $a037f4da29032475$export$2e2bcd8739ae039 = (0, $db52d1799ba5ba81$export$7dd73e517d9d8a3)($a037f4da29032475$var$HeaderAfterIconElement);














const $af2fc30072ef2472$var$iconWidth = '40px';
const $af2fc30072ef2472$var$itemIconStyles = (0, $ecnYn.xcss)({
    width: $af2fc30072ef2472$var$iconWidth,
    height: $af2fc30072ef2472$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $af2fc30072ef2472$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $42omo.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $af2fc30072ef2472$var$itemIconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $l998X.jsx)(ResolvedIcon, {
                label: title
            })
        })
    });
}
var $af2fc30072ef2472$export$2e2bcd8739ae039 = (0, $db52d1799ba5ba81$export$7dd73e517d9d8a3)($af2fc30072ef2472$var$HeaderIcon);




const $b6b68ed5d492495b$var$selector = (states)=>{
    return {
        showContextPanel: states.extensionState?.showContextPanel,
        extensionProvider: states.extensionState?.extensionProvider,
        processParametersAfter: states.extensionState?.processParametersAfter
    };
};
function $b6b68ed5d492495b$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $b6b68ed5d492495b$var$selector);
    (0, $42omo.useEffect)(()=>{
        const nodeWithPos = (0, $1aea8836743878dc$export$cdb701fa2b3c99df)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $b6b68ed5d492495b$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $b6b68ed5d492495b$export$2a2eb89a1c258b39(configPanelId, api) {
    const closePanelById = api?.contextPanel?.actions?.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $b6b68ed5d492495b$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos?.node.attrs;
        const extensionType = nodeAttrs?.extensionType;
        const extensionKey = nodeAttrs?.extensionKey;
        /**
		 * Loading extension manifest fails when using
		 * 	extensionKey directly from nodeAttrs.
		 * Always get extensionKey from getExtensionKeyAndNodeKey to load
		 * 	extension manifest successfully.
		 */ const [extKey, _] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $af2fc30072ef2472$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $a037f4da29032475$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $b6b68ed5d492495b$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(editorView.state);
                    /**
						 * 	If context panel is open, then first update extension plugin state.
						 * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
						 * 		which will call hideConfigPanel.
						 */ if (extensionState?.showContextPanel) {
                        await $b6b68ed5d492495b$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $7NMV8.CONFIG_PANEL_WIDTH));
    }
}
async function $b6b68ed5d492495b$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    const applyChange = api?.contextPanel?.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $d61ca718ec6d02a8$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $d61ca718ec6d02a8$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $b6b68ed5d492495b$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorState = editorView.state;
    const extensionState = (0, $7c3916ff30296215$export$f05434c51e3762e)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $edcdc351883ee8ae$export$7ceebdb305e167df), {
                duration: 5000,
                visible: true,
                children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $94f53d3f64228b83$export$2e2bcd8739ae039), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        onChange: async (updatedParameters)=>{
                            await (0, $ab33982f3ff76825$export$2f221d4ebb46923c)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        onCancel: ()=>$b6b68ed5d492495b$export$237eef05f48e1226({
                                api: api,
                                editorView: editorView
                            }),
                        featureFlags: featureFlags,
                        // Remove below prop when cleaning platform_editor_ai_object_sidebar_injection FG
                        // Becuase it will always be true
                        usingObjectSidebarPanel: true
                    });
                }
            })
        });
};


const $19fd44dc1dd6e218$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $7NMV8.CONFIG_PANEL_ID)}-${(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()}`;
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $2xxP6.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $dba54e90a92c69fe$export$1a85854d3d541a64)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $u6ZFj.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $aotp7.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $aotp7.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $c9b341a736aaedb1$export$18d4026d1ea86bb1).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel,
                extensionProvider: pluginState?.extensionProvider,
                processParametersAfter: pluginState?.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $9c14eded2e96d0e7$export$ae829ec7b2625219)(dispatch, providerFactory, extensionHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight
                        }, featureFlags, options?.__rendererExtensionOptions);
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $391952836eb8b15d$export$2e2bcd8739ae039)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $901577c8e6386978$export$ae829ec7b2625219)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $e83e7d9c02de9f75$export$ae829ec7b2625219)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $96bd81a1f1e3494f$export$5c70dcf0377b6800)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            insertMacroFromMacroBrowser: (0, $b35d6c52d15b10f4$export$4ec44b2939e261e2)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5d025507818a1091$export$f151d046c10e64b5)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5d025507818a1091$export$8ee156b55126996c)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $5d025507818a1091$export$1efb7858e16078f5)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            runMacroAutoConvert: $b35d6c52d15b10f4$export$774dc72aee79b8eb,
            forceAutoSave: $d61ca718ec6d02a8$export$265d048971b3d878
        },
        pluginsOptions: {
            floatingToolbar: (0, $cbbd6680b3b391a3$export$86ce8f8241c20a3)({
                breakoutEnabled: options.breakoutEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: // if showContextPanel action is not available, or platform_editor_ai_object_sidebar_injection feature flag is off
            // 	then keep using old context panel.
            !showContextPanel || !(0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? (0, $ab33982f3ff76825$export$7c8c60c0acb92731)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? ({ editorView: editorView })=>{
            (0, $b6b68ed5d492495b$export$781dfcd068e3a2e0)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};
module.exports["extensionPlugin"] = $19fd44dc1dd6e218$export$feb99ebbc74a9193;

});

parcelRegister("8y1DS", function(module, exports) {

let $6392c5cf93d8a552$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6392c5cf93d8a552$var$load("eFHVS").then(()=>parcelRequire('hx1ag'));

});

parcelRegister("7NMV8", function(module, exports) {
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $dbe157a86c6b2ed1$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $dbe157a86c6b2ed1$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $dbe157a86c6b2ed1$export$57e7dbe0bbfe09b5 = 320;
const $dbe157a86c6b2ed1$export$cb69418acbe13bc2 = 'extensions-panel';
module.exports["ALLOWED_LOGGED_MACRO_PARAMS"] = $dbe157a86c6b2ed1$export$2a99ab8c82908148;
module.exports["ALLOWED_PARAM_TYPES"] = $dbe157a86c6b2ed1$export$d17c9f402b8c93c8;
module.exports["CONFIG_PANEL_WIDTH"] = $dbe157a86c6b2ed1$export$57e7dbe0bbfe09b5;
module.exports["CONFIG_PANEL_ID"] = $dbe157a86c6b2ed1$export$cb69418acbe13bc2;

});

parcelRegister("1ux1Z", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $5pF33 = parcelRequire("5pF33");


var $aoVih = parcelRequire("aoVih");


var $9hlns = parcelRequire("9hlns");


var $iu6m9 = parcelRequire("iu6m9");

function $2519f064eb7ebc07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2519f064eb7ebc07$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $2519f064eb7ebc07$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $2519f064eb7ebc07$var$LoadingStateWithErrorHandling = (0, $gmMgo.default)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aoVih.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $5pF33.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $2519f064eb7ebc07$var$LoadingStateWithoutErrorHandling = ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2519f064eb7ebc07$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
const $2519f064eb7ebc07$var$LoadingState = (props)=>(0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) ? $2519f064eb7ebc07$var$LoadingStateWithErrorHandling(props) : $2519f064eb7ebc07$var$LoadingStateWithoutErrorHandling();
var $2519f064eb7ebc07$export$2e2bcd8739ae039 = $2519f064eb7ebc07$var$LoadingState;
module.exports["default"] = $2519f064eb7ebc07$export$2e2bcd8739ae039;

});

parcelRegister("cSDQf", function(module, exports) {

let $96096ee9741dcf06$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $96096ee9741dcf06$var$load("73RjE"),
    $96096ee9741dcf06$var$load("4sHQA"),
    $96096ee9741dcf06$var$load("6wr18"),
    $96096ee9741dcf06$var$load("3w411"),
    $96096ee9741dcf06$var$load("eY3St"),
    $96096ee9741dcf06$var$load("bkd4T"),
    $96096ee9741dcf06$var$load("7EorR"),
    $96096ee9741dcf06$var$load("ffEVr"),
    $96096ee9741dcf06$var$load("hhss7"),
    $96096ee9741dcf06$var$load("djfev")
]).then(()=>parcelRequire('7oBuJ'));

});

parcelRegister("1eYoq", function(module, exports) {

var $42omo = parcelRequire("42omo");




const $c316ee5083a2c330$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $c316ee5083a2c330$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $c316ee5083a2c330$var$safeError('Missing AbortController');
    return new AbortController();
};
function $c316ee5083a2c330$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $42omo.useMemo)(()=>$c316ee5083a2c330$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $42omo.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $42omo.useCallback)(callback, deps);
    (0, $42omo.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}


function $ab362e0d4d3dfbd5$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $42omo.useCallback)(callback, deps);
    const [value, setValue] = (0, $42omo.useState)(initialValue);
    (0, $c316ee5083a2c330$export$daf4e774a28efe06)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}
module.exports["useStateFromPromise"] = $ab362e0d4d3dfbd5$export$4960a9d54b2095bb;

});

parcelRegister("fYKTL", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6dGgK = parcelRequire("6dGgK");


var $2daQU = parcelRequire("2daQU");


var $eTj7Y = parcelRequire("eTj7Y");


var $eiA8Z = parcelRequire("eiA8Z");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");

const $3d3ae8905552ef3e$export$bc90872e265d166e = 12;
const $3d3ae8905552ef3e$var$key = new (0, $ks2lK.PluginKey)('gridPlugin');
const $3d3ae8905552ef3e$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($3d3ae8905552ef3e$var$key, props);
        dispatch(tr);
        return true;
    };
const $3d3ae8905552ef3e$var$sides = [
    'left',
    'right'
];
const $3d3ae8905552ef3e$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $3d3ae8905552ef3e$export$bc90872e265d166e && maxHighlight >= $3d3ae8905552ef3e$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $3d3ae8905552ef3e$export$bc90872e265d166e + size : true);
};
const $3d3ae8905552ef3e$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $aFUXX.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $3d3ae8905552ef3e$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', $3d3ae8905552ef3e$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $aFUXX.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $3d3ae8905552ef3e$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $3d3ae8905552ef3e$export$bc90872e265d166e;
    for(let i = 0; i <= $3d3ae8905552ef3e$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $3d3ae8905552ef3e$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $3d3ae8905552ef3e$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$3d3ae8905552ef3e$var$lineLengthGridLines(highlight),
        ...$3d3ae8905552ef3e$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none'
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $3d3ae8905552ef3e$var$ThemedGrid = (0, $6dGgK.b)($3d3ae8905552ef3e$var$Grid);
const $3d3ae8905552ef3e$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $3d3ae8905552ef3e$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $3d3ae8905552ef3e$var$selector);
    if (visible === undefined || !highlight) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($3d3ae8905552ef3e$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $aFUXX.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight
    });
};
const $3d3ae8905552ef3e$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $3d3ae8905552ef3e$var$gridPMPlugin = new (0, $1S4f7.SafePlugin)({
    key: $3d3ae8905552ef3e$var$key,
    state: {
        init () {
            return $3d3ae8905552ef3e$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($3d3ae8905552ef3e$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $3d3ae8905552ef3e$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $3d3ae8905552ef3e$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $3d3ae8905552ef3e$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$3d3ae8905552ef3e$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)($3d3ae8905552ef3e$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};
module.exports["gridPlugin"] = $3d3ae8905552ef3e$export$c090e341e8f725a9;

});

parcelRegister("4HPW1", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $kfJSC = parcelRequire("kfJSC");

const $48cec7a5ea226746$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $48cec7a5ea226746$export$e331ccfa6f694c99 = (range)=>!!(typeof range === 'object' && range && 'start' in range && 'end' in range);
const $48cec7a5ea226746$export$75d81fc396e386db = (pos)=>$48cec7a5ea226746$export$7e4aa119212bc614(pos.x);
const $48cec7a5ea226746$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};
const $48cec7a5ea226746$export$d52a13210f6817c5 = (containerWidth)=>{
    const padding = containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth)) / 2;
};
const $48cec7a5ea226746$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $aFUXX.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = mediaNode?.attrs || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $kfJSC.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $kfJSC.roundToNearest)(pixelWidth),
        height: (0, $kfJSC.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};
module.exports["isVerticalPosition"] = $48cec7a5ea226746$export$75d81fc396e386db;
module.exports["getGuidelineTypeFromKey"] = $48cec7a5ea226746$export$3fa50479f031580;
module.exports["getContainerWidthOrFullEditorWidth"] = $48cec7a5ea226746$export$d52a13210f6817c5;
module.exports["getMediaSingleDimensions"] = $48cec7a5ea226746$export$c7bf42817f6e4244;

});

parcelRegister("6MTPr", function(module, exports) {
const $7d01492d97569010$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $7d01492d97569010$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $7d01492d97569010$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};
module.exports["getGuidelinesWithHighlights"] = $7d01492d97569010$export$529f80a31b4cd2ac;

});

parcelRegister("8b5jG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ce0c3cc8105bda$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2daQU = parcelRequire("2daQU");


var $9MZd8 = parcelRequire("9MZd8");


var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $5duTD = parcelRequire("5duTD");


var $7QdQz = parcelRequire("7QdQz");

const $d4ce0c3cc8105bda$var$resizerLabelStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $d4ce0c3cc8105bda$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $d4ce0c3cc8105bda$var$ResizerNext = (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $42omo.useState)(false);
    const resizable = (0, $42omo.useRef)(null);
    const resizeHandleThumbRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const onResizeStart = (0, $42omo.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $42omo.useCallback)((_event, _direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        handleResize(originalState, delta);
    }, [
        handleResize
    ]);
    const onResizeStop = (0, $42omo.useCallback)((_event, _direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        setIsResizing(false);
        handleResizeStop(originalState, delta);
    }, [
        handleResizeStop
    ]);
    const handles = {
        left: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), 'left', handleSize, handleAlignmentMethod),
        right: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(handleClassName ?? (0, $7QdQz.resizerHandleClassName), 'right', handleSize, handleAlignmentMethod)
    };
    const baseHandleStyles = {
        width: handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)",
        zIndex: (0, $7QdQz.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const offset = handlePositioning === 'adjacent' ? `calc(${baseHandleStyles.width} * -1)` : `calc(${baseHandleStyles.width} * -0.5)`;
    const nextHandleStyles = $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES.reduce((result, position)=>({
            ...result,
            [position]: {
                ...baseHandleStyles,
                [position]: offset,
                ...handleStyles?.[position]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, (0, $7QdQz.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $7QdQz.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHoverZoneClassName), {
        [(0, $7QdQz.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleComponent = (0, $42omo.useMemo)(()=>{
        return $d4ce0c3cc8105bda$var$SUPPORTED_HANDLES.reduce((result, position)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $7QdQz.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position}-thumb`,
                "aria-label": formatMessage((0, $5duTD.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result,
                [position]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $7QdQz.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    contentEditable: false,
                    style: $d4ce0c3cc8105bda$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $42omo.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MZd8.Resizable), {
        ref: resizable,
        size: {
            width: width ?? 'auto',
            // just content itself (no paddings)
            height: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $7QdQz.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: resizerZoneClassName,
        ref: (ref)=>childrenDOMRef && childrenDOMRef(ref)
    }, children), labelComponent && (0, $iu6m9.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d4ce0c3cc8105bda$var$resizerLabelStyles
    }, labelComponent));
};
var $d4ce0c3cc8105bda$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $42omo.forwardRef)($d4ce0c3cc8105bda$var$ResizerNext);

});

parcelRegister("7QdQz", function(module, exports) {
/*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/ const $18d786e757e244a7$export$a06160db3520e5a2 = 'resizer-item';
const $18d786e757e244a7$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $18d786e757e244a7$export$10b67c6ff1748bd = 'resizer-is-extended';
const $18d786e757e244a7$export$6afc20f0ff6d041 = 'resizer-handle';
const $18d786e757e244a7$export$a5792d7e2a486d41 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-track`;
const $18d786e757e244a7$export$2201bc1aaee73f36 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-thumb`;
const $18d786e757e244a7$export$97a99610b6f0a178 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-danger`;
const $18d786e757e244a7$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $18d786e757e244a7$export$b5fa87f62ced4967 = 3;
const $18d786e757e244a7$export$3d867927ebf9bc1f = 1;
module.exports["resizerItemClassName"] = $18d786e757e244a7$export$a06160db3520e5a2;
module.exports["resizerHoverZoneClassName"] = $18d786e757e244a7$export$c42cdcfd48254bda;
module.exports["resizerExtendedZone"] = $18d786e757e244a7$export$10b67c6ff1748bd;
module.exports["resizerHandleClassName"] = $18d786e757e244a7$export$6afc20f0ff6d041;
module.exports["resizerHandleTrackClassName"] = $18d786e757e244a7$export$a5792d7e2a486d41;
module.exports["resizerHandleThumbClassName"] = $18d786e757e244a7$export$2201bc1aaee73f36;
module.exports["resizerDangerClassName"] = $18d786e757e244a7$export$97a99610b6f0a178;
module.exports["handleWrapperClass"] = $18d786e757e244a7$export$b123b2c8a2536d05;
module.exports["resizerHandleThumbWidth"] = $18d786e757e244a7$export$b5fa87f62ced4967;
module.exports["resizerHandleZIndex"] = $18d786e757e244a7$export$3d867927ebf9bc1f;

});

parcelRegister("2yr9J", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

/* Copied from type-ahead */ 
var $zT4ZO = parcelRequire("zT4ZO");





var $ks2lK = parcelRequire("ks2lK");

function $afd69cdd98cccec1$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $afd69cdd98cccec1$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        const mappedStart = start;
        const nodeNormalized = (0, $zT4ZO.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $zT4ZO.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $5SAOw.Slice).maxOpen((0, $5SAOw.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $afd69cdd98cccec1$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $ks2lK.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $afd69cdd98cccec1$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $5SAOw.Node) ? (0, $5SAOw.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(start + (fragment?.size || 0))));
};
const $afd69cdd98cccec1$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $5SAOw.Node) && node.isBlock) $afd69cdd98cccec1$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $afd69cdd98cccec1$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};


const $70ee1fe528814985$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = options.insertAt ?? tr.selection;
        if (!(node instanceof (0, $5SAOw.Node) || node instanceof (0, $5SAOw.Fragment))) return false;
        (0, $afd69cdd98cccec1$export$a6d88483216c3859)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };


const $82f437225d73d5b3$export$e8397698249f8f72 = (analyticsApi)=>({
        actions: {
            insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
                if (!state || !dispatch) return false;
                const { tr: tr } = state;
                (0, $70ee1fe528814985$export$68b1ab6a0b98c537)({
                    node: node,
                    options: options
                })(tr);
                if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                dispatch(tr);
                return true;
            }
        },
        commands: {
            insert: ({ node: node, options: options })=>({ tr: tr })=>{
                    (0, $70ee1fe528814985$export$68b1ab6a0b98c537)({
                        node: node,
                        options: options
                    })(tr);
                    if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                    return tr;
                }
        }
    });


const $de3cfc3b9e359069$export$8469b5a27995930b = ({ api: api })=>{
    const { actions: actions, commands: commands } = (0, $82f437225d73d5b3$export$e8397698249f8f72)(api?.analytics?.actions);
    return {
        name: 'contentInsertion',
        actions: actions,
        commands: commands
    };
};
module.exports["contentInsertionPlugin"] = $de3cfc3b9e359069$export$8469b5a27995930b;

});

parcelRegister("7x0qS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $5duTD = parcelRequire("5duTD");

const $756d2e4a7a125dee$var$fullWidthLabelWrapperStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $756d2e4a7a125dee$var$fullWidthLabelStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $756d2e4a7a125dee$export$46c20f09a5d207e4 = ({ layout: breakoutLayout })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        switch(breakoutLayout){
            case 'max':
                return formatMessage((0, $5duTD.messages).maxWidthLabel);
            case 'full-width':
                return formatMessage((0, $5duTD.messages).fullWidthLabel);
            case 'wide':
                return formatMessage((0, $5duTD.messages).wideWidthLabel);
            default:
                return null;
        }
    }, [
        breakoutLayout,
        formatMessage
    ]);
    return message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "resizer-breakout-mode-label",
        xcss: $756d2e4a7a125dee$var$fullWidthLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $756d2e4a7a125dee$var$fullWidthLabelStyles
    }, message));
};
module.exports["ResizerBreakoutModeLabel"] = $756d2e4a7a125dee$export$46c20f09a5d207e4;

});

parcelRegister("5DsxN", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bLhD4 = parcelRequire("bLhD4");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $dh538 = parcelRequire("dh538");





var $zT4ZO = parcelRequire("zT4ZO");


var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");

const $1f0d3cb22128de73$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
	 * This is a workaround to get rid of the typeahead text when using quick insert
	 * Once we insert *nothing*, we get a new transaction, so we can use the new selection
	 * without considering the extra text after the `/` command.
	 **/ tr = state.tr.replaceWith(start, end, (0, $5SAOw.Fragment).empty);
    tr = (0, $zT4ZO.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $1f0d3cb22128de73$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $1f0d3cb22128de73$export$718ed5cb714e84ae(state, start, end, (0, $d925B.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
function $1f0d3cb22128de73$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push(// eslint-disable-next-line require-unicode-regexp
        (0, $l03WE.createRule)(/^(\-\-\-|\*\*\*)$/, (state, _match, start, end)=>$1f0d3cb22128de73$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $l03WE.createRule)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`${(0, $14sLv.leafNodeReplacementCharacter)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $1f0d3cb22128de73$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $1f0d3cb22128de73$export$2e2bcd8739ae039 = $1f0d3cb22128de73$export$568a7ed6897c4817;


const $25833fa2bf91b712$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $1f0d3cb22128de73$export$718ed5cb714e84ae)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };







var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


function $8de4c454409556ee$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.insertRule).common, (0, $25833fa2bf91b712$export$439dcefd29ca03b3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.escape).common, ()=>true, list);
    return (0, $dus6D.keymap)(list);
}
var $8de4c454409556ee$export$2e2bcd8739ae039 = $8de4c454409556ee$export$e832373cff8dec22;


const $be38216c2eedb78a$export$7cc71f8da095a98d = ({ api: api })=>{
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $bLhD4.ruleWithLocalId) : (0, $bLhD4.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $25833fa2bf91b712$export$439dcefd29ca03b3)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>(0, $1f0d3cb22128de73$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>(0, $8de4c454409556ee$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDivider), {}),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.rule.createChecked());
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["rulePlugin"] = $be38216c2eedb78a$export$7cc71f8da095a98d;

});

parcelRegister("eeGWn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $63Ztt = parcelRequire("63Ztt");


var $d925B = parcelRequire("d925B");

var $3824I = parcelRequire("3824I");


var $d7ZU3 = parcelRequire("d7ZU3");


var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");


var $hgeg8 = parcelRequire("hgeg8");


var $4HWgE = parcelRequire("4HWgE");


var $sxTNo = parcelRequire("sxTNo");


var $gmyMu = parcelRequire("gmyMu");


var $1S4f7 = parcelRequire("1S4f7");


var $8m4tT = parcelRequire("8m4tT");


var $ks2lK = parcelRequire("ks2lK");


var $dmcsV = parcelRequire("dmcsV");


var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");

function $8066f11773850466$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $7XFGZ.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, cells);
}





const $be4cdf109bd11991$export$8dc63188bf2e0962 = new (0, $ks2lK.PluginKey)('selectingCells');
const $be4cdf109bd11991$export$9731ba46aee163cb = new (0, $ks2lK.PluginKey)('fix-tables');



var $LmqWp = parcelRequire("LmqWp");


var $jl382 = parcelRequire("jl382");


var $d1kIV = parcelRequire("d1kIV");

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function $6e94456addd84fb2$var$changedDescendants(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    // eslint-disable-next-line no-labels
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $6e94456addd84fb2$var$changedDescendants(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}
function $6e94456addd84fb2$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = $6e94456addd84fb2$export$26dfac117c7732d8(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) $6e94456addd84fb2$var$changedDescendants(oldState.doc, state.doc, 0, check);
    return tr;
}
function $6e94456addd84fb2$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $LmqWp.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $LmqWp.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $jl382.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nodes.push((0, $d1kIV.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $be4cdf109bd11991$export$9731ba46aee163cb), {
        fixTables: true
    });
}






var $iu6m9 = parcelRequire("iu6m9");







function $fc3f1737d6e568d3$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $ks2lK.NodeSelection)) role = sel.node.type.spec.tableRole;
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    if (sel instanceof (0, $ks2lK.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $7XFGZ.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $7XFGZ.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $LmqWp.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $7XFGZ.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $ks2lK.TextSelection) && $fc3f1737d6e568d3$var$isCellBoundarySelection(sel)) normalize = (0, $ks2lK.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $ks2lK.TextSelection) && (isMultiSelect ? $fc3f1737d6e568d3$var$isTextSelectionAcrossSameTableCells(sel) : $fc3f1737d6e568d3$var$isTextSelectionAcrossCells(sel))) normalize = (0, $ks2lK.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $fc3f1737d6e568d3$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return afterFrom === beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function $fc3f1737d6e568d3$var$isTextSelectionAcrossCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            fromCellBoundaryNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            toCellBoundaryNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function $fc3f1737d6e568d3$var$isTextSelectionAcrossSameTableCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    let fromCellTableNode;
    let toCellTableNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') fromCellBoundaryNode = node;
        if (node.type.name === 'table') {
            fromCellTableNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') toCellBoundaryNode = node;
        if (node.type.name === 'table') {
            toCellTableNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== undefined && toCellBoundaryNode !== undefined && fromCellBoundaryNode !== toCellBoundaryNode && toCellTableNode === fromCellTableNode && $to.parentOffset === 0;
}


// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $dus6D = parcelRequire("dus6D");


var $5SAOw = parcelRequire("5SAOw");








var $id9O1 = parcelRequire("id9O1");




var $3gZJH = parcelRequire("3gZJH");


var $bMyNT = parcelRequire("bMyNT");


const $ae1fd67c68cac0cd$export$bab59f27a7347e45 = (0, $dus6D.keydownHandler)({
    ArrowLeft: $ae1fd67c68cac0cd$var$arrow('horiz', -1),
    ArrowRight: $ae1fd67c68cac0cd$var$arrow('horiz', 1),
    ArrowUp: $ae1fd67c68cac0cd$var$arrow('vert', -1),
    ArrowDown: $ae1fd67c68cac0cd$var$arrow('vert', 1),
    'Shift-ArrowLeft': $ae1fd67c68cac0cd$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $ae1fd67c68cac0cd$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $ae1fd67c68cac0cd$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $ae1fd67c68cac0cd$var$shiftArrow('vert', 1),
    Backspace: $ae1fd67c68cac0cd$var$deleteCellSelection,
    'Mod-Backspace': $ae1fd67c68cac0cd$var$deleteCellSelection,
    Delete: $ae1fd67c68cac0cd$var$deleteCellSelection,
    'Mod-Delete': $ae1fd67c68cac0cd$var$deleteCellSelection
});
function $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $ae1fd67c68cac0cd$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $7XFGZ.CellSelection)) return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, (0, $ks2lK.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, (0, $ks2lK.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $3gZJH.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $ks2lK.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $ks2lK.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $ks2lK.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $ae1fd67c68cac0cd$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $7XFGZ.CellSelection))) {
            const end = view ? $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes(maybeTableCell?.parent?.type.name || '');
            if (!sameCell) return false;
            sel = new (0, $7XFGZ.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $3gZJH.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, new (0, $7XFGZ.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $ae1fd67c68cac0cd$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $7XFGZ.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const baseContent = (0, $d1kIV.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $5SAOw.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
function $ae1fd67c68cac0cd$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $3gZJH.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $7XFGZ.CellSelection)($cell)));
    return true;
}
function $ae1fd67c68cac0cd$export$b4a93e0b711d8f7(view, event, dragAndDropEnabled) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const startDOMCell = $ae1fd67c68cac0cd$var$domInCell(view, startEvent.target);
    const $anchor = (0, $3gZJH.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $7XFGZ.CellSelection)) {
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        const isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (dragAndDropEnabled && isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $ae1fd67c68cac0cd$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $ae1fd67c68cac0cd$var$cellUnderMouse(view, event);
        const starting = (0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) == null;
        if (!$head || !(0, $bMyNT.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $7XFGZ.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mouseup', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('dragstart', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mousemove', move);
        if ((0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962), -1));
    }
    function move(event) {
        const anchor = (0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const currDOMCell = $ae1fd67c68cac0cd$var$domInCell(view, event.target);
        const isCurrCellInsideNestedTable = $ae1fd67c68cac0cd$var$isInsideNestedTable(view, event);
        const isStartCellInsideNestedTable = $ae1fd67c68cac0cd$var$isInsideNestedTable(view, startEvent);
        const isBothCellsInSameTable = isCurrCellInsideNestedTable === isStartCellInsideNestedTable;
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if (currDOMCell !== startDOMCell && isBothCellsInSameTable) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $ae1fd67c68cac0cd$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('dragstart', stop);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mousemove', move);
    return false;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $ks2lK.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}
function $ae1fd67c68cac0cd$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $ae1fd67c68cac0cd$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $3gZJH.cellAround)(view.state.doc.resolve(mousePos.pos));
}
function $ae1fd67c68cac0cd$var$isInsideNestedTable(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return false;
    const pos = view.state.doc.resolve(mousePos.pos);
    const table = (0, $id9O1.findTableClosestToPos)(pos);
    if (!table) return false;
    const parent = view.state.doc.resolve(table.pos).parent;
    const nodeTypes = view.state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
}



function $4bda0cf32d3d9590$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, dragAndDropEnabled: dragAndDropEnabled = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $ks2lK.Plugin)({
        key: (0, $be4cdf109bd11991$export$8dc63188bf2e0962),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $8066f11773850466$export$938a078fa3e1d420),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $ae1fd67c68cac0cd$export$b4a93e0b711d8f7)(view, event, dragAndDropEnabled);
                }
            },
            createSelectionBetween (view) {
                if ((0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $ae1fd67c68cac0cd$export$f17e34274dd6fcf5,
            handleKeyDown: $ae1fd67c68cac0cd$export$bab59f27a7347e45,
            handlePaste: $dmcsV.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $fc3f1737d6e568d3$export$64b8795b15903d8d)(state, (0, $6e94456addd84fb2$export$d6d48849d9121a1)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}



var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");





var $kB2tR = parcelRequire("kB2tR");





var $24P9d = parcelRequire("24P9d");





var $1zav4 = parcelRequire("1zav4");


var $caYZ2 = parcelRequire("caYZ2");

var $3Ter7 = parcelRequire("3Ter7");





var $aFUXX = parcelRequire("aFUXX");




const $8588522c22c049a0$export$dd66abdcfb4bb2cf = 48;
const $8588522c22c049a0$export$bffd6819c009a916 = 1800;
const $8588522c22c049a0$export$8a91b25da594a758 = 4000;
const $8588522c22c049a0$export$b5e6eff3efdc4860 = 1800;
const $8588522c22c049a0$export$e8dbf55270553cd3 = 0.3;
const $8588522c22c049a0$export$2e7c88a39ad490e6 = 0.4;
const $8588522c22c049a0$export$7c8bcfa1d3f9af23 = 76;
const $8588522c22c049a0$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $8588522c22c049a0$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $8588522c22c049a0$export$c332ba2dd5aa2199 = 2 * ($8588522c22c049a0$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $8588522c22c049a0$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);



var $6fQl1 = parcelRequire("6fQl1");


















function $b61fc0745b235461$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) {
        let padding = (0, $aFUXX.akEditorGutterPaddingDynamic)();
        if (containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        })) padding = (0, $aFUXX.akEditorGutterPaddingReduced);
        return containerWidth ? Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
    }
    const calculatedTableWidth = (0, $1zav4.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $6fQl1.layoutToWidth)[tableLayout] || containerWidth;
}
function $b61fc0745b235461$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $b61fc0745b235461$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    const width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $b61fc0745b235461$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $6fQl1.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $b61fc0745b235461$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $b61fc0745b235461$export$44361276769f7eff = (table)=>{
    if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table)) // TODO: ED-26961 - is there a scenario where ADF columns are SMALLER than container width?
    return (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $b61fc0745b235461$export$a34136fcfaec1907(table);
};
const $b61fc0745b235461$export$a34136fcfaec1907 = (table)=>{
    return (0, $6fQl1.getTableContainerWidth)(table);
};
const $b61fc0745b235461$export$817f7cd897b65634 = (isCommentEditor, isChromelessEditor, isTableScalingEnabled)=>{
    const maxResizerWidthForNonCommentEditor = isTableScalingEnabled ? `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px)` : `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px)`;
    return isCommentEditor || isChromelessEditor ? '100%' : maxResizerWidthForNonCommentEditor;
};
const $b61fc0745b235461$export$708cde710ed0df70 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = (0, $6fQl1.getTableContainerWidth)(node);
    if (!node.attrs.width && (isCommentEditor || isChromelessEditor)) // width undefined would make .resizer-item width to be `auto`
    return undefined;
    return tableWidthAttribute;
};
const $b61fc0745b235461$export$7d968ec824de6aa6 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = $b61fc0745b235461$export$708cde710ed0df70(node, isCommentEditor, isChromelessEditor);
    return tableWidthAttribute ? `${tableWidthAttribute}px` : 'auto';
};
const $b61fc0745b235461$export$30421da09613cb3d = (node, isTableScalingEnabled)=>{
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(node);
    // for full page appearance
    if (isTableScalingEnabled) return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${tableWidth}px)`;
    return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${tableWidth}px)`;
};
const $b61fc0745b235461$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(table);
    const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $b61fc0745b235461$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $d7e0ca7a06057b05$export$b44a013e4f554514)(table)) {
        const tableWidth = (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $b61fc0745b235461$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};


const $d7e0ca7a06057b05$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $d7e0ca7a06057b05$var$generateColStyle = (fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, hasTableBeenResized)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const maxScaledRatio = 1 - maxScalingPercent;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // for nested tables, or chromeless editor, which used non resizable table container
    if (isNested || isChromelessEditor) {
        if (hasTableBeenResized) return `width: max(${fixedColWidth}px, ${0, $1zav4.tableCellMinWidth}px)`;
        return `width: ${0, $1zav4.tableCellMinWidth}px)`;
    }
    if (isFullPageEditor || !isFullPageEditor && isTableHasWidth) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $aFUXX.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth}px * ${maxScaledRatio}), calc(${fixedColWidth} * ${scaledPercent}), ${0, $1zav4.tableCellMinWidth}px)`;
    }
    // table resized to full-width in comment editor
    // it doesn't have a width attribute, and cols has been resized
    if (hasTableBeenResized) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $aFUXX.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth} * ${scaledPercent}), ${0, $1zav4.tableCellMinWidth}px)`;
    }
    return `width: ${0, $1zav4.tableCellMinWidth}px`;
};
const $d7e0ca7a06057b05$export$465034143db788da = (table, isCommentEditor, isChromelessEditor, isNested, isTableScalingEnabled, shouldUseIncreasedScalingPercent)=>{
    const cols = [];
    const map = (0, $LmqWp.TableMap).get(table);
    const isTableHasWidth = !!table.attrs.width;
    const isNumberColumnEnabled = table.attrs.isNumberColumnEnabled || false;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        // if the table has been resized
        if (Array.isArray(cell.attrs.colwidth)) cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
            // existing logic for calculating the width of the column
            const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(width, map.width);
            const tableWidth = isFullPageEditor || !isFullPageEditor && isTableHasWidth ? (0, $b61fc0745b235461$export$a34136fcfaec1907)(table) : (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
            if (isTableScalingEnabled) cols.push([
                'col',
                {
                    style: $d7e0ca7a06057b05$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, true)
                }
            ]);
            else cols.push([
                'col',
                {
                    style: `width: max(${fixedColWidth}px, ${(0, $1zav4.tableCellMinWidth)}px)`
                }
            ]);
        });
        else if (!isTableScalingEnabled) cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $1zav4.tableCellMinWidth)}px;`
                }
            ]));
        else // columns has not been resized, so distribute the width evenly
        cols.push(...Array.from({
            length: colspan
        }, (_)=>{
            const tableWidth = (0, $b61fc0745b235461$export$a34136fcfaec1907)(table);
            const columnWidth = tableWidth / map.width || 0;
            const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(columnWidth, map.width || 0);
            return [
                'col',
                {
                    style: $d7e0ca7a06057b05$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth)
                }
            ];
        }));
    });
    return cols;
};
const $d7e0ca7a06057b05$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentEditor)=>{
    const cols = [];
    const map = (0, $LmqWp.TableMap).get(table);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentEditor && !table.attrs?.width) scalePercent = (0, $b61fc0745b235461$export$4e884677f8e54bba)(table, tableRef);
                else scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    // existing logic for calculating the width of the column
                    const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $1zav4.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$d7e0ca7a06057b05$export$66302252070a658d(width ? Math.max(width, (0, $1zav4.tableCellMinWidth)) : (0, $1zav4.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $1zav4.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $d7e0ca7a06057b05$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let colgroup = tableRef?.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef?.removeChild(colgroup);
    colgroup = $d7e0ca7a06057b05$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
    if (shouldRemove) tableRef?.insertBefore(colgroup, tableRef?.firstChild);
    return colgroup.children;
};
const $d7e0ca7a06057b05$export$8c07f44cea64e3c7 = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return !!(0, $3Ter7.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $d7e0ca7a06057b05$export$b44a013e4f554514 = $d7e0ca7a06057b05$export$8c07f44cea64e3c7;
const $d7e0ca7a06057b05$export$2878318085bf6dbf = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cellArray = (0, $3Ter7.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $1zav4.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $d7e0ca7a06057b05$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor) {
    const rendered = (0, $5SAOw.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$d7e0ca7a06057b05$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentEditor)
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return rendered.dom;
}
const $d7e0ca7a06057b05$export$dc24345db4290451 = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    return map.width;
};
const $d7e0ca7a06057b05$export$e7ee55be67771d90 = (node)=>{
    const currentColumnCount = $d7e0ca7a06057b05$export$dc24345db4290451(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};





const $8b84c930bc26bcf8$export$2cbc54593c64b1f2 = 'align-start';
const $8b84c930bc26bcf8$export$3ea9e188ab01c845 = 'center';
const $8b84c930bc26bcf8$export$2e10df95acfe6933 = (layout)=>layout === $8b84c930bc26bcf8$export$3ea9e188ab01c845 || layout === $8b84c930bc26bcf8$export$2cbc54593c64b1f2 ? layout : $8b84c930bc26bcf8$export$3ea9e188ab01c845;
const $8b84c930bc26bcf8$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $8b84c930bc26bcf8$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $8588522c22c049a0$export$b5e6eff3efdc4860));


const $b5ee4b1040c29bb8$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $b5ee4b1040c29bb8$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) ? $b5ee4b1040c29bb8$var$leftAlignStyle : $b5ee4b1040c29bb8$var$centerAlignStyle;


const $da7b34fe5d676606$export$477bb32cbededd65 = (config)=>{
    const tableNode = config.isNestingSupported ? (0, $63Ztt.tableWithNestedTable) : (0, $63Ztt.table);
    return {
        ...tableNode,
        toDOM: (node)=>{
            const alignmentStyle = Object.entries((0, $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(v)}`).join(';');
            const tableMinWidth = (0, $d7e0ca7a06057b05$export$e7ee55be67771d90)(node);
            const isFullPageEditor = !config.isChromelessEditor && !config.isCommentEditor;
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-ssr-placeholder': `table-${node.attrs.localId}`,
                'data-ssr-placeholder-replace': `table-${node.attrs.localId}`
            };
            // This would be used for table scaling in colgroup CSS
            // cqw, or px is well supported
            const resizableTableWidth = isFullPageEditor ? (0, $b61fc0745b235461$export$30421da09613cb3d)(node, config.isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $d7e0ca7a06057b05$export$465034143db788da)(node, config.isCommentEditor, config.isChromelessEditor, config.isNested, config.isTableScalingEnabled, config.shouldUseIncreasedScalingPercent)
            ];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-wrapper'
                    },
                    [
                        'table',
                        attrs,
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ]
            ];
            if (!config.tableResizingEnabled || config.isNested) return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true',
                    style: (0, $24P9d.convertToInlineCss)({
                        '--ak-editor-table-width': resizableTableWidth
                    })
                },
                tableContainerDiv
            ];
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: (0, $24P9d.convertToInlineCss)({
                            '--ak-editor-table-gutter-padding': config.isTableScalingEnabled ? 'calc(var(--ak-editor--large-gutter-padding) * 2)' : 'calc(var(--ak-editor--large-gutter-padding) * 2 - var(--ak-editor-resizer-handle-spacing))',
                            '--ak-editor-table-width': resizableTableWidth,
                            width: `var(--ak-editor-table-width)`
                        })
                    },
                    [
                        'div',
                        {
                            class: 'resizer-item display-handle',
                            style: (0, $24P9d.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-max-width': `${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px`,
                                '--ak-editor-table-min-width': `${tableMinWidth}px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: (0, $b61fc0745b235461$export$817f7cd897b65634)(config.isCommentEditor, config.isChromelessEditor, config.isTableScalingEnabled),
                                width: (0, $b61fc0745b235461$export$7d968ec824de6aa6)(node, config.isCommentEditor, config.isChromelessEditor)
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableResizingDiv
            ];
        }
    };
};











var $a4TK8 = parcelRequire("a4TK8");





var $4vlwG = parcelRequire("4vlwG");

var $7iE7T = parcelRequire("7iE7T");

var $kTbzR = parcelRequire("kTbzR");




















const $40458289442cabaf$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };







const $88d5b76f5df04f99$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };


var $iP1et = parcelRequire("iP1et");

var $BW42l = parcelRequire("BW42l");

var $iYC9s = parcelRequire("iYC9s");

var $8usfh = parcelRequire("8usfh");

const $008a20f9f9e43ec0$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $8usfh.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};


var $kEbNW = parcelRequire("kEbNW");

var $bzgWU = parcelRequire("bzgWU");



const $e4d9ceb64529799d$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $8usfh.cloneTr)(tr);
        }
        return tr;
    };





/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json






const $8b6ac7577f3a66b8$export$1a38c7157d718094 = 30;
var $8b6ac7577f3a66b8$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    return TableDecorations;
}({});
const $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f = {
    ...(0, $1zav4.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $63Ztt.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $63Ztt.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $63Ztt.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_ROW_FLOATING_DRAG_HANDLE: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-drag-handle`,
    DRAG_COLUMN_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $63Ztt.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $63Ztt.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $63Ztt.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $63Ztt.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $63Ztt.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $63Ztt.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $63Ztt.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $63Ztt.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $63Ztt.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $63Ztt.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $63Ztt.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $63Ztt.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $63Ztt.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $63Ztt.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $63Ztt.tableCellSelector),
    TABLE_HEADER_CELL: (0, $63Ztt.tableHeaderSelector),
    TABLE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $63Ztt.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $63Ztt.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $63Ztt.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-last-row-insert-line__inactive`,
    NATIVE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-row-native-sticky`,
    NATIVE_STICKY_ACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-row-native-sticky-active`,
    NO_OVERFLOW: `${(0, $63Ztt.tablePrefixSelector)}-no-overflow`
};
var $8b6ac7577f3a66b8$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});



var $4KOFJ = parcelRequire("4KOFJ");
















/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json



const $fedf15e5199146e8$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tablePlugin');


/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $9YoeD = parcelRequire("9YoeD");





var $2pjJ5 = parcelRequire("2pjJ5");












const $e9b9e23609860f66$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableWidthPlugin');
const $e9b9e23609860f66$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, maxWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $e9b9e23609860f66$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($e9b9e23609860f66$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($e9b9e23609860f66$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = (0, $2pjJ5.isReplaceDocOperation)(transactions, oldState);
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (maxWidthEnabled) tableWidthCal = (0, $aFUXX.akEditorMaxWidthLayoutWidth);
                        else if (fullWidthEnabled) tableWidthCal = (0, $aFUXX.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $aFUXX.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $aFUXX.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $aFUXX.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: _width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $9YoeD.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916))) tr.setNodeAttribute(pos, 'width', (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2));
                        }
                    });
                });
            });
            return tr;
        }
    });
};


// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck











var $gmMgo = parcelRequire("gmMgo");


var $cUcZ5 = parcelRequire("cUcZ5");
















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $8C5kA = parcelRequire("8C5kA");





var $2CQVV = parcelRequire("2CQVV");


var $3gadb = parcelRequire("3gadb");


const $95b600cf03e08426$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage((0, $2CQVV.messages).adjustColumns),
            keymap: (0, $hgeg8.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};


const $9283ce7d62ffd391$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $9283ce7d62ffd391$export$8042b574593bd713 = (decorationSet)=>$9283ce7d62ffd391$var$filterDecorationByKey((0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED, decorationSet);
const $9283ce7d62ffd391$export$6577d2f7fe84e45c = (decorationSet)=>$9283ce7d62ffd391$var$filterDecorationByKey((0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER, decorationSet);
const $9283ce7d62ffd391$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING
        }, {
            key: (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER
        }));
const $9283ce7d62ffd391$export$ecf836094c108a0 = (cells, type, tr, isDragAndDropEnable, hoveredIndexes, danger, selected)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $id9O1.findTable)(selection);
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL
        ];
        if (danger) classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL);
        if (isDragAndDropEnable) {
            if (type === 'column' || type === 'row') {
                classes.pop();
                classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT);
            }
        } else classes.push(type === 'column' ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN : type === 'row' ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_ROW : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_TABLE);
        let key;
        switch(type){
            case 'row':
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $ftzrq.Decoration).node(pos, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $9283ce7d62ffd391$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $id9O1.findTable)(selection);
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $ftzrq.Decoration).node(pos + table.start, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + table.start + cell.nodeSize, {
            class: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED}_${index}`
        });
    });
};
const $9283ce7d62ffd391$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $ftzrq.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $9283ce7d62ffd391$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $9283ce7d62ffd391$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $9283ce7d62ffd391$var$makeArray = (n)=>Array.from(Array(n).keys());
const $9283ce7d62ffd391$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl, nodeViewPortalProviderAPI)=>{
    const emptyResult = [
        [],
        []
    ];
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table || !table.node) return emptyResult;
    const map = (0, $LmqWp.TableMap).get(table.node);
    if (!map.width) return emptyResult;
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $ftzrq.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $gmMgo.Provider), {
                    value: getIntl()
                }, (0, $42omo.createElement)((0, $95b600cf03e08426$export$e84bed3a1e3da852), {
                    startIndex: cellColumnPositioning.left,
                    endIndex: cellColumnPositioning.right,
                    includeTooltip: includeTooltip
                })), element, decorationRenderKey);
            return element;
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (node)=>{
                nodeViewPortalProviderAPI.remove(decorationRenderKey);
            }
        });
    };
    const createLastCellElementDecoration = (cellColumnPositioning, cellPos, cellNode)=>{
        let lastItemPositions;
        cellNode.forEach((childNode, offset, index)=>{
            if (index === cellNode.childCount - 1) {
                const from = offset + cellPos + 1;
                lastItemPositions = {
                    from: from,
                    to: from + childNode.nodeSize
                };
            }
        });
        if (!lastItemPositions) return null;
        return (0, $ftzrq.Decoration).node(lastItemPositions.from, lastItemPositions.to, {
            class: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).LAST_ITEM_IN_CELL
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).LAST_CELL_ELEMENT}_${cellColumnPositioning.left}_${cellColumnPositioning.right}`
        });
    };
    const resizeHandleCellDecorations = [];
    const lastCellElementsDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            const lastCellDec = createLastCellElementDecoration({
                left: startIndex,
                right: endIndex
            }, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
            lastCellElementsDecorations.push(lastCellDec);
        }
    }
    return [
        resizeHandleCellDecorations,
        lastCellElementsDecorations.filter((0, $kTbzR.nonNullable))
    ];
};
const $9283ce7d62ffd391$export$c1faae7fcf0653ce = (selection, cellColumnPositioning, isDragAndDropEnabled)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isDragAndDropEnabled ? isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE : isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE;
    const cellPositions = $9283ce7d62ffd391$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};
const $9283ce7d62ffd391$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $9283ce7d62ffd391$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};
const $9283ce7d62ffd391$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};


const $f134087c7f5a0a6e$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);


const $54e3fa1bb68d93c9$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $7XFGZ.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $54e3fa1bb68d93c9$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9283ce7d62ffd391$export$6577d2f7fe84e45c)(decorationSet));
const $54e3fa1bb68d93c9$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$54e3fa1bb68d93c9$var$isColumnSelected(tr)) return decorationSet;
    return (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)(tr), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
};
const $54e3fa1bb68d93c9$var$maybeUpdateColumnControlsDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return decorationSet;
    return (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, (0, $9283ce7d62ffd391$export$fbcaf99fd4d31ced)(tr.selection), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_DECORATIONS);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9283ce7d62ffd391$export$8042b574593bd713)(decorationSet));
const $54e3fa1bb68d93c9$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $9283ce7d62ffd391$export$8042b574593bd713)(decorationSet).length;
const $54e3fa1bb68d93c9$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$54e3fa1bb68d93c9$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $54e3fa1bb68d93c9$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr, options: options })=>{
    if (options.isDragAndDropEnabled) return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
        $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration,
        $54e3fa1bb68d93c9$var$removeControlsHoverDecoration,
        $54e3fa1bb68d93c9$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
    return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
        $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration,
        $54e3fa1bb68d93c9$var$removeControlsHoverDecoration,
        $54e3fa1bb68d93c9$var$maybeUpdateColumnSelectedDecoration,
        $54e3fa1bb68d93c9$var$maybeUpdateColumnControlsDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};


const $de8398c45f744acc$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableDecorationsPlugin');
const $de8398c45f744acc$export$968abecb43309c32 = (state)=>$de8398c45f744acc$export$18d4026d1ea86bb1.getState(state);
const $de8398c45f744acc$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    const isResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(newState)?.resizing;
    const wasResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(oldState)?.resizing;
    const { isDragAndDropEnabled: isDragAndDropEnabled = false, isInDanger: isInDanger, isTableHovered: isTableHovered } = (0, $fedf15e5199146e8$export$18d4026d1ea86bb1).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $ftzrq.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $7XFGZ.CellSelection) || changedResizing) return (0, $54e3fa1bb68d93c9$export$967c329e5e466f2)({
        decorationSet: decorationSet,
        tr: tr,
        options: {
            isDragAndDropEnabled: isDragAndDropEnabled
        }
    });
    else if (tr.selectionSet) {
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $7XFGZ.CellSelection)) return (0, $54e3fa1bb68d93c9$export$cbb3730335eda2fb)({
            decorationSet: decorationSet,
            tr: tr
        });
        // We're exiting a table with an existing decorations so we should clean it up
        if ((isInDanger || isTableHovered) && (!(0, $4KOFJ.insideTable)(newState) || (0, $id9O1.findTable)(newState.selection)?.node !== (0, $id9O1.findTable)(oldState.selection)?.node)) return (0, $54e3fa1bb68d93c9$export$967c329e5e466f2)({
            decorationSet: decorationSet,
            tr: tr,
            options: {
                isDragAndDropEnabled: isDragAndDropEnabled
            }
        });
    }
    return decorationSet;
};
const $de8398c45f744acc$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>(0, $ftzrq.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $de8398c45f744acc$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $de8398c45f744acc$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$de8398c45f744acc$export$968abecb43309c32(state)
        }
    });
};





const $8d12b05d544e83c2$var$emptyDecorations = [
    [],
    []
];
const $8d12b05d544e83c2$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, columnResizesDecorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET);
const $8d12b05d544e83c2$var$updateLastCellElement = (lastCellElementsDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, lastCellElementsDecorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).LAST_CELL_ELEMENT);
const $8d12b05d544e83c2$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = columnEndIndex < 0 ? $8d12b05d544e83c2$var$emptyDecorations : (0, $9283ce7d62ffd391$export$dab489ad285db87)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl, nodeViewPortalProviderAPI);
        return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
            $8d12b05d544e83c2$var$updateColumnResizeHandle(columnResizesDecorations),
            $8d12b05d544e83c2$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $8d12b05d544e83c2$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        const [columnResizesDecorations, lastCellElementsDecorations] = $8d12b05d544e83c2$var$emptyDecorations;
        return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
            $8d12b05d544e83c2$var$updateColumnResizeHandle(columnResizesDecorations),
            $8d12b05d544e83c2$var$updateLastCellElement(lastCellElementsDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };



var $lkJUe = parcelRequire("lkJUe");

// #region Imports

var $cCTpf = parcelRequire("cCTpf");


var $5mxQU = parcelRequire("5mxQU");







const $780923e152cc8f13$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $780923e152cc8f13$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};





const $452bdd9463f93418$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableFlexiColumnResizing');






var $aXG5V = parcelRequire("aXG5V");




const $8c756dab441d0bf4$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $8c756dab441d0bf4$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $id9O1.findTable)(selection);
    if (!nodePos) return $8c756dab441d0bf4$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $5SAOw.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $8c756dab441d0bf4$var$bail();
    const canWrap = (0, $aXG5V.findWrapping)(range, expand);
    if (canWrap === null) return $8c756dab441d0bf4$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
		 * Do we ever want to deal with the result of `findWrapping`? Probably not,
		 * but we have it anyway.
		 */ findWrappingRes: canWrap
    };
};
const $8c756dab441d0bf4$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $8c756dab441d0bf4$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
	 * TODO: add attrs: { __expanded: false } when
	 * - it is working with new collab (CEMS-1204)
	 * - synchrony is no longer used
	 *
	 *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
	 *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
	 */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};











const $bdb0299b531c40df$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $bdb0299b531c40df$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch (e) {
        return false;
    }
    return true;
};
const $bdb0299b531c40df$export$86a810659e2d575 = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $bdb0299b531c40df$export$653b4f383b39a1d0 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), $bdb0299b531c40df$export$a21ded6c12f16fdf, false);
const $bdb0299b531c40df$export$b8efdc0183f04d59 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), $bdb0299b531c40df$export$86a810659e2d575, false);
const $bdb0299b531c40df$export$101f2696d8127fe0 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $bdb0299b531c40df$export$4910020ffe58186f = (node)=>{
    return $bdb0299b531c40df$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $bdb0299b531c40df$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    const currentTableWidths = $bdb0299b531c40df$var$getTableWidths(currentTable);
    const previousTableWidths = $bdb0299b531c40df$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $bdb0299b531c40df$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $LmqWp.TableMap).get(previousTable);
    const currentMap = (0, $LmqWp.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $bdb0299b531c40df$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $LmqWp.TableMap).get(previousTable);
    const currentMap = (0, $LmqWp.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $bdb0299b531c40df$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $bdb0299b531c40df$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    const tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $bdb0299b531c40df$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const $tablePos = state.doc.resolve(tablePos);
    return $tablePos.depth > 0;
};
const $bdb0299b531c40df$export$e31912a493829c23 = (state, tablePos = 0)=>{
    return state.doc.resolve(tablePos).depth > 2;
};
const $bdb0299b531c40df$var$anyChildCellMergedAcrossRow = (node)=>(0, $3Ter7.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $bdb0299b531c40df$export$4af45fdaadf67b18 = (node)=>{
    const allHeaders = (0, $3Ter7.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    const someMerged = $bdb0299b531c40df$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};


const $50cdb605d97c868c$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $cCTpf.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $50cdb605d97c868c$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $452bdd9463f93418$export$18d4026d1ea86bb1))) return undefined;
    return resizeHandleColumnIndex;
};
const $50cdb605d97c868c$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $8m4tT.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        if (pluginState.targetCellPosition === targetCellPosition) return pluginState;
        return {
            ...pluginState,
            targetCellPosition: targetCellPosition
        };
    };
const $50cdb605d97c868c$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $5mxQU.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $780923e152cc8f13$export$af473ce758096273),
            tableNode: tableNode,
            ordering: $50cdb605d97c868c$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $50cdb605d97c868c$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(tr.selection),
            isHeaderColumnEnabled: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(tr.selection),
            isHeaderRowEnabled: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(tr.selection)
        };
    };
const $50cdb605d97c868c$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
		 * If we don't have focus, or collapse isn't allowed, or a table node doesn't
		 * exist, we don't need to waste extra checks below
		 */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $8m4tT.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $8c756dab441d0bf4$export$34840b5e3787a37c)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $50cdb605d97c868c$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) return pluginState.targetCellPosition ? {
                ...pluginState,
                targetCellPosition: undefined
            } : pluginState;
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $50cdb605d97c868c$export$a9962e3214ca2ff7 = (tr, pluginState)=>$50cdb605d97c868c$var$buildPluginState([
        $50cdb605d97c868c$var$updateTargetCellPosition,
        $50cdb605d97c868c$var$updateTableNodePluginState,
        $50cdb605d97c868c$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $id9O1.findTable)(tr.selection)
    })(pluginState);




var $d19295ed9bb2f523$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $780923e152cc8f13$export$af473ce758096273)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};


const { createPluginState: $69d6e2a2c784f306$export$656c7661095efe2e, createCommand: $69d6e2a2c784f306$export$8d4021544bdece00, getPluginState: $69d6e2a2c784f306$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), (0, $d19295ed9bb2f523$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $50cdb605d97c868c$export$a9962e3214ca2ff7),
    onSelectionChanged: (0, $50cdb605d97c868c$export$a9962e3214ca2ff7)
});

















const $04bc37fa10be064a$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;


function $d5d08c4fa562e06d$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $d5d08c4fa562e06d$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $d5d08c4fa562e06d$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $d5d08c4fa562e06d$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $d5d08c4fa562e06d$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO: ED-26961 - There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // TODO: ED-26961 - doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $04bc37fa10be064a$export$d486eb5767febcd9)(style.minWidth));
            const { width: width } = $d5d08c4fa562e06d$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $d5d08c4fa562e06d$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $d5d08c4fa562e06d$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlaskit/editor/no-as-casting
    parent = node.parentNode;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($d5d08c4fa562e06d$var$measureText(canvas, current, font), acc), 0);
    return $d5d08c4fa562e06d$var$measureText(canvas, textContent, font);
}



const $52c8652e4f6c617c$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $52c8652e4f6c617c$export$8c54458430be6d1d(cells, $52c8652e4f6c617c$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? (0, $1zav4.tableNewColumnMinWidth) : $52c8652e4f6c617c$export$8c54458430be6d1d(cells, $52c8652e4f6c617c$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $1zav4.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $52c8652e4f6c617c$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $52c8652e4f6c617c$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const col = (0, $8m4tT.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $52c8652e4f6c617c$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $52c8652e4f6c617c$export$8a19622c99267fdf = (amount, css)=>amount + (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.paddingLeft) + (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.paddingRight);
function $52c8652e4f6c617c$var$calculateColumnWidthCallback(css) {
    return (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.width);
}
function $52c8652e4f6c617c$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.width);
        const { minWidth: minContentWidth } = (0, $d5d08c4fa562e06d$export$698d25a635a3873a)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($52c8652e4f6c617c$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}




const $994471c61aed7ad3$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $994471c61aed7ad3$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = $994471c61aed7ad3$var$replaceCells(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $994471c61aed7ad3$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $994471c61aed7ad3$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $994471c61aed7ad3$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $994471c61aed7ad3$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $994471c61aed7ad3$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $994471c61aed7ad3$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = $994471c61aed7ad3$var$replaceCells(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $994471c61aed7ad3$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $aFUXX.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $aFUXX.akEditorDefaultLayoutWidth) && totalWidth < (0, $aFUXX.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $994471c61aed7ad3$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    const cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $52c8652e4f6c617c$export$43e8ce817a8e5c42)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $52c8652e4f6c617c$export$8c54458430be6d1d)(cells, (_, col)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return (0, $d5d08c4fa562e06d$export$698d25a635a3873a)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $1zav4.tableCellMinWidth));
        }
    }
    return cols;
}
// TODO: ED-26961 - move to prosemirror-utils
const $994471c61aed7ad3$var$replaceCells = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // TODO: ED-26961 - The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};






const $8f7786e61047e565$export$884c674a282996e7 = (state, decorations, key)=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(state.doc, (0, $de8398c45f744acc$export$968abecb43309c32)(state), decorations, key);


const $4ca83755c936c9c8$var$DARK_MODE_CELL_COLOR = '#1f1f21';
const $4ca83755c936c9c8$var$DARK_MODE_HEADER_COLOR = '#303134';
const $4ca83755c936c9c8$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'SET_EDITOR_FOCUS',
        data: {
            editorHasFocus: editorHasFocus
        }
    });
const $4ca83755c936c9c8$export$79b661cbf50c3490 = (ref)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $id9O1.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(state.selection),
                isHeaderRowEnabled: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(state.selection),
                isHeaderColumnEnabled: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(state.selection),
                // decoration set is drawn by the decoration plugin, skip this for DnD as all controls are floating
                decorationSet: !isDragAndDropEnabled ? (0, $8f7786e61047e565$export$884c674a282996e7)(state, (0, $9283ce7d62ffd391$export$fbcaf99fd4d31ced)(state.selection), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_DECORATIONS) : undefined,
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$c8d277469ceb354b = (name, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $7XFGZ.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $bzgWU.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter?.type, {
                    ...cell.nodeAfter?.attrs,
                    [name]: value
                }));
                return true;
            }
        }
        return false;
    };
const $4ca83755c936c9c8$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $ks2lK.TextSelection)) {
            const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $7XFGZ.CellSelection)) {
            const rect = (0, $iP1et.getSelectionRect)(selection);
            if (!(0, $bdb0299b531c40df$export$b8efdc0183f04d59)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $4ca83755c936c9c8$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$80a571fa7de8754d = (slice, schema)=>{
    // the background attr in adf should always store the light mode value of the background color
    // and tables which have been created without a background color set will have background as undefined
    // in the undefined case, when pasting from renderer, we get a background color which is the dark mode color
    // we need to convert it back to undefined, otherwise it will be interpreted as a light mode value and be inverted
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            if (maybeCell.type === tableCell && cellAttrs.background === $4ca83755c936c9c8$var$DARK_MODE_CELL_COLOR || maybeCell.type === tableHeader && cellAttrs.background === $4ca83755c936c9c8$var$DARK_MODE_HEADER_COLOR) cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $4ca83755c936c9c8$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $4ca83755c936c9c8$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $4ca83755c936c9c8$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $id9O1.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $LmqWp.TableMap).get(currentTable.node);
        const slicedMap = (0, $LmqWp.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch  {
        return undefined;
    }
};
const $4ca83755c936c9c8$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table || !type) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cell = (0, $id9O1.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $4ca83755c936c9c8$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $008a20f9f9e43ec0$export$5b4a0d6329b35552)(state.tr));
    return true;
};
const $4ca83755c936c9c8$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) return $4ca83755c936c9c8$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $4ca83755c936c9c8$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $id9O1.findTable)(tr.selection);
        const map = (0, $LmqWp.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $4ca83755c936c9c8$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $bdb0299b531c40df$export$b75dc620676872cc)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $bdb0299b531c40df$export$b75dc620676872cc)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
    ensure we're just at a top level paragraph
    otherwise, perform regular backspace behaviour
   */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $4ca83755c936c9c8$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if ((0, $BW42l.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)((0, $id9O1.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $id9O1.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                if ((0, $1oCLl.expValEquals)('platform_editor_table_cell_colour_change', 'isEnabled', true)) {
                    editorView?.focus();
                    dispatch(tr);
                } else {
                    if (cursorPos !== undefined) {
                        editorView?.focus();
                        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(cursorPos)));
                    }
                    dispatch(tr);
                }
            }
            return true;
        }
        return false;
    };
const $4ca83755c936c9c8$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const decorations = (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)((0, $kEbNW.selectColumn)(column, expand)(state.tr));
        const decorationSet = (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>(0, $kEbNW.selectColumn)(column, expand)(tr).setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard));
const $4ca83755c936c9c8$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $40458289442cabaf$export$c14b77638b178c5d)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)((0, $kEbNW.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $40458289442cabaf$export$c14b77638b178c5d)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $kEbNW.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $4ca83755c936c9c8$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        let targetCellPosition;
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $kEbNW.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $4ca83755c936c9c8$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $kEbNW.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$72433e6f15f8aeaa = (columnIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$27d9631a056c3f39 = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, nodeViewPortalProviderAPI, isKeyboardResize)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $id9O1.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(rowIndex, columnIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$31eed8673ceee613 = (nodeViewPortalProviderAPI, rowIndex, columnIndex, includeTooltip)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $id9O1.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$99c5230572e6696d = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$a590d16867e1babd)()({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $994471c61aed7ad3$export$8d491ebb055c561d)(view, node, table, basePos, opts));
    return true;
};
const $4ca83755c936c9c8$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $kTbzR.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $7iE7T.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong?.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $4ca83755c936c9c8$export$833849b68219cbcc = (widthToWidest)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const { widthToWidest: prevWidthToWidest } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $4ca83755c936c9c8$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $id9O1.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $6fQl1.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4ca83755c936c9c8$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $6fQl1.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4ca83755c936c9c8$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));


var $80e2e1780dfad522$export$4e6e4e454d4dbb37 = /*#__PURE__*/ function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
    return AnalyticPluginTypes;
}({});








const $5aef720a18b9fb47$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableAnalyticPlugin');



const $352fa929b617731a$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};


const $569fa7ec33daa007$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $352fa929b617731a$export$49d5fc8cba920a0).rowOrColumnMoved
            };
        default:
            return state;
    }
};


const { createPluginState: $feb9fc552ec5b9d2$export$656c7661095efe2e, createCommand: $feb9fc552ec5b9d2$export$8d4021544bdece00, getPluginState: $feb9fc552ec5b9d2$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), (0, $569fa7ec33daa007$export$1650419e431d3ba3));




const $e0bf7ec1b6ce132f$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $e0bf7ec1b6ce132f$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $e0bf7ec1b6ce132f$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $352fa929b617731a$export$49d5fc8cba920a0).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells || prevState.numberOfCells,
        type: nextState?.type
    };
};


const $b6ae840bbb0dbfb0$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $feb9fc552ec5b9d2$export$8d4021544bdece00)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $feb9fc552ec5b9d2$export$f05434c51e3762e)(state);
        const data = (0, $e0bf7ec1b6ce132f$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $b6ae840bbb0dbfb0$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), payload);
    };
const $b6ae840bbb0dbfb0$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $feb9fc552ec5b9d2$export$f05434c51e3762e)(state);
        const data = (0, $e0bf7ec1b6ce132f$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), payload);
    };





const $5ee9558e2724a8ab$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $1S4f7.SafePlugin)({
        key: (0, $5aef720a18b9fb47$export$18d4026d1ea86bb1),
        state: (0, $feb9fc552ec5b9d2$export$656c7661095efe2e)(dispatch, (0, $352fa929b617731a$export$49d5fc8cba920a0)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1))?.data?.currentActions?.includes('pasted'));
            if (tr) {
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        type: tr.getMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1))?.data?.type
                    }
                });
                return (0, $b6ae840bbb0dbfb0$export$39ebe85f9f5fbe7e)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $4ca83755c936c9c8$export$1798097ddb0b05de)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $4ca83755c936c9c8$export$950c7c2913136ae5)(state.selection, type)) return;
                const count = (0, $4ca83755c936c9c8$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $b6ae840bbb0dbfb0$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $4ca83755c936c9c8$export$e5b37491e59cd9d)(state.selection);
                const count = (0, $4ca83755c936c9c8$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $b6ae840bbb0dbfb0$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });


// #region Imports

var $1rJN9 = parcelRequire("1rJN9");






















var $9b9Mr = parcelRequire("9b9Mr");







const $8fbf19abc35dbd28$export$93d48be6ee61745 = (columnIndex)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $8usfh.cloneTr)((0, $9b9Mr.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex));
        }
        return tr;
    };








var $9MzzS = parcelRequire("9MzzS");












const $da196c89e6ffa52b$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        const foundCells = [];
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $da196c89e6ffa52b$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $d1kIV.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                const cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    const rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        const foundCells = $da196c89e6ffa52b$var$filterCellsInRow(i, (cell, _tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $8m4tT.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };
const $da196c89e6ffa52b$export$643f25d380b0167d = (rowIndex, clonePreviousRow)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $8usfh.cloneTr)($da196c89e6ffa52b$export$46bec710cf196d80(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $8usfh.cloneTr)((0, $9MzzS.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex));
        }
        return tr;
    };




var $2QyFu = parcelRequire("2QyFu");





/**
 * A plugin is created for collecting payload data for tableOverflowChanged analytics event
 */ 










const $92e1eed7d2f10a77$var$pluginKey = new (0, $ks2lK.PluginKey)('tableOverflowAnalyticsPlugin');
const $92e1eed7d2f10a77$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $92e1eed7d2f10a77$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $1S4f7.SafePlugin)({
        key: $92e1eed7d2f10a77$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($92e1eed7d2f10a77$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const newPluginState = $92e1eed7d2f10a77$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            const lastTriggerName = newPluginState?.lastTrigger?.name || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $3824I.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });































var $lWghV = parcelRequire("lWghV");











function $d406f1b0c5d56902$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $id9O1.findTable)(selection);
    if (table) {
        map = (0, $LmqWp.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $d406f1b0c5d56902$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $d406f1b0c5d56902$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $d406f1b0c5d56902$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI?.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $d406f1b0c5d56902$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $LmqWp.TableMap).get(props.resizedNode);
    return {
        action: (0, $3824I.TABLE_ACTION).RESIZED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(props.resizedNode) ? (0, $bdb0299b531c40df$export$4910020ffe58186f)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $d406f1b0c5d56902$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $d406f1b0c5d56902$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $d406f1b0c5d56902$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $3824I.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $d406f1b0c5d56902$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    const frameCount = (0, $42omo.useRef)(0);
    const lastTime = (0, $42omo.useRef)(0);
    const timeoutId = (0, $42omo.useRef)();
    const frameRateSamples = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};
const $d406f1b0c5d56902$var$tableContainerNodes = new Set([
    'layoutSection',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'extensionFrame',
    'table',
    'tableCell',
    'tableHeader',
    'tableRow'
]);
const $d406f1b0c5d56902$export$208d2421b73f3f86 = (editorView, editorWidth)=>{
    const tablesInfo = [];
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$d406f1b0c5d56902$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                tableWidth: table.scrollWidth,
                isNestedTable: isNestedTable,
                hasScrollbar: table.parentElement ? table?.parentElement.clientWidth < table.scrollWidth : false
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lWghV.getBreakpointKey)(editorWidth),
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            maxTableWidthBreakpoint: (0, $lWghV.getBreakpointKey)(maxTableWidth),
            tableWidthInfo: tablesInfo,
            mode: 'editor'
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
const $d406f1b0c5d56902$export$34e5b28c67455a81 = (editorView)=>{
    const tablesInfo = [];
    const editorPopupScrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
    // don't send the event if the editor scroll parent is not available
    if (!editorPopupScrollParent) return undefined;
    const editorScrollParentClientHeight = editorPopupScrollParent.clientHeight;
    const isEditorScrollable = editorPopupScrollParent.scrollHeight > editorScrollParentClientHeight;
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$d406f1b0c5d56902$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                isNestedTable: isNestedTable,
                tableHeight: table.scrollHeight
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_EDITOR_HEIGHT_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorScrollParentClientHeight: editorScrollParentClientHeight,
            isEditorScrollable: isEditorScrollable,
            maxTableToEditorHeightRatio: maxTableHeight / editorScrollParentClientHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};


























/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json







var $6fnsQ = parcelRequire("6fnsQ");


const $fbbb9ee8877c285e$export$3efa753685336605 = `var(--ds-surface, ${(0, $6fnsQ.N0)})`;
const $fbbb9ee8877c285e$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $aFUXX.akEditorTableHeaderCellBackground)})`;
const $fbbb9ee8877c285e$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $aFUXX.akEditorTableToolbar)})`;
const $fbbb9ee8877c285e$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`;
const $fbbb9ee8877c285e$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`;
const $fbbb9ee8877c285e$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`;
const $fbbb9ee8877c285e$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $aFUXX.akEditorTableCellBlanketSelected)})`;
const $fbbb9ee8877c285e$export$7c0a2e8110d12a28 = `var(--ds-background-selected-pressed, ${(0, $6fnsQ.B200)})`;
const $fbbb9ee8877c285e$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $6fnsQ.B200)})`;
const $fbbb9ee8877c285e$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $aFUXX.akEditorTableBorderSelected)})`;
const $fbbb9ee8877c285e$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $6fnsQ.N300)})`;
const $fbbb9ee8877c285e$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $6fnsQ.N20A)})`;
const $fbbb9ee8877c285e$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $aFUXX.akEditorTableCellBlanketDeleted)})`;
const $fbbb9ee8877c285e$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $6fnsQ.R400)})`;
const $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $6fnsQ.R75)})`;
const $fbbb9ee8877c285e$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $fbbb9ee8877c285e$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $6fnsQ.R300)})`;
const $fbbb9ee8877c285e$export$371da7842ff35a5b = 3;
const $fbbb9ee8877c285e$export$e5ff276883773ffd = 8;
const $fbbb9ee8877c285e$export$92421f8864c287b1 = 15;
const $fbbb9ee8877c285e$export$cbcfa4314b903419 = 2;
const $fbbb9ee8877c285e$export$6d23b13c5fcb846c = 20;
const $fbbb9ee8877c285e$export$cb376ed67c7ae37e = 16;
const $fbbb9ee8877c285e$export$52b432855099b8bd = 6;
const $fbbb9ee8877c285e$export$a4d60e31f4f6188b = (0, $aFUXX.akEditorTableToolbarSize);
const $fbbb9ee8877c285e$export$880976487022eb5 = (0, $1zav4.tableMarginTop) + $fbbb9ee8877c285e$export$e5ff276883773ffd - (0, $1zav4.tableCellBorderWidth);
const $fbbb9ee8877c285e$export$73b1242ebdcc73be = 3;
const $fbbb9ee8877c285e$export$86dfc955b6099b88 = 32;
const $fbbb9ee8877c285e$export$893fc0cfd2a0c40e = 13;
const $fbbb9ee8877c285e$export$a3e71c692f2c2213 = 4;
const $fbbb9ee8877c285e$export$62374dd2f63076b0 = 25;
const $fbbb9ee8877c285e$export$da0ccd381b1a80f = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$83da30a15600a83e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + 1;
const $fbbb9ee8877c285e$export$45aeeddcedd441ab = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$5b53cc051bf05434 = $fbbb9ee8877c285e$export$83da30a15600a83e + 1;
const $fbbb9ee8877c285e$export$cc7ed656b7dcf729 = 3;
const $fbbb9ee8877c285e$export$72409f838e9c33c7 = (0, $8b6ac7577f3a66b8$export$1a38c7157d718094) / 3;
const $fbbb9ee8877c285e$export$45d9825f76985b4e = 2;
const $fbbb9ee8877c285e$export$887c1388be90c08e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + (0, $aFUXX.akRichMediaResizeZIndex);
const $fbbb9ee8877c285e$export$3969371f057ce1e5 = 16;
const $fbbb9ee8877c285e$export$a6ed027d1a83416d = 180;
const $fbbb9ee8877c285e$export$42d9040c5091b076 = 250;
const $fbbb9ee8877c285e$export$1279af870a198fea = $fbbb9ee8877c285e$export$887c1388be90c08e + 2;
const $fbbb9ee8877c285e$export$83c60dd0aac17107 = 8;
const $fbbb9ee8877c285e$export$13b0e72269a9a3aa = 1;
const $fbbb9ee8877c285e$export$40311377f05dbfc4 = 8;
const $fbbb9ee8877c285e$export$1680d391e1ce7b96 = 32;
const $fbbb9ee8877c285e$export$3cdde837cf189e96 = 188;
const $fbbb9ee8877c285e$export$9c3151841258b6f0 = 24;
const $fbbb9ee8877c285e$export$a13fb25a398e2fab = (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 5;
const $fbbb9ee8877c285e$export$471fb2a0b2f2f936 = $fbbb9ee8877c285e$export$a13fb25a398e2fab + 1;
const $fbbb9ee8877c285e$export$7b64f35449327c05 = $fbbb9ee8877c285e$export$a13fb25a398e2fab - 1;
const $fbbb9ee8877c285e$export$b2015400488f9243 = 14;
const $fbbb9ee8877c285e$export$8f6133b6e2b4291 = 9;
const $fbbb9ee8877c285e$export$edb1b9caf8ff5b32 = 10;
const $fbbb9ee8877c285e$export$7af5c65e392a647 = 2;
const $fbbb9ee8877c285e$export$11cf30061861ec4a = 5;
const $fbbb9ee8877c285e$export$858d012f03ae70a5 = -68;
const $fbbb9ee8877c285e$export$a13bd817a2eda041 = 92;
const $fbbb9ee8877c285e$export$e0140c2b978caac5 = 4;
const $fbbb9ee8877c285e$export$c6a9e7014cf7aedc = 6;
const $fbbb9ee8877c285e$export$963fb187132ee7cf = 250;
const $fbbb9ee8877c285e$export$d18320cc8ee69115 = 16;
const $fbbb9ee8877c285e$export$6bec1f8a2aa82be8 = 150;
const $fbbb9ee8877c285e$export$c2ef52861254b274 = 14;
const $fbbb9ee8877c285e$export$2c18704a8d793cdb = 7;
const $fbbb9ee8877c285e$export$150cd2564fec30b7 = 8;


const $7eacb027e2e3fea2$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $id9O1.findTable)(selection);
    if (table) {
        const map = (0, $LmqWp.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const cellRef = (0, $8m4tT.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $7eacb027e2e3fea2$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $7eacb027e2e3fea2$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $7eacb027e2e3fea2$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $7eacb027e2e3fea2$export$d231dfb66a75f6c1 = (tr)=>{
    // get the colspans
    const rowColSpans = (0, $4vlwG.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $4vlwG.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        const domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...$7eacb027e2e3fea2$var$getRelativeDomCellWidths(cell));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $7eacb027e2e3fea2$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $7eacb027e2e3fea2$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $7eacb027e2e3fea2$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};




















const $885c1a71dd6e181b$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        const rows = tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $4vlwG.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $885c1a71dd6e181b$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $885c1a71dd6e181b$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $885c1a71dd6e181b$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $iYC9s.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $885c1a71dd6e181b$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $LmqWp.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            const cells = [];
            const fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $8m4tT.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };


const $b432f0a26e9b5b59$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
        $b432f0a26e9b5b59$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $b432f0a26e9b5b59$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $b432f0a26e9b5b59$export$3658aa65e79e3104 = (view, event)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    if (!(0, $4vlwG.containsClassName)(target, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $4vlwG.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $b432f0a26e9b5b59$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $4vlwG.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $1zav4.tableCellBorderWidth);
    table.style.marginTop = `${(0, $1zav4.tableMarginTop) + firstRowHeight}px`;
};
const $b432f0a26e9b5b59$var$applyColWidthsToStickyRow = (colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $7eacb027e2e3fea2$export$d231dfb66a75f6c1)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $b432f0a26e9b5b59$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $b432f0a26e9b5b59$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $b432f0a26e9b5b59$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $b432f0a26e9b5b59$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
    }
};



const $77650a1f6e0f1ab2$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && table.attrs?.width) {
        const scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $caYZ2.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $1zav4.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $1zav4.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !table.attrs?.width ? maxSize : (0, $6fQl1.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $52c8652e4f6c617c$export$43e8ce817a8e5c42)(index, table, start, domAtPos);
        return (0, $52c8652e4f6c617c$export$5c09bfb77c404ce)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $77650a1f6e0f1ab2$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef?.querySelectorAll(':scope > colgroup > col');
    const columnsCount = cols?.length;
    /**
     updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
     We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
     We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
     * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $d7e0ca7a06057b05$export$66302252070a658d)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $1zav4.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols?.[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols?.[i]) cols[i].style.width = `${(0, $d7e0ca7a06057b05$export$66302252070a658d)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tableRef);
};
const $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $77650a1f6e0f1ab2$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $77650a1f6e0f1ab2$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $77650a1f6e0f1ab2$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $77650a1f6e0f1ab2$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $77650a1f6e0f1ab2$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $77650a1f6e0f1ab2$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $77650a1f6e0f1ab2$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $77650a1f6e0f1ab2$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fixes total table widths by adding missing pixels to columns widths here and there
    return $77650a1f6e0f1ab2$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $77650a1f6e0f1ab2$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $77650a1f6e0f1ab2$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement?.closest('table');
    if (!tableRef) return;
    const layout = $77650a1f6e0f1ab2$var$normaliseTableLayout(tableRef?.dataset.layout);
    const maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = $77650a1f6e0f1ab2$export$38f73cf370cfaafc({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $77650a1f6e0f1ab2$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};
















const $9ca3c6b800e4b699$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $9ca3c6b800e4b699$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $77650a1f6e0f1ab2$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
const $9ca3c6b800e4b699$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $9ca3c6b800e4b699$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $77650a1f6e0f1ab2$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
function $9ca3c6b800e4b699$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $52c8652e4f6c617c$export$529a1befd331574)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $9ca3c6b800e4b699$var$ColType = /*#__PURE__*/ function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
    return ColType;
}($9ca3c6b800e4b699$var$ColType || {});
// TODO: ED-26961 - should handle when destIdx:
// - is beyond the range, and then not give it back
function $9ca3c6b800e4b699$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $52c8652e4f6c617c$export$529a1befd331574)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($9ca3c6b800e4b699$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($9ca3c6b800e4b699$var$amountFor("src")(amount) < 0 && $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $9ca3c6b800e4b699$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $9ca3c6b800e4b699$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(state);
        if (totalWidth - srcCol.width + $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $9ca3c6b800e4b699$var$stackSpace(state, destIdx, amount) {
    let candidates = $9ca3c6b800e4b699$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        const candidateIdx = $9ca3c6b800e4b699$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $52c8652e4f6c617c$export$529a1befd331574)(column) <= 0) break;
        const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $9ca3c6b800e4b699$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $52c8652e4f6c617c$export$529a1befd331574)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $9ca3c6b800e4b699$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $9ca3c6b800e4b699$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $9ca3c6b800e4b699$var$amountFor(colType)(amount);
}
function $9ca3c6b800e4b699$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $9ca3c6b800e4b699$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}





// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $0e5c6cf05dff4e80$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $6fQl1.getTableContainerWidth)(node) : (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $bdb0299b531c40df$export$4910020ffe58186f)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $6fQl1.getTableContainerWidth)(node) : (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $0e5c6cf05dff4e80$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    const newTotalWidth = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(newState);
    if (newTotalWidth > maxSize) newState = (0, $9ca3c6b800e4b699$export$827dd2d6fa38543e)(newState, newTotalWidth - maxSize);
    return (0, $77650a1f6e0f1ab2$export$b07f5f5f9c98720a)(newState, maxSize);
}
const $0e5c6cf05dff4e80$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, allowFixedColumnWidthOption = false, isCommentEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && allowFixedColumnWidthOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
    const resizeState = parentWidth ? $0e5c6cf05dff4e80$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, shouldUseIncreasedScalingPercent) : $0e5c6cf05dff4e80$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(resizeState, tableRef, node, false, 1);
};
const $0e5c6cf05dff4e80$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) resizeState = $0e5c6cf05dff4e80$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        else resizeState = $0e5c6cf05dff4e80$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(resizeState, node, start, api)(tr);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
           scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
           Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
         */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };


const $b2a65d666c2c28a8$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $LmqWp.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $aXG5V.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth === undefined ? null : updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api?.batchAttributeUpdates) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $b2a65d666c2c28a8$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement?.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $b61fc0745b235461$export$44361276769f7eff)(table.node),
                possibleMaxWidth: (0, $b61fc0745b235461$export$a34136fcfaec1907)(table.node),
                isResized: isResized
            };
            else previousTableInfo = {
                // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                /** the is the width the table can reach before overflowing */ possibleMaxWidth: tableRef?.parentElement?.clientWidth || 0,
                isResized: isResized
            };
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $LmqWp.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $1zav4.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $1zav4.tableCellMinWidth) || previousTableInfo.isResized && (0, $d7e0ca7a06057b05$export$2878318085bf6dbf)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $1zav4.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $1zav4.tableCellMinWidth),
                        minWidth: (0, $1zav4.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $b2a65d666c2c28a8$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
                minWidth: (0, $1zav4.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $0e5c6cf05dff4e80$export$5de2ae9923ce5a0)(resizeState, previousTableInfo.possibleMaxWidth);
            return $b2a65d666c2c28a8$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };





/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $be162319d9eff55e$export$1c3aefb711c3a4cc = ()=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $be162319d9eff55e$var$staticValue = false;
const $be162319d9eff55e$export$31b40729666a4ae0 = {
    setStatic (value) {
        $be162319d9eff55e$var$staticValue = value;
    },
    generate () {
        return $be162319d9eff55e$var$staticValue || $be162319d9eff55e$export$1c3aefb711c3a4cc();
    }
};


const $4efd607b0fe3314c$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $4efd607b0fe3314c$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $d1kIV.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $4efd607b0fe3314c$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $4efd607b0fe3314c$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $be162319d9eff55e$export$31b40729666a4ae0).generate(),
        width: width,
        layout: layout
    }, rows);
};






const $93be038868ed0558$var$NESTED_TABLE_DEFAULT_ROWS = 2;
const $93be038868ed0558$var$NESTED_TABLE_DEFAULT_COLS = 2;
const $93be038868ed0558$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isMaxWidthModeEnabled: isMaxWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, isNestedTable: isNestedTable, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isNestedTable) {
            attrsOverrides.rowsCount = createTableProps?.rowsCount ? createTableProps?.rowsCount : $93be038868ed0558$var$NESTED_TABLE_DEFAULT_ROWS;
            attrsOverrides.colsCount = createTableProps?.colsCount ? createTableProps?.colsCount : $93be038868ed0558$var$NESTED_TABLE_DEFAULT_COLS;
        }
        if (isTableScalingEnabled && !isCommentEditor) {
            if (((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled) attrsOverrides.tableWidth = (0, $8588522c22c049a0$export$8a91b25da594a758);
            else if (isFullWidthModeEnabled) attrsOverrides.tableWidth = (0, $8588522c22c049a0$export$bffd6819c009a916);
        }
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $4efd607b0fe3314c$export$33bbb3ec7652e187)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };



function $b53892aeb6ce63cd$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}




function $6921de1f1a31eb9c$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) return tr.step((0, $1rJN9.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $6921de1f1a31eb9c$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $8fbf19abc35dbd28$export$93d48be6ee61745)(column)(updatedTr);
            const table = (0, $id9O1.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $b2a65d666c2c28a8$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $b6ae840bbb0dbfb0$export$800a77929fdae774)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $6921de1f1a31eb9c$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $2QyFu.selectedRect)(state);
            dispatch($6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $6921de1f1a31eb9c$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $2QyFu.selectedRect)(state);
            dispatch($6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $6921de1f1a31eb9c$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            const tr = $6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr);
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $6921de1f1a31eb9c$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $885c1a71dd6e181b$export$173c92a3a1ff68a7)(state.schema)(row)(state.tr) : (0, $da196c89e6ffa52b$export$643f25d380b0167d)(row, undefined)(state.tr);
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $b6ae840bbb0dbfb0$export$800a77929fdae774)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $6921de1f1a31eb9c$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, isMaxWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $8m4tT.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $6921de1f1a31eb9c$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isMaxWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isMaxWidthModeEnabled: isMaxWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $8m4tT.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: rowsCount,
                    totalColumnCount: colsCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(newTr);
            return newTr;
        };
    };
const $6921de1f1a31eb9c$export$b57b177fe1ab7f1f = ({ isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, isFullWidthModeEnabled: isFullWidthModeEnabled = false, isMaxWidthModeEnabled: isMaxWidthModeEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, isTableResizingEnabled: isTableResizingEnabled = false, createTableProps: createTableProps = {} }, api, analyticsPayload)=>({ tr: tr })=>{
        const { schema: schema } = tr.doc.type;
        // If the cursor is inside a table
        let insertAt;
        let isNestedTable = false;
        if ((0, $8m4tT.hasParentNodeOfType)(schema.nodes.table)(tr.selection) && (0, $sxTNo.isNestedTablesSupported)(schema)) {
            // If the experiment is disabled, or we're trying to nest deeper than one level, we insert the table after the top table
            if ((0, $iu6m9.editorExperiment)('nested-tables-in-tables', false, {
                exposure: true
            }) || (0, $sxTNo.getParentOfTypeCount)(schema.nodes.table)(tr.selection.$from) > 1) {
                const positionAfterTopTable = (0, $sxTNo.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(tr.selection.$from);
                if (!positionAfterTopTable) return tr;
                insertAt = (0, $ks2lK.TextSelection).create(tr.doc, positionAfterTopTable);
            } else // Table can be nested in parent table
            isNestedTable = true;
        }
        const node = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled,
            isNestedTable: isNestedTable,
            createTableProps: createTableProps
        })(schema);
        api?.contentInsertion?.commands?.insert({
            node: node,
            options: {
                selectNodeInserted: false,
                analyticsPayload: analyticsPayload ? {
                    ...analyticsPayload,
                    attributes: {
                        ...analyticsPayload.attributes,
                        localId: node.attrs.localId
                    }
                } : undefined,
                insertAt: insertAt
            }
        })({
            tr: tr
        });
        return tr;
    };


const $46b4a5487442d4d4$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};


















var $9KolL = parcelRequire("9KolL");


var $2v1PW = parcelRequire("2v1PW");


var $51lK8 = parcelRequire("51lK8");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");











const $c2cd42e9bb213cdd$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}`) || !!(0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL}`)));
};
const $c2cd42e9bb213cdd$export$94cf9243187b20f0 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON);
const $c2cd42e9bb213cdd$export$7a8d111d40fb198c = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW) || (0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY) && (0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS}`);
const $c2cd42e9bb213cdd$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $c2cd42e9bb213cdd$export$14eb53395cc0cf57 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
const $c2cd42e9bb213cdd$export$edad492f0c70264f = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
const $c2cd42e9bb213cdd$export$4cf9002f70d2d324 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION);
const $c2cd42e9bb213cdd$export$b4f0758743701ac9 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP);
const $c2cd42e9bb213cdd$export$2b59104f44ee317b = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER);
const $c2cd42e9bb213cdd$export$b2ae534578c0ae33 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $c2cd42e9bb213cdd$export$666ae3fd07127e7f = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $c2cd42e9bb213cdd$export$571c943db7bc729c = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER);
const $c2cd42e9bb213cdd$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $c2cd42e9bb213cdd$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $c2cd42e9bb213cdd$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $4vlwG.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $c2cd42e9bb213cdd$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $c2cd42e9bb213cdd$export$449115d164fc37c3 = (element)=>{
    if (!element || element instanceof Window) return 0;
    return element?.getBoundingClientRect?.()?.top ?? 0;
};
const $c2cd42e9bb213cdd$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = cell?.parentElement ?? undefined;
    if (!Number.isFinite(row?.rowIndex) || !Number.isFinite(cell?.cellIndex)) return undefined;
    return {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        row: row.rowIndex,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        col: cell.cellIndex
    };
};
const $c2cd42e9bb213cdd$export$732358707dcc2511 = (entry)=>{
    const rects = [
        entry.boundingClientRect,
        entry.rootBounds,
        entry.intersectionRect
    ];
    return rects.every((rect)=>rect && rect.width === 0 && rect.height === 0 && rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0);
};







const $0e87c5ebb1bfe871$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $0e87c5ebb1bfe871$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $0e87c5ebb1bfe871$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $0e87c5ebb1bfe871$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $LmqWp.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $0e87c5ebb1bfe871$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $LmqWp.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $0e87c5ebb1bfe871$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $0e87c5ebb1bfe871$export$9af117e01db30223(indexes, map, type);
    };
const $0e87c5ebb1bfe871$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    const minIndex = Math.min(...indexes);
    const maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
   * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
   TODO: ED-22335 this should better called only when hover over the drag handle.
  */ const isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    const isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $0e87c5ebb1bfe871$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};


const $769dcbe1acb4060b$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};











function $53e8172627dd7927$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the 2nd cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the 2nd cell is a header then the entire row/col is a header.
    // Be carefull though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we wont be able to reliably identify header state on tables smaller the 2x2, however we can do best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, 1) is a header cell or not
    // bit: 2 = Identifies if the cell at (1, 0) is a header cell or not
    let mask = 0;
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = table.nodeAt(tableMap.map[1]);
        // If the cell at (0, 1) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}










const $c544c9e42ea52662$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(startIndex)(tr.selection);
        const firstRowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };





const $6c611051a8223ad8$export$9cb09a71b7d66923 = (array)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array[0].map((_, i)=>{
        return array.map((column)=>column[i]);
    });
};
const $6c611051a8223ad8$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $LmqWp.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};
const $6c611051a8223ad8$var$moveRowInArrayOfRows = (arrayOfNodes, indexesOrigin, indexesTarget, directionOverride)=>{
    const direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;
    const rowsExtracted = arrayOfNodes.splice(indexesOrigin[0], indexesOrigin.length);
    const positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
    let target;
    if (directionOverride === -1 && direction === 1) target = indexesTarget[0] - 1;
    else if (directionOverride === 1 && direction === -1) target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
    else target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
    // @ts-ignore no idea what this line does
    arrayOfNodes.splice.apply(arrayOfNodes, [
        target,
        0
    ].concat(rowsExtracted));
    return arrayOfNodes;
};
const $6c611051a8223ad8$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $LmqWp.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};
const $6c611051a8223ad8$export$8eeacd95914015c2 = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $6c611051a8223ad8$export$63019a088e9d8f5f(table.node);
    rows = $6c611051a8223ad8$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    return $6c611051a8223ad8$export$5c8f3870f9ad667(table.node, rows);
};
const $6c611051a8223ad8$export$18d467ff157d6daa = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $6c611051a8223ad8$export$9cb09a71b7d66923($6c611051a8223ad8$export$63019a088e9d8f5f(table.node));
    rows = $6c611051a8223ad8$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    rows = $6c611051a8223ad8$export$9cb09a71b7d66923(rows);
    return $6c611051a8223ad8$export$5c8f3870f9ad667(table.node, rows);
};
const $6c611051a8223ad8$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};





function $c6bfdfd835c0e3db$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $c6bfdfd835c0e3db$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const originalColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = $c6bfdfd835c0e3db$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $c6bfdfd835c0e3db$var$createContentNodeFactory(table);
        const newTr = (0, $8usfh.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $c6bfdfd835c0e3db$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$c6bfdfd835c0e3db$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $c6bfdfd835c0e3db$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $c6bfdfd835c0e3db$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $c6bfdfd835c0e3db$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}
















const $3ed7b5445cd344b0$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(startIndex)(tr.selection);
        const firstColumnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };






function $a69dc46ce4b17569$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $a69dc46ce4b17569$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = $a69dc46ce4b17569$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8usfh.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$a69dc46ce4b17569$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $a69dc46ce4b17569$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}















function $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : dir;
}






const $0b010a9a091e74d7$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const originalColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = (0, $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $0b010a9a091e74d7$var$createContentNodeFactory(table);
        const newTr = (0, $8usfh.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $0b010a9a091e74d7$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' || tableMap.isCellMergedTopLeft(y, actualTargetIndex) ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$0b010a9a091e74d7$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $0b010a9a091e74d7$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $0b010a9a091e74d7$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $0b010a9a091e74d7$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}




















const $9cafb746affc3203$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = (0, $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8usfh.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$9cafb746affc3203$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $9cafb746affc3203$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}





const $23a3656b396423d5$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};









const $c8432cced568eda6$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('dragAndDropPlugin');




var $0295690b8f66cf4b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $23a3656b396423d5$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};


const { createPluginState: $abc6204662f4f035$export$656c7661095efe2e, createCommand: $abc6204662f4f035$export$8d4021544bdece00, getPluginState: $abc6204662f4f035$export$f05434c51e3762e } = (0, $lkJUe.pluginFactory)((0, $c8432cced568eda6$export$18d4026d1ea86bb1), (0, $0295690b8f66cf4b$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});



// TODO: ED-26961 - This command is a placeholder example. Please replace this if required.
const $68bb38467b052d2c$var$getDecorations = (state)=>{
    return (0, $c8432cced568eda6$export$18d4026d1ea86bb1).getState(state)?.decorationSet || (0, $ftzrq.DecorationSet).empty;
};
const $68bb38467b052d2c$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(state.doc, $68bb38467b052d2c$var$getDecorations(state), decorations, key);
const $68bb38467b052d2c$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $ftzrq.DecorationSet).empty;
        if (type === 'column') decorationSet = $68bb38467b052d2c$var$updatePluginStateDecorations(state, (0, $9283ce7d62ffd391$export$6012cbb334f87faa)(index, state.selection, hasMergedCells), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $68bb38467b052d2c$var$updatePluginStateDecorations(state, (0, $9283ce7d62ffd391$export$c47f6da2c2a0ebc8)(index, state.selection, hasMergedCells), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_INSERT_LINE);
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $68bb38467b052d2c$export$e74dec9e818a8c0b = (tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (dropTargetType === (0, $23a3656b396423d5$export$9377432e002bc2da).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $68bb38467b052d2c$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $9cafb746affc3203$export$fbe24096ca2da576) : (0, $0b010a9a091e74d7$export$d1fbe0eb3fc9219);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $68bb38467b052d2c$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $68bb38467b052d2c$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $a69dc46ce4b17569$export$94fc9bbbd60f961f) : (0, $c6bfdfd835c0e3db$export$799175205f855ccd);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });






















parcelRequire("42omo");


var $5rHEx = parcelRequire("5rHEx");








var $4c0se = parcelRequire("4c0se");


var $dmsGX = parcelRequire("dmsGX");


var $iV7dk = parcelRequire("iV7dk");


var $luItc = parcelRequire("luItc");


var $6p8nb = parcelRequire("6p8nb");


var $4Ilrk = parcelRequire("4Ilrk");


var $lvYQd = parcelRequire("lvYQd");


var $batr4 = parcelRequire("batr4");


var $iBNSQ = parcelRequire("iBNSQ");


var $kDG2N = parcelRequire("kDG2N");


var $4s9K9 = parcelRequire("4s9K9");


var $HbwpQ = parcelRequire("HbwpQ");


var $krMwx = parcelRequire("krMwx");


var $gzmk4 = parcelRequire("gzmk4");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $2XqLN = parcelRequire("2XqLN");










var $aaI8u = parcelRequire("aaI8u");





var $61p3e = parcelRequire("61p3e");










var $iHzeA = parcelRequire("iHzeA");





var $hMewq = parcelRequire("hMewq");


var $fWSjz = parcelRequire("fWSjz");

const $81b7b6f3cf3366fc$var$cellBackgroundColorPalette = [];
(0, $63Ztt.tableBackgroundColorPalette).forEach((label, color)=>{
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $hMewq.default)((0, $fWSjz.default), key);
    $81b7b6f3cf3366fc$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $63Ztt.tableBackgroundBorderColor),
        message: message
    });
});
var $81b7b6f3cf3366fc$export$2e2bcd8739ae039 = $81b7b6f3cf3366fc$var$cellBackgroundColorPalette;


var $lhtyR = parcelRequire("lhtyR");




var $5GR8v = parcelRequire("5GR8v");








var $6f5RK = parcelRequire("6f5RK");






















function $92cfb9d684c33d6a$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}
function $92cfb9d684c33d6a$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        const sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $7XFGZ.CellSelection))) {
            cellNode = $92cfb9d684c33d6a$export$603245c099db0b11(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $3gZJH.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            const rect = (0, $2QyFu.selectedRect)(state);
            const tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $7XFGZ.CellSelection) && $lastCellPosition instanceof (0, $5SAOw.ResolvedPos)) {
                const cellSelection = new (0, $7XFGZ.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}





const $2d87994eabccd17d$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $d1kIV.tableNodeTypes)(state.schema);
    return (0, $92cfb9d684c33d6a$export$8c441a625fd4d770)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};



var $dxgIg = parcelRequire("dxgIg");


var $1dusJ = parcelRequire("1dusJ");


var $2MuFw = parcelRequire("2MuFw");


var $isYda = parcelRequire("isYda");


var $gKvd9 = parcelRequire("gKvd9");













// #region Imports


















const $1731f25dceb7d4d1$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $1731f25dceb7d4d1$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $LmqWp.TableMap).get(prevTableNode);
    const currentTableMap = (0, $LmqWp.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $2CQVV.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $2CQVV.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $2CQVV.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $2CQVV.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};



const $7132c436572167eb$var$makeArray = (n)=>Array.from(Array(n).keys());
const $7132c436572167eb$export$59dcdc44819c7e7c = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const mergedCellsPositions = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $id9O1.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $9283ce7d62ffd391$export$e1f7dd2d4ed6c778)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(hoveredColumns)(state.tr.selection);
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!cells) return false;
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'column', state.tr, isDragAndDropEnabled, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'row', state.tr, isDragAndDropEnabled, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const hoveredColumns = $7132c436572167eb$var$makeArray(map.width);
        const hoveredRows = $7132c436572167eb$var$makeArray(map.height);
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'table', state.tr, isDragAndDropEnabled, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$d4bebf197f3770e4 = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $7132c436572167eb$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, (0, $9283ce7d62ffd391$export$c1faae7fcf0653ce)(state.selection, cellColumnPositioning, isDragAndDropEnabled), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        };
    });
const $7132c436572167eb$export$5ad4eed96dbaffaf = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $7132c436572167eb$export$f217071b524cec4f = (hovered)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));





const $54880c895472da5f$export$fa79c3ccfdddfece = (sourceNode)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $5GR8v.removeConnectedNodes)(state, sourceNode) : tr;
    });

































// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck




var $de12874950226c67$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};


function $bd73f3b7ba9edc98$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $bd73f3b7ba9edc98$var$factory = (0, $lkJUe.pluginFactory)((0, $452bdd9463f93418$export$18d4026d1ea86bb1), (0, $de12874950226c67$export$2e2bcd8739ae039), {
    mapping: $bd73f3b7ba9edc98$var$mapping
});
const $bd73f3b7ba9edc98$export$8d4021544bdece00 = $bd73f3b7ba9edc98$var$factory.createCommand;
const $bd73f3b7ba9edc98$export$656c7661095efe2e = $bd73f3b7ba9edc98$var$factory.createPluginState;
const $bd73f3b7ba9edc98$export$f05434c51e3762e = $bd73f3b7ba9edc98$var$factory.getPluginState;




const $fab8fdccc1cad2fc$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $iYC9s.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $b432f0a26e9b5b59$export$f76d638a91295d45)(event, lastClick)) {
            const newState = (0, $77650a1f6e0f1ab2$export$aa593d179f012fe1)(resizeState);
            $fab8fdccc1cad2fc$var$setLastClick(null, (tr)=>(0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $fab8fdccc1cad2fc$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $fab8fdccc1cad2fc$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $fab8fdccc1cad2fc$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $fab8fdccc1cad2fc$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $fab8fdccc1cad2fc$export$d1301521f1f26547 = (tr)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $fab8fdccc1cad2fc$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $fab8fdccc1cad2fc$var$setLastClick = (lastClick, transform)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);





























function $c13226e4e2217284$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $7XFGZ.CellSelection)) || !$c13226e4e2217284$export$9df87bad3fce982f(tr)) return tr;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rect = (0, $iP1et.getSelectionRect)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $id9O1.findTable)(selection);
    const map = (0, $LmqWp.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $c13226e4e2217284$var$isEmptyCell(cell) ? (0, $5SAOw.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$c13226e4e2217284$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $c13226e4e2217284$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $5SAOw.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $c13226e4e2217284$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $ks2lK.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $c13226e4e2217284$export$9df87bad3fce982f(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $7XFGZ.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    if ($c13226e4e2217284$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $c13226e4e2217284$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $c13226e4e2217284$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $c13226e4e2217284$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $c13226e4e2217284$var$getEmptyColumnIndexes(table) {
    const map = (0, $LmqWp.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $c13226e4e2217284$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $LmqWp.TableMap).get(table);
    const emptyColumnIndexes = $c13226e4e2217284$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}


const $afc8bdade8a657ed$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $LmqWp.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $c13226e4e2217284$export$84575ef2cffee22a)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $afc8bdade8a657ed$var$getNextCursorPos(newTable, rowsToDelete);
        // If we delete a row we should also clean up the hover selection
        tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $afc8bdade8a657ed$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $LmqWp.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}














const $4964dcabee9819e6$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $d1kIV.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $8usfh.cloneTr)(tr);
            }
        }
        return tr;
    };






const $f49a30b111b3e46f$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $BW42l.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $4964dcabee9819e6$export$1a1df84fec87e1b5)((0, $id9O1.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $id9O1.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $4964dcabee9819e6$export$1a1df84fec87e1b5)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $ks2lK.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };



const $39aa9905e2194032$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $8c756dab441d0bf4$export$436c9f28d887a0c3)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};




























// Resize a given column by an amount from the current state


const $b475a539e4faa154$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $9ca3c6b800e4b699$export$276e2d0f37ca319a)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $9ca3c6b800e4b699$export$99e30963fc7d1a1e)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};





const $cee807f94f070ba4$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $cee807f94f070ba4$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};


const $9f1d04378e27f5e1$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos, nodeViewPortalProviderAPI)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(rowIndex, columnIndex, true, getIntl, nodeViewPortalProviderAPI)({
            tr: customTr,
            decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(customTr.doc, decorationsWithWidget, (0, $9283ce7d62ffd391$export$c1faae7fcf0653ce)(state.selection, {
            right: columnIndex
        }, isDragAndDropEnabled), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $9f1d04378e27f5e1$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $452bdd9463f93418$export$18d4026d1ea86bb1), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $9f1d04378e27f5e1$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos, nodeViewPortalProviderAPI)(state, dispatch);
        return false;
    };
const $9f1d04378e27f5e1$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $id9O1.findTableClosestToPos)($currentCell);
        const tableMap = (0, $LmqWp.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $3gZJH.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch);
            }
        }
        return false;
    };
const $9f1d04378e27f5e1$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const cell = (0, $id9O1.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $LmqWp.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell?.node.attrs;
        const width = (0, $b61fc0745b235461$export$8f862fd911e06936)(view, cell?.pos, cellAttrs);
        (0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
            minWidth: (0, $1zav4.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(state);
        const selectionRect = (0, $iP1et.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(originalTable, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        const newResizeState = (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $9f1d04378e27f5e1$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $8d12b05d544e83c2$export$a590d16867e1babd)()({
            tr: customTr,
            decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(customTr.doc, decorationWithoutWidget, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $9f1d04378e27f5e1$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };























function $eb6b76c935ecabc6$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    const mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $LmqWp.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                const mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}


const $2519da145d38150e$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: ED-26961 - After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $eb6b76c935ecabc6$export$e526e68a5eecfb66)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        const mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $1rJN9.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $2519da145d38150e$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $2519da145d38150e$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $2519da145d38150e$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $2519da145d38150e$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $2519da145d38150e$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $LmqWp.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $2519da145d38150e$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $2519da145d38150e$var$fixRowSpans(table) {
    const map = (0, $LmqWp.TableMap).get(table);
    const minRowSpans = $2519da145d38150e$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $2519da145d38150e$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $2519da145d38150e$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $2519da145d38150e$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $id9O1.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $b2a65d666c2c28a8$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };



const $e4429e273b8a2818$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $2519da145d38150e$export$9dbd3595d5638a0b)(rect, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        // If we delete a column we should also clean up the hover selection
        tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };





const $4f0e4300b954578f$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};










var $d4WtM = parcelRequire("d4WtM");















const $463dc03ee3a8d9cd$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (data && (data.name || data.title)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $463dc03ee3a8d9cd$export$53e8d4c581cfe158 = (columnIndex, order = (0, $5rHEx.SortOrder).DESC)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $BW42l.isSelectionType)(tr.selection, 'cell') ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $iP1et.getSelectionRect)(tr.selection) : (0, $id9O1.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const tableArray = (0, $6c611051a8223ad8$export$63019a088e9d8f5f)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
            getInlineCardTextFromStore: $463dc03ee3a8d9cd$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $6c611051a8223ad8$export$5c8f3870f9ad667)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $cCTpf.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos)));
    });




const $6a2616981e4f9350$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $92cfb9d684c33d6a$export$8c441a625fd4d770)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};


//#region Imports






var $2vynv = parcelRequire("2vynv");



const $4d39a5caa29eeec8$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $4d39a5caa29eeec8$export$2155c86bec6ad614 = (state, dispatch)=>(0, $2vynv.toggleHeader)('row')(state, (tr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $4d39a5caa29eeec8$export$cb41f2462444ad87 = (state, dispatch)=>(0, $2vynv.toggleHeader)('column')(state, (tr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $4d39a5caa29eeec8$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { node: node, pos: pos } = (0, $id9O1.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $4d39a5caa29eeec8$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $id9O1.findTable)(state.selection);
    if (!table) return false;
    const layout = $4d39a5caa29eeec8$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $4d39a5caa29eeec8$export$458dbe7d48b81d0a = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion


const $d9aad08b0e0e65bb$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).CLEARED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $f49a30b111b3e46f$export$5d68db27bfdddb78)(targetCellPosition));
const $d9aad08b0e0e65bb$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).MERGED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $c13226e4e2217284$export$124b0cee26577176)(state.tr));
            return true;
        });
const $d9aad08b0e0e65bb$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            const cell = (0, $id9O1.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $3824I.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $6a2616981e4f9350$export$74933b5979945879));
const $d9aad08b0e0e65bb$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).COLORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $63Ztt.tableBackgroundColorPalette).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$91116982335533cf)({
            background: cellColor
        }, editorView));
const $d9aad08b0e0e65bb$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const rect = isCellSelection ? (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $d9aad08b0e0e65bb$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $d9aad08b0e0e65bb$export$e45f3a1f9c021052 = (editorAnalyticsAPI)=>(inputMethod, options)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $6921de1f1a31eb9c$export$5a4e94bbc04b5f2)(options.index, options.moveCursorToInsertedRow));
const $d9aad08b0e0e65bb$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            return {
                action: (0, $3824I.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table?.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $9f1d04378e27f5e1$export$4627714f08bcfd8)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $d9aad08b0e0e65bb$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $6921de1f1a31eb9c$export$35ae1d3df4b27cf0)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $d9aad08b0e0e65bb$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $afc8bdade8a657ed$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $d9aad08b0e0e65bb$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $e4429e273b8a2818$export$136e266e21963ad8)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $4ca83755c936c9c8$export$e5b37491e59cd9d)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $d9aad08b0e0e65bb$export$ad9854279980efbe(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $d9aad08b0e0e65bb$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $d925B.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $d9aad08b0e0e65bb$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
    return {
        action: (0, $3824I.TABLE_ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $d9aad08b0e0e65bb$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>$d9aad08b0e0e65bb$var$getTableDeletedAnalytics(selection, (0, $d925B.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$4882f04e79ed0a80));
const $d9aad08b0e0e65bb$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>$d9aad08b0e0e65bb$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$a853c8f1dbe33b1f));
const $d9aad08b0e0e65bb$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$2155c86bec6ad614));
const $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$cb41f2462444ad87));
const $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $bdb0299b531c40df$export$101f2696d8127fe0)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$67d4f89bd3067fa2));
const $d9aad08b0e0e65bb$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $463dc03ee3a8d9cd$export$53e8d4c581cfe158)(columnIndex, sortOrder));
const $d9aad08b0e0e65bb$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(()=>{
            return {
                action: (0, $3824I.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $fab8fdccc1cad2fc$export$e8f15c4883bd4cb9)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $d9aad08b0e0e65bb$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $3824I.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $39aa9905e2194032$export$8afb7fb379a7ebd1));
const $d9aad08b0e0e65bb$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table?.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $3824I.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table?.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4f0e4300b954578f$export$6ed6a850e47b73cc)));
const $d9aad08b0e0e65bb$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, previousAlignment, inputMethod, reason)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table?.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4ca83755c936c9c8$export$e0cd4746386d78b5)(newAlignment, isCommentEditor)));
const $d9aad08b0e0e65bb$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(()=>{
            const map = (0, $LmqWp.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $3824I.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4ca83755c936c9c8$export$2880e63de92f5116)(newAlignment, tableNodeWithPos)));














/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hArLp = parcelRequire("hArLp");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $d179d7a7f1f90c15$var$containerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $d179d7a7f1f90c15$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $d179d7a7f1f90c15$var$containerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};


const $b9cb78eca8ad2cf1$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $2CQVV.messages).lockColumnWidths),
            onClick: (0, $d9aad08b0e0e65bb$export$ebf85a007abbf908)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $2CQVV.messages).headerRow),
            onClick: (0, $d9aad08b0e0e65bb$export$2e66edaa488e7a1d)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $2CQVV.messages).headerColumn),
            onClick: (0, $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $dh538.fg)('platform_editor_rename_numbered_rows_label') ? (0, $2CQVV.messages).numberedRows : (0, $2CQVV.messages).numberedColumn),
            onClick: (0, $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $2CQVV.messages).collapseTable),
            onClick: (0, $d9aad08b0e0e65bb$export$70cd1c3ffea1a5d0)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    if (state.isDragAndDropEnabled) return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($isYda))),
        title: formatMessage((0, $2CQVV.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
    else return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        title: formatMessage((0, $2CQVV.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $b9cb78eca8ad2cf1$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $2CQVV.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                const index = selectionRect?.right;
                if (index) (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $2CQVV.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                const index = selectionRect?.bottom;
                if (index) (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $2CQVV.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $b9cb78eca8ad2cf1$var$highlightColumnsHandler,
            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            onMouseOver: $b9cb78eca8ad2cf1$var$highlightColumnsHandler,
            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $2CQVV.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $b9cb78eca8ad2cf1$var$highlightRowsHandler,
            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            onMouseOver: $b9cb78eca8ad2cf1$var$highlightRowsHandler,
            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $2CQVV.messages).mergeCells),
        onClick: (0, $d9aad08b0e0e65bb$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $c13226e4e2217284$export$9df87bad3fce982f)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $2CQVV.messages).splitCell),
        onClick: (0, $d9aad08b0e0e65bb$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $2d87994eabccd17d$export$74933b5979945879)(editorState)
    });
    if (pluginState?.pluginConfig?.allowDistributeColumns) {
        let wouldChange = true; // Default to enabled - show the button.
        let newResizeStateWithAnalytics;
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled && !(0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
            newResizeStateWithAnalytics = editorView ? (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(initialSelectionRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor) : undefined;
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
        const distributeColumnWidths = (state, dispatch, view)=>{
            // When optimization is enabled, calculate on-demand when clicked
            if (isLimitedModeEnabled || (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
                if (view) {
                    const resizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(initialSelectionRect, state, view.domAtPos.bind(view), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (resizeState) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, resizeState)(state, dispatch);
                        return true;
                    }
                }
                return false;
            } else {
                // Original behavior: use pre-calculated state
                if (newResizeStateWithAnalytics) {
                    (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
                    return true;
                }
                return false;
            }
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $2CQVV.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: !wouldChange
        });
    }
    if (pluginState?.pluginConfig?.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $2CQVV.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $2CQVV.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $5rHEx.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $2CQVV.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $5rHEx.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $2CQVV.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f5RK.shortcutStyle)
        }, (0, $hgeg8.tooltip)((0, $hgeg8.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $2CQVV.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $b9cb78eca8ad2cf1$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
};
const $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $id9O1.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $LmqWp.TableMap).get(tableObject.node);
    const tableRect = new (0, $LmqWp.Rect)(0, 0, map.width, map.height);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, $BW42l.isSelectionType)(selection, 'cell') ? (0, $iP1et.getSelectionRect)(selection) : tableRect;
};
// Memoize the expensive DOM queries (querySelector, closestElement) separately
// Cache key is the parent DOM node reference - stays same when typing in same cell
const $b9cb78eca8ad2cf1$var$getTableWrapperFromParentImpl = (parent)=>{
    if (!parent) return undefined;
    // These are the expensive DOM operations
    const tableRef = // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    parent.querySelector('table') || undefined;
    if (!tableRef) return undefined;
    return (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
};
// Create memoized version ONCE - reused across all calls
const $b9cb78eca8ad2cf1$var$getMemoizedTableWrapperFromParent = (0, $2XqLN.default)($b9cb78eca8ad2cf1$var$getTableWrapperFromParentImpl);
const $b9cb78eca8ad2cf1$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $id9O1.findTable)(state.selection);
            const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const resizeState = (0, $452bdd9463f93418$export$18d4026d1ea86bb1).getState(state);
            const tableWidthState = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(state);
            const isTableScalingEnabled = options?.isTableScalingEnabled || false;
            const nodeType = state.schema.nodes.table;
            const toolbarTitle = 'Table floating controls';
            const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                let isDragHandleMenuOpened = false;
                let isTableRowOrColumnDragged = false;
                if (options?.dragAndDropEnabled) {
                    const { isDragMenuOpen: isDragMenuOpen = false, isDragging: isDragging = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
                    isDragHandleMenuOpened = isDragMenuOpen;
                    isTableRowOrColumnDragged = isDragging;
                }
                const isTableOrColumnResizing = !!(resizeState?.dragging || tableWidthState?.resizing);
                const isTableMenuOpened = pluginState.isContextualMenuOpen || isDragHandleMenuOpened;
                const isTableState = isTableRowOrColumnDragged || isTableOrColumnResizing || isTableMenuOpened;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Note: when focus is in codeblocks, pluginState.editorHasFocus is false, so the codeblocks toolbar
                // won't be suppressed.
                const shouldSuppressAllToolbars = isTableState && pluginState.editorHasFocus && !isViewMode;
                if (shouldSuppressAllToolbars) return {
                    title: toolbarTitle,
                    items: [],
                    nodeType: nodeType
                };
            }
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState?.resizing;
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing) {
                const isNested = pluginState.tablePos && (0, $bdb0299b531c40df$export$d4302a800316ebd6)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? (editorView)=>{
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $8m4tT.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    return $b9cb78eca8ad2cf1$var$getMemoizedTableWrapperFromParent(parent);
                } : (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $8m4tT.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) {
                        const tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                        if (tableRef) element = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
                    }
                    return element;
                };
                const menu = $b9cb78eca8ad2cf1$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = config.allowTableAlignment && !isNested ? $b9cb78eca8ad2cf1$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, options?.fullWidthEnabled, options?.isCommentEditor) : [];
                const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                const cellItems = pluginState.isDragAndDropEnabled ? [] : $b9cb78eca8ad2cf1$var$getCellItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, options?.isCommentEditor, isLimitedModeEnabled);
                const columnSettingsItems = pluginState.isDragAndDropEnabled ? $b9cb78eca8ad2cf1$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options?.isCommentEditor, isLimitedModeEnabled) : [];
                const colorPicker = !areAnyNewToolbarFlagsEnabled ? $b9cb78eca8ad2cf1$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView) : [];
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $5GR8v.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $2CQVV.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $2CQVV.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $5GR8v.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $5GR8v.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $2CQVV.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$b9cb78eca8ad2cf1$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                const deleteButton = {
                    id: 'editor.table.delete',
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    onClick: (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI),
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(true),
                    onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(true),
                    onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                    onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                    title: intl.formatMessage((0, $61p3e.default).remove),
                    focusEditoronEnter: true,
                    confirmDialog: confirmDialog
                };
                const copyButton = {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(false, true),
                            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                            onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(false, true),
                            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)()
                        }
                    ]
                };
                const isNestedTable = (0, $sxTNo.isNestedTablesSupported)(state.schema) && (0, $sxTNo.isSelectionTableNestedInTable)(state);
                const hoverTableProps = (isInDanger, isSelected)=>({
                        onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(isInDanger, isSelected),
                        onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                        onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(isInDanger, isSelected),
                        onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)()
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const overflowDropdownTestId = 'table-overflow-dropdown-trigger';
                const extensionState = api?.extension?.sharedState?.currentState();
                const extensionApi = api?.extension?.actions.api();
                return {
                    title: toolbarTitle,
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $b9cb78eca8ad2cf1$var$separator(menu.hidden)
                        ] : [],
                        ...alignmentMenu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $b9cb78eca8ad2cf1$var$separator(alignmentMenu.length === 0)
                        ] : [],
                        ...cellItems,
                        ...columnSettingsItems,
                        ...colorPicker,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            {
                                type: 'extensions-placeholder',
                                separator: 'end'
                            },
                            copyButton,
                            {
                                type: 'separator'
                            },
                            deleteButton
                        ] : [
                            areAnyNewToolbarFlagsEnabled && {
                                type: 'separator',
                                fullHeight: true
                            },
                            {
                                type: 'overflow-dropdown',
                                testId: overflowDropdownTestId,
                                dropdownWidth: 220,
                                options: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        render: (editorView, dropdownOptions)=>{
                                            if (!editorView) return null;
                                            if (!extensionApi || !extensionState?.extensionProvider) return null;
                                            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aaI8u.DropdownMenuExtensionItems), {
                                                node: tableObject.node,
                                                editorView: editorView,
                                                extension: {
                                                    extensionProvider: extensionState?.extensionProvider ? Promise.resolve(extensionState.extensionProvider) : undefined,
                                                    extensionApi: extensionApi
                                                },
                                                dropdownOptions: dropdownOptions,
                                                disabled: (key)=>{
                                                    return isNestedTable && [
                                                        'referentiality:connections',
                                                        'chart:insert-chart'
                                                    ].includes(key);
                                                },
                                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                                            });
                                        }
                                    },
                                    ...extensionApi && extensionState?.extensionProvider && !areAnyNewToolbarFlagsEnabled ? [
                                        {
                                            type: 'separator'
                                        }
                                    ] : [],
                                    {
                                        title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                                        onClick: ()=>{
                                            api?.core?.actions.execute(// @ts-ignore
                                            api?.floatingToolbar?.commands.copyNode(nodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                                            return true;
                                        },
                                        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                                            label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                                        }),
                                        ...hoverTableProps(false, true)
                                    },
                                    {
                                        title: intl.formatMessage((0, $61p3e.default).delete),
                                        onClick: (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI),
                                        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                                            label: intl.formatMessage((0, $61p3e.default).delete)
                                        }),
                                        ...hoverTableProps(true),
                                        confirmDialog: confirmDialog
                                    }
                                ]
                            }
                        ]
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $b9cb78eca8ad2cf1$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $b9cb78eca8ad2cf1$var$getCellItems = (state, view, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const initialSelectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (initialSelectionRect) {
        const cellOptions = $b9cb78eca8ad2cf1$export$99943093c6d7192b(state, view, initialSelectionRect, {
            formatMessage: formatMessage
        }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isLimitedModeEnabled);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            cellOptions,
            $b9cb78eca8ad2cf1$var$separator(cellOptions.hidden)
        ];
    }
    return [];
};
const $b9cb78eca8ad2cf1$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $b9cb78eca8ad2cf1$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorState);
    const items = [];
    let wouldChange = true; // Default to enabled - show the button.
    let newResizeStateWithAnalytics;
    if ((0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
        if (!editorView) return [];
    } else {
        const selectionOrTableRect = $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect(editorState);
        if (!selectionOrTableRect || !editorView) return [];
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled) {
            newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionOrTableRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
    }
    if (pluginState?.pluginConfig?.allowDistributeColumns && pluginState.isDragAndDropEnabled) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $2CQVV.messages).distributeColumns),
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                spacing: 'spacious',
                label: ''
            }),
        onClick: (state, dispatch, view)=>$b9cb78eca8ad2cf1$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: !wouldChange
    });
    if (items.length !== 0 && !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) items.push({
        type: 'separator'
    });
    return items;
};
const $b9cb78eca8ad2cf1$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = node?.attrs?.background || '#ffffff';
    const defaultPalette = (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039).find((item)=>item.value === currentBackground) || {
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'Custom',
        value: currentBackground,
        border: (0, $lhtyR.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $2CQVV.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            defaultValue: defaultPalette,
            options: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
            returnEscToButton: true,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: (option)=>(0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $b9cb78eca8ad2cf1$var$separator(menu.hidden)
    ];
};
const $b9cb78eca8ad2cf1$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI)(state, dispatch);
        else (0, $54880c895472da5f$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };
const $b9cb78eca8ad2cf1$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $b9cb78eca8ad2cf1$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $b9cb78eca8ad2cf1$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $id9O1.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dusJ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-start-icon"
                })
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dxgIg))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-center-icon"
                })
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $2CQVV.messages).alignTableCenter,
        'align-start': (0, $2CQVV.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        const shouldDisableLayoutOption = (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? $b9cb78eca8ad2cf1$var$getMemoizedIsLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView !== null, shouldUseIncreasedScalingPercent, isFullWidthEditor) : $b9cb78eca8ad2cf1$var$isLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor);
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(currentLayout) === value,
            onClick: (0, $d9aad08b0e0e65bb$export$5d8dfbdf832abbae)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $d925B.INPUT_METHOD).FLOATING_TB, (0, $3824I.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...shouldDisableLayoutOption && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d179d7a7f1f90c15$export$a6e8f537af71668f), {
                alignmentButtons: alignmentButtons,
                ...props,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 74,
        height: 32
    };
    const selectedAlignmentIcon = $b9cb78eca8ad2cf1$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $2CQVV.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon?.icon
        }
    ];
    return alignmentToolbarItem;
};
const $b9cb78eca8ad2cf1$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(selectedAlignment));
};
const $b9cb78eca8ad2cf1$var$isLayoutOptionDisabledImpl = (selectedNode, getEditorContainerWidth, hasEditorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (hasEditorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $b61fc0745b235461$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};
const $b9cb78eca8ad2cf1$var$getMemoizedIsLayoutOptionDisabled = (0, $2XqLN.default)($b9cb78eca8ad2cf1$var$isLayoutOptionDisabledImpl, ([prevNode, ...prevRest], [nextNode, ...nextRest])=>{
    // Only node needs special comparison (attrs only), rest use reference equality
    const nodeEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevNode.attrs, nextNode.attrs);
    const restEqual = prevRest.every((val, idx)=>val === nextRest[idx]);
    return nodeEqual && restEqual;
});
const $b9cb78eca8ad2cf1$var$isLayoutOptionDisabled = (selectedNode, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (editorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $b61fc0745b235461$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};








const $95cc14ff7c35ef77$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect) : (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect);
    const targetIndex = $95cc14ff7c35ef77$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $0e87c5ebb1bfe871$export$7ef37f297601e698)(targetIndex, selection) : (0, $0e87c5ebb1bfe871$export$834c4ba4fe64e8f2)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $95cc14ff7c35ef77$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
    if (rect) {
        const selectedColIndexes = (0, $cee807f94f070ba4$export$915a77877be361e9)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $95cc14ff7c35ef77$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $95cc14ff7c35ef77$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, ariaNotifyPlugin, isCommentEditor = false, isColumnSortingEnabled = true)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG2N))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4s9K9))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($luItc))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p8nb))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addColumnAfter)
        }
    ];
    const isNewKeymapExperiment = (0, $1oCLl.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzmk4))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveRowUp) : (0, $hgeg8.moveRowUpOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-row', -1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($krMwx))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveRowDown) : (0, $hgeg8.moveRowDownOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-row', 1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lvYQd))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveColumnLeft) : (0, $hgeg8.moveColumnLeftOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-column', -1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($batr4))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveColumnRight) : (0, $hgeg8.moveColumnRightOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-column', 1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $5rHEx.SortOrder).ASC,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c0se))), {
                    spacing: 'spacious',
                    label: ''
                })
        },
        {
            label: 'decreasing',
            order: (0, $5rHEx.SortOrder).DESC,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                    spacing: 'spacious',
                    label: ''
                })
        }
    ] : [];
    const sortConfigs = [
        ...sortOptions.map(({ label: label, order: order, icon: icon })=>({
                id: `sort_column_${order}`,
                title: `Sort ${label}`,
                disabled: hasMergedCellsInTable,
                icon: icon,
                onClick: (state, dispatch)=>{
                    (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                    return true;
                }
            }))
    ];
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $hgeg8.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$95cc14ff7c35ef77$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
                if (selectionRect) {
                    const newResizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                    spacing: 'spacious',
                    label: ''
                })
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.tooltip)((0, $hgeg8.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $95cc14ff7c35ef77$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $95cc14ff7c35ef77$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: direction === 'row' ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($HbwpQ))), {
                    spacing: 'spacious',
                    label: ''
                }) : ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ilrk))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: direction === 'row' ? (0, $hgeg8.tooltip)((0, $hgeg8.deleteRow)) : (0, $hgeg8.tooltip)((0, $hgeg8.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (_state, _dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $66674519b4a32446$export$137f4de350aca2d8)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getOriginIndexes(selectionRect), // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $hgeg8.tooltip)(keymap)
            }))
    ];
    const allConfigs = [
        ...restConfigs
    ];
    if (isColumnSortingEnabled && (0, $dh538.fg)('platform_editor_enable_table_dnd') || !(0, $dh538.fg)('platform_editor_enable_table_dnd')) allConfigs.unshift(...sortConfigs);
    return allConfigs.filter(Boolean);
};





const $66674519b4a32446$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).MOVED_ROW : (0, $3824I.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes?.length ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)(tr)(state, dispatch);
            return true;
        });
    };
const $66674519b4a32446$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).MOVED_ROW : (0, $3824I.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $3824I.TABLE_STATUS).CANCELLED : (0, $3824I.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $68bb38467b052d2c$export$1326c72b3102f66d)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $d925B.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $2CQVV.messages).rowMovedDown : (0, $2CQVV.messages).rowMovedUp : direction > 0 ? (0, $2CQVV.messages).columnMovedRight : (0, $2CQVV.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $66674519b4a32446$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const selectionRect = isCellSelection ? (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect) : (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            if (!(0, $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $95cc14ff7c35ef77$export$79db8995cf046b43)(selectedIndexes, direction);
            return $66674519b4a32446$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $d925B.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $66674519b4a32446$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).CLONED_ROW : (0, $3824I.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $3824I.TABLE_STATUS).CANCELLED : (0, $3824I.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$88277f1015e99c8a)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };
const $66674519b4a32446$export$ade80ff7f1fbb779 = (editorAnalyticsAPI)=>(isDragMenuOpen, direction, index, trigger = 'mouse')=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
            if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return undefined;
            let updatedMenuOpenState;
            if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
            else // menu open but menu direction changed, means user clicked on drag handle of different row/column
            // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
            // 2 scenarios above , menu should remain open.
            if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
            else updatedMenuOpenState = !previousOpenState;
            if (updatedMenuOpenState) // We only want to fire analytics when the menu is opened
            return {
                action: (0, $3824I.TABLE_ACTION).DRAG_MENU_OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: trigger === 'keyboard' ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE,
                    direction: direction ?? previousDragMenuDirection ?? 'column'
                }
            };
            return undefined;
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$8a902a12acc69924)(isDragMenuOpen, direction, index, trigger)(state, dispatch);
            return true;
        });
    };






var $2WHHL = parcelRequire("2WHHL");







const $af1654059f589843$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    const isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};


const $5d9f70a2f60147a3$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $2WHHL.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $af1654059f589843$export$b95259a1f587c41)(location.current.input)
    };
};


const $58c44b411bfbf733$var$destroyFn = (editorView, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableDragAndDrop');
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                // 'null' will remove the inline style
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $51lK8.autoScrollForElements)({
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $bSjaC.combine)(...rowAutoScrollers, (0, $4T4vf.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === tableNode?.attrs.localId;
        },
        onDragStart: ()=>{
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableDragAndDrop');
            (0, $68bb38467b052d2c$export$8a902a12acc69924)(false)(editorView.state, editorView.dispatch);
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
        },
        onDrag (event) {
            const data = (0, $5d9f70a2f60147a3$export$6d440138302b6316)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: ED-26961 - as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $23a3656b396423d5$export$9377432e002bc2da).ROW : (0, $23a3656b396423d5$export$9377432e002bc2da).COLUMN;
            const hasMergedCells = (0, $0e87c5ebb1bfe871$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $68bb38467b052d2c$export$a54c991ec4a21b4a)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
        },
        onDrop (event) {
            const data = (0, $5d9f70a2f60147a3$export$6d440138302b6316)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const cell = (0, $c2cd42e9bb213cdd$export$fe489db90f7f492a)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: cell?.row ?? hoveredCell.rowIndex,
                        colIndex: cell?.col ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), action);
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging') api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                if (event?.source?.data?.type === 'table-row' || event?.source?.data?.type === 'table-column') return (0, $66674519b4a32446$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, event.source.data?.indexes, (0, $3824I.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                return (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $0e87c5ebb1bfe871$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $23a3656b396423d5$export$9377432e002bc2da).ROW : (0, $23a3656b396423d5$export$9377432e002bc2da).COLUMN)(editorView.state.selection)) {
                (0, $66674519b4a32446$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $3824I.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                return;
            }
            requestAnimationFrame(()=>{
                if (behaviour === 'clone') (0, $66674519b4a32446$export$e432b518ff8f345a)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $66674519b4a32446$export$137f4de350aca2d8)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
            });
        }
    }));
};
const $58c44b411bfbf733$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, api)=>{
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $abc6204662f4f035$export$656c7661095efe2e)(dispatch, ()=>({
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                dropTargetType: (0, $23a3656b396423d5$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $c8432cced568eda6$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(dragMenuIndex)(tr.selection);
                        // TODO: ED-20673 - check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $7XFGZ.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $c8432cced568eda6$export$18d4026d1ea86bb1), action);
                         // else NOP
                    } else return tr.setMeta((0, $c8432cced568eda6$export$18d4026d1ea86bb1), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $58c44b411bfbf733$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
				 * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
				 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
				 */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9KolL.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((event.target || null)?.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};









const $c80e8922e1b59353$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('editorContentAreaHeightPlugin');
const $c80e8922e1b59353$export$4d09e1a8cc78d53 = 1200;
const $c80e8922e1b59353$export$e591924e2463f32f = '.ak-editor-content-area-region';
const $c80e8922e1b59353$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $c80e8922e1b59353$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    height: $c80e8922e1b59353$export$4d09e1a8cc78d53
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($c80e8922e1b59353$export$18d4026d1ea86bb1);
                if (meta) return {
                    ...pluginState,
                    ...meta
                };
                return pluginState;
            }
        },
        view: (view)=>{
            const editorContentAreaEl = view.dom.closest($c80e8922e1b59353$export$e591924e2463f32f);
            let resizeObserver;
            if (editorContentAreaEl) {
                resizeObserver = new ResizeObserver((entries)=>{
                    for (const entry of entries){
                        const height = entry.contentRect.height;
                        const tr = view.state.tr.setMeta($c80e8922e1b59353$export$18d4026d1ea86bb1, {
                            height: height,
                            isObserved: true
                        });
                        view.dispatch(tr);
                    }
                });
                resizeObserver.observe(editorContentAreaEl);
            }
            return {
                destroy () {
                    resizeObserver?.disconnect();
                }
            };
        }
    });












var $astHL = parcelRequire("astHL");


































function $8948cb1031c9ee31$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $8948cb1031c9ee31$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $bMyNT.isInTable)(state)) return false;
        const cellSelection = (0, $bzgWU.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $8948cb1031c9ee31$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).between($cell, $8948cb1031c9ee31$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $8948cb1031c9ee31$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        let table = $cell.node(-1);
        // table is the parent table, not the nested table
        if ($cell.node(-4) && $cell.node(-4).type.name === 'table') table = $cell.node(-4);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}







const $2408f65fb4ff5ac9$var$TAB_FORWARD_DIRECTION = 1;
const $2408f65fb4ff5ac9$var$TAB_BACKWARD_DIRECTION = -1;
const $2408f65fb4ff5ac9$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state)?.isKeyboardResize;
            if (isColumnResizing) {
                (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $LmqWp.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $8m4tT.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // When tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $2408f65fb4ff5ac9$var$TAB_BACKWARD_DIRECTION) {
                (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // When tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $2408f65fb4ff5ac9$var$TAB_FORWARD_DIRECTION) {
                (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $8948cb1031c9ee31$export$78a7cb7971e0752d)(direction)(state, dispatch);
            return true;
        };
const $2408f65fb4ff5ac9$export$24bf4ae22c7b6454 = (direction)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const nestedTableSelection = (0, $sxTNo.isSelectionTableNestedInTable)(state);
        if (!(selection instanceof (0, $ks2lK.NodeSelection)) && !nestedTableSelection) return false; // Let ProseMirror handle other selection types
        let table = (0, $id9O1.findTable)(selection);
        let cell = (0, $id9O1.findCellClosestToPos)(state.doc.resolve(selection.from));
        let selectionPos = selection.from;
        // Handle when we have nested table fully selected
        if (table && nestedTableSelection && (0, $iYC9s.isTableSelected)(selection)) {
            const parentTablePos = table.pos;
            table = (0, $id9O1.findTableClosestToPos)(state.doc.resolve(parentTablePos));
            cell = (0, $id9O1.findCellClosestToPos)(state.doc.resolve(parentTablePos));
            selectionPos = parentTablePos;
        }
        if (!table || !cell || !cell.pos) return false;
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        // Let ProseMirror handle movement within the cell if content exists above/below
        if ($2408f65fb4ff5ac9$var$cellHasContentInDirection(cell.node, cell.pos, selectionPos, direction)) return false;
        // Move to the next cell vertically
        const map = (0, $LmqWp.TableMap).get(table.node);
        const nextCellPos = map.nextCell(cell.pos - table.start, 'vert', direction);
        if (dispatch && nextCellPos) {
            const nextCellStart = table.start + nextCellPos;
            const $nextCell = state.doc.resolve(nextCellStart);
            if ($nextCell.nodeAfter?.type && [
                tableCell,
                tableHeader
            ].includes($nextCell.nodeAfter?.type)) {
                const contentPos = $2408f65fb4ff5ac9$var$getTargetPositionInNextCell($nextCell.nodeAfter, nextCellStart, direction);
                dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, contentPos)));
                return true;
            }
            return false;
        }
        return false; // No next cell found
    };
function $2408f65fb4ff5ac9$var$cellHasContentInDirection(cellNode, cellPos, selectionPos, direction) {
    let hasContent = false;
    cellNode.content.forEach((node, offset)=>{
        const nodeStart = cellPos + 1 + offset;
        const nodeEnd = nodeStart + node.nodeSize;
        if (direction === 1 && nodeStart > selectionPos && node.isBlock) hasContent = true; // Content below
        else if (direction === -1 && nodeEnd <= selectionPos && node.isBlock) hasContent = true; // Content above
    });
    return hasContent;
}
function $2408f65fb4ff5ac9$var$getTargetPositionInNextCell(cellNode, nextCellStart, direction) {
    let contentPos = nextCellStart + 1; // Default: just inside the cell
    if (cellNode.content.size > 0) {
        if (direction === 1) {
            const firstChild = cellNode.firstChild;
            if (firstChild && firstChild.isBlock) contentPos = nextCellStart + 1 + (firstChild.isLeaf ? 0 : 1); // Down: Start of first block
        } else if (direction === -1) {
            let lastBlock;
            let lastOffset = 0;
            cellNode.content.forEach((node, offset)=>{
                if (node.isBlock) {
                    lastBlock = node;
                    lastOffset = offset;
                }
            });
            if (lastBlock) contentPos = nextCellStart + 1 + lastOffset + (lastBlock.isLeaf ? 0 : lastBlock.nodeSize - 1);
        }
    }
    return contentPos;
}






function $7b84646b01762248$export$e832373cff8dec22(getEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.nextCell).common, (0, $2408f65fb4ff5ac9$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.previousCell).common, (0, $2408f65fb4ff5ac9$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleTable).common, (0, $gmyMu.editorCommandToPMCommand)((0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
        isTableScalingEnabled: isTableScalingEnabled,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: !!isFullWidthEnabled,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableResizingEnabled: isTableResizingEnabled
    }, api, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (0, $astHL.chainCommands)((0, $d9aad08b0e0e65bb$export$253ebd9c41cefd54)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.backspace).common, (0, $4ca83755c936c9c8$export$f49961c90342f4db), list);
    // Add row/column shortcuts
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowBefore).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowAfter).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnBefore).common, (0, $6921de1f1a31eb9c$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnAfter).common, (0, $6921de1f1a31eb9c$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowBeforeVO).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowAfterVO).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnBeforeVO).common, (0, $6921de1f1a31eb9c$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnAfterVO).common, (0, $6921de1f1a31eb9c$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if (dragAndDropEnabled && (0, $hgeg8.moveRowDown).common && (0, $hgeg8.moveRowUp).common && (0, $hgeg8.moveColumnLeft).common && (0, $hgeg8.moveColumnRight).common) {
        const isNewKeyMapExperiment = (0, $1oCLl.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
        // Move row/column shortcuts
        /**
     * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
     * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
     * to make sure the logic for holding the shortcut keys is valid
     * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
     */ (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveRowDown).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveRowDownOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveRowUp).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveRowUpOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveColumnLeft).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveColumnLeftOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveColumnRight).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveColumnRightOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.deleteColumn).common, (0, $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.deleteRow).common, (0, $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.startColumnResizing).common, (0, $9f1d04378e27f5e1$export$833f46f974daec36)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (0, $9f1d04378e27f5e1$export$44cde2b92e1bbc4a)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (0, $9f1d04378e27f5e1$export$44cde2b92e1bbc4a)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (0, $2408f65fb4ff5ac9$export$24bf4ae22c7b6454)(1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (0, $2408f65fb4ff5ac9$export$24bf4ae22c7b6454)(-1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.decreaseMediaSize).common, (0, $d9aad08b0e0e65bb$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $d925B.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.increaseMediaSize).common, (0, $d9aad08b0e0e65bb$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $d925B.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.escape).common, (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.focusToContextMenuTrigger).common, (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(), list);
    return (0, $dus6D.keymap)(list);
}
var $7b84646b01762248$export$2e2bcd8739ae039 = $7b84646b01762248$export$e832373cff8dec22;


















var $igNsz = parcelRequire("igNsz");

var $hcbpx = parcelRequire("hcbpx");

var $edTnG = parcelRequire("edTnG");




























const $425e1bfad150b07f$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --anchor');
    return false;
});
const $425e1bfad150b07f$export$2ee7329d46115d8f = (isDragAndDropEnabled)=>{
    const safariVersion = (0, $d7ZU3.getBrowserInfo)().safari_version;
    const isBrowserSafari = !Number.isNaN(safariVersion);
    return(// Safari has a bug with position: sticky and content editable, so we don't support it
    !isBrowserSafari && $425e1bfad150b07f$export$2073a24f9367a16f() && isDragAndDropEnabled);
};





parcelRequire("42omo");





var $2gkmX = parcelRequire("2gkmX");


























parcelRequire("42omo");














var $2daQU = parcelRequire("2daQU");


var $2P8Ax = parcelRequire("2P8Ax");








var $h3X17 = parcelRequire("h3X17");





var $92LVN = parcelRequire("92LVN");






























var $jtbk8 = parcelRequire("jtbk8");


var $h9dtK = parcelRequire("h9dtK");


var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $1PEak = parcelRequire("1PEak");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");


var $8e8VQ = parcelRequire("8e8VQ");


var $lFBSq = parcelRequire("lFBSq");

function $1c290c738b99c876$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $1c290c738b99c876$export$b220adcde0a1c5fd = {
    top: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};


// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $4a66a924dc2ff4b9$var$getSpacingFromProvided(value) {
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
function $4a66a924dc2ff4b9$var$getHitboxSpacing(provided) {
    return {
        top: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forTopEdge),
        right: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forRightEdge),
        bottom: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forBottomEdge),
        left: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forLeftEdge)
    };
}
function $4a66a924dc2ff4b9$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $4a66a924dc2ff4b9$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $ajYex.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $1c290c738b99c876$export$b220adcde0a1c5fd)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
			 * Intentionally _not_ doing an explicit check to
			 * see if `client` is with within the `overElementHitbox`.
			 *
			 * **Why?**
			 *
			 * 1. 🥱 Redundant
			 * This check is already achieved by `element.contains(underUsersPointer)`
			 *
			 * 2. 📐 Overlap on boundaries
			 * Two elements can share the same `{x,y}` points on shared edges.
			 * It's not clear which of the two will be picked by
			 * `const underUsersPointer = document.elementFromPoint(x,y)`
			 * The edge of an "outside" element, can have shared `{x,y}`
			 * values along the edge of an "inside element".
			 * So when `underUsersPointer` is the "outer" element, the `client`
			 * point might actually be also within the "inner" element.
			 * We are exclusively relying on `underUsersPointer` make the decision
			 * on what we are "over" so we should not be doing "over element" hitbox
			 * testing here.
			 * https://twitter.com/alexandereardon/status/1721758766507638996
			 *
			 *
			 * 3. 🐞 Chrome bug
			 * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
			 * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
			 * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
			 */ if ((0, $6UNNA.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $6UNNA.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $1PEak.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $eIOs5.isAxisAllowed)((0, $ajYex.edgeAxisLookup)[value.edge], allowedAxis) && (0, $hhm38.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}


function $4e0224677ef5d1d3$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $4a66a924dc2ff4b9$export$6cfa6dfe6898b98f)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}


function $896fd387f906313a$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $4e0224677ef5d1d3$export$10dd8807a40dbd8b)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}


const $c48213aba266fe77$var$api = (0, $896fd387f906313a$export$b8fa21320a811083)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $c48213aba266fe77$export$b6fc2123c6c7faac = $c48213aba266fe77$var$api.unsafeOverflowAutoScroll;



const $f69a5020d7054d5c$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $51lK8.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            }
        }),
        (0, $c48213aba266fe77$export$b6fc2123c6c7faac)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            },
            getOverflow: ()=>({
                    forTopEdge: {
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        right: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        left: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    },
                    forRightEdge: {
                        right: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        bottom: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    },
                    forLeftEdge: {
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        left: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        bottom: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    }
                })
        })
    ];
};





const $1562ea854f0ae047$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('stickyHeadersPlugin');


const $894c3bb16e3b70ec$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};



























































const $f10f08824d624bfc$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $f10f08824d624bfc$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $f10f08824d624bfc$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $f10f08824d624bfc$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $f10f08824d624bfc$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $f10f08824d624bfc$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $d7ZU3.browser).ie_version !== 11 && !$f10f08824d624bfc$var$isFocusingCalendar(event) && !$f10f08824d624bfc$var$isFocusingModal(event) && !$f10f08824d624bfc$var$isFocusingFloatingToolbar(event) && !$f10f08824d624bfc$var$isFocusingDragHandles(event) && !$f10f08824d624bfc$var$isFocusingDragHandlesClickableZone(event)) (0, $4ca83755c936c9c8$export$f516ed9c5f43abfc)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $f10f08824d624bfc$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $4ca83755c936c9c8$export$f516ed9c5f43abfc)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $f10f08824d624bfc$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $id9O1.findTable)(view.state.selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    if (event instanceof MouseEvent && (0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(element)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const [startIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    !(0, $kTbzR.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $LmqWp.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const colElement = (0, $4vlwG.closestElement)(element, 'td') || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $4vlwG.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $kTbzR.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $kTbzR.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $f10f08824d624bfc$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if ((0, $c2cd42e9bb213cdd$export$7a8d111d40fb198c)(target)) {
        const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        const positionRow = (0, $c2cd42e9bb213cdd$export$3bf5911758d564a4)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $4ca83755c936c9c8$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
    }
    if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(target)) {
        const [startIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $7132c436572167eb$export$4cf548f2efac0afe)([
            startIndex
        ], false)(state, dispatch);
    }
    const isNestedTable = (0, $sxTNo.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1;
    if (isNestedTable) {
        // if the table is nested inside a table, we only call hideInsertColumnOrRowButton if the table nearest to the mouse target is NOT the parent table
        const nearestTable = (0, $4vlwG.closestElement)(target, 'table');
        const nestedTable = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.doc.resolve(state.selection.from), [
            state.schema.nodes.table
        ]);
        const parentTable = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.doc.resolve(nestedTable?.pos || 0), [
            state.schema.nodes.table
        ]);
        if (nearestTable?.dataset.tableLocalId !== parentTable?.node.attrs.localId && ((0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(target) || (0, $c2cd42e9bb213cdd$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch);
    } else if (((0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(target) || (0, $c2cd42e9bb213cdd$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch);
    if ((0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(target)) {
        const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        return (0, $7132c436572167eb$export$9b72d13d82d16e72)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $7132c436572167eb$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $f10f08824d624bfc$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $LmqWp.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $4ca83755c936c9c8$export$72433e6f15f8aeaa)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $f10f08824d624bfc$export$b4a93e0b711d8f7 = (_, event)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $c2cd42e9bb213cdd$export$2b59104f44ee317b)(event.target) || (0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(event.target) || (0, $c2cd42e9bb213cdd$export$edad492f0c70264f)(event.target) || (0, $c2cd42e9bb213cdd$export$571c943db7bc729c)(event.target)));
    if (isControl) event.preventDefault();
    return isControl;
};
const $f10f08824d624bfc$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(target) && !(0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $7132c436572167eb$export$5ad4eed96dbaffaf)()(state, dispatch);
    }
    return false;
};
const $f10f08824d624bfc$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (!isTableHovered) return (0, $7132c436572167eb$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $f10f08824d624bfc$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isDragAndDropEnabled: isDragAndDropEnabled, isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (isTableHovered) {
        if (isDragAndDropEnabled) {
            const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
            !isDragMenuOpen && (0, $7132c436572167eb$export$f217071b524cec4f)(false)(state, dispatch);
        } else (0, $7132c436572167eb$export$f217071b524cec4f)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$f10f08824d624bfc$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $c2cd42e9bb213cdd$export$b4f0758743701ac9)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $f10f08824d624bfc$var$handleMouseMoveDebounce = (nodeViewPortalProviderAPI)=>(0, $2P8Ax.default)((view, event, offsetX)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        const element = event.target;
        if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(element) || (0, $c2cd42e9bb213cdd$export$666ae3fd07127e7f)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
            const positionColumn = (0, $c2cd42e9bb213cdd$export$3dde6150a2e2df0a)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
            if (positionColumn !== insertColumnButtonIndex) return (0, $4ca83755c936c9c8$export$72433e6f15f8aeaa)(positionColumn)(state, dispatch);
        }
        if ((0, $c2cd42e9bb213cdd$export$edad492f0c70264f)(element) || (0, $c2cd42e9bb213cdd$export$b2ae534578c0ae33)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertRowButtonIndex: insertRowButtonIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
            const positionRow = (0, $c2cd42e9bb213cdd$export$3bf5911758d564a4)(event) === 'bottom' ? endIndex : startIndex;
            if (positionRow !== insertRowButtonIndex) return (0, $4ca83755c936c9c8$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
        }
        if (!(0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(element) && (0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(element)) {
            const positionColumn = (0, $c2cd42e9bb213cdd$export$3dde6150a2e2df0a)(event, offsetX, (0, $8b6ac7577f3a66b8$export$1a38c7157d718094));
            if (positionColumn !== null) {
                const { state: state, dispatch: dispatch } = view;
                const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                const isKeyboardResize = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state).isKeyboardResize;
                const tableCell = (0, $4vlwG.closestElement)(element, 'td, th');
                const cellStartPosition = view.posAtDOM(tableCell, 0);
                const rect = (0, $id9O1.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
                if (rect) {
                    const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                    const rowIndexTarget = rect.top;
                    if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $c2cd42e9bb213cdd$export$80e4fcc9d7220616)({
                        target: element,
                        columnEndIndexTarget: columnEndIndexTarget
                    })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                    ) return (0, $4ca83755c936c9c8$export$cc6f44d67305c400)(rowIndexTarget, columnEndIndexTarget, true, nodeViewPortalProviderAPI)(state, dispatch);
                }
            }
        }
        return false;
    });
const $f10f08824d624bfc$export$3248c033e90a4ba0 = (nodeViewPortalProviderAPI)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
        // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
        // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
        // in the deferred callback handler.
        // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
        $f10f08824d624bfc$var$handleMouseMoveDebounce(nodeViewPortalProviderAPI)(view, event, (0, $d7ZU3.browser).gecko ? event.offsetX : NaN);
        return false;
    };
function $f10f08824d624bfc$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $3gZJH.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $ks2lK.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $ks2lK.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $ks2lK.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $f10f08824d624bfc$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $7XFGZ.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $7XFGZ.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            const rect = (0, $iP1et.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).CUT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $008a20f9f9e43ec0$export$5b4a0d6329b35552)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(newState);
                        tr = (0, $afc8bdade8a657ed$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $2519da145d38150e$export$9dbd3595d5638a0b)(rect, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $f10f08824d624bfc$export$42d5d9cc7457d81e = (view)=>{
    return !!(0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state)?.tableNode && !(0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(view.state)?.dragging;
};
const $f10f08824d624bfc$export$82a75cb550f27e28 = (eventHandler, pluginInjectionApi)=>(view, mouseEvent)=>{
        if (!$f10f08824d624bfc$export$42d5d9cc7457d81e(view)) return false;
        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        /**
   * Table cannot be in focus if we are in view mode.
   * This will prevent an infinite flow of adding and removing
   * resize handle decorations in view mode that causes unpredictable
   * selections.
   */ if (isViewMode) return false;
        return eventHandler(view, mouseEvent);
    };
const $f10f08824d624bfc$var$trackCellLocation = (view, mouseEvent)=>{
    const target = mouseEvent.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const maybeTableCell = (0, $kTbzR.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const tableElement = (0, $4vlwG.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement?.dataset?.tableLocalId && tableElement.dataset.tableLocalId !== tableNode?.attrs.localId) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $4vlwG.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const tableMap = tableNode && (0, $LmqWp.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $7eacb027e2e3fea2$export$b53a50910add7502)(htmlColIndex, htmlRowIndex, tableMap);
        colIndex = (0, $7eacb027e2e3fea2$export$ffa56ed053ef832e)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $7132c436572167eb$export$1d614a0f0fe37c44)(htmlRowIndex, colIndex)(view.state, view.dispatch);
};
const $f10f08824d624bfc$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state).isDragAndDropEnabled && (0, $abc6204662f4f035$export$f05434c51e3762e)(view.state) && !(0, $abc6204662f4f035$export$f05434c51e3762e)(view.state).isDragging) $f10f08824d624bfc$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };



















/* eslint-disable @atlaskit/design-system/prefer-primitives */ 

























/* eslint-disable @atlaskit/design-system/no-html-button */ 









var $jTxSS = parcelRequire("jTxSS");






















var $afUmf = parcelRequire("afUmf");











parcelRequire("42omo");









parcelRequire("42omo");

const $a906c61be8f1260e$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "9",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "13",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "17",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                stroke: "var(--ds-border-inverse, #FFFFFF)",
                strokeWidth: "2"
            })
        ]
    });


const $0478538aa7e68e3c$var$boxStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    backgroundColor: 'color.blanket.selected'
});
const $0478538aa7e68e3c$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    const marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    const marginTop = direction === 'row' ? height / 2 - 14 : -10;
    const transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0478538aa7e68e3c$var$boxStyles,
        style: {
            width: `${width}px`,
            height: `${height}px`
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a906c61be8f1260e$export$227151c7eab30def), {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `${marginLeft}px`,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: `${marginTop}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                transform: transform
            }
        })
    });
};





parcelRequire("42omo");




parcelRequire("42omo");

const $2c3f7bd5b3179fae$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "7",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "11",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "15",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $ff4957c8f89fc920$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                })
            })
        ]
    });





parcelRequire("42omo");


const $5f4c29316e84f6e9$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED,
            width: "24",
            height: "5",
            rx: "3"
        })
    });


const $8b9780e38922bcca$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2c3f7bd5b3179fae$export$b005cb3a0f2a5647), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ff4957c8f89fc920$export$7d3bc85820ac4455), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5f4c29316e84f6e9$export$e32dc8bb64018ca1), {});
};


const $7c8b405b164adf54$var$DragHandleComponent = ({ isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage } })=>{
    const dragHandleDivRef = (0, $42omo.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $42omo.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    const hasMergedCells = (0, $42omo.useMemo)(()=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table?.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $ks2lK.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $0e87c5ebb1bfe871$export$1d4a5608e72f1096)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $0e87c5ebb1bfe871$export$1d4a5608e72f1096)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $42omo.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        if (dragHandleDivRefCurrent) return (0, $4T4vf.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $afUmf.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if (browser.safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                type: "button",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
                "data-testid": "table-drag-handle-clickable-zone-button",
                style: {
                    height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $fbbb9ee8877c285e$export$d18320cc8ee69115}px)` : `${"var(--ds-space-200, 16px)"}`,
                    // 16px here because it's the size of drag handle button's large side
                    width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
                     : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $fbbb9ee8877c285e$export$d18320cc8ee69115}px)`,
                    left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
                    bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
                    alignSelf: isColumn ? 'none' : 'center',
                    zIndex: isColumn ? '-1' : 'auto',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    pointerEvents: 'auto'
                },
                onMouseUp: (e)=>{
                    // should toggle menu if current drag menu open.
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                "aria-label": formatMessage((0, $2CQVV.messages).dragHandleZone)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                type: "button",
                id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
                    [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED]: hasMergedCells
                }),
                ref: dragHandleDivRef,
                style: {
                    transform: isColumn ? 'none' : 'rotate(90deg)',
                    alignSelf: isColumn ? 'none' : 'center'
                },
                "data-testid": "table-drag-handle-button",
                "aria-label": formatMessage(isRow ? (0, $2CQVV.messages).rowDragHandle : (0, $2CQVV.messages).columnDragHandle),
                "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
                "aria-haspopup": "menu",
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseOver: (e)=>{
                    setIsHovered(true);
                    onMouseOver && onMouseOver(e);
                },
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseOut: (e)=>{
                    setIsHovered(false);
                    onMouseOut && onMouseOut(e);
                },
                onMouseUp: (e)=>{
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') toggleDragMenu && toggleDragMenu('keyboard');
                },
                children: appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
                browser.gecko ? // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8b9780e38922bcca$export$8749e1cb5c52435f), {
                    ...handleIconProps
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        pointerEvents: 'none'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8b9780e38922bcca$export$8749e1cb5c52435f), {
                        ...handleIconProps
                    })
                }) : null
            }),
            previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $l998X.jsx)((0, $0478538aa7e68e3c$export$905ab40ac2179daa), {
                direction: direction,
                width: previewWidth,
                height: previewHeight
            }), previewContainer)
        ]
    });
};
const $7c8b405b164adf54$export$a0c24614540b0efb = (0, $gmMgo.default)($7c8b405b164adf54$var$DragHandleComponent);


const $e85fd443bde152fa$var$getSelectedColumns = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection) && selection.isColSelection()) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $cee807f94f070ba4$export$915a77877be361e9)(rect);
    }
    return [];
};
const $e85fd443bde152fa$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $42omo.useRef)(null);
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const widths = colWidths?.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ') ?? '0px';
    // TODO: ED-26961 - reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(colWidths ?? []);
    const colIndex = hoveredCell?.colIndex;
    const selectedColIndexes = $e85fd443bde152fa$var$getSelectedColumns(selection || editorView.state.selection);
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = 45;
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $42omo.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $4ca83755c936c9c8$export$41a42e79fbe56d35)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $42omo.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $7132c436572167eb$export$4cf548f2efac0afe)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $42omo.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $7132c436572167eb$export$1d614a0f0fe37c44)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $42omo.useCallback)((trigger, event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (event?.shiftKey) return;
        (0, $66674519b4a32446$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex,
        api?.analytics?.actions
    ]);
    const colIndexes = (0, $42omo.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = getScrollOffset?.() ?? 0;
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = rowHeights?.reduce((sum, cur)=>sum + cur, 0) ?? 0;
        const previewWidth = colWidths?.reduce((sum, v, i)=>sum + (v ?? (0, $1zav4.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0) ?? (0, $1zav4.tableCellMinWidth);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            contentEditable: false,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative'
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : selectedColIndexes[0]}-drag-handle`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7c8b405b164adf54$export$a0c24614540b0efb), {
                isDragMenuTarget: !isHover,
                direction: "column",
                tableLocalId: localId || '',
                indexes: indexes,
                hoveredCell: hoveredCell,
                previewWidth: previewWidth,
                forceDefaultHandle: !isHover,
                previewHeight: previewHeight,
                appearance: appearance,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = selectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > selectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedColIndexes[0] + 1} / span ${selectedColIndexes.length}`, selectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !selectedColIndexes.includes(colIndex)) handles.push(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            ref: columnControlsRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridTemplateColumns: widths,
                marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginTop,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                width: stickyTop ? containerWidth : undefined,
                overflowX: stickyTop ? 'hidden' : 'visible',
                pointerEvents: isDragging ? 'none' : undefined
            },
            children: [
                columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            gridColumn: `${startIndex + 1} / span 1`
                        },
                        "data-start-index": startIndex,
                        "data-end-index": endIndex,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
                        contentEditable: false,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: columnParams.length - 1 === index ? {
                                right: '0'
                            } : {}
                        })
                    }, index)),
                columnHandles()
            ]
        })
    });
};






















const $d471513cc0a7aea8$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $af1654059f589843$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};


const $f70703bd6e177feb$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${getScrollOffset?.() ?? 0}px`;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls-drop-targets",
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d471513cc0a7aea8$export$e8a325e09c5453d5), {
                    index: index,
                    localId: localId,
                    width: width,
                    height: tableHeight,
                    marginTop: 0
                }, index);
            })
        })
    });
};


const $fc03cc481fa1e1aa$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor, isDragAndDropEnabled: isDragAndDropEnabled })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node?.attrs.localId;
    const hasHeaderColumn = (0, $bdb0299b531c40df$export$a21ded6c12f16fdf)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $42omo.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(editorView);
    if (stickyTop) {
        const columnControlTopOffsetFromParent = '-12px';
        containerRef?.current?.style.setProperty('top', columnControlTopOffsetFromParent);
    } else containerRef?.current?.style.removeProperty('top');
    let anchorStyles = {};
    if ((0, $425e1bfad150b07f$export$2ee7329d46115d8f)(isDragAndDropEnabled ?? false) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        const rowAnchorName = tableRef.querySelector('tr')?.style.getPropertyValue('anchor-name');
        // cast here is due to CSSProperties missing valid positionAnchor property
        anchorStyles = {
            /* We need to default to checking the anchor style because there may be a conflict with the block controls
       plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
       */ positionAnchor: rowAnchorName === '' ? tableRef.querySelector('tr')?.dataset.nodeAnchor : rowAnchorName
        };
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper",
        // anchor name is determined dynamically so can't use static styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: anchorStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e85fd443bde152fa$export$a71b12ee0b179860), {
                editorView: editorView,
                hoveredCell: hoveredCell,
                tableRef: tableRef,
                tableActive: tableActive,
                isTableHovered: isTableHovered,
                stickyTop: tableActive ? stickyTop : undefined,
                localId: currentNodeLocalId,
                isInDanger: isInDanger,
                rowHeights: rowHeights,
                colWidths: colWidths,
                hasHeaderColumn: hasHeaderColumn,
                tableContainerWidth: tableContainerWidth,
                isNumberColumnEnabled: isNumberColumnEnabled,
                isDragging: isDragging,
                getScrollOffset: getScrollOffset,
                api: api
            }),
            isDragging && /*#__PURE__*/ (0, $l998X.jsx)((0, $f70703bd6e177feb$export$9878f6beafc50edd), {
                tableRef: tableRef,
                isHeaderSticky: stickyHeader?.sticky && hasHeaderRow,
                tableHeight: tableWrapperHeight,
                localId: currentNodeLocalId,
                colWidths: colWidths,
                getScrollOffset: getScrollOffset
            })
        ]
    });
};
var $fc03cc481fa1e1aa$export$2e2bcd8739ae039 = $fc03cc481fa1e1aa$var$TableFloatingColumnControls;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















































const $c3edf387a25033c9$var$DragCornerControlsComponent = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage } })=>{
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $42omo.useMemo)(()=>{
        const { selection: selection } = editorView.state;
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        return (0, $iYC9s.isTableSelected)(selection);
    }, [
        editorView.state
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseOut: handleMouseOut,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $c3edf387a25033c9$var$DragCornerControlsComponentWithSelection = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $42omo.useMemo)(()=>{
        if (!selection) return;
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        return (0, $iYC9s.isTableSelected)(selection);
    }, [
        selection
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseOut: handleMouseOut,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $c3edf387a25033c9$export$2e06061cfdb64df2 = (0, $gmMgo.default)($c3edf387a25033c9$var$DragCornerControlsComponentWithSelection);
const $c3edf387a25033c9$export$2beb96b6455e9966 = (0, $gmMgo.default)($c3edf387a25033c9$var$DragCornerControlsComponent);





parcelRequire("42omo");































// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, @typescript-eslint/no-explicit-any
class $8c2dcccfe6a575f9$var$CornerControlComponent extends (0, $42omo.Component) {
    render() {
        const { isInDanger: isInDanger, tableRef: tableRef, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, intl: { formatMessage: formatMessage } } = this.props;
        if (!tableRef) return null;
        const isActive = this.isActive();
        return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, {
                active: isActive,
                sticky: this.props.stickyTop !== undefined
            }),
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: this.props.stickyTop !== undefined ? `0px` : undefined
            },
            contentEditable: false,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("button", {
                    "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
                    type: "button",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, {
                        danger: isActive && isInDanger
                    }),
                    onClick: this.selectTable,
                    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                    onMouseOver: this.hoverTable,
                    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                    onMouseOut: this.clearHoverSelection
                }),
                !isHeaderRowEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                    })
                }),
                !isHeaderColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_COLUMN_MARKER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.isActive = ()=>{
            const { editorView: editorView, hoveredRows: hoveredRows, isResizing: isResizing } = this.props;
            const { selection: selection } = editorView.state;
            const table = (0, $id9O1.findTable)(selection);
            if (!table) return false;
            return (0, $iYC9s.isTableSelected)(selection) || hoveredRows && hoveredRows.length === (0, $LmqWp.TableMap).get(table.node).height && !isResizing;
        };
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.selectTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
        };
        this.hoverTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$41c571b711ba06e)()(state, dispatch);
        };
    }
}
const $8c2dcccfe6a575f9$export$c4e380678531b264 = (0, $gmMgo.default)($8c2dcccfe6a575f9$var$CornerControlComponent);


















// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2720990bf6054318$var$RowControlsComponent extends (0, $42omo.Component) {
    render() {
        const { editorView: editorView, tableRef: tableRef, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, selection: selectionState } = this.props;
        if (!tableRef) return null;
        const { selection: selection } = editorView.state;
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        const rowsParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(rowHeights);
        const firstRow = tableRef.querySelector('tr');
        const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_INNER,
                children: rowsParams.map(({ startIndex: startIndex, endIndex: endIndex, height: height }, index)=>{
                    // if previous row was header row, add its height to our margin
                    let marginTop = -1;
                    if (index === 1 && hasHeaderRow && this.props.stickyTop !== undefined) marginTop += rowHeights[index - 1] + (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b);
                    const thisRowSticky = this.props.stickyTop !== undefined && index === 0 && hasHeaderRow;
                    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP} ${(0, $885c1a71dd6e181b$export$8969ab96fc5961ae)(startIndex, selectionState || selection, hoveredRows, isInDanger, isResizing)} ${thisRowSticky ? 'sticky' : ''}`,
                        style: {
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            height: height,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            marginTop: `${marginTop}px`,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            top: thisRowSticky ? `3px` : undefined,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            paddingTop: thisRowSticky ? `${(0, $fbbb9ee8877c285e$export$880976487022eb5) - 2}px` : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                                "aria-label": formatMessage((0, $2CQVV.messages).rowControl),
                                type: "button",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON}`,
                                onClick: (event)=>this.props.selectRow(startIndex, event.shiftKey),
                                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                                onMouseOver: ()=>this.props.hoverRows([
                                        startIndex
                                    ]),
                                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                                onMouseOut: this.clearHoverSelection,
                                "data-start-index": startIndex,
                                "data-end-index": endIndex
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                            })
                        ]
                    }, startIndex);
                })
            })
        }));
    }
    constructor(...args){
        super(...args);
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
    }
}
const $2720990bf6054318$export$bd67b796ee9987b2 = (0, $gmMgo.default)($2720990bf6054318$var$RowControlsComponent);


const $a72f571dbc5509cd$export$4017f69d73e46bd1 = ({ editorView: editorView, tableRef: tableRef, isInDanger: isInDanger, isResizing: isResizing, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, hoveredRows: hoveredRows, stickyTop: stickyTop, hoverRows: hoverRows, selectRow: selectRow, tableActive: tableActive, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8c2dcccfe6a575f9$export$c4e380678531b264), {
                editorView: editorView,
                tableRef: tableRef,
                isInDanger: isInDanger,
                isResizing: isResizing,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                hoveredRows: hoveredRows,
                stickyTop: tableActive ? stickyTop : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2720990bf6054318$export$bd67b796ee9987b2), {
                selection: selection,
                editorView: editorView,
                tableRef: tableRef,
                hoverRows: hoverRows,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isResizing: isResizing,
                selectRow: selectRow,
                stickyTop: tableActive ? stickyTop : undefined
            })
        ]
    });
};












var $eTj7Y = parcelRequire("eTj7Y");











class $b09bdd4510c4ed50$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        if ((0, $eTj7Y.isSSR)()) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'hidden' // Ensure the column is not visible during SSR
            },
            contentEditable: false
        });
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'visible'
            },
            contentEditable: false,
            children: rowHeights.map((rowHeight, index)=>isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index, true),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                    onMouseOver: ()=>updateCellHoverLocation(index),
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`) : // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    onClick: (event)=>this.selectRow(index, event),
                    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                    onMouseOver: ()=>this.hoverRows(index),
                    // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                    onMouseOut: this.clearHoverSelection,
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`))
        });
    }
    constructor(...args){
        super(...args);
        this.hoverRows = (index)=>{
            return this.props.tableActive ? this.props.hoverRows([
                index
            ]) : null;
        };
        this.selectRow = (index, event)=>{
            const { tableActive: tableActive, editorView: editorView, selectRow: selectRow } = this.props;
            // If selection is outside the table then first reset the selection inside table
            if (!tableActive && event.target && event.target instanceof Node) {
                const { doc: doc, selection: selection, tr: tr } = editorView.state;
                const pos = editorView.posAtDOM(event.target, 1);
                const $pos = doc.resolve(pos);
                const newPos = selection.head > pos ? // Selection is after table
                // nodeSize - 3 will move the position inside last table cell
                (0, $ks2lK.Selection).near(doc.resolve(pos + ($pos.parent.nodeSize - 3)), -1) : // Selection is before table
                (0, $ks2lK.Selection).near($pos);
                editorView.dispatch(tr.setSelection(newPos));
            }
            selectRow(index, event.shiftKey);
        };
        this.clearHoverSelection = ()=>{
            const { tableActive: tableActive, editorView: editorView } = this.props;
            if (tableActive) {
                const { state: state, dispatch: dispatch } = editorView;
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
            }
        };
        this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = 0;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        };
        this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, tableActive: tableActive } = this.props;
            const isActive = (0, $iYC9s.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, {
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER]: tableActive && isActive && isInDanger,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE]: tableActive && isActive
            });
        };
    }
}


/* eslint-disable @atlaskit/design-system/prefer-primitives */ 









































const $1ec0dafc4a18e7bb$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $af1654059f589843$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $1ec0dafc4a18e7bb$export$2e2bcd8739ae039 = $1ec0dafc4a18e7bb$var$RowDropTarget;


const $cfea739a66bdcdd3$var$getSelectedRows = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection) && selection.isRowSelection()) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $cee807f94f070ba4$export$d023456f91fdf995)(rect);
    }
    return [];
};
const $cfea739a66bdcdd3$export$350d0cf1f91b53f4 = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api, selection: selection })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
    const rowsParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $cfea739a66bdcdd3$var$getSelectedRows(selection ?? editorView.state.selection);
    const currentNodeLocalId = tableNode?.attrs?.localId ?? '';
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === tableNode?.attrs.localId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $42omo.useCallback)((trigger, event)=>{
        if (event?.shiftKey) return;
        (0, $66674519b4a32446$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'row', hoveredCell?.rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell?.rowIndex,
        api?.analytics?.actions
    ]);
    const rowIndex = hoveredCell?.rowIndex;
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $42omo.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target?.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS}`);
        const rowIndex = target?.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $42omo.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $42omo.useCallback)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        const isClickOutsideSelectedRows = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectRow(rowIndex, e.shiftKey);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE : undefined,
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`,
            "data-row-index": rowIndex,
            "data-selected-row-index": selectedRowIndexes[0],
            "data-handle-appearance": appearance,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7c8b405b164adf54$export$a0c24614540b0efb), {
                isDragMenuTarget: !isHover,
                direction: "row",
                tableLocalId: currentNodeLocalId,
                indexes: indexes,
                forceDefaultHandle: !isHover,
                previewWidth: tableWidth,
                previewHeight: previewHeight,
                appearance: appearance,
                hoveredCell: hoveredCell,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder', `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8}px ${0, $fbbb9ee8877c285e$export$c2ef52861254b274}px ${tableWidth}px` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0px ${0, $fbbb9ee8877c285e$export$c2ef52861254b274}px 0px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false,
        children: [
            rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '2'
                            },
                            "data-start-index": startIndex,
                            "data-end-index": endIndex,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
                            contentEditable: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT
                            })
                        }, `insert-dot-${index}`),
                        isDragging && /*#__PURE__*/ (0, $l998X.jsx)((0, $1ec0dafc4a18e7bb$export$2e2bcd8739ae039), {
                            index: index,
                            localId: currentNodeLocalId,
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '1 / span 3',
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                pointerEvents: 'auto',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                position: 'relative',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                left: "var(--ds-space-negative-100, -8px)"
                            }
                        }, `drop-target-${index}`)
                    ]
                }, index)),
            rowHandles()
        ]
    });
};
const $cfea739a66bdcdd3$export$8bade456cc132de4 = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, tableActive: tableActive, hoveredCell: hoveredCell, isInDanger: isInDanger, isTableHovered: isTableHovered, isResizing: isResizing, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)($cfea739a66bdcdd3$export$350d0cf1f91b53f4, {
        editorView: editorView,
        tableRef: tableRef,
        tableNode: tableNode,
        tableWidth: tableWidth,
        tableActive: tableActive,
        hoveredCell: hoveredCell,
        isInDanger: isInDanger,
        isTableHovered: isTableHovered,
        isResizing: isResizing,
        hoverRows: hoverRows,
        selectRow: selectRow,
        selectRows: selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api,
        selection: selection
    });
};


function $534ff361a414cc4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $534ff361a414cc4b$var$styles = {
    name: "lr2r3w",
    styles: "&:has(~ .pm-table-wrapper-no-overflow){margin-top:0;}"
};
const $534ff361a414cc4b$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, isDragAndDropEnabled: isDragAndDropEnabled, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $42omo.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $4ca83755c936c9c8$export$e247ed8cec4832f4)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $42omo.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $4ca83755c936c9c8$export$b5ba3b60192c7a8d)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $42omo.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$ab63d99b591b89)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $42omo.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $7132c436572167eb$export$1d614a0f0fe37c44)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER;
    const tablePos = (0, $id9O1.findTable)(editorView.state.selection)?.pos;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const isNested = tablePos !== undefined && (0, $bdb0299b531c40df$export$d4302a800316ebd6)(editorView.state, tablePos);
    const shouldShowCornerControls = isNested && !(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes');
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassName,
        css: [
            (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && !(0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') && $534ff361a414cc4b$var$styles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault()
    }, isNumberColumnEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $b09bdd4510c4ed50$export$2e2bcd8739ae039), {
        editorView: editorView,
        hoverRows: _hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        updateCellHoverLocation: updateCellHoverLocation,
        stickyTop: stickyTop,
        isDragAndDropEnabled: isDragAndDropEnabled
    }) : null, tableActive && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, shouldShowCornerControls && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c3edf387a25033c9$export$2e06061cfdb64df2), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        api: api
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cfea739a66bdcdd3$export$8bade456cc132de4), {
        tableRef: tableRef,
        tableNode: tableNode,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        editorView: editorView,
        tableActive: tableActive,
        isInDanger: isInDanger,
        isResizing: isResizing,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tableWidth: tableWrapperWidth,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        selectRows: _selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api
    })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a72f571dbc5509cd$export$4017f69d73e46bd1), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined,
        tableActive: tableActive,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        api: api
    }))));
};
var $534ff361a414cc4b$export$2e2bcd8739ae039 = $534ff361a414cc4b$export$1e425115e5c75aac;

















const $17073aeea32b894f$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const currentNodeLocalId = node?.attrs.localId;
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(editorView);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8) - (0, $1zav4.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $fbbb9ee8877c285e$export$b2015400488f9243)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // move drop targets based on table wrapper scroll
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `-${getScrollOffset()}px`
            },
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d471513cc0a7aea8$export$e8a325e09c5453d5), {
                    index: index,
                    localId: currentNodeLocalId,
                    width: width,
                    height: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                    marginTop: 0
                }, index);
            })
        })
    });
};






























































var $6MTPr = parcelRequire("6MTPr");











var $hWRJP = parcelRequire("hWRJP");


var $8b5jG = parcelRequire("8b5jG");


var $b3YrF = parcelRequire("b3YrF");




























const $605f685ca1d87a0d$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};
const $605f685ca1d87a0d$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return $605f685ca1d87a0d$export$192a1a4af16beb38(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};



var $4HPW1 = parcelRequire("4HPW1");










const $94176587bf937630$var$numberOfLanesInDefaultLayoutWidth = 12;
const $94176587bf937630$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $94176587bf937630$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$94176587bf937630$var$calculateSubSnappingWidths($94176587bf937630$var$numberOfLanesInDefaultLayoutWidth, (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $aFUXX.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $aFUXX.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $94176587bf937630$var$getPadding = (editorContainerWidth)=>{
    return editorContainerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
const $94176587bf937630$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWidth = (0, $aFUXX.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $94176587bf937630$var$getPadding(editorContainerWidth);
    const dynamicFullWidthLine = editorContainerWidth - padding * 2 >= (0, $aFUXX.akEditorFullWidthLayoutWidth) ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const dynamicMaxWidthLine = editorContainerWidth - padding * 2 >= (0, $aFUXX.akEditorMaxWidthLayoutWidth) ? (0, $aFUXX.akEditorMaxWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) guides.push(dynamicMaxWidthLine - lengthOffset);
    if (!exclude.breakoutPoints) guides.unshift((0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset, (0, $aFUXX.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$94176587bf937630$var$calculateSubSnappingWidths($94176587bf937630$var$numberOfLanesInDefaultLayoutWidth, (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $94176587bf937630$export$c5e672719c546336 = $94176587bf937630$export$c4ddb11be0806484();
const $94176587bf937630$export$b2f61428a1609695 = 0;
const $94176587bf937630$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $94176587bf937630$var$getPadding(editorContainerWidth);
    return editorContainerWidth - padding * 2 > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? $94176587bf937630$export$c4ddb11be0806484() : $94176587bf937630$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $94176587bf937630$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $4HPW1.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};


const $386bd6c12e70d174$export$71ea7e0a71c6d202 = (0, $605f685ca1d87a0d$export$24448ad8894709b4)([
    0,
    ...(0, $94176587bf937630$export$c4ddb11be0806484)(-1)
]);
const $386bd6c12e70d174$export$d25f7f8989bf9598 = -1;
const $386bd6c12e70d174$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $94176587bf937630$export$7542cd96381664c2)(lengthOffset, editorContainerWidth, exclude);
    return (0, $605f685ca1d87a0d$export$24448ad8894709b4)(lengths, undefined, true);
};




const $cfef72949acb5fed$var$RESIZE_STEP_VALUE = 10;
const $cfef72949acb5fed$var$handles = {
    right: true
};
const $cfef72949acb5fed$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $cfef72949acb5fed$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = tableRef?.clientHeight ?? 0;
    /*
     - One row table height (minimum possible table height) ~ 45px
     - Two row table height ~ 90px
     - Three row table height ~ 134px
      In the if below we need to use:
     - > 46 because the height of the table can be a float number like 45.44.
     - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $cfef72949acb5fed$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $d7e0ca7a06057b05$export$dc24345db4290451)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
const $cfef72949acb5fed$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $cfef72949acb5fed$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $fbbb9ee8877c285e$export$858d012f03ae70a5);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $386bd6c12e70d174$export$d25f7f8989bf9598) + 1;
        const padding = $cfef72949acb5fed$var$getPadding(containerWidth);
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * padding + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $cfef72949acb5fed$var$selector = (states)=>({
        widthToWidest: states.tableState?.widthToWidest
    });
const $cfef72949acb5fed$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, disabled: disabled })=>{
    const currentGap = (0, $42omo.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $42omo.useRef)(false);
    const areResizeMetaKeysPressed = (0, $42omo.useRef)(false);
    const resizerRef = (0, $42omo.useRef)(null);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const { widthToWidest: widthToWidest } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], $cfef72949acb5fed$var$selector);
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const currentSelection = editorView.state?.selection;
    const tableFromSelection = (0, $42omo.useMemo)(()=>{
        return (0, $id9O1.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection?.pos;
    const isTableSelected = (0, $42omo.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        if (interactionState === 'hasNotHadInteraction') return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $hWRJP.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        interactionState,
        getPos
    ]);
    const resizerMinWidth = $cfef72949acb5fed$var$getResizerMinWidth(node);
    const handleSize = $cfef72949acb5fed$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $d406f1b0c5d56902$export$9642a56c1e8805cc)();
    const excludeGuidelineConfig = (0, $42omo.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && isFullWidthModeEnabled)
        }), [
        isFullWidthModeEnabled,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $42omo.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $cfef72949acb5fed$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $6MTPr.getGuidelinesWithHighlights)(gap, (0, $fbbb9ee8877c285e$export$8f6133b6e2b4291), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $42omo.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $94176587bf937630$export$461c50a158de0369)((0, $94176587bf937630$export$b2f61428a1609695), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $94176587bf937630$export$c5e672719c546336)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $42omo.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $8b84c930bc26bcf8$export$8dcb9bda5f25db3a)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $d9aad08b0e0e65bb$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $8b84c930bc26bcf8$export$3ea9e188ab01c845), (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2), tableNodeWithPos, (0, $d925B.INPUT_METHOD).AUTO, (0, $3824I.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi?.analytics?.actions
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableResize');
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('resizing')({
            tr: tr
        });
        dispatch(tr);
        const visibleGuidelines = $cfef72949acb5fed$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        isFullWidthModeEnabled,
        lineLength,
        containerWidth,
        excludeGuidelineConfig,
        displayGuideline,
        onResizeStart,
        pluginInjectionApi?.userIntent?.commands
    ]);
    const handleResize = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (originalState, delta)=>{
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch  {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth;
        const closestSnap = !isCommentEditor && (0, $94176587bf937630$export$5ea7b9558ea477a)(newWidth, isTableScalingEnabled ? (0, $94176587bf937630$export$461c50a158de0369)((0, $94176587bf937630$export$b2f61428a1609695), editorContainerWidth, excludeGuidelineConfig) : (0, $94176587bf937630$export$c5e672719c546336), isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), (0, $fbbb9ee8877c285e$export$edb1b9caf8ff5b32), (0, $fbbb9ee8877c285e$export$7af5c65e392a647));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const fullWidthGuideline = (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? closestSnap && fullWidthGuideline && closestSnap.keys.includes(fullWidthGuideline.key) : closestSnap && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = isCommentEditor ? Math.floor(containerWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199)) : (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916);
        const shouldUpdateWidthToWidest = isCommentEditor ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = isCommentEditor && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $0e5c6cf05dff4e80$export$2d57109fc9066ba2)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, allowFixedColumnWidthOption, isCommentEditor);
        (0, $astHL.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $4ca83755c936c9c8$export$833849b68219cbcc)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isTableScalingEnabled,
        allowFixedColumnWidthOption,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $42omo.useMemo)(()=>(0, $2P8Ax.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((originalState, delta)=>{
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const tableMaxWidth = isCommentEditor ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('default')({
            tr: tr
        });
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $d406f1b0c5d56902$export$29574a7e6ffc8eb4)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                attachAnalyticsEvent(payload)?.(tr);
            });
        }
        if (typeof pos === 'number') {
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth,
                layout: node.attrs.layout !== (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) && node.attrs.layout !== (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) ? (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) : node.attrs.layout
            });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $0e5c6cf05dff4e80$export$edcf1a404e75ce35)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment editor, because in comment editor
                // newWidth can be underined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                parentWidth: isCommentEditor ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, isCommentEditor)(tr);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const scaledNode = tr.doc.nodeAt(pos);
            attachAnalyticsEvent((0, $d406f1b0c5d56902$export$a12b1eaff522a2d1)({
                originalNode: node,
                resizedNode: scaledNode
            }))?.(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2CQVV.messages).tableSizeDecreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        else if (delta.width > 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2CQVV.messages).tableSizeIncreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableResize');
        return newWidth;
    }, [
        editorView,
        getPos,
        node,
        isCommentEditor,
        widthToWidest,
        endMeasure,
        displayGapCursor,
        displayGuideline,
        updateWidth,
        scheduleResize,
        onResizeStop,
        pluginInjectionApi,
        attachAnalyticsEvent,
        tableRef,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        formatMessage
    ]);
    const handleTableSizeChangeOnKeypress = (0, $42omo.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        resizerMinWidth
    ]);
    const handleEscape = (0, $42omo.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $cfef72949acb5fed$var$RESIZE_STEP_VALUE : -$cfef72949acb5fed$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $42omo.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView?.dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keydown', handleKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keyup', handleKeyUp);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keydown', handleKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(node.attrs.layout) === (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) ? 2 : 1;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8b5jG.default), {
            ref: resizerRef,
            enable: disabled ? {} : $cfef72949acb5fed$var$handles,
            width: width,
            handleAlignmentMethod: "sticky",
            handleSize: handleSize,
            handleStyles: $cfef72949acb5fed$var$handleStyles,
            handleResizeStart: handleResizeStart,
            handleResize: scheduleResize,
            handleResizeStop: handleResizeStop,
            resizeRatio: resizeRatio,
            minWidth: resizerMinWidth,
            maxWidth: maxWidth,
            snapGap: (0, $fbbb9ee8877c285e$export$8f6133b6e2b4291),
            snap: guidelineSnaps,
            handlePositioning: "adjacent",
            isHandleVisible: isTableSelected,
            needExtendedResizeZone: !isTableSelected,
            appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
            handleHighlight: "shadow",
            handleTooltipContent: ({ update: update })=>{
                updateTooltip.current = update;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                    description: formatMessage((0, $2CQVV.messages).resizeTable),
                    keymap: (0, $hgeg8.focusTableResizer)
                });
            },
            "data-vc-nvs": "true",
            children: children
        })
    });
};


const $18d33f212dd25a88$var$InnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, style: style, node: node, children: children, tableWrapperHeight: tableWrapperHeight }, ref)=>{
    const bordersReady = (0, $1oCLl.expValEquals)('platform_editor_table_borders_ready_fix', 'isEnabled', true) ? tableWrapperHeight !== undefined && tableWrapperHeight > 0 : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-borders-ready": bordersReady,
        "data-testid": "table-container",
        children: children
    });
});
const $18d33f212dd25a88$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) ? (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) : (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], (states)=>({
            isFullWidthModeEnabled: states.tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: states.tableState?.wasFullWidthModeEnabled
        }));
    (0, $42omo.useEffect)(()=>{
        if (editorView && getPos) {
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) && node.attrs.width > (0, $aFUXX.akEditorDefaultLayoutWidth)) {
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $d9aad08b0e0e65bb$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $8b84c930bc26bcf8$export$3ea9e188ab01c845), alignment, {
                    pos: pos,
                    node: node
                }, (0, $d925B.INPUT_METHOD).AUTO, (0, $3824I.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        isFullWidthModeEnabled,
        wasFullWidthModeEnabled,
        node
    ]);
    const style = (0, $42omo.useMemo)(()=>{
        return (0, $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e)(alignment);
    }, [
        alignment
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
};
const $18d33f212dd25a88$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: children
    });
};
const $18d33f212dd25a88$var$selector = (states)=>({
        tableState: states.tableState,
        editorViewModeState: states.editorViewModeState
    });
const $18d33f212dd25a88$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
const $18d33f212dd25a88$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    const tableWidth = (0, $6fQl1.getTableContainerWidth)(node);
    const containerRef = (0, $42omo.useRef)(null);
    const tableWidthRef = (0, $42omo.useRef)((0, $aFUXX.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $42omo.useState)(false);
    const { tableState: tableState, editorViewModeState: editorViewModeState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table',
        'editorViewMode'
    ], $18d33f212dd25a88$var$selector);
    const isFullWidthModeEnabled = tableState?.isFullWidthModeEnabled;
    const mode = editorViewModeState?.mode;
    const updateContainerHeight = (0, $42omo.useCallback)((height)=>{
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = containerRef.current?.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            const stickyHeaderHeight = containerRef.current?.getElementsByTagName('th')[0].getBoundingClientRect().height || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $42omo.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $42omo.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $42omo.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $42omo.useCallback)((guidelines)=>{
        return pluginInjectionApi?.guideline?.actions?.displayGuideline(editorView)({
            guidelines: guidelines
        }) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        return pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $42omo.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const { width: width, maxResizerWidth: maxResizerWidth } = (0, $42omo.useMemo)(()=>{
        let responsiveContainerWidth = 0;
        const resizeHandleSpacing = 12;
        const padding = $18d33f212dd25a88$var$getPadding(containerWidth);
        // When Full width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
        // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
        // issues when viwport width is less than full width Editor's width. To detect avoid them
        // we need to use lineLength to defined responsiveWidth instead of containerWidth
        // (which does not get updated when Mac setting changes) in Full-width editor.
        if (isFullWidthModeEnabled) {
            // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
            // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
            // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
            responsiveContainerWidth = isTableScalingEnabled ? lineLength : containerWidth - padding * 2 - resizeHandleSpacing;
            // platform_editor_table_fw_numcol_overflow_fix:
            // lineLength is undefined on first paint → width: NaN → wrapper expands to page
            // width. rAF col-sizing then runs before the number-column padding and
            // the final shrink, so column widths are locked in wrong.
            // With the flag ON, if the value isn’t finite we fall back to gutterWidth
            // for that first frame—no flash, no premature rAF.
            //
            // Type clean-up comes later:
            // 1) ship this runtime guard (quick fix, no breakage);
            // 2) TODO: widen lineLength to `number|undefined` and remove this block.
            if ((0, $dh538.fg)('platform_editor_table_fw_numcol_overflow_fix')) {
                if (isTableScalingEnabled && !Number.isFinite(responsiveContainerWidth)) responsiveContainerWidth = containerWidth - padding * 2 - resizeHandleSpacing;
            }
        } else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199);
        else // 76 is currently an accepted padding value considering the spacing for resizer handle
        // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
        // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
        // padding left = padding right = akEditorGutterPadding = 32
        responsiveContainerWidth = isTableScalingEnabled ? containerWidth - padding * 2 : containerWidth - padding * 2 - resizeHandleSpacing;
        // Fix for HOT-119925: Ensure table width is properly constrained and responsive
        // For wide tables, ensure they don't exceed container width and can be scrolled
        const calculatedWidth = !node.attrs.width && isCommentEditor ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
        // Ensure minimum width for usability while respecting container constraints
        const width = Math.max(calculatedWidth, Math.min(responsiveContainerWidth * 0.5, 300));
        const maxResizerWidth = isCommentEditor ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916));
        return {
            width: width,
            maxResizerWidth: maxResizerWidth
        };
    }, [
        containerWidth,
        isCommentEditor,
        isFullWidthModeEnabled,
        isTableScalingEnabled,
        lineLength,
        node.attrs.width,
        tableWidth
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isResizing) tableWidthRef.current = width;
    }, [
        width,
        isResizing
    ]);
    // CSS Solution for table resizer container width
    const tableResizerContainerWidth = (0, $42omo.useMemo)(()=>{
        return (0, $b61fc0745b235461$export$30421da09613cb3d)(node, isTableScalingEnabled);
    }, [
        node,
        isTableScalingEnabled
    ]);
    // CSS Solution for table resizer max width
    const tableResizerMaxWidth = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
        const nonResizingMaxWidth = isFullPageAppearance ? (0, $b61fc0745b235461$export$817f7cd897b65634)(isCommentEditor, isChromelessEditor, isTableScalingEnabled) : maxResizerWidth;
        // isResizing is needed, otherwise we can't resize table.
        // when not resizing, maxWidth is calculated based on the container width via CSS
        return !isResizing ? nonResizingMaxWidth : maxResizerWidth;
    }, [
        isCommentEditor,
        isChromelessEditor,
        isTableScalingEnabled,
        isResizing,
        maxResizerWidth
    ]);
    const tableResizerProps = {
        width: // The `width` is used for .resizer-item in <TableResizer>, and it has to be a number
        // So we can't use min(var(--ak-editor-table-width), ${tableWidth}px) here
        // We still have to use JS to calculate width
        width,
        maxWidth: tableResizerMaxWidth,
        containerWidth: containerWidth,
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor
    };
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                '--ak-editor-table-gutter-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2)',
                '--ak-editor-table-width': isFullPageAppearance ? tableResizerContainerWidth : `${tableWidthRef.current}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: 'var(--ak-editor-table-width)',
                height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
                position: isLivePageViewMode ? 'relative' : 'unset'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RESIZER_CONTAINER,
            ref: containerRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cfef72949acb5fed$export$65233f8d64070eeb), {
                ...tableResizerProps,
                disabled: isLivePageViewMode,
                children: /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$InnerContainer, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: className,
                    node: node,
                    tableWrapperHeight: tableWrapperHeight,
                    children: children
                })
            })
        })
    });
});
const $18d33f212dd25a88$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerWidth: editorWidth,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        children: children
    });
    const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const resizableTableWidth = isFullPageAppearance ? (0, $b61fc0745b235461$export$30421da09613cb3d)(node, isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$InnerContainer, {
        node: node,
        tableWrapperHeight: tableWrapperHeight,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, {
            'less-padding': editorWidth < (0, $aFUXX.akEditorMobileBreakoutPoint) && !isNested && !(isChromelessEditor && isDragAndDropEnabled)
        }),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--ak-editor-table-width': resizableTableWidth
        },
        children: children
    });
};



var $7YjFd = parcelRequire("7YjFd");





class $561368c6992f96d2$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.editorScrollableElement = // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (entry.rootBounds?.height === 0) return;
                if (target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        // Multiple bottom sentinels may be found if there are nested tables. We need to make sure we get the last one which will belong to the parent table.
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = bottomSentinels?.item(bottomSentinels.length - 1);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>{
            if (el !== null && this.intersectionObserver) this.intersectionObserver.observe(el);
        });
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0) || // When editorScrollableElement is the root document or inside modal,
        // so the boundingClientRect.top will never be less than the rootBounds.top,
        // so we need to check if the boundingClientRect.top is less than 20% of the rootBounds.height
        // to determine if the bottom sentinel is above the scroll area
        entry.boundingClientRect.top < (entry.rootBounds?.height || 0) * 0.2;
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
    constructor(wrapper, view){
        this.wrapper = void 0;
        this.view = void 0;
        this.editorScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.view = view;
        if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', true)) requestAnimationFrame(()=>{
            this.init();
        });
        else this.init();
    }
}


// Prevent unnecessary parentWidth updates when table is nested inside of a node that is nested itself.
const $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD = 2;
const $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD = 20;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e98a20a38af9057c$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(this.props.view.dom);
        if (this.table) {
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.table,
                onFirstVisible: ()=>{
                    this.initialiseEventListenersAfterMount();
                    // force width calculation - missed resize event under firefox when
                    // table is nested within bodied extension
                    if (this.wrapper) this.wrapperWidth = this.wrapper?.clientWidth;
                }
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeNewDebounced);
        }
    }
    initialiseEventListenersAfterMount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode } = this.props;
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        const isIE11 = browser.ie_version === 11;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseover', this.handleMouseOver);
        if (this.wrapper) {
            this.wrapperReisizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries)this.wrapperWidth = entry.contentRect?.width;
            });
            this.wrapperReisizeObserver.observe(this.wrapper);
        }
        if (allowColumnResizing && this.wrapper && !isIE11) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if (this.table && !this.isNestedInTable) this.stickyScrollbar = new (0, $561368c6992f96d2$export$8c072780619cfc83)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $bSjaC.combine)(...(0, $f69a5020d7054d5c$export$aed4bc7b473fc217)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $1562ea854f0ae047$export$18d4026d1ea86bb1).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.on((0, $1562ea854f0ae047$export$18d4026d1ea86bb1).key, this.onStickyState);
    }
    componentWillUnmount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, view: view, isInDanger: isInDanger } = this.props;
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        const isIE11 = browser.ie_version === 11;
        if (this.wrapper && !isIE11) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        if (this.nodeVisibilityObserverCleanupFn) this.nodeVisibilityObserverCleanupFn();
        this.resizeObserver?.disconnect();
        this.wrapperReisizeObserver?.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!allowTableResizing) this.handleWindowResizeDebounced.cancel();
        this.handleWindowResizeNewDebounced.cancel();
        if (isInDanger) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(view.state, view.dispatch);
        if (!allowTableResizing && allowColumnResizing) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeDebounced);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeNewDebounced);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseover', this.handleMouseOver);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.off((0, $1562ea854f0ae047$export$18d4026d1ea86bb1).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, getEditorFeatureFlags: getEditorFeatureFlags, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options?.isCommentEditor ? containerWidth.width - ((0, $8588522c22c049a0$export$c332ba2dd5aa2199) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $8588522c22c049a0$export$7c8bcfa1d3f9af23);
        tableNodeWidth = options?.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(tableNode, this.node);
        const { width: containerWidthValue, lineLength: containerLineLength } = containerWidth;
        const isLineLengthChanged = this.containerWidth?.lineLength !== containerLineLength;
        const isFullWidthModeAndLineLengthChanged = this.updateColGroupFromFullWidthChange && isLineLengthChanged;
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !options?.isCommentEditor || isNumberColumnChanged || isNumberOfColumnsChanged || this.state.windowResized;
        if (force || maybeScale || isFullWidthModeAndLineLengthChanged) {
            const isWidthChanged = this.containerWidth?.width !== containerWidthValue;
            const wasTableResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(this.node);
            const isTableResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = this.shouldUpdateColgroup({
                isWindowResized: this.state.windowResized,
                isWidthChanged: isWidthChanged,
                isTableWidthChanged: isTableWidthChanged,
                isColumnsDistributed: isColumnsDistributed,
                isTableResizedFullWidth: isTableResizedFullWidth,
                isTableDisplayModeChanged: isTableDisplayModeChanged,
                isNumberColumnChanged: isNumberColumnChanged,
                isNumberOfColumnsChanged: isNumberOfColumnsChanged,
                isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged,
                isTableResized: isTableResized
            });
            const tableWithFixedColumnWidthsOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.props?.allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!this.props.options?.isTableScalingEnabled && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!this.props.options?.isTableScalingEnabled && !!this.props.options?.isCommentEditor;
            if (force || !isResizing && shouldUpdateColgroup) {
                const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
                    minWidth: (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!this.props.options?.isCommentEditor
                });
                let shouldScaleOnColgroupUpdate = false;
                if (this.props.options?.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if (this.props.options?.isTableScalingEnabled && this.props.options?.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!this.props.options?.isCommentEditor || this.props.options?.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(tableNode, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, shouldUseIncreasedScalingPercent);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    scalePercent = (0, $b61fc0745b235461$export$4e884677f8e54bba)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(resizeState, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        if (isFullWidthModeAndLineLengthChanged) this.updateColGroupFromFullWidthChange = false;
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    componentDidUpdate(_, prevState) {
        const { getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, getEditorFeatureFlags: getEditorFeatureFlags, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const tableWithFixedColumnWidthsOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!this.props.options?.isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if (this.props.options?.isCommentEditor && allowTableResizing && !options?.isTableScalingEnabled) this.removeInlineTableWidth();
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $bdb0299b531c40df$export$8fe872ff9fc9b477)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) this.props.pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify((0, $1731f25dceb7d4d1$export$cea95ea93d5f9224)(previousTable, currentTable, this.props.intl), {
            priority: 'important'
        });
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $bdb0299b531c40df$export$8f2a10e9b102ac33)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !allowTableResizing || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                }
                (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
    }
    observeTable(table) {
        if (table) this.resizeObserver?.observe(table);
    }
    render() {
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, allowTableResizing: // here we can use options.isTableScalingEnabled
        allowTableResizing, allowTableAlignment: allowTableAlignment, selection: selection, isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const node = getNode();
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $bdb0299b531c40df$export$86a810659e2d575)(node);
        const rowControls = /*#__PURE__*/ (0, $l998X.jsx)((0, $534ff361a414cc4b$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        });
        const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fc03cc481fa1e1aa$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            getScrollOffset: ()=>this.wrapper?.scrollLeft || 0,
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor,
            isDragAndDropEnabled: isDragAndDropEnabled
        }) : null;
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(view.state, tablePos);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!this.props.options?.isCommentEditor);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $18d33f212dd25a88$export$f2c3aea42b2a048f), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, {
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY]: !this.props.limitedMode && this.state.stickyHeader && hasHeaderRow,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED]: (0, $iYC9s.isTableSelected)(selection ?? view.state.selection),
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS]: tableActive && allowControls && this.isNestedInTable
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: allowTableResizing,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            allowFixedColumnWidthOption: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: allowTableAlignment,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options?.isCommentEditor,
            isChromelessEditor: options?.isChromelessEditor,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP,
                    "data-testid": "sticky-sentinel-top"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }),
                allowControls && rowControls,
                isDragAndDropEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $17073aeea32b894f$export$1041cb8214100cd2), {
                    editorView: view,
                    node: node,
                    getScrollOffset: ()=>{
                        return this.wrapper?.scrollLeft || 0;
                    },
                    getTableWrapperWidth: ()=>{
                        return this.wrapper?.clientWidth || 760;
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER),
                    ref: (elem)=>{
                        this.wrapper = elem;
                        if (elem) {
                            this.props.contentDOM(elem);
                            const tableElement = elem.querySelector('table');
                            if (tableElement !== this.table) {
                                this.table = tableElement;
                                this.observeTable(this.table);
                                // // Update tableRef in plugin state when table is properly mounted
                                // // At this point, both table and wrapper are in DOM with correct parent-child relationship
                                if (this.table && this.props.view && ((0, $1oCLl.expValEquals)('platform_editor_table_update_table_ref', 'isEnabled', true) || (0, $dh538.fg)('platform_editor_enable_table_update_ref_atlas'))) (0, $4ca83755c936c9c8$export$79b661cbf50c3490)(this.table)(this.props.view.state, this.props.view.dispatch);
                            }
                        }
                    },
                    children: allowControls && colControls
                }),
                !this.isNestedInTable ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    "data-vc-nvs": "true",
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: 'none',
                        // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                        width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            width: tableRef?.clientWidth,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: '100%'
                        },
                        "data-vc-nvs": "true"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        width: tableRef?.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    },
                    "data-vc-nvs": "true"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM,
                    "data-testid": "sticky-sentinel-bottom"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_BORDER,
                    "data-with-numbered-table": node.attrs.isNumberColumnEnabled,
                    "data-testid": "table-left-border"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_BORDER,
                    "data-testid": "table-right-border"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            parentWidth: undefined,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined,
            windowResized: false
        };
        this.wrapper = void 0;
        this.table = void 0;
        this.node = void 0;
        this.containerWidth = void 0;
        this.wasResizing = void 0;
        this.tableNodeWidth = void 0;
        this.layoutSize = void 0;
        this.stickyScrollbar = void 0;
        this.isNestedInTable = void 0;
        this.initialOverflowCaptureTimerId = void 0;
        this.resizeObserver = void 0;
        this.wrapperWidth = void 0;
        this.wrapperReisizeObserver = void 0;
        this.updateColGroupFromFullWidthChange = void 0;
        this.dragAndDropCleanupFn = void 0;
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.handleMouseOut = (event)=>{
            if (!(0, $f10f08824d624bfc$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $f10f08824d624bfc$export$72517da01e0ce829)(this.props.view, event);
        };
        this.handleMouseOver = (event)=>{
            if (!(0, $f10f08824d624bfc$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$321c2da35903b013))(this.props.view, event);
        };
        this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        };
        this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $kTbzR.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $894c3bb16e3b70ec$export$91d61a242b14c7fb)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) this.setState({
                stickyHeader: stickyHeader
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.prevTableState = null;
        this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
            }
            // force update to for table controls to re-align
            this.forceUpdate();
        };
        this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options, allowTableResizing: allowTableResizing } = this.props;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(this.props.view.state, this.props.getPos());
            let parentWidth = this.getParentNodeWidth();
            if (isNested && (0, $bdb0299b531c40df$export$e31912a493829c23)(this.props.view.state, this.props.getPos())) {
                const resizeObsWrapperWidth = this.wrapperWidth || 0;
                const wrapperWidthDiffBetweenRerenders = Math.abs(resizeObsWrapperWidth - (this.state.parentWidth || 0));
                const isOusideOfThreshold = wrapperWidthDiffBetweenRerenders <= $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD || wrapperWidthDiffBetweenRerenders > $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD;
                // 1. Check isOusideOfThreshold is added to prevent undersired state update.
                // When table is nested in the extenstion and the table column is being resized,
                // space available within extension can change and cause undesirable state update.
                // MIN_THRESNESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLDHOLD value is required
                // as the resizeObsWrapperWidth can differ between page reloads by 2px.
                // 2. Check resizeObsWrapperWidth > 1 is added to prevent parentWidth update when table unmounts.
                // When a is nested table in a nested expand and the expand collabses, the table unmounts and
                // resizeObsWrapperWidth becomes 1.
                parentWidth = isOusideOfThreshold && resizeObsWrapperWidth > 1 ? resizeObsWrapperWidth : this.state.parentWidth;
            }
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!allowTableResizing || allowTableResizing && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (allowTableResizing && hasNumberedColumnChanged) {
                    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        };
        // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $kTbzR.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $0e5c6cf05dff4e80$export$edcf1a404e75ce35)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) {
                (0, $h3X17.tintDirtyTransaction)(tr);
                // Avoid adding this transaction separately to the history as these are automatic updates
                // as a consequence of another action
                tr.setMeta('addToHistory', false);
            }
            dispatch(tr);
        };
        this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $kTbzR.isValidPosition)(pos, view.state)) return;
                (0, $4ca83755c936c9c8$export$d6e5d8afaa172954)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        };
        this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        };
        // This is a new handler for window resize events that sets the windowResized state immediately
        // This is needed to update colgroup on window resize, to enforce the table scaling
        this.handleWindowResizeNew = ()=>{
            // Set resizing to true immediately
            if (!this.state.windowResized) this.setState({
                windowResized: true
            });
        };
        this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $kTbzR.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $6fQl1.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        };
        this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        };
        this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {});
        this.shouldUpdateColgroup = (params)=>{
            const { isWindowResized: isWindowResized, isWidthChanged: isWidthChanged, isTableWidthChanged: isTableWidthChanged, isColumnsDistributed: isColumnsDistributed, isTableResizedFullWidth: isTableResizedFullWidth, isTableDisplayModeChanged: isTableDisplayModeChanged, isNumberColumnChanged: isNumberColumnChanged, isNumberOfColumnsChanged: isNumberOfColumnsChanged, isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged } = params;
            const isFullPageEditor = !this.props.options?.isCommentEditor && !this.props.options?.isChromelessEditor;
            if (isFullPageEditor) return !!isWindowResized || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
            return isWidthChanged || isTableWidthChanged || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
        };
        this.scaleTableDebounced = (0, $2P8Ax.default)(this.scaleTable);
        this.handleTableResizingDebounced = (0, $2P8Ax.default)(this.handleTableResizing);
        this.handleScrollDebounced = (0, $2P8Ax.default)(this.handleScroll);
        this.handleAutoSizeDebounced = (0, $2P8Ax.default)(this.handleAutoSize);
        this.handleWindowResizeDebounced = (0, $2P8Ax.default)(this.handleWindowResize);
        this.handleWindowResizeNewDebounced = (0, $2P8Ax.default)(this.handleWindowResizeNew);
        const { options: _options, containerWidth: _containerWidth, getNode: _getNode } = props;
        this.node = _getNode();
        this.containerWidth = _containerWidth;
        const tablePos = props.getPos();
        this.isNestedInTable = tablePos ? (0, $sxTNo.getParentOfTypeCount)(props.view.state.schema.nodes.table)(props.view.state.doc.resolve(tablePos)) > 0 : false;
        if (!this.updateColGroupFromFullWidthChange) this.updateColGroupFromFullWidthChange = _options?.isFullWidthModeEnabled && !_options?.wasFullWidthModeEnabled;
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = _options ? _options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, _containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)this.setState((prev)=>{
                return prev?.tableWrapperWidth === entry.contentRect?.width && prev?.tableWrapperHeight === entry.contentRect?.height ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
        if (!(0, $1oCLl.expValEquals)('platform_editor_disable_query_command_supported', 'isEnabled', true)) {
            if ('execCommand' in document) // Disable inline table editing and resizing controls in Firefox
            // https://github.com/ProseMirror/prosemirror/issues/432
            [
                'enableObjectResizing',
                'enableInlineTableEditing'
            ].forEach((cmd)=>{
                if (document.queryCommandSupported(cmd)) document.execCommand(cmd, false, 'false');
            });
        }
    }
}
$e98a20a38af9057c$var$TableComponent.displayName = 'TableComponent';
var $e98a20a38af9057c$export$2e2bcd8739ae039 = (0, $gmMgo.default)($e98a20a38af9057c$var$TableComponent);


const $fd705b3bea000047$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    const { isTableResizing: isTableResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isResizing: isResizing, isInDanger: isInDanger, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger, interaction: interaction, isFullscreen: isFullscreen, lineLength: lineLength, mode: mode, selection: selection, width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'table',
        'width',
        'media',
        'selection',
        'editorViewMode',
        'interaction'
    ], (states)=>({
            // tableState
            isTableResizing: states.tableState?.isTableResizing,
            isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
            isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
            ordering: states.tableState?.ordering,
            isResizing: states.tableState?.isResizing,
            isInDanger: states.tableState?.isInDanger,
            hoveredCell: states.tableState?.hoveredCell,
            hoveredRows: states.tableState?.hoveredRows,
            isTableHovered: states.tableState?.isTableHovered,
            isWholeTableInDanger: states.tableState?.isWholeTableInDanger,
            // Required so that table control re-renders
            targetCellPosition: states.tableState?.targetCellPosition,
            // mediaState
            isFullscreen: states.mediaState?.isFullscreen,
            // selectionState
            selection: states.selectionState?.selection,
            // editorViewModeState
            mode: states.editorViewModeState?.mode,
            // widthState
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength,
            // interactionState
            interaction: states.interactionState?.interactionState
        }));
    const isLivePageViewMode = mode === 'view';
    /**
	 *  ED-19810
	 *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
	 *  directly to confluence since this bug is now in production.
	 */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        currentTablePos = undefined;
    }
    const selectedTable = (0, $id9O1.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e98a20a38af9057c$export$2e2bcd8739ae039), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: isFullscreen,
        options: options,
        allowControls: allowControls,
        isHeaderRowEnabled: isHeaderRowEnabled ?? false,
        isHeaderColumnEnabled: isHeaderColumnEnabled ?? false,
        isDragAndDropEnabled: options?.isDragAndDropEnabled && !isLivePageViewMode,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        allowTableAlignment: allowTableAlignment,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        tableActive: tableActive && !isLivePageViewMode && interaction !== 'hasNotHadInteraction',
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        containerWidth: {
            width: width ?? 0,
            lineLength: lineLength
        },
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        selection: selection
    });
};



const $1a05aa95aa438aa8$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $1a05aa95aa438aa8$var$getInlineWidth = (node, options, state, pos, allowTableResizing)=>{
    if (!node.attrs.width && options?.isChromelessEditor || !node.attrs.width && options?.isCommentEditor && allowTableResizing) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = allowTableResizing && !(0, $bdb0299b531c40df$export$d4302a800316ebd6)(state, pos);
    let widthValue = (0, $6fQl1.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $1a05aa95aa438aa8$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
class $1a05aa95aa438aa8$export$2e2bcd8739ae039 extends (0, $2gkmX.default) {
    getContentDOM() {
        const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(this.view.state, this.getPos());
        const tableDOMStructure = (0, $da7b34fe5d676606$export$477bb32cbededd65)({
            allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
            tableResizingEnabled: !!this.reactComponentProps.allowTableResizing,
            getEditorContainerWidth: this.reactComponentProps.getEditorContainerWidth,
            isTableScalingEnabled: this.reactComponentProps.options?.isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: this.reactComponentProps.options?.shouldUseIncreasedScalingPercent,
            isCommentEditor: this.reactComponentProps.options?.isCommentEditor,
            isChromelessEditor: this.reactComponentProps.options?.isChromelessEditor,
            isNested: isNested
        }).toDOM(this.node);
        const rendered = (0, $5SAOw.DOMSerializer).renderSpec(document, tableDOMStructure);
        if (rendered.dom) {
            const tableElement = rendered.dom.querySelector('table');
            this.table = tableElement ? tableElement : rendered.dom;
            this.renderedDOM = rendered.dom;
            const allowFixedColumnWidthOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && allowFixedColumnWidthOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $1a05aa95aa438aa8$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos(), this.reactComponentProps.allowTableResizing);
                if (tableInlineWidth) $1a05aa95aa438aa8$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    /**
   * Handles moving the table from ProseMirror's DOM structure into a React-rendered table node.
   * Temporarily disables mutation observers (except for selection changes) during the move,
   * preserves selection state, and restores it afterwards if mutations occurred and cursor
   * wasn't at start of node. This prevents duplicate tables and maintains editor state during
   * the DOM manipulation.
   */ _handleTableRef(node) {
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // Only proceed if we have both a node and table, and the table isn't already inside the node
        if (node && this.table && !node.contains(this.table)) {
            // Store the current ignoreMutation handler so we can restore it later
            oldIgnoreMutation = this.ignoreMutation;
            // Set up a temporary mutation handler that:
            // - Ignores all DOM mutations except selection changes
            // - Tracks when mutations have been ignored via mutationsIgnored flag
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // Store the current selection state if there is a visible selection
            // This lets us restore it after DOM changes
            if ((0, $1oCLl.expValEquals)('platform_editor_fix_cursor_flickering', 'isEnabled', true)) {
                const { selection: selection } = this.view.state;
                const tablePos = this.getPos();
                if (selection.empty && tablePos && (0, $ks2lK.TextSelection).near(this.view.state.doc.resolve(tablePos)).from === selection.from) selectionBookmark = this.view.state.selection.getBookmark();
            } else if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            if (this.dom) {
                this.dom.setAttribute('data-ssr-placeholder', `table-nodeview-${this.node.attrs.localId}`);
                this.dom.setAttribute('data-ssr-placeholder-replace', `table-nodeview-${this.node.attrs.localId}`);
            }
            // Remove the ProseMirror table DOM structure to avoid duplication, as it's replaced with the React table node.
            if (this.dom && this.renderedDOM) this.dom.removeChild(this.renderedDOM);
            // Move the table from the ProseMirror table structure into the React rendered table node.
            node.appendChild(this.table);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    if ((0, $1oCLl.expValEquals)('platform_editor_fix_cursor_flickering', 'isEnabled', true)) /**
             * This handles a very specific case only -> insertion by the user of a new
             * table
             * Since it's behind a RAF it's possible the user has clicked elsewhere or
             * it affects collaborative users (which selection changes shouldn't ever)
             *
             * This ensures that the selectionBookmark *before* is inside the first
             * position in the table and that after it is the text position directly
             * before the table
             * Ideally we want to remove this RAF entirely but that would require removing
             * the DOM manipulation and is a more complex effort
             */ {
                        if (!resolvedSelection.eq(this.view.state.selection) && resolvedSelection.empty && // Ensure that the *next* valid text position matches the first position
                        // in the table
                        (0, $ks2lK.TextSelection).findFrom(this.view.state.doc.resolve(this.view.state.selection.from + 1), 1, true)?.eq(resolvedSelection)) {
                            const tr = this.view.state.tr.setSelection(resolvedSelection);
                            tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                            this.view.dispatch(tr);
                        }
                    } else if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    setDomAttrs(node) {
        if (!this.table) return; // width / attribute application to actual table will happen later when table is set
        const attrs = $1a05aa95aa438aa8$var$tableAttributes(node);
        Object.keys(attrs).forEach((attr)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.table.setAttribute(attr, attrs[attr]);
        });
        const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
        // Preserve Table Width cannot have inline width set on the table
        if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && node.attrs.displayMode === 'fixed') {
            // handle inline style when table been resized
            const tableInlineWidth = $1a05aa95aa438aa8$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos(), this.reactComponentProps.allowTableResizing);
            const isTableResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(this.view.state)?.resizing;
            if (!isTableResizing && tableInlineWidth) $1a05aa95aa438aa8$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fd705b3bea000047$export$b6d58ec6836e4dcf), {
            forwardRef: forwardRef,
            getNode: this.getNode,
            view: props.view,
            options: props.options,
            eventDispatcher: props.eventDispatcher,
            api: props.pluginInjectionApi,
            allowColumnResizing: props.allowColumnResizing,
            allowTableAlignment: props.allowTableAlignment,
            allowTableResizing: props.allowTableResizing,
            allowControls: props.allowControls,
            getPos: props.getPos,
            getEditorFeatureFlags: props.getEditorFeatureFlags,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption
        });
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(this.view.state);
        const hoveredRowsChanged = !!hoveredRows?.length !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!hoveredRows?.length;
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $LmqWp.TableMap).get(node);
        const nextTableMap = (0, $LmqWp.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && nodeName?.toUpperCase() === 'DIV' && firstChild?.nodeName.toUpperCase() === 'TABLE') return false;
        // ED-16668
        // Do not remove this fixes an issue with windows firefox that relates to
        // the addition of the shadow sentinels
        if (type === 'selection' && nodeName?.toUpperCase() === 'TABLE' && (firstChild?.nodeName.toUpperCase() === 'COLGROUP' || firstChild?.nodeName.toUpperCase() === 'SPAN')) return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher?.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props, undefined, undefined, // @portal-render-immediately
        true);
        this.table = void 0;
        this.renderedDOM = void 0;
        this.resizeObserver = void 0;
        this.eventDispatcher = void 0;
        this.getPos = void 0;
        this.options = void 0;
        this.getEditorFeatureFlags = void 0;
        this.getNode = ()=>{
            return this.node;
        };
        this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
        this.handleRef = (node)=>this._handleTableRef(node);
    }
}
const $1a05aa95aa438aa8$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption)=>{
    const { pluginConfig: pluginConfig, isDragAndDropEnabled: isDragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled // same as options.isTableScalingEnabled
     } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
    // Use shared state for isFullWidthModeEnabled and wasFullWidthModeEnabled for most up-to-date values
    const tableState = pluginInjectionApi?.table?.sharedState.currentState();
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls, allowTableResizing: allowTableResizing, allowTableAlignment: allowTableAlignment } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(pluginConfig);
    const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
    return new $1a05aa95aa438aa8$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowTableResizing: allowTableResizing,
        allowTableAlignment: allowTableAlignment,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: tableState?.wasFullWidthModeEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isCommentEditor: // same as options.isTableScalingEnabled
            isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }).init();
};













class $aa5e4371d8281b79$export$2e2bcd8739ae039 {
    /**
   * @constructor
   */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        /**
     * Variables
     */ this.dom = void 0;
        this.contentDOM = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}


const $aeff2d6ebbdab783$var$DEFAULT_COL_SPAN = 1;
const $aeff2d6ebbdab783$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $aeff2d6ebbdab783$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $aeff2d6ebbdab783$var$cssVariablePattern = /^VAR\(--.*\)$/;
class $aeff2d6ebbdab783$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = (0, $63Ztt.getCellDomAttrs)(this.node);
        const nextAttrs = (0, $63Ztt.getCellDomAttrs)(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $63Ztt.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $aeff2d6ebbdab783$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $aeff2d6ebbdab783$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher);
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        this.delayHandle = void 0;
        this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                // eslint-disable-next-line compat/compat
                window?.cancelIdleCallback?.(this.delayHandle);
                window?.cancelAnimationFrame?.(this.delayHandle);
            }
        };
        if ($aeff2d6ebbdab783$var$cssVariablePattern.test(node.attrs.background)) this.delayHandle = $aeff2d6ebbdab783$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
}



var $jSnXV = parcelRequire("jSnXV");


var $8Yfbq = parcelRequire("8Yfbq");






















const $738e0202c4e34f01$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const { createPluginState: $738e0202c4e34f01$export$656c7661095efe2e, createCommand: $738e0202c4e34f01$export$8d4021544bdece00 } = (0, $lkJUe.pluginFactory)((0, $1562ea854f0ae047$export$18d4026d1ea86bb1), $738e0202c4e34f01$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});


const $1e600b287caa90c3$export$dd348cf8bfd51272 = (rowState)=>(0, $738e0202c4e34f01$export$8d4021544bdece00)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $1e600b287caa90c3$export$98af81c5504c750e = (pos)=>(0, $738e0202c4e34f01$export$8d4021544bdece00)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));








// limit scroll event calls
const $41994fbd33408f1b$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $41994fbd33408f1b$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $41994fbd33408f1b$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.shouldSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    const isInsideLayout = (0, $8m4tT.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })?.node;
                    if (isInsideLayout) return false;
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
      # Overview
        I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
        The format of the states are;    {top|bottom}:{in|above|below}
        ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
         For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
        above and out of the viewport
         This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
       # States
        top:in / bottom:in - NOT sticky
        top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:in / bottom:below - NOT sticky
        top:above / bottom:in - STICKY
        top:above / bottom:above - NOT sticky
        top:above / bottom:below - STICKY
        top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:below - NOT sticky
       # Summary
        The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
        is in or below it.
      */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $fbbb9ee8877c285e$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isSticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $fbbb9ee8877c285e$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotSticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isSticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $41994fbd33408f1b$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $41994fbd33408f1b$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.isHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) this.isInNestedTable = (0, $sxTNo.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        } catch (e) {}
        else if (pos) this.isInNestedTable = (0, $sxTNo.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
    }
}












































// limit scroll event calls
const $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $9ce7b5ba4bcfa9b7$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) {
            if (!newNodeIsHeaderRow && this.isHeaderRow) this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`)?.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
            return false; // re-create nodeview
        }
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.overflowObserver && this.overflowObserver.disconnect();
            this.overflowObserverEntries = undefined;
            this.stickyStateObserver && this.stickyStateObserver.disconnect();
            this.nodeVisibilityObserver?.disconnect();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
            if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_5')) {
                this.scrollListener = ()=>{
                    if (this.hasScrolledSinceLoad) return;
                    this.hasScrolledSinceLoad = true;
                    if (!this.overflowObserver) return;
                    // Re-check intersection state now that scrolling has occurred
                    const entries = this.overflowObserverEntries ?? this.overflowObserver.takeRecords();
                    this.overflowObserverEntries = undefined;
                    /** NOTE: This logic is duplicated in the overflowObserver callback
           *  to avoid conflicting with a follow up refactor where this will
           *  be cleaned up.
           */ entries.forEach((entry)=>{
                        const tableWrapper = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
                        if (tableWrapper && tableWrapper instanceof HTMLElement && (!(0, $c2cd42e9bb213cdd$export$732358707dcc2511)(entry) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true) || !(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true))) {
                            if (entry.isIntersecting) {
                                tableWrapper.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = true;
                            } else {
                                tableWrapper.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = false;
                            }
                            this.refreshLegacyStickyState();
                        }
                    });
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.editorScrollableElement.addEventListener('scroll', this.scrollListener, {
                    passive: true,
                    once: true
                });
            }
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.scrollListener && this.editorScrollableElement) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = undefined;
        }
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    initOverflowObserver() {
        const tableWrapper = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        if (!tableWrapper) return;
        const options = {
            root: tableWrapper,
            threshold: 1
        };
        this.overflowObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (!(observer.root instanceof HTMLElement)) return;
                // Only apply classes if page has scrolled since load
                if (!this.hasScrolledSinceLoad && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_5')) {
                    this.overflowObserverEntries = entries;
                    return;
                }
                if (entry.isIntersecting) {
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        if (!this.disableNativeSticky) this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = true;
                } else {
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = false;
                }
                this.refreshLegacyStickyState();
                if ((0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) this.api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).STICKY_HEADER_METHOD_TOGGLED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE_STICKY_HEADER,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        nativeStickyHeaderEnabled: entry.isIntersecting
                    }
                });
            });
        }, options);
    }
    /**
   * This observer is used to track the 'stuck' state of the header row.
   * This roughly mimics `(at)container scroll-state(stuck: top)` in CSS,
   * but with full browser support.
   */ initStickyStateObserver() {
        if (!this.editorScrollableElement || !(this.editorScrollableElement instanceof Element)) return;
        const options = {
            root: this.editorScrollableElement,
            rootMargin: `-${(0, $1zav4.tableMarginTop) + 1}px 0px 0px 0px`,
            threshold: 1
        };
        this.stickyStateObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const tableContainer = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
                if (entry.intersectionRect.top === entry.rootBounds?.top && (!this.disableNativeSticky || !(0, $dh538.fg)('platform_editor_table_sticky_header_patch_4'))) {
                    this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) tableContainer.dataset.tableHeaderIsStuck = 'true';
                } else {
                    this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) {
                        if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_3')) delete tableContainer.dataset.tableHeaderIsStuck;
                        else tableContainer.dataset.tableHeaderIsStuck = 'false';
                    }
                }
            });
        }, options);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        if (this.isHeaderRow && !this.isInNestedTable) {
            if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) this.dom.style.setProperty('anchor-name', this.dom.getAttribute('data-node-anchor') ?? '');
            this.initOverflowObserver();
            if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.initNodeVisibilityObserver();
            const closestTable = this.dom.closest('table');
            if (closestTable) {
                this.overflowObserver?.observe(closestTable);
                if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.nodeVisibilityObserver?.observe(closestTable);
            }
            this.initStickyStateObserver();
            this.stickyStateObserver?.observe(this.dom);
        }
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // initialise intersection observer to track whether table is in scroll area
    initNodeVisibilityObserver() {
        this.nodeVisibilityObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!this.isNativeSticky) return;
                if (entry.intersectionRatio !== 0 && entry.intersectionRatio !== 1) return;
                if (this.disableNativeSticky === true) this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                if (this.disableNativeSticky === false) this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            });
        }, {
            threshold: [
                0,
                0.05,
                0.95,
                1
            ]
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
                    }
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        const viewportHeight = this.editorContentAreaHeight ?? (0, $c80e8922e1b59353$export$4d09e1a8cc78d53);
                        this.toggleDisableNativeSticky(newHeight, viewportHeight);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshLegacyStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshLegacyStickyState() {
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        if (this.isNativeSticky) {
            this.makeRowHeaderNotLegacySticky(table);
            return;
        }
        const shouldStick = this.shouldSticky();
        if (this.isLegacySticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowLegacySticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotLegacySticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    const isInsideLayout = (0, $8m4tT.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })?.node;
                    if (isInsideLayout) return false;
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
    # Overview
     I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
     The format of the states are;    {top|bottom}:{in|above|below}
     ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
     above and out of the viewport
      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
    # States
     top:in / bottom:in - NOT sticky
     top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:in / bottom:below - NOT sticky
     top:above / bottom:in - STICKY
     top:above / bottom:above - NOT sticky
     top:above / bottom:below - STICKY
     top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:below - NOT sticky
    # Summary
     The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
     is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotLegacySticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $fbbb9ee8877c285e$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isLegacySticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowLegacySticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isLegacySticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isLegacySticky) {
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isLegacySticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotLegacySticky(table, isEditorDestroyed = false) {
        if (!this.isLegacySticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isLegacySticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $fbbb9ee8877c285e$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
            this.onEditorContentAreaHeightChange?.();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isLegacySticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        this.api = void 0;
        /** Native sticky header variables */ this.overflowObserver = void 0;
        this.stickyStateObserver = void 0;
        this.hasScrolledSinceLoad = false;
        this.scrollListener = void 0;
        this.overflowObserverEntries = void 0;
        this.isNativeSticky = void 0;
        this.disableNativeSticky = false;
        this.onEditorContentAreaHeightChange = void 0;
        this.editorContentAreaHeight = void 0;
        this.nodeVisibilityObserver = void 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
            if (this.isLegacySticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.toggleDisableNativeSticky = (headerHeight, viewportHeight)=>{
            if (!this.disableNativeSticky && headerHeight > viewportHeight * 0.5) {
                this.disableNativeSticky = true;
                if (this.isNativeSticky === undefined) this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            }
            if (this.disableNativeSticky && headerHeight <= viewportHeight * 0.5) this.disableNativeSticky = false;
        };
        this.isHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        this.isLegacySticky = false;
        const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        this.api = api;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        if (pos) this.isInNestedTable = (0, $sxTNo.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
        if (this.isHeaderRow && this.isStickyHeaderEnabled && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.onEditorContentAreaHeightChange = api?.table?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.editorContentAreaHeight && nextSharedState?.editorContentAreaHeight !== this.editorContentAreaHeight) {
                this.editorContentAreaHeight = nextSharedState.editorContentAreaHeight;
                this.toggleDisableNativeSticky(this.stickyRowHeight ?? 0, nextSharedState.editorContentAreaHeight);
            }
        });
    }
}


const $6edebf68ab9a523e$export$58b58f8ab97e94ed = (options)=>{
    return (node, view, getPos)=>{
        return (0, $1a05aa95aa438aa8$export$f0e1dd383a612bf9)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor, options?.allowFixedColumnWidthOption);
    };
};
const $6edebf68ab9a523e$export$cb505927d54cfbe6 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $aeff2d6ebbdab783$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $6edebf68ab9a523e$export$182d82ed34901998 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $aeff2d6ebbdab783$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $6edebf68ab9a523e$export$2b8a69d954e9d30 = (options)=>{
    return (node, view, getPos)=>{
        if ((0, $425e1bfad150b07f$export$2ee7329d46115d8f)(options.isDragAndDropEnabled ?? false) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) return new (0, $9ce7b5ba4bcfa9b7$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
        else return new (0, $41994fbd33408f1b$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    };
};





























const $331e9acffee27015$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) {
        const table = (0, $id9O1.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $3824I.TABLE_ACTION).REPLACED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};

























const $91aa52f15622bdd0$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
                content.push(...(0, $8m4tT.flatten)(maybeCell, false).map((child)=>child.node));
                return false;
            }
            return true;
        });
        return content;
    }
    return maybeTable;
};
// Flattens nested tables after a given nesting depth
// If this looks familiar, it's a heavily modified version of `mapFragment` which has been
// adjusted to support tracking nesting depth. This wasn't possible by using `mapFragment` directly
const $91aa52f15622bdd0$var$unwrapNestedTables = (content, schema, unwrapNestDepth, currentNestDepth = 0)=>{
    const flattenNested = (node, tableDepth)=>{
        if (node.type === schema.nodes.table) {
            if (tableDepth >= unwrapNestDepth) return $91aa52f15622bdd0$export$c2e425c24c996f14(node);
            return node;
        }
        return node;
    };
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? flattenNested(node, currentNestDepth) : flattenNested(node.copy((0, $5SAOw.Fragment).fromArray($91aa52f15622bdd0$var$unwrapNestedTables(node.content, schema, unwrapNestDepth, node.type === schema.nodes.table ? currentNestDepth + 1 : currentNestDepth))), currentNestDepth);
        if (transformed) {
            if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return children;
};
const $91aa52f15622bdd0$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $91aa52f15622bdd0$export$c2e425c24c996f14(node) : node;
};
const $91aa52f15622bdd0$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $91aa52f15622bdd0$export$c2e425c24c996f14(node) : node;
};
const $91aa52f15622bdd0$export$8bc9a7cde47c4f8e = (slice, schema, selection)=>{
    const isNestingAllowed = (0, $iu6m9.editorExperiment)('nested-tables-in-tables', true);
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let openEnd = slice.openEnd;
    const newFragment = (0, $3Ter7.flatmap)(slice.content, (node, i, fragment)=>{
        // if pasted content is a node that supports nesting a table
        // such as layoutSection or expand allow 1 level by default
        let allowedTableNesting = 1;
        const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
        const isPasteInTable = (0, $8m4tT.hasParentNodeOfType)([
            table,
            tableCell,
            tableHeader
        ])(selection);
        const isPasteInNestedTable = (0, $sxTNo.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1;
        const isPasteFullTableInsideEmptyCellEnabled = (0, $dh538.fg)('platform_editor_paste_full_table_inside_empty_cell');
        // Pasted content only contains a table and no other content
        const isCellPaste = isPasteInTable && slice.content.childCount === 1 && slice.content.firstChild?.type === table && (!isPasteFullTableInsideEmptyCellEnabled || slice.openStart !== 0 && slice.openEnd !== 0);
        if (isNestingAllowed) {
            // if nesting is allowed we bump up the default nesting allowance to 2 to support
            // two levels of nesting in nodes that support table nesting already such as layoutSection and expands
            allowedTableNesting = 2;
            // however if pasted content is a table, allow just one level
            if (node.type === schema.nodes.table) {
                allowedTableNesting = 1;
                // if paste is inside a table, allow no further nesting
                if (isPasteInTable) allowedTableNesting = 0;
                // unless we are pasting inside a nested table, then bounce back to 1 level
                // because editor-plugin-paste will lift the table to the parent table (just below it)
                if (isPasteInNestedTable) allowedTableNesting = 1;
                // paste of table cells into a table cell - content is spread across multiple cells
                // by editor-tables so needs to be treated a little differently
                if (isCellPaste || isCellSelection) {
                    allowedTableNesting = 1;
                    if (isPasteInNestedTable) allowedTableNesting = 0;
                }
            }
            // Prevent invalid openEnd after pasting tables with a selection that ends inside a nested table cell.
            // If the slice ends with a selection that ends inside a nested table, and we paste inside a table we
            // need to adjust the openEnd because it is no longer correct. If we don't, Prosemirror fires an exception
            // because it iterates to a non-existent depth and the transform will not be applied
            if (slice.openEnd >= 7 && // depth of a nested table cell
            slice.content.childCount > 1 && slice.content.lastChild?.type === table && isPasteInTable) // re-point the slice's openEnd to non-nested table cell depth
            openEnd = 4;
        } else // for layouts and expands, we start with 1 level of nesting as set above
        // if pasted content is a table, don't allow further nesting
        if (node.type === schema.nodes.table) allowedTableNesting = 0;
        if (isCellSelection && !isCellPaste) // if pasting into a cell selection, we need to flatten the parent table as well
        return $91aa52f15622bdd0$var$unwrapNestedTables((0, $5SAOw.Fragment).fromArray([
            node
        ]), schema, allowedTableNesting);
        else {
            // after we've worked out what the allowed nesting depth is, unwrap nested tables
            const newChildren = $91aa52f15622bdd0$var$unwrapNestedTables(node.content, schema, allowedTableNesting);
            return node.copy((0, $5SAOw.Fragment).fromArray(newChildren));
        }
    });
    return new (0, $5SAOw.Slice)(newFragment, slice.openStart, openEnd);
};
const $91aa52f15622bdd0$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak?.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $91aa52f15622bdd0$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $91aa52f15622bdd0$var$isNodeSingleCellTable = (node, schema)=>{
    return node.childCount === 1 && node.firstChild?.type === schema.nodes.tableRow && node.firstChild.childCount === 1 && (node.firstChild.firstChild?.type === schema.nodes.tableCell || node.firstChild.firstChild?.type === schema.nodes.tableHeader);
};
const $91aa52f15622bdd0$var$isFragmentSingleCellTable = (fragment, schema)=>{
    return fragment.childCount === 1 && fragment.firstChild !== null && $91aa52f15622bdd0$var$isNodeSingleCellTable(fragment.firstChild, schema);
};
const $91aa52f15622bdd0$var$containsNonTableBlockChildren = (fragment, schema)=>{
    let containsNonTableBlock = false;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    fragment.forEach((node)=>{
        if (node.isBlock && ![
            table,
            tableCell,
            tableHeader
        ].includes(node.type)) containsNonTableBlock = true;
    });
    return containsNonTableBlock;
};
const $91aa52f15622bdd0$export$7932630df6a9b5d9 = (slice, schema)=>{
    // Case 1: A slice of a block selection inside a nested table
    // Prosemirror wraps nested block selections in their respective tables
    // We are using `safeInsert` to paste nested tables, so we do not want to preserve this wrapping
    // slice starts and ends inside a nested table at the same depth
    if (slice.openStart >= 7 && slice.openEnd >= 7) {
        let cleaned = slice;
        let descendedDepth = 0;
        const tableDepthDecrement = 2;
        // if the slice is a single cell table and contains cells with single cell tables, descend into it until we find textblock children
        if ($91aa52f15622bdd0$var$isFragmentSingleCellTable(slice.content, schema)) slice.content.firstChild?.descendants((node)=>{
            if ($91aa52f15622bdd0$var$isNodeSingleCellTable(node, schema)) descendedDepth += tableDepthDecrement;
            else if (node.type === schema.nodes.table) return false;
            else if ($91aa52f15622bdd0$var$containsNonTableBlockChildren(node.content, schema)) {
                descendedDepth += tableDepthDecrement;
                // create a new slice with the content of non-table block children and the depth of the nested tables subtracted
                cleaned = new (0, $5SAOw.Slice)(node.content, slice.openStart - descendedDepth - tableDepthDecrement, slice.openEnd - descendedDepth - tableDepthDecrement);
                return false;
            }
        });
        if (!cleaned.eq(slice)) return cleaned;
    }
    // Case 2: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    slice.content.firstChild.type === schema.nodes.table) {
        // we're removing the table, tableRow and tableCell reducing the open depth by 3
        const depthDecrement = 3;
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (slice.content.firstChild?.content?.firstChild?.content?.firstChild?.type === schema.nodes.table) cleaned = new (0, $5SAOw.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $5SAOw.Slice)((0, $3Ter7.flatmap)(cleaned.content, $91aa52f15622bdd0$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 3: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && slice.content.firstChild?.type === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $5SAOw.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $91aa52f15622bdd0$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $91aa52f15622bdd0$export$cbabf4b236642ebb(state) {
    const tableState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $91aa52f15622bdd0$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $3Ter7.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};


const $acc346d62149cd5a$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, fullWidthModeEnabled, previousFullWidthModeEnabled, dragAndDropEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption)=>{
    const state = (0, $69d6e2a2c784f306$export$656c7661095efe2e)(dispatch, {
        pluginConfig: pluginConfig,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isDragAndDropEnabled: dragAndDropEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        ...(0, $780923e152cc8f13$export$4c0699e9a8272521),
        ...(0, $780923e152cc8f13$export$af473ce758096273),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    const getNodeView = ()=>{
        return {
            table: (0, $6edebf68ab9a523e$export$58b58f8ab97e94ed)({
                portalProviderAPI: portalProviderAPI,
                eventDispatcher: eventDispatcher,
                getEditorContainerWidth: getEditorContainerWidth,
                getEditorFeatureFlags: getEditorFeatureFlags,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            tableRow: (0, $6edebf68ab9a523e$export$2b8a69d954e9d30)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                isDragAndDropEnabled: dragAndDropEnabled
            }),
            tableCell: (0, $6edebf68ab9a523e$export$cb505927d54cfbe6)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableHeader: (0, $6edebf68ab9a523e$export$182d82ed34901998)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            })
        };
    };
    const nodeViews = getNodeView();
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        key: (0, $fedf15e5199146e8$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $f10f08824d624bfc$export$1c3f791fb2a5168)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $994471c61aed7ad3$export$d6d48849d9121a1)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $994471c61aed7ad3$export$d6d48849d9121a1)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            return {
                update: (view, prevState)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    let tableRef;
                    if ((0, $dh538.fg)('platform_editor_enable_table_dnd')) {
                        const parent = (0, $8m4tT.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                        let shouldSetTableRef = (0, $dh538.fg)('platform_editor_enable_table_dnd_patch_1') ? parent && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' : parent;
                        if ((0, $1oCLl.expValEquals)('platform_editor_table_update_table_ref', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_update_table_ref_fix')) shouldSetTableRef = parent && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && pluginInjectionApi?.interaction?.sharedState.currentState()?.interactionState !== 'hasNotHadInteraction';
                        if (shouldSetTableRef) tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                    }
                    if (pluginState.editorHasFocus) {
                        if (!(0, $dh538.fg)('platform_editor_enable_table_dnd')) {
                            const parent = (0, $8m4tT.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                            if (parent) tableRef = // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            parent.querySelector('table') || undefined;
                        }
                        const tableNode = (0, $id9O1.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = pluginPrevState?.tableNode !== tableNode?.node;
                            if (pluginPrevState?.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $LmqWp.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $LmqWp.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $4ca83755c936c9c8$export$79b661cbf50c3490)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $4ca83755c936c9c8$export$bf5ab08a5036bda8)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $4ca83755c936c9c8$export$99c5230572e6696d)()(state, dispatch);
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $4KOFJ.insideTable)(editorState) && (0, $91aa52f15622bdd0$export$cbabf4b236642ebb)(editorState)) slice = (0, $4ca83755c936c9c8$export$bb3294affcb5059f)(slice, schema);
                // This fixes pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $4KOFJ.insideTable)(editorState) && isCommentEditor && pluginConfig.allowTableAlignment && isTableScalingEnabled) slice = (0, $91aa52f15622bdd0$export$4e98c990eb0fdba6)(slice, schema);
                slice = (0, $91aa52f15622bdd0$export$fc3230cbfe498044)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $edTnG.transformSliceToRemoveOpenLayoutNodes)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $hcbpx.transformSliceToRemoveOpenExpand)(slice, schema);
                // transformSliceToRemoveOpenTable() transforms based on the depth of the root node, assuming that the tables will be at the root
                // Bodied extensions will contribute to the depth of the table selection so we need to remove them first
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $igNsz.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $91aa52f15622bdd0$export$7932630df6a9b5d9)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $igNsz.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $91aa52f15622bdd0$export$5354b8e5d3b01769)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $4ca83755c936c9c8$export$8fcd87e05a98248e)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $4ca83755c936c9c8$export$f4e57bcfd514085d)(slice, schema);
                else slice = (0, $4ca83755c936c9c8$export$80a571fa7de8754d)(slice, schema);
                slice = (0, $hcbpx.transformSliceToRemoveOpenNestedExpand)(slice, schema);
                if ((0, $sxTNo.isNestedTablesSupported)(schema)) slice = (0, $91aa52f15622bdd0$export$8bc9a7cde47c4f8e)(slice, schema, editorState.selection);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $de8398c45f744acc$export$18d4026d1ea86bb1).getState(state);
                const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                if ((0, $9283ce7d62ffd391$export$6577d2f7fe84e45c)(decorationSet).length) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if (browser.chrome && event.target) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER)) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $8m4tT.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $4vlwG.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                if (isKeyboardResize) {
                    (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $331e9acffee27015$export$ea73b328547c6ad5)(state, text, (0, $d925B.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: nodeViews,
            handleDOMEvents: {
                focus: (0, $f10f08824d624bfc$export$185584c64f36588),
                blur: (0, $f10f08824d624bfc$export$27d5d91e7417534c),
                mousedown: (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$b4a93e0b711d8f7)),
                mouseleave: (0, $f10f08824d624bfc$export$fcff8e67f71577c3),
                mousemove: (0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$3248c033e90a4ba0)(nodeViewPortalProviderAPI), pluginInjectionApi),
                mouseenter: (0, $f10f08824d624bfc$export$2560ef85393729a7),
                mouseup: (0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$88f4dbb0cd0ffc84)),
                click: (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$b981489921ee18cd)))
            },
            handleTripleClick: $f10f08824d624bfc$export$f17e34274dd6fcf5
        }
    });
};



/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 








const $d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $ks2lK.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $d6be50079e9249c7$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $ftzrq.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $ftzrq.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $ftzrq.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $ftzrq.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>$d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)?.decorations,
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
					 * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
					 * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
					 * The condition here checks to see if the entire text node is about to be swapped inside of an element
					 */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};







const $def0041f08b1347a$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $738e0202c4e34f01$export$656c7661095efe2e)(dispatch, initialState),
        key: (0, $1562ea854f0ae047$export$18d4026d1ea86bb1)
    });
};





// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid

var $dQl1W = parcelRequire("dQl1W");





var $04H9b = parcelRequire("04H9b");













class $8a4fbf3fe4f0ae86$var$ObjHash {
    static getForNode(node) {
        if (this.cache.has(node)) return this.cache.get(node) || '';
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid
        const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        this.cache.set(node, uniqueId);
        return uniqueId;
    }
}
$8a4fbf3fe4f0ae86$var$ObjHash.cache = new WeakMap();
const $8a4fbf3fe4f0ae86$var$getNodeAnchor = (node)=>{
    const handleId = $8a4fbf3fe4f0ae86$var$ObjHash.getForNode(node);
    return `--table-${node.type.name}-${handleId}`;
};
const $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations = (state)=>{
    const decs = [];
    let headerRowId;
    state.doc.nodesBetween(0, state.doc.content.size, (node, pos, parent, index)=>{
        const isTableHeader = node.type.name === 'tableHeader';
        const isTableRow = node.type.name === 'tableRow';
        const isParentTableRow = parent?.type.name === 'tableRow';
        const isParentTableHeaderRow = parent?.type.name === 'tableRow' && headerRowId && parent?.attrs?.localId === headerRowId;
        const shouldAddDecorationToHeader = (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? isParentTableHeaderRow && isTableHeader : isTableHeader;
        const isFirstRow = isTableRow && index === 0;
        if (isFirstRow) headerRowId = node.attrs.localId;
        // only apply to header cells and the first row of a table, for performance reasons
        if (isFirstRow || shouldAddDecorationToHeader) {
            const anchorName = $8a4fbf3fe4f0ae86$var$getNodeAnchor(node);
            const shouldAddAnchorNameInDecoration = !(0, $04H9b.isCSSAttrAnchorSupported)() && (0, $04H9b.isCSSAnchorSupported)() && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_8');
            const attributes = {
                'data-node-anchor': anchorName,
                'style': `anchor-name: ${anchorName};`
            };
            decs.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, shouldAddAnchorNameInDecoration ? attributes : {
                'data-node-anchor': anchorName
            }));
        }
        // only decend if there is a possible table row or table header node after the current node, for performance reasons
        return (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? !(isTableHeader || isParentTableHeaderRow) : !(isTableHeader || isParentTableRow);
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, decs);
};
const $8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableAnchorNamesPlugin');
const $8a4fbf3fe4f0ae86$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: (_config, state)=>{
                return $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations(state);
            },
            apply: (tr, decorationSet, _, newState)=>{
                if (tr.docChanged) return $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations(newState);
                return decorationSet;
            }
        },
        key: $8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1.getState(state) || (0, $ftzrq.DecorationSet).empty
        }
    });
};


/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 



var $fO7hX = parcelRequire("fO7hX");










const $d5b05171647091ac$var$pluginKey = new (0, $ks2lK.PluginKey)('tableLocalIdPlugin');
const $d5b05171647091ac$var$getPluginState = (state)=>state && $d5b05171647091ac$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $d5b05171647091ac$export$ae829ec7b2625219 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        key: $d5b05171647091ac$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($d5b05171647091ac$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($d5b05171647091ac$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
				 * Utilise the update cycle for _one_ scan through an initial doc
				 * to ensure existing tables without IDs get them when this plugin is
				 * enabled.
				 *
				 * This entire block can be skipped if we simply remove the `checkIsAddingTable`
				 * check in appendTransaction, but that comes with 2 cons:
				 *
				 * 1. require a transaction before we actually add the local IDs
				 * 2. ever slightly more unncessary checks
				 *
				 * Finally, this never happens in practice when utilising this in
				 * confluence, as the collab/synchrony initialisation process will
				 * trigger a transaction which adds tables, and thus this plugin will
				 * add/dedupe the necessary IDs. But general usage of the editor
				 * without collab should still solve for IDs.
				 */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $d5b05171647091ac$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $2P8Ax.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $fO7hX.uuid).generate()
                                });
                                return false;
                            }
                            /**
							 * Otherwise continue traversing, we can encounter tables nested in
							 * expands/bodiedExtensions
							 */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($d5b05171647091ac$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $kTbzR.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $fO7hX.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });













































const $85a33fc35d6cf43a$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)=>{
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    event.preventDefault();
    if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableColumnResize');
    const tr = view.state.tr;
    tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width) maxSize = editorWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199);
    else maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $fab8fdccc1cad2fc$export$c955b9a736441250)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const width = (0, $b61fc0745b235461$export$8f862fd911e06936)(view, localResizeHandlePos, cell.attrs);
    (0, $fab8fdccc1cad2fc$export$e747fb9908ce65b7)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $4ca83755c936c9c8$export$31eed8673ceee613)(nodeViewPortalProviderAPI, undefined, undefined, false)(state, dispatch);
    function finish(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mouseup', finish);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (resizeHandlePos === null) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)()(state, dispatch);
        }
        if (!(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos))) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            return;
        }
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({})(state, dispatch, view);
            else return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            const { startX: startX } = dragging;
            // If the dimensions of the table have changed through a remote modification by another
            // person for example don't persist the new column widths as we couldn't reliably remap them
            // For example, if a table col is deleted
            // There may be a more elegant solution to this, to avoid a jarring experience. This used to
            // be an equality check but that caused issues when a nested table would change (eg. when it
            // dynamically updates its width on resize)
            if (!(0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(originalTable, table)) {
                const map = (0, $LmqWp.TableMap).get(table);
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $iP1et.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(originalTable, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
                const newResizeState = (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, table, start, api)(tr);
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $3824I.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $d925B.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $d925B.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)(tr)(state, dispatch);
        }
    }
    function move(event) {
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos)) || !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $LmqWp.TableMap).get(table);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(table, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(state);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mouseup', finish);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mousemove', move);
    return true;
};





function $b3a746dda27eb371$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, isCommentEditor) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $452bdd9463f93418$export$18d4026d1ea86bb1),
        state: (0, $bd73f3b7ba9edc98$export$656c7661095efe2e)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state).resizeHandlePos || (0, $b432f0a26e9b5b59$export$3658aa65e79e3104)(view, event);
                    const { dragging: dragging } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
          	We need to start listening mouse events if column resize started from keyboard.
          	This will allow continue resizing via mouse
          */ const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $85a33fc35d6cf43a$export$b4a93e0b711d8f7)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $fab8fdccc1cad2fc$export$4d14ce8b526952e5)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}













var $adhil = parcelRequire("adhil");

var $l6okE = parcelRequire("l6okE");

var $cQ4aK = parcelRequire("cQ4aK");




















var $5a97dbfcccfa8f8d$var$TableSelectionDirection = /*#__PURE__*/ function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
    return TableSelectionDirection;
}($5a97dbfcccfa8f8d$var$TableSelectionDirection || {});
const $5a97dbfcccfa8f8d$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $7XFGZ.CellSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $adhil.GapCursorSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ks2lK.TextSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $7XFGZ.CellSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $adhil.GapCursorSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ks2lK.TextSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $iYC9s.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $cQ4aK.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $iYC9s.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $5a97dbfcccfa8f8d$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const rect = (0, $2QyFu.selectedRect)(state);
            if (table && (0, $iYC9s.isRowSelected)(rect.top)(selection)) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $LmqWp.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $5a97dbfcccfa8f8d$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const rect = (0, $2QyFu.selectedRect)(state);
            if (table && (0, $iYC9s.isColumnSelected)(rect.left)(selection)) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $4ca83755c936c9c8$export$e247ed8cec4832f4)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $LmqWp.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $adhil.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $adhil.Side).LEFT) {
                const table = (0, $id9O1.findTable)(selection);
                if (table && $5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $adhil.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $adhil.Side).RIGHT) {
                const table = (0, $id9O1.findTable)(selection);
                if (table && $5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $5a97dbfcccfa8f8d$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $LmqWp.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $7XFGZ.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $cQ4aK.RelativeSelectionPos).End;
            } else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $7XFGZ.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $cQ4aK.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $adhil.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $adhil.GapCursorSelection)($firstPosInsideCell, (0, $adhil.Side).LEFT) : (0, $ks2lK.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $adhil.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $adhil.GapCursorSelection)($lastPosInsideCell, (0, $adhil.Side).RIGHT) : (0, $ks2lK.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $adhil.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $adhil.GapCursorSelection)($beforeTablePos, (0, $adhil.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $adhil.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $adhil.GapCursorSelection)($afterTablePos, (0, $adhil.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable = ($pos, selection)=>(0, $l6okE.isSelectionAtStartOfNode)($pos, (0, $id9O1.findTable)(selection)?.node);
const $5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable = ($pos, selection)=>(0, $l6okE.isSelectionAtEndOfNode)($pos, (0, $id9O1.findTable)(selection)?.node);
const $5a97dbfcccfa8f8d$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const selectionRect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
            const index = selectionRect?.top;
            if (table && index === 0) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $iYC9s.isTableSelected)(selection);
            if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };


function $493109f8baa484ba$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    const list = {};
    const editorSelectionAPI = pluginInjectionApi?.selection;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveRight).common, (0, $5a97dbfcccfa8f8d$export$2e5835b1a25e33b)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveLeft).common, (0, $5a97dbfcccfa8f8d$export$2c7e1bbc14ebf0ec)(editorSelectionAPI)(), list);
    (0, $hgeg8.bindKeymapArrayWithCommand)((0, $hgeg8.selectColumn), (0, $5a97dbfcccfa8f8d$export$41a42e79fbe56d35)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $hgeg8.bindKeymapArrayWithCommand)((0, $hgeg8.selectRow), (0, $5a97dbfcccfa8f8d$export$b5ba3b60192c7a8d)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.shiftArrowUp).common, (0, $5a97dbfcccfa8f8d$export$ef446fa0355915f)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.selectTable).common, (0, $5a97dbfcccfa8f8d$export$1de5b4cd2a72d822)(editorSelectionAPI)(), list);
    return (0, $dus6D.keymap)(list);
}








const $030f86662bf3c0ad$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableSizeSelectorPlugin');
const $030f86662bf3c0ad$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $030f86662bf3c0ad$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({
                    isSelectorOpen: false
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($030f86662bf3c0ad$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return currentPluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...currentPluginState,
                            ...meta
                        };
                        dispatch($030f86662bf3c0ad$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return currentPluginState;
            }
        }
    });
};



/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 












const $0a5bcf7050b8ed19$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableWidthInCommentFixPlugin');
const $0a5bcf7050b8ed19$var$getPluginState = (state)=>state && $0a5bcf7050b8ed19$export$18d4026d1ea86bb1.getState(state);
const $0a5bcf7050b8ed19$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $0a5bcf7050b8ed19$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($0a5bcf7050b8ed19$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($0a5bcf7050b8ed19$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $0a5bcf7050b8ed19$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $2P8Ax.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $aFUXX.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($0a5bcf7050b8ed19$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};




/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 












var $2QYOD = parcelRequire("2QYOD");










parcelRequire("42omo");





var $7f6CO = parcelRequire("7f6CO");

const $a438db2af398b98d$export$25fb1502cf13990c = (props)=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    if (mode === 'edit') return null;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7f6CO.default), {
        ...props
    });
};



const $ef6a076f3671a2c9$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $ef6a076f3671a2c9$export$fb5c0ba8f0806db1 = 'is-disabled';
const $ef6a076f3671a2c9$export$665a01df2c44393a = 'data-sort-index';





const $1e532babbc96e86a$export$994e077cfffa9ab4 = new (0, $ks2lK.PluginKey)('tableViewModeSortPlugin');











const $b64e469133d270dc$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const tbody = tableElement.querySelector(`:scope > tbody`);
    const rows = tableElement.querySelectorAll(`:scope > tbody > tr`);
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody?.appendChild(rows[item.index + 1]);
    });
};
const $b64e469133d270dc$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        // TODO: ED-26961 - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $b64e469133d270dc$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $ef6a076f3671a2c9$export$b61cb5d3425147f)}`);
    if (widget?.classList.contains((0, $ef6a076f3671a2c9$export$fb5c0ba8f0806db1)) || !widget) return;
    const dataSortIndex = target?.closest('.ProseMirror-widget')?.getAttribute((0, $ef6a076f3671a2c9$export$665a01df2c44393a));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode?.attrs.localId;
    if (!tableId || !tableNode || tableNode?.type?.name !== 'table') return;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, direction: direction, order: oldOrder } = pluginState?.[tableId] || {};
    // Unsort if there was already a sort
    if (direction !== (0, $2QYOD.SortOrder).NO_ORDER && oldOrder !== undefined) $b64e469133d270dc$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            direction = (0, $2QYOD.SortOrder).ASC;
            break;
        case (0, $2QYOD.SortOrder).ASC:
            direction = (0, $2QYOD.SortOrder).DESC;
            break;
        case (0, $2QYOD.SortOrder).DESC:
            direction = (0, $2QYOD.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $2QYOD.SortOrder).ASC; // default direction when a new index is clicked
    const order = $b64e469133d270dc$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $2QYOD.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $b64e469133d270dc$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = tableElement?.querySelector(':scope > tbody');
    const rows = tableElement?.querySelectorAll(':scope > tbody > tr');
    return {
        tbody: tbody,
        rows: rows
    };
};


const $236c7224c8ab51a2$export$ae829ec7b2625219 = (api, nodeViewPortalProviderAPI)=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                // TODO: ED-26961 - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = api.editorViewMode?.sharedState.currentState() || {};
                if (mode !== 'view') {
                    const sortingDecorations = pluginState?.decorations?.find(undefined, undefined, (s)=>s?.type === 'sorting-decoration');
                    return {
                        ...pluginState,
                        decorations: pluginState?.decorations?.remove(sortingDecorations)
                    };
                }
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                const removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta?.[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
         * Create decorations for the sorting icons
         */ const decs = [];
                const sortingDecorations = pluginState.decorations.find(undefined, undefined, (spec)=>spec.tableId === tableId && spec.type === 'sorting-decoration');
                // TODO: ED-26961 - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta || isTableInState && !sortingDecorations.length) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $LmqWp.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                            const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                            decs.push((0, $ftzrq.Decoration).widget(cell + pos + 2, ()=>{
                                const element = document.createElement('div');
                                element.setAttribute((0, $ef6a076f3671a2c9$export$665a01df2c44393a), `${index}`);
                                element.classList.add((0, $ef6a076f3671a2c9$export$b61cb5d3425147f));
                                if (hasMergedCells) element.classList.add((0, $ef6a076f3671a2c9$export$fb5c0ba8f0806db1));
                                let sortOrdered;
                                if (index === sort[tableId]?.index) sortOrdered = sort[tableId]?.direction;
                                else sortOrdered = (0, $2QYOD.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(oldState);
                                nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $gmMgo.Provider), {
                                        value: getIntl()
                                    }, (0, $42omo.createElement)((0, $a438db2af398b98d$export$25fb1502cf13990c), {
                                        isSortingAllowed: !hasMergedCells,
                                        sortOrdered: sortOrdered,
                                        onClick: ()=>{},
                                        onKeyDown: ()=>{},
                                        api: api
                                    })), element, decorationRenderKey);
                                return element;
                            }, {
                                destroy: (node)=>{
                                    nodeViewPortalProviderAPI.remove(decorationRenderKey);
                                },
                                type: 'sorting-decoration',
                                tableId: tableId
                            }));
                        });
                    });
                    decorations = (0, $ftzrq.DecorationSet).create(tr.doc, decs);
                }
                /**
         * Map the decorations to the new document if there are changes
         */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $1e532babbc96e86a$export$994e077cfffa9ab4,
        appendTransaction: (trs, oldState, newState)=>{
            // return newState.tr;
            const { mode: mode } = api?.editorViewMode?.sharedState.currentState() || {};
            if (mode !== 'view') return newState.tr;
            let allTables = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(newState)?.allTables || [];
            /**
       * If incoming changes have affected a table node, remove the sorting. This prevents the
       * table from breaking if changes like merged cells are incoming.
       */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(oldState);
                const newPluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(newState);
                for (const table of allTables){
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = oldPluginState?.sort?.[tableId] || {};
                    if (isChangesIncoming) {
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = maybeTableNode?.attrs?.localId !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $b64e469133d270dc$export$8bb6f5de29aeee1e)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
           * Sort the table if the sort order has changed
           */ const { order: newOrder, direction: newDirection, index: newIndex } = newPluginState?.sort?.[tableId] || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $2QYOD.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $b64e469133d270dc$export$8bb6f5de29aeee1e)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody?.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO: ED-26961 - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        const pluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                        (0, $b64e469133d270dc$export$e9466f5bf01e21a7)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    const pluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                    (0, $b64e469133d270dc$export$e9466f5bf01e21a7)(view, event, pluginState);
                }
            },
            decorations (state) {
                const decs = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(state)?.decorations || (0, $ftzrq.DecorationSet).empty;
                return decs;
            }
        }
    });
};





parcelRequire("42omo");





var $7fmpI = parcelRequire("7fmpI");


var $kuh1P = parcelRequire("kuh1P");





var $7x0qS = parcelRequire("7x0qS");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





















var $jwWgu = parcelRequire("jwWgu");


var $a4eZN = parcelRequire("a4eZN");








var $ghftu = parcelRequire("ghftu");


























/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766












var $1j8OE = parcelRequire("1j8OE");




var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $3e9f2b46b7207c53$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #292A2E)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #3B3D42)"};
  }
`;















var $dZ8uq = parcelRequire("dZ8uq");







/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766














const $a1b9a7d0f0cb60f0$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{background:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";display:none;position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";", cssString, ";}");
const $a1b9a7d0f0cb60f0$var$Marker = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $fbbb9ee8877c285e$export$a3e71c692f2c2213)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $fbbb9ee8877c285e$export$a3e71c692f2c2213)}px`,
        borderRadius: "var(--ds-radius-full, 9999px)",
        pointerEvents: 'none'
    });
const $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER, "{", $a1b9a7d0f0cb60f0$var$Marker(), ";", cssString, ";}");
const $a1b9a7d0f0cb60f0$var$Button = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)("border-radius:var(--ds-radius-small, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $a1b9a7d0f0cb60f0$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`, ";background-color:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}");
const $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`, ";background-color:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";position:relative;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}");
const $a1b9a7d0f0cb60f0$var$InsertButton = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{height:", (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c), "px;width:", (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N60A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`};
      color: ${`var(--ds-icon, ${(0, $6fnsQ.N300)})`};
    `), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:flex;}");
const $a1b9a7d0f0cb60f0$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $6fnsQ.B300)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex) + 10, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $6fnsQ.N300)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $fbbb9ee8877c285e$export$d18320cc8ee69115)}px;
    width: ${(0, $fbbb9ee8877c285e$export$d18320cc8ee69115)}px;
  `), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $6fnsQ.B300)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $6fnsQ.B300)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 99, ";&.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
const $a1b9a7d0f0cb60f0$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $a1b9a7d0f0cb60f0$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    height: 2px;
    top: -11px;
	${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    left: ${(0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) - 1}px;
  `));
const $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{height:", (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e), "px;width:", (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
        background: ${(0, $fbbb9ee8877c285e$export$cd5e5900c9fa42dc)};
        color: ${(0, $fbbb9ee8877c285e$export$a699493d7d7580c3)};
      `), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $fbbb9ee8877c285e$export$9907ca2ad437ddcc), ";color:", (0, $fbbb9ee8877c285e$export$6cc2aa96833a5989), ";cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $1zav4.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $1zav4.tableMarginTop), "px;z-index:", (0, $aFUXX.akEditorShadowZIndex), ";width:", (0, $fbbb9ee8877c285e$export$1680d391e1ce7b96), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $6fnsQ.N40A)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, ").", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $6fnsQ.N40A)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, $fbbb9ee8877c285e$export$1680d391e1ce7b96), "px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{", $a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}");
const $a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $1zav4.tableMarginTopWithControl), "px);top:", (0, $1zav4.tableMarginTopWithControl), "px;}");
};
const $a1b9a7d0f0cb60f0$export$b9641ea8858d4b62 = (tableOverflowShadowWidth)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", tableOverflowShadowWidth, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}");
const $a1b9a7d0f0cb60f0$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $fbbb9ee8877c285e$export$95883e661e73a1d1),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $fbbb9ee8877c285e$export$83da30a15600a83e)
    });
const $a1b9a7d0f0cb60f0$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("tr th:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $a1b9a7d0f0cb60f0$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $a1b9a7d0f0cb60f0$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("div.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;right:-1px;}");
};
const $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $fbbb9ee8877c285e$export$62374dd2f63076b0) + (0, $1zav4.tableCellBorderWidth), "px;height:", (0, $fbbb9ee8877c285e$export$62374dd2f63076b0), "px;&::before{content:' ';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $a1b9a7d0f0cb60f0$var$columnHeaderButton(`
        border-right: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-top: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-bottom: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        box-sizing: content-box;
        height: ${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0) - (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b)}px;
        left: 0px;
        z-index: ${(0, $fbbb9ee8877c285e$export$da0ccd381b1a80f)};
      `), ";}}", $a1b9a7d0f0cb60f0$var$getFloatingDotOverrides(), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_TABLE, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";border-left:", (0, $1zav4.tableCellBorderWidth), "px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";left:-", (0, $1zav4.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-left:", (0, $1zav4.tableCellBorderWidth), "px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";left:-", (0, $1zav4.tableCellBorderWidth), "px;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}}");
};
const $a1b9a7d0f0cb60f0$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}}}");
const $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}");
const $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $9K4OG.css)(":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $6fnsQ.Y50)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $6fnsQ.Y200)})`, ";}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $a1b9a7d0f0cb60f0$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;}");
};
const $a1b9a7d0f0cb60f0$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7), "px;height:100%;top:0;right:-", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7) / 2, "px;cursor:col-resize;z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}tr th:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}", $a1b9a7d0f0cb60f0$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fbbb9ee8877c285e$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2
});
const $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $fbbb9ee8877c285e$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2
});
const $a1b9a7d0f0cb60f0$var$insertLineActiveColor = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)
});
const $a1b9a7d0f0cb60f0$var$insertLineInactiveColor = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`
});
const $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}}");


const $93fa7bbbefe5a956$var$cornerControlHeight = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1;
const $93fa7bbbefe5a956$export$af45328890cf2a82 = (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2;
const $93fa7bbbefe5a956$export$cc4d06b9af7cea87 = 44;
// Shared styling for numbered column buttons in selected state
const $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles = `
	border-bottom: 1px solid ${(0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)};
	border-color: ${(0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)};
	background-color: ${(0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1)};
	position: relative;
	z-index: ${(0, $aFUXX.akEditorUnitZIndex)};
	color: ${`var(--ds-text-selected, ${(0, $6fnsQ.N0)})`};
`;
const $93fa7bbbefe5a956$var$rangeSelectionStyles = `
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $93fa7bbbefe5a956$var$rangeSelectionStylesForFakeBorders = `
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} .${(0, $1zav4.TableSharedCssClassName).TABLE_LEFT_BORDER},
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} .${(0, $1zav4.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
	  background: ${(0, $aFUXX.akEditorSelectedBorderColor)};
}
`;
const $93fa7bbbefe5a956$var$sentinelStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0)}px;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + (0, $fbbb9ee8877c285e$export$e5ff276883773ffd) * 2 + 23}px;
  }
  &.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
    > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0)}px;
    }
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
 > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0) + $93fa7bbbefe5a956$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $aFUXX.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarContainerStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarStyles = `${$93fa7bbbefe5a956$var$stickyScrollbarContainerStyles} ${$93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles}`;
const $93fa7bbbefe5a956$var$shadowSentinelStyles = `
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $93fa7bbbefe5a956$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(">*:not([data-mark-type='fragment']) .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $93fa7bbbefe5a956$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("th{.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":hover)){>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}}");
};
const $93fa7bbbefe5a956$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    /*
  This is MAGIC!
  This fixes a bug which occurs in firefox when the first row becomes sticky.
  see https://product-fabric.atlassian.net/browse/ED-19177
   */ if (browser.gecko) return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle = (props)=>/*#__PURE__*/ (0, $9K4OG.css)((0, $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc)(), ";", (0, $a1b9a7d0f0cb60f0$export$4d63bf225990ad34)(), ";", (0, $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0)(), ";", (0, $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85), ";", (0, $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad)(), ";", (0, $a1b9a7d0f0cb60f0$export$8e36b812ea421d73)(), ";", $93fa7bbbefe5a956$var$rangeSelectionStyles, ";", $93fa7bbbefe5a956$var$rangeSelectionStylesForFakeBorders, ";", $93fa7bbbefe5a956$var$viewModeSortStyles(), ";", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $93fa7bbbefe5a956$var$tableAnchorStyles, ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, "{background-color:", (0, $fbbb9ee8877c285e$export$3efa753685336605), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";border-bottom:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $a1b9a7d0f0cb60f0$export$d9daf73b486785b9)(), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $a1b9a7d0f0cb60f0$export$595c9c01d7c39885)(), ";}", (0, $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e)(), " ", (0, $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f)(), (0, $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050)(), (0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${0, $fbbb9ee8877c285e$export$83c60dd0aac17107}px;
			width: ${0, $aFUXX.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $aFUXX.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $fbbb9ee8877c285e$export$83c60dd0aac17107}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		` : `
    	.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${0, $fbbb9ee8877c285e$export$83c60dd0aac17107}px;
			width: ${0, $aFUXX.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $aFUXX.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $fbbb9ee8877c285e$export$83c60dd0aac17107}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		`, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $aFUXX.akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}", $93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $aFUXX.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px solid var(--ds-surface, white);margin-left:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px;position:fixed;display:grid;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $6fnsQ.N40A)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa), "px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";margin-right:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $93fa7bbbefe5a956$export$af45328890cf2a82 + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, "{tr.sticky td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fbbb9ee8877c285e$export$72409f838e9c33c7) - (0, $fbbb9ee8877c285e$export$45d9825f76985b4e)) / 2 + 1, "px;}}tr.sticky td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",tr.sticky th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fbbb9ee8877c285e$export$72409f838e9c33c7) - (0, $fbbb9ee8877c285e$export$45d9825f76985b4e)) / 2, "px;}}}tr.sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ",tr.sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{z-index:1;}tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{position:sticky;top:", (0, $1zav4.tableMarginTop), "px;z-index:calc(", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex), " - 5);box-shadow:inset -1px 1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}::after {
				height: 100%;
				content: '';
				border-left: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
				border-bottom: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
				position: absolute;
				right: 0px;
				top: 0px;
				bottom: 0;
				width: 100%;
				display: inline-block;
				pointer-events: none;
			}` : ``, ";&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, "{box-shadow:inset -1px 1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{content:' ';display:block;top:0;box-sizing:border-box;width:100%;height:0;margin-bottom:-", (0, $1zav4.tableMarginTop), "px;position:sticky;border-top:", (0, $1zav4.tableMarginTop), "px solid var(--ds-surface, #FFFFFF);z-index:", (0, $fbbb9ee8877c285e$export$1279af870a198fea), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_2') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY})::before {
			border-top: ${0, $1zav4.tableMarginTop}px solid transparent;
		}

		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE})::before {
			border-top: ${0, $1zav4.tableMarginTop}px solid ${"var(--ds-surface, #FFFFFF)"};
		}` : (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY})::before {
				margin-top: 1px;
			}` : ``, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{top:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;z-index:", (0, $fbbb9ee8877c285e$export$471fb2a0b2f2f936), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER}:has(~ .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW}) {
			margin-top: 0;
		}
	` : ``, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-table-header-is-stuck='true']:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{z-index:", (0, $fbbb9ee8877c285e$export$7b64f35449327c05), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " ", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? `tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY}` : '', ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{top:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;}.pm-table-wrapper:has([data-number-column='true'] tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth), "px;width:calc(100% + ", (0, $aFUXX.akEditorTableNumberColumnWidth), "px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "[data-table-header-is-stuck='true'] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE, ":is([data-row-index='0'], [data-selected-row-index='0']:not([data-handle-appearance='default'])){visibility:hidden;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{top:", (0, $1zav4.tableMarginTop), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $fbbb9ee8877c285e$export$880976487022eb5), "px;}", (0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY} > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${0, $fbbb9ee8877c285e$export$880976487022eb5}px;
		}
		` : `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${0, $fbbb9ee8877c285e$export$880976487022eb5}px;
		}
		`, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{border-top:", (0, $fbbb9ee8877c285e$export$880976487022eb5) - (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px solid var(--ds-surface, white);}", $93fa7bbbefe5a956$var$sentinelStyles, " ", (0, $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c)(props.featureFlags?.tableDragAndDrop), " ", $93fa7bbbefe5a956$var$stickyScrollbarStyles, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;&::after{right:6px!important;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-4px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$e5ff276883773ffd) - 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", (0, $fbbb9ee8877c285e$export$40311377f05dbfc4), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}.", (0, $1zav4.TableSharedCssClassName).TABLE_LEFT_BORDER, "{left:8px;}.", (0, $1zav4.TableSharedCssClassName).TABLE_RIGHT_BORDER, "{right:8px;}}>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $93fa7bbbefe5a956$var$breakoutWidthStyling(), " ", (0, $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a)(), ";", (0, $a1b9a7d0f0cb60f0$export$a2258906ae78ec82)(), ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, "{width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;height:", $93fa7bbbefe5a956$var$cornerControlHeight, "px;display:none;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";border-radius:0;border-top-left-radius:", (0, $fbbb9ee8877c285e$export$371da7842ff35a5b), "px;background:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";background:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{width:", (0, $aFUXX.akEditorTableToolbarSize) + (0, $aFUXX.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";background:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";cursor:pointer;}:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";background:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;box-sizing:border-box;display:none;position:relative;", (0, $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $a1b9a7d0f0cb60f0$export$c7c73467b57835d)(`
        border-bottom: 1px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b)}px;

        .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $fbbb9ee8877c285e$export$371da7842ff35a5b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $fbbb9ee8877c285e$export$45aeeddcedd441ab) + 4, ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{height:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;width:100%;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $6fnsQ.N0)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, $a1b9a7d0f0cb60f0$export$125caa90718a4ea9)(), " :not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{", (0, $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4)(), " ", (0, $a1b9a7d0f0cb60f0$export$7f243984d41e6570)(), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $aFUXX.akEditorTableToolbarSize), "px;top:", props.isDragAndDropEnabled || (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, $aFUXX.akEditorTableToolbarSize), "px;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:", (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? (0, $aFUXX.relativeSizeToBaseFontSize)(10) : `10px`, " 2px;text-align:center;font-size:", (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? (0, $aFUXX.relativeSizeToBaseFontSize)(14) : (0, $aFUXX.relativeFontSizeToBase16)(14), ";background-color:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";color:", (0, $fbbb9ee8877c285e$export$14da8da34a807702), ";border-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}", (0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER} {
				.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		` : `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY} {
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		`, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{display:block;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active{", $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles, ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}}", (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? `/* Apply numbered column styling when table is selected via text selection (e.g., block menu) */
	.${0, $aFUXX.akEditorSelectedNodeClassName} {
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} {
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				${$93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles}
				${0, $ieXGd.hideNativeBrowserTextSelectionStyles}
			}
		}
	}` : '', " :not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{", $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $6fnsQ.R500)})`, ";position:relative;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}", (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? `.tableView-content-wrap.danger {
		:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING}) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				background-color: ${0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50};
				border: 1px solid ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
				border-left: 0;
				color: ${`var(--ds-text-danger, ${0, $6fnsQ.R500})`};
				position: relative;
				z-index: ${0, $aFUXX.akEditorUnitZIndex};
			}
		}
	}` : '', ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $aFUXX.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $fbbb9ee8877c285e$export$f26d047169b4195d), ";z-index:", (0, $aFUXX.akEditorSmallZIndex), ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{border-left-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-top-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";&::after{height:100%;width:100%;border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";display:inline-block;pointer-events:none;background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ",td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $aFUXX.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $93fa7bbbefe5a956$var$tableBorderStyles(), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $93fa7bbbefe5a956$var$tableBorderStyles(), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $1zav4.tableMarginTop), "px;left:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled ? `
			margin-top: ${0, $1zav4.tableMarginTop}px;
			top: 0;
			left: -${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $1zav4.tableMarginTop) - $93fa7bbbefe5a956$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b}px;
		`, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $1zav4.tableMarginTop), "px;}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `
	.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $1zav4.tableMarginTop}px;
		background: ${"var(--ds-surface, #FFFFFF)"};
		top: unset;
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) + 1};
	}` : `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $1zav4.tableMarginTop}px;
		background: ${"var(--ds-surface, #FFFFFF)"};
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) + 1};
	}`, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "::before{content:'';position:relative;display:inline-block;margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$c2ef52861254b274), "px;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$c2ef52861254b274), "px;height:", (0, $1zav4.tableMarginTop), "px;background:var(--ds-surface, #FFFFFF);z-index:", (0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) - 1, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type::before{content:'';position:absolute;display:inline-block;box-sizing:border-box;left:0;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;height:100%;margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth), "px;margin-top:-", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px;outline:", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `0.5px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}`, ";border-left:", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? 'none' : `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}`, ";background:var(--ds-background-accent-gray-subtlest, #F0F1F2);", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};` : ``, " ", (0, $d7ZU3.getBrowserInfo)().gecko && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `border-top: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};` : `border-top: none;`, ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') ? `.ak-editor-selected-node .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"]:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED}) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type {
			&::before {
				margin-top: 0;
			}
			&::after {
				width: 100%;
				border-left: 1px solid ${0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb};
				background: ${0, $fbbb9ee8877c285e$export$f26d047169b4195d};
			}
	}` : '', " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "):first-of-type::before,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ", .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, "):first-of-type::before{outline:none;border-left-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top-color: ${0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb};` : ``, " background:", (0, $fbbb9ee8877c285e$export$7c0a2e8110d12a28), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:first-of-type::before, .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
			outline: none;
			border-left: unset;
			border-top: unset;
			background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type::before, .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
		outline: none;
		border-left-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
		border-top-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
		background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}` : `	.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
			}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				border-left-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
				background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}`, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, " th:first-of-type::before{box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, " *){margin-top:", (0, $1zav4.tableMarginTop), "px!important;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_6') ? `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS}:has(tr.sticky) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			box-shadow: 0 -5px 0 1px ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
		}` : ``, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, "{overflow:visible;}");
const $93fa7bbbefe5a956$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $9K4OG.css)((0, $1zav4.tableSharedStyle)(), ";", $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle(props), ";");
const $93fa7bbbefe5a956$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror{", (0, $1oCLl.expValEquals)('platform_editor_ssr_renderer', 'isEnabled', true) ? $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle(props) : $93fa7bbbefe5a956$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $3e9f2b46b7207c53$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_CURSOR, "{cursor:col-resize;}", $93fa7bbbefe5a956$var$shadowSentinelStyles, ";");
const $93fa7bbbefe5a956$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $93fa7bbbefe5a956$export$61a2da566f69d1df = /*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $3e9f2b46b7207c53$export$b2380b18b089518f), ";}");
const $93fa7bbbefe5a956$var$tableAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)(".pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableHeader']{anchor-name:var(", (0, $04H9b.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}.pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableRow']{anchor-name:var(", (0, $04H9b.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}");


const $a9f4aaa0a150f4bb$var$BUTTON_WIDTH = 20;
const $a9f4aaa0a150f4bb$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $a9f4aaa0a150f4bb$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $a9f4aaa0a150f4bb$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $42omo.useRef)(null);
    const observerTargetRef = (0, $42omo.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $42omo.useRef)(0);
    const leftPosDataRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $a9f4aaa0a150f4bb$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $93fa7bbbefe5a956$export$af45328890cf2a82)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $2P8Ax.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = 0;
    const containerLeft = (0, $42omo.useMemo)(()=>{
        const container = targetCellRef.closest('[data-editor-container="true"]');
        return container?.getBoundingClientRect().left || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $42omo.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $a9f4aaa0a150f4bb$export$ed0fda2c59cbba0f({
            buttonWidth: $a9f4aaa0a150f4bb$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: fixedButtonRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: fixedButtonTop + stickyHeader.padding + offset * 2,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex),
                left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                left,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: "var(--ds-space-250, 20px)",
                // BUTTON_WIDTH
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON_FIXED,
            children: children
        })
    }), mountTo);
};
var $a9f4aaa0a150f4bb$export$2e2bcd8739ae039 = $a9f4aaa0a150f4bb$export$c947181980f67d40;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







const $dd69dcd623361863$export$554a9cb1559eb2d5 = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: `var(--ds-surface, ${(0, $6fnsQ.N20)})`,
            borderRadius: "var(--ds-radius-small, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $fbbb9ee8877c285e$export$3969371f057ce1e5) + 2}px`,
            width: "var(--ds-space-250, 20px)",
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, none)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${`var(--ds-surface, ${(0, $6fnsQ.N0)})`}`,
            borderRadius: '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30A)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, rgba(179, 212, 255, 0.6))"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
const $dd69dcd623361863$export$cd6af2ca27c1a823 = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: `var(--ds-background-selected, ${(0, $6fnsQ.N700)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: `var(--ds-background-selected-hovered, ${(0, $6fnsQ.N700)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: `var(--ds-background-selected-pressed, ${(0, $6fnsQ.N700)})`
        }
    });


const $35f649121590a9ea$var$BUTTON_OFFSET = 3;
const $35f649121590a9ea$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX = 2;
const $35f649121590a9ea$var$anchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    positionVisibility: 'anchors-visible',
    zIndex: $35f649121590a9ea$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX
});
const $35f649121590a9ea$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isDragAndDropEnabled: isDragAndDropEnabled, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $8m4tT.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $42omo.useEffect)(()=>{
        if (isCellMenuOpenByKeyboard && !isContextualMenuOpen) {
            const { state: state, dispatch: dispatch } = editorView;
            // open the menu when the keyboard shortcut is pressed
            (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
        }
    }, [
        isCellMenuOpenByKeyboard,
        isContextualMenuOpen,
        editorView
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $2CQVV.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dd69dcd623361863$export$554a9cb1559eb2d5)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isContextualMenuOpen && (0, $dd69dcd623361863$export$cd6af2ca27c1a823)()
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON,
        selected: isContextualMenuOpen,
        title: labelCellOptions,
        keymap: (0, $hgeg8.focusToContextMenuTrigger),
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": isContextualMenuOpen
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    const parentStickyNative = targetCellRef.parentElement && ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? tableWrapper?.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) : targetCellRef.parentElement.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY));
    if (parentStickyNative && targetCellRef.nodeName === 'TH' && (0, $425e1bfad150b07f$export$2ee7329d46115d8f)(isDragAndDropEnabled ?? false) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        /* We need to default to checking the anchor style because there may be a conflict with the block controls
     plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
     */ let rowAnchorName = targetCellRef.parentElement?.style.getPropertyValue('anchor-name');
        let colAnchorName = targetCellRef.style.getPropertyValue('anchor-name');
        if (rowAnchorName === '') rowAnchorName = targetCellRef.parentElement?.dataset.nodeAnchor;
        if (colAnchorName === '') colAnchorName = targetCellRef?.dataset.nodeAnchor;
        if (!(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $35f649121590a9ea$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
        if (rowAnchorName && colAnchorName) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $35f649121590a9ea$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
    }
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a9f4aaa0a150f4bb$export$2e2bcd8739ae039), {
        offset: $35f649121590a9ea$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isContextualMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        offset: [
            $35f649121590a9ea$var$BUTTON_OFFSET,
            -$35f649121590a9ea$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $aFUXX.akEditorSmallZIndex)
    }, button);
});
const $35f649121590a9ea$var$FloatingContextualButton = (0, $gmMgo.default)($35f649121590a9ea$var$FloatingContextualButtonInner);
function $35f649121590a9ea$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($35f649121590a9ea$var$FloatingContextualButton, props));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
























/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





















var $lwMQJ = parcelRequire("lwMQJ");


var $8LFdJ = parcelRequire("8LFdJ");

var $hxEux = parcelRequire("hxEux");

var $ahQKW = parcelRequire("ahQKW");


var $9Z3I5 = parcelRequire("9Z3I5");

var $5v8Ta = parcelRequire("5v8Ta");

var $h4TOP = parcelRequire("h4TOP");


var $1eLzC = parcelRequire("1eLzC");





var $6icEc = parcelRequire("6icEc");






var $7TXtV = parcelRequire("7TXtV");





var $lZgFC = parcelRequire("lZgFC");


var $4nv4H = parcelRequire("4nv4H");


































// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766











const $992337a348060053$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $992337a348060053$export$62225ca66ffe289c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N60A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`, ";display:block;position:absolute;top:0;left:", isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:20px;height:20px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:", `var(--ds-icon, ${(0, $6fnsQ.N90)})`, ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $6fnsQ.N90)})`, ";}}");


const $cea27b5fb5fc6748$var$arrowsList = new Set([
    'ArrowRight',
    'ArrowLeft'
]);
const $cea27b5fb5fc6748$var$elementBeforeIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
class $cea27b5fb5fc6748$export$f55c8e309b1cad66 extends (0, $42omo.Component) {
    componentDidMount() {
        // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
        // until user pressed ArrowDown.
        // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
        // so here is triggering componentDidUpdate inside dropdown to set focus on first element
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        if (isCellMenuOpenByKeyboard) this.setState({
            ...this.state,
            isOpenAllowed: isCellMenuOpenByKeyboard
        });
    }
    componentDidUpdate() {
        const { isDragAndDropEnabled: isDragAndDropEnabled, isContextualMenuOpen: isContextualMenuOpen } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(this.props.editorView.state);
        if (isDragAndDropEnabled && this.props.isDragMenuOpen && isContextualMenuOpen) (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(this.props.editorView.state, this.props.editorView.dispatch);
    }
    render() {
        const { isOpen: isOpen, offset: offset, boundariesElement: boundariesElement, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, api: api } = this.props;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
        const items = isDragAndDropEnabled ? this.createNewContextMenuItems() : this.createOriginalContextMenuItems();
        let isOpenAllowed = false;
        isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1eLzC.UserIntentPopupWrapper), {
            userIntent: "tableContextualMenuPopupOpen",
            api: api
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $h4TOP.default), {
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            arrowKeyNavigationProviderOptions: {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: !isCellMenuOpenByKeyboard || this.state.isSubmenuOpen
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d),
            shouldFocusFirstItem: ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            },
            boundariesElement: boundariesElement,
            offset: offset,
            section: isDragAndDropEnabled ? {
                hasSeparator: true
            } : undefined,
            allowEnterDefaultBehavior: this.state.isSubmenuOpen
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        };
        this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.handleSubMenuRef = (ref)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const dom = this.props.editorView.dom;
            const parent = (0, $4vlwG.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $4vlwG.closestElement)(dom, '.ak-editor-content-area');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (!!this.props.mountPoint) return;
            const offsetParent = ref?.offsetParent;
            if (!offsetParent) return;
            const offsetParentRect = offsetParent.getBoundingClientRect();
            const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
            const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
            if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
            // if it overflows regardless of side, let it overlap with the parent menu
            if (leftOverflow > 0 && rightOverflow > 0) {
                if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
                else ref.style.left = `-${rect.width - leftOverflow}px`;
            }
        };
        this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowBackgroundColor) {
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $6icEc.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
                const selectedRowAndColumnFromPalette = (0, $ahQKW.getSelectedRowAndColumnFromPalette)((0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                background, (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb));
                const selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                const selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                return {
                    content: isDragAndDropEnabled ? formatMessage((0, $2CQVV.messages).backgroundColor) : formatMessage((0, $2CQVV.messages).cellBackground),
                    value: {
                        name: 'background'
                    },
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7TXtV))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).backgroundColor)
                    })) : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $992337a348060053$export$bc7b8b99ac8e8073)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON
                    }), isSubmenuOpen && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hxEux.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        paletteOptions: {
                            palette: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
                            paletteColorTooltipMessages: (0, $8LFdJ.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $6icEc.hexToEditorBackgroundPaletteColor)
                        }
                    })))),
                    'aria-expanded': isSubmenuOpen
                };
            }
        };
        // Used in the NewContextMenuItems object
        this.newDistributeColumnsItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.createDistributeColumnsItemInternal({
                elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).distributeColumns)
                }))
            });
        };
        this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $2CQVV.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $c13226e4e2217284$export$9df87bad3fce982f)(state.tr),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lZgFC))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).mergeCells)
                    })) : undefined
                },
                {
                    content: formatMessage((0, $2CQVV.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $2d87994eabccd17d$export$74933b5979945879)(state),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nv4H))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).splitCell)
                    })) : undefined
                }
            ];
            return [];
        };
        this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2CQVV.messages).addColumnRight : (0, $2CQVV.messages).insertColumn);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p8nb))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).addColumnRight)
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter), String(content))
            };
        };
        this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2CQVV.messages).addRowBelow : (0, $2CQVV.messages).insertRow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4s9K9))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).addRowBelow)
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter), String(content))
            };
        };
        this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $2CQVV.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.backspace))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    })
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.backspace), String(content))
            };
        };
        this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $2CQVV.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ilrk))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).removeColumns, {
                        0: noOfColumns
                    })
                })) : undefined
            };
        };
        this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $2CQVV.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($HbwpQ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).removeRows, {
                        0: noOfRows
                    })
                })) : undefined
            };
        };
        this.createDistributeColumnsItemInternal = (partialMenuItem)=>{
            const { selectionRect: selectionRect, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, intl: { formatMessage: formatMessage } } = this.props;
            const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const newResizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
            const wouldChange = newResizeState?.changed ?? false;
            return {
                content: formatMessage((0, $2CQVV.messages).distributeColumns),
                value: {
                    name: 'distribute_columns'
                },
                isDisabled: !wouldChange,
                ...partialMenuItem
            };
        };
        this.createDistributeColumnsItem = ()=>{
            const { editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled, pluginConfig: { allowDistributeColumns: allowDistributeColumns } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowDistributeColumns && !isDragAndDropEnabled) return this.createDistributeColumnsItemInternal();
            return null;
        };
        this.createSortColumnItems = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView, allowColumnSorting: allowColumnSorting } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowColumnSorting && !isDragAndDropEnabled) {
                const hasMergedCellsInTable = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(editorView.state.tr).length > 0;
                const warning = hasMergedCellsInTable ? {
                    tooltipDescription: formatMessage((0, $2CQVV.messages).canNotSortTable),
                    isDisabled: true
                } : {};
                return [
                    {
                        content: formatMessage((0, $2CQVV.messages).sortColumnASC),
                        value: {
                            name: 'sort_column_asc'
                        },
                        ...warning
                    },
                    {
                        content: formatMessage((0, $2CQVV.messages).sortColumnDESC),
                        value: {
                            name: 'sort_column_desc'
                        },
                        ...warning
                    }
                ];
            }
            return null;
        };
        this.createOriginalContextMenuItems = ()=>{
            const items = [];
            const sortColumnItems = this.createSortColumnItems();
            const backgroundColorItem = this.createBackgroundColorItem();
            const distributeColumnsItem = this.createDistributeColumnsItem();
            sortColumnItems && items.push(...sortColumnItems);
            backgroundColorItem && items.push(backgroundColorItem);
            items.push(this.createInsertColumnItem());
            items.push(this.createInsertRowItem());
            items.push(this.createDeleteColumnItem());
            items.push(this.createDeleteRowItem());
            items.push(...this.createMergeSplitCellItems());
            distributeColumnsItem && items.push(distributeColumnsItem);
            items.push(this.createClearCellsItem());
            return [
                {
                    items: items
                }
            ];
        };
        this.createNewContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            const items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) items[1].items.push(this.newDistributeColumnsItem());
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        };
        this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen)) {
                const { tr: tr } = state;
                tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $5rHEx.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $5rHEx.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $d9aad08b0e0e65bb$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $d9aad08b0e0e65bb$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, this.props.api)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen) this.setState({
                        isSubmenuOpen: true
                    });
                    break;
            }
        };
        this.toggleOpen = ()=>{
            const { isOpen: isOpen, editorView: { state: state, dispatch: dispatch } } = this.props;
            (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
            if (!isOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (payload) {
                const { event: event } = payload;
                if (event && event instanceof KeyboardEvent) {
                    if (!this.state.isSubmenuOpen) {
                        if ($cea27b5fb5fc6748$var$arrowsList.has(event.key)) // preventing default behavior for avoiding cursor jump to next/previous table column
                        // when left/right arrow pressed.
                        event.preventDefault();
                        (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(false)(state, dispatch);
                        dom.focus();
                    }
                } else {
                    // mouse click outside
                    (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
                    this.setState({
                        isSubmenuOpen: false
                    });
                    if (isCellMenuOpenByKeyboard) (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(false)(state, dispatch);
                }
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (item.value.name === 'background') {
                if (!this.state.isSubmenuOpen) this.setState({
                    isSubmenuOpen: true
                });
            }
            if (item.value.name === 'delete_column') (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (item.value.name === 'background') this.closeSubmenu();
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            (0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            this.toggleOpen();
        };
    }
}
$cea27b5fb5fc6748$export$f55c8e309b1cad66.defaultProps = {
    boundariesElement: typeof document !== 'undefined' ? document.body : undefined
};
var $cea27b5fb5fc6748$export$2e2bcd8739ae039 = (0, $gmMgo.default)($cea27b5fb5fc6748$export$f55c8e309b1cad66);



const $b47da77c2d9945b4$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api, isDragMenuOpen: isDragMenuOpen })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && !editorView) return null;
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    // Remove ! during platform_editor_hydratable_ui cleanup
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $8m4tT.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        alignX: "right",
        alignY: "top",
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
        fitWidth: isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $aFUXX.akEditorFloatingDialogZIndex) : (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $992337a348060053$export$62225ca66ffe289c)(isDragAndDropEnabled)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cea27b5fb5fc6748$export$2e2bcd8739ae039), {
        // Remove ! during platform_editor_hydratable_ui cleanup
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        offset: [
            (0, $fbbb9ee8877c285e$export$3969371f057ce1e5) / 2,
            -(0, $fbbb9ee8877c285e$export$3969371f057ce1e5)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowMergeCells: pluginConfig.allowMergeCells,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api,
        isDragMenuOpen: isDragMenuOpen
    })));
};
$b47da77c2d9945b4$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $b47da77c2d9945b4$export$2e2bcd8739ae039 = $b47da77c2d9945b4$var$FloatingContextualMenu;












































parcelRequire("42omo");





const $91703e3fafeca120$var$DeleteButton = ({ style: style, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, removeLabel: removeLabel, intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            "aria-label": formatMessage(removeLabel, {
                0: 1
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON,
            onMouseDown: onClick,
            onMouseMove: (e)=>e.preventDefault(),
            children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M12.242 10.828L9.414 8l2.828-2.829a.999.999 0 1 0-1.414-1.414L8 6.587l-2.829-2.83a1 1 0 0 0-1.414 1.414l2.83 2.83-2.83 2.827a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a.999.999 0 1 0 1.414-1.414",
                    fill: "currentColor",
                    fillRule: "evenodd"
                })
            })
        })
    });
var $91703e3fafeca120$export$2e2bcd8739ae039 = (0, $gmMgo.default)($91703e3fafeca120$var$DeleteButton);



const $193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) + (0, $fbbb9ee8877c285e$export$52b432855099b8bd);
function $193fc70e9c765515$var$getColumnOptions(left, tableWrapper) {
    return {
        alignX: 'left',
        alignY: 'start',
        offset: [
            left,
            $193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET
        ],
        shouldRenderPopup () {
            if (tableWrapper) {
                const rect = tableWrapper.getBoundingClientRect();
                const maxVisibleLeftPosition = rect.width + tableWrapper.scrollLeft - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e);
                const minVisibleLeftPosition = tableWrapper.scrollLeft;
                return maxVisibleLeftPosition - left > 0 && left > minVisibleLeftPosition;
            }
            return true;
        }
    };
}
function $193fc70e9c765515$var$getRowOptions(top) {
    return {
        alignX: 'left',
        alignY: 'start',
        forcePlacement: true,
        offset: [
            0,
            -top
        ],
        onPositionCalculated (position) {
            return {
                ...position,
                // We need to force left to always be the offset to not be affected by overflow
                left: -$193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET
            };
        }
    };
}
function $193fc70e9c765515$export$2e2bcd8739ae039({ left: left, top: top, selectionType: selectionType, tableWrapper: tableWrapper }) {
    switch(selectionType){
        case 'column':
            return $193fc70e9c765515$var$getColumnOptions(left, tableWrapper);
        case 'row':
            return $193fc70e9c765515$var$getRowOptions(top);
        default:
            return {};
    }
}


function $deb8cdf2192525db$var$getSelectionType(selection) {
    if (!(0, $iYC9s.isTableSelected)(selection) && selection instanceof (0, $7XFGZ.CellSelection)) {
        if (selection.isRowSelection()) return 'row';
        if (selection.isColSelection()) return 'column';
    }
    return;
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $deb8cdf2192525db$var$FloatingDeleteButton extends (0, $42omo.Component) {
    shouldComponentUpdate(_, nextState) {
        return this.state.selectionType !== nextState.selectionType || this.state.left !== nextState.left || this.state.top !== nextState.top || this.state.scrollLeft !== nextState.scrollLeft;
    }
    componentDidMount() {
        this.updateWrapper();
    }
    componentDidUpdate() {
        this.updateWrapper();
    }
    componentWillUnmount() {
        if (this.wrapper) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
    }
    /**
   * We derivate the button state from the properties passed.
   * We do this in here because we need this information in different places
   * and this prevent to do multiple width calculations in the same component.
   */ static getDerivedStateFromProps(nextProps, prevState) {
        const selectionType = $deb8cdf2192525db$var$getSelectionType(nextProps.selection);
        const inStickyMode = nextProps.stickyHeaders && nextProps.stickyHeaders.sticky;
        const rect = (0, $iP1et.getSelectionRect)(nextProps.selection);
        // only tie row delete to sticky header if it's the only thing
        // in the selection, otherwise the row delete will hover around
        // the rest of the selection
        const firstRowInSelection = rect && rect.top === 0 && rect.bottom === 1;
        const shouldStickyButton = inStickyMode && firstRowInSelection;
        const stickyTop = nextProps.stickyHeaders ? nextProps.stickyHeaders.top + nextProps.stickyHeaders.padding : 0;
        if (selectionType) switch(selectionType){
            case 'column':
                {
                    // Calculate the button position and indexes for columns
                    const columnsWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(nextProps.editorView);
                    const deleteBtnParams = (0, $7eacb027e2e3fea2$export$bedfed4734d37a07)(columnsWidths, nextProps.editorView.state.selection);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        top: inStickyMode ? nextProps.stickyHeaders.top : 0,
                        position: inStickyMode ? 'sticky' : undefined,
                        selectionType: selectionType
                    };
                    return null;
                }
            case 'row':
                // Calculate the button position and indexes for rows
                if (nextProps.tableRef) {
                    const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(nextProps.tableRef);
                    const offsetTop = inStickyMode ? -rowHeights[0] : 0;
                    const deleteBtnParams = (0, $885c1a71dd6e181b$export$b0ece9f607a8bda1)(rowHeights, nextProps.editorView.state.selection, shouldStickyButton ? stickyTop : offsetTop);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        position: shouldStickyButton ? 'sticky' : undefined,
                        left: 0,
                        selectionType: selectionType
                    };
                }
                return null;
        }
        // Clean state if no type
        if (prevState.selectionType !== selectionType) return {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: []
        };
        // Do nothing if doesn't change anything
        return null;
    }
    render() {
        const { mountPoint: mountPoint, boundariesElement: boundariesElement, tableRef: tableRef } = this.props;
        const { selectionType: selectionType } = this.state;
        if (!selectionType || !tableRef) return null;
        const tableContainerWrapper = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
        const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $91703e3fafeca120$export$2e2bcd8739ae039), {
            removeLabel: selectionType === 'column' ? (0, $2CQVV.messages).removeColumns : (0, $2CQVV.messages).removeRows,
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        });
        const popupOpts = (0, $193fc70e9c765515$export$2e2bcd8739ae039)({
            left: this.state.left,
            top: this.state.top,
            selectionType: this.state.selectionType,
            tableWrapper: this.wrapper
        });
        const mountTo = tableContainerWrapper || mountPoint;
        if (this.state.position === 'sticky' && mountTo) {
            const headerRow = tableRef.querySelector('tr.sticky');
            if (headerRow) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const rect = headerRow.getBoundingClientRect();
                const calculatePosition = popupOpts.onPositionCalculated || ((pos)=>pos);
                const pos = calculatePosition({
                    left: this.state.left,
                    top: this.state.top
                });
                return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'fixed',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: pos.top,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        zIndex: (0, $fbbb9ee8877c285e$export$1279af870a198fea),
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: rect.left + (pos.left || 0) - (this.state.selectionType === 'column' ? this.state.scrollLeft : 0) - // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        (this.props.isNumberColumnEnabled ? (0, $aFUXX.akEditorTableNumberColumnWidth) : 0)
                    },
                    children: button
                }), mountTo);
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
            target: tableRef,
            mountTo: mountTo,
            boundariesElement: tableContainerWrapper || boundariesElement,
            scrollableElement: this.wrapper || undefined,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...popupOpts,
            children: button
        });
    }
    constructor(props){
        super(props);
        this.wrapper = null;
        this.updateWrapper = ()=>{
            const tableWrapper = (0, $4vlwG.closestElement)(this.props.tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
            if (tableWrapper) {
                this.wrapper = tableWrapper;
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.wrapper.addEventListener('scroll', this.onWrapperScrolled);
                this.setState({
                    scrollLeft: tableWrapper.scrollLeft
                });
            } else {
                if (this.wrapper) {
                    // unsubscribe if we previously had one and it just went away
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
                    // and reset scroll position
                    this.setState({
                        scrollLeft: 0
                    });
                }
                this.wrapper = null;
            }
        };
        this.onWrapperScrolled = (e)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const wrapper = e.target;
            this.setState({
                scrollLeft: wrapper.scrollLeft
            });
        };
        this.handleMouseEnter = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            switch(this.state.selectionType){
                case 'row':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $7132c436572167eb$export$ab63d99b591b89)(this.state.indexes, true)(state, dispatch, this.props.editorView);
                case 'column':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $7132c436572167eb$export$4cf548f2efac0afe)(this.state.indexes, true)(state, dispatch, this.props.editorView);
            }
            return false;
        };
        this.handleMouseLeave = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            return (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        /**
     *
     *
     * @private
     * @memberof FloatingDeleteButton
     */ this.handleClick = (event)=>{
            event.preventDefault();
            const { editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            let { state: state, dispatch: dispatch } = this.props.editorView;
            const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const rect = (0, $iP1et.getSelectionRect)(state.selection);
            if (rect) switch(this.state.selectionType){
                case 'column':
                    (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, this.props.api)((0, $d925B.INPUT_METHOD).BUTTON, rect)(state, dispatch, this.props.editorView);
                    return;
                case 'row':
                    (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).BUTTON, rect, !!isHeaderRowRequired)(state, dispatch);
                    return;
            }
            ({ state: state, dispatch: dispatch } = this.props.editorView);
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.state = {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: [],
            scrollLeft: 0
        };
    }
}
$deb8cdf2192525db$var$FloatingDeleteButton.displayName = 'FloatingDeleteButton';
var $deb8cdf2192525db$export$2e2bcd8739ae039 = $deb8cdf2192525db$var$FloatingDeleteButton;





parcelRequire("42omo");















/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 


































































var $82gXq = parcelRequire("82gXq");











/* eslint-disable @atlaskit/design-system/prefer-primitives */ 






var $9CaSN = parcelRequire("9CaSN");











var $efG2U = parcelRequire("efG2U");





var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


const $1ff18a7a5a57b9d2$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $efG2U.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9CaSN.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $1ff18a7a5a57b9d2$var$DropListWithOutsideListeners = (0, $efG2U.default)($1ff18a7a5a57b9d2$var$DropListWithOutsideClickTargetRef);
const $1ff18a7a5a57b9d2$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $42omo.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $42omo.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    const offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    const offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)($1ff18a7a5a57b9d2$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            handleClickOutside: ()=>handleClose('editor'),
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf)
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                    role: "menu",
                    children: items.map((group, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            hasSeparator: section?.hasSeparator && index > 0,
                            title: section?.title,
                            children: group.items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuItem), {
                                    shouldUseDefaultRole: false,
                                    item: item,
                                    onItemActivated: onItemActivated,
                                    onMouseEnter: onMouseEnter,
                                    onMouseLeave: onMouseLeave
                                }, item.key ?? String(item.content)))
                        }, index))
                })
            ]
        });
    };
    const onClose = (0, $42omo.useCallback)(()=>handleClose('handle'), [
        handleClose
    ]);
    const onSelection = (0, $42omo.useCallback)((index)=>{
        const results = items.flatMap((item)=>'items' in item ? item.items : item);
        // onSelection is called when any focusable element is 'activated'
        // this is an issue as some menu items have toggles, which cause the index value
        // in the callback to be outside of array length.
        // The logic below normalises the index value based on the number
        // of menu items with 2 focusable elements, and adjusts the index to ensure
        // the correct menu item is sent in onItemActivated callback
        const keys = [
            'row_numbers',
            'header_row',
            'header_column'
        ];
        let doubleItemCount = 0;
        const firstIndex = results.findIndex((value)=>{
            const key = value.key;
            return key !== undefined && keys.includes(key);
        });
        if (firstIndex === -1 || index <= firstIndex) {
            onItemActivated && onItemActivated({
                item: results[index]
            });
            return;
        }
        for(let i = firstIndex; i < results.length; i += 1){
            const key = results[i].key;
            if (key !== undefined && keys.includes(key)) doubleItemCount += 1;
            if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
            if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
        }
    }, [
        items,
        onItemActivated
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: "drag-dropdown-menu-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: "drag-dropdown-menu-popup-ref",
                ref: handleRef
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                target: targetRefDiv,
                mountTo: mountPoint,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                onPlacementChanged: (placement)=>{
                    setPopupPlacement(placement);
                },
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
                offset: [
                    offsetX,
                    offsetY
                ],
                allowOutOfBounds: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                    closeOnTab: !disableKeyboardHandling,
                    type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                    handleClose: onClose,
                    onSelection: onSelection,
                    // disableKeyboardHandling is linked with isSubmenuOpen in DragMenu
                    // When isSubmenuOpen is true, the background color picker palette is open, and the picker is a ColorPaletteArrowKeyNavigationProvider
                    // At the same time the MenuArrowKeyNavigationProvider are renderer too, as it is the wrapper for all other DragMenu items
                    // In this case we want the ColorPaletteArrowKeyNavigationProvider to handle the keyboard event, not the MenuArrowKeyNavigationProvider
                    // Hence set disableArrowKeyNavigation to true when disableKeyboardHandling is true
                    disableArrowKeyNavigation: disableKeyboardHandling,
                    children: innerMenu()
                })
            })
        ]
    }));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766











function $f06d467cdb1ed078$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f06d467cdb1ed078$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $f06d467cdb1ed078$export$2a71c1910478944e = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, white);box-shadow:", `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N60A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`, ";display:block;position:absolute;top:", (0, $fbbb9ee8877c285e$export$e0140c2b978caac5) + (0, $fbbb9ee8877c285e$export$a13bd817a2eda041) + (0, $fbbb9ee8877c285e$export$c6a9e7014cf7aedc), "px;left:", (0, $fbbb9ee8877c285e$export$963fb187132ee7cf), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:", `var(--ds-icon, ${(0, $6fnsQ.N90)})`, ";}}");
const $f06d467cdb1ed078$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};


const $eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $2CQVV.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $2CQVV.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $2CQVV.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $2CQVV.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $2CQVV.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $2CQVV.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $2CQVV.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $2CQVV.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $2CQVV.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $2CQVV.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $2CQVV.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $2CQVV.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $2CQVV.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $2CQVV.messages).sortColumnDecreasing,
        plural: null
    }
};
const $eda89f8ab7004d19$var$getGroupedDragMenuConfig = ()=>{
    const groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    groupedDragMenuConfig.unshift(sortColumnItems);
    return groupedDragMenuConfig;
};
const $eda89f8ab7004d19$var$elementBeforeIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $eda89f8ab7004d19$var$convertToDropdownItems = (dragMenuConfig, formatMessage, selectionRect)=>{
    const groupedDragMenuConfig = $eda89f8ab7004d19$var$getGroupedDragMenuConfig();
    const menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    const menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id]?.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $eda89f8ab7004d19$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(item.icon, {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].message, options)
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        curr?.length > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $eda89f8ab7004d19$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $LmqWp.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $42omo.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
    const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = tableMap?.hasMergedCells() ?? false;
    const allowBackgroundColor = pluginConfig?.allowBackgroundColor ?? false;
    const dragMenuConfig = (0, $95cc14ff7c35ef77$export$25f919d23e41e94d)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig?.isHeaderRowRequired, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, ariaNotifyPlugin, isCommentEditor, pluginConfig?.allowColumnSorting ?? true);
    const { menuItems: menuItems, menuCallback: menuCallback } = $eda89f8ab7004d19$var$convertToDropdownItems(dragMenuConfig, formatMessage, selectionRect);
    const handleSubMenuRef = (ref)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = editorView.dom;
        const parent = (0, $4vlwG.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $4vlwG.closestElement)(dom, '.ak-editor-content-area');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (!!mountPoint) return;
        const offsetParent = ref?.offsetParent;
        if (!offsetParent) return;
        const offsetParentRect = offsetParent.getBoundingClientRect();
        const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
        const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
        if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
        // if it overflows regardless of side, let it overlap with the parent menu
        if (leftOverflow > 0 && rightOverflow > 0) {
            if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
            else ref.style.left = `-${rect.width - leftOverflow}px`;
        }
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $6icEc.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)((0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039), background, (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb));
        return {
            key: 'background',
            content: formatMessage((0, $2CQVV.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $eda89f8ab7004d19$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7TXtV))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2CQVV.messages).backgroundColor)
            })),
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $f06d467cdb1ed078$export$2a71c1910478944e)()
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $f06d467cdb1ed078$export$bc7b8b99ac8e8073)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    target?.focus();
                    target?.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hxEux.default), {
                cols: (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb),
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                paletteOptions: {
                    palette: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
                    paletteColorTooltipMessages: (0, $8LFdJ.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $6icEc.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $d9aad08b0e0e65bb$export$2e66edaa488e7a1d)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55)(editorAnalyticsAPI)(state, dispatch);
    };
    const HeaderColumnToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
            id: "toggle-header-column",
            label: formatMessage((0, $2CQVV.messages).headerColumn),
            onChange: toggleHeaderColumn,
            isChecked: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(selection)
        }));
    const HeaderRowToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
            id: "toggle-header-row",
            label: formatMessage((0, $2CQVV.messages).headerRow),
            onChange: toggleHeaderRow,
            isChecked: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(selection)
        }));
    const createHeaderRowColumnMenuItemOld = (direction)=>{
        return direction === 'column' ? {
            key: 'header_column',
            content: formatMessage((0, $2CQVV.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderColumnToggle, null)
        } : {
            key: 'header_row',
            content: formatMessage((0, $2CQVV.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderRowToggle, null)
        };
    };
    const createHeaderRowColumnMenuItem = (direction)=>{
        if (direction === 'column' && (pluginConfig?.advanced || pluginConfig?.allowHeaderColumn)) return {
            key: 'header_column',
            content: formatMessage((0, $2CQVV.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderColumnToggle, null)
        };
        if (direction === 'row' && (pluginConfig?.advanced || pluginConfig?.allowHeaderRow)) return {
            key: 'header_row',
            content: formatMessage((0, $2CQVV.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderRowToggle, null)
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $dh538.fg)('platform_editor_rename_numbered_rows_label') ? (0, $2CQVV.messages).numberedRows : (0, $2CQVV.messages).rowNumbers),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
                id: "toggle-row-numbers",
                label: formatMessage((0, $dh538.fg)('platform_editor_rename_numbered_rows_label') ? (0, $2CQVV.messages).numberedRows : (0, $2CQVV.messages).numberedColumn),
                onChange: toggleRowNumbers,
                isChecked: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target?.focus();
            else if ((0, $1oCLl.expValEquals)('platform_editor_table_cell_colour_change', 'isEnabled', true)) editorView.focus();
            else editorView.dom.focus();
            (0, $68bb38467b052d2c$export$8a902a12acc69924)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        menuCallback[item.value.name]?.(state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!item.value.name?.startsWith('delete')) return;
        (item.value.name === 'delete_column' ? (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true) : (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true))(state, dispatch);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    (0, $42omo.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) menuItems[1].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) {
        if (!(0, $dh538.fg)('platform_editor_enable_table_dnd')) menuItems.push({
            items: [
                createHeaderRowColumnMenuItemOld(direction)
            ]
        });
        else if ((pluginConfig?.advanced || pluginConfig?.allowHeaderColumn || pluginConfig?.allowHeaderRow) && (0, $dh538.fg)('platform_editor_enable_table_dnd')) {
            const headerRowColumnMenuItem = createHeaderRowColumnMenuItem(direction);
            headerRowColumnMenuItem && menuItems.push({
                items: [
                    headerRowColumnMenuItem
                ]
            });
        }
    }
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row' && ((0, $dh538.fg)('platform_editor_enable_table_dnd') ? pluginConfig?.advanced || pluginConfig?.allowNumberColumn : true)) index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1eLzC.UserIntentPopupWrapper), {
        api: api,
        userIntent: "tableDragMenuPopupOpen"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1ff18a7a5a57b9d2$export$e44a253a59704894), {
        disableKeyboardHandling: isSubmenuOpen,
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    }));
});
var $eda89f8ab7004d19$export$2e2bcd8739ae039 = (0, $gmMgo.default)($eda89f8ab7004d19$var$DragMenu);


const $efc91945e1888679$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor, tableWrapper: tableWrapper })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky || tableWrapper?.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7');
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    const offset = direction === 'row' ? [
        -9,
        0
    ] : [
        0,
        -7
    ];
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $7XFGZ.CellSelection))) return null;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags?.() ?? {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf),
        fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $aFUXX.akEditorFloatingDialogZIndex) : (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: offset,
        stick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eda89f8ab7004d19$export$2e2bcd8739ae039), {
            editorView: editorView,
            isOpen: isOpen,
            tableNode: tableNode,
            direction: direction,
            index: index,
            target: targetHandleRef || undefined,
            targetCellPosition: targetCellPosition,
            getEditorContainerWidth: getEditorContainerWidth,
            editorAnalyticsAPI: editorAnalyticsAPI,
            pluginConfig: pluginConfig,
            fitWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf),
            fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
            mountPoint: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isTableScalingEnabled: isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            ariaNotifyPlugin: ariaNotifyPlugin,
            api: api,
            isCommentEditor: isCommentEditor || false
        })
    });
};
$efc91945e1888679$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $efc91945e1888679$export$2e2bcd8739ae039 = $efc91945e1888679$var$FloatingDragMenu;













































const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2);
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $aFUXX.akEditorTableNumberColumnWidth);
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be);
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be);
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON = -((0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be) + (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c));
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2;
function $1f4cdf22bfe2994c$var$getRowOptions(index, isDragAndDropEnabled) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: isDragAndDropEnabled ? $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG : $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON
            };
        }
    };
}
function $1f4cdf22bfe2994c$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            isDragAndDropEnabled ? $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG : $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            const { left: left } = position;
            if (!left) // If not left, lest skip expensive next calculations.
            return position;
            if (index === 0) return {
                ...position,
                left: hasNumberedColumns ? $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $1f4cdf22bfe2994c$var$getPopupOptions(direction, index, hasNumberedColumns, isDragAndDropEnabled, tableContainer) {
    switch(direction){
        case 'column':
            return $1f4cdf22bfe2994c$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled);
        case 'row':
            return $1f4cdf22bfe2994c$var$getRowOptions(index, isDragAndDropEnabled);
        default:
            return {};
    }
}
var $1f4cdf22bfe2994c$export$2e2bcd8739ae039 = $1f4cdf22bfe2994c$var$getPopupOptions;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");






























const $3717dbb6fe2829eb$var$getInsertLineHeight = (tableRef, hasStickyHeaders, isDragAndDropEnabled)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $1zav4.tableMarginTop) * (isDragAndDropEnabled ? 3 : 4) - LINE_OFFSET : (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $3717dbb6fe2829eb$var$getToolbarSize = (tableRef)=>{
    const parent = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}`) ? (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $aFUXX.akEditorTableNumberColumnWidth) - 1 : (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b);
    return 0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b;
};
const $3717dbb6fe2829eb$var$getNumberColumnWidth = (tableRef, isDragAndDropEnabled)=>{
    const parent = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
    if (parent && isDragAndDropEnabled) return parent.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}`) ? (0, $aFUXX.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $3717dbb6fe2829eb$var$getInsertLineWidth = (tableRef, isDragAndDropEnabled, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 4;
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parentOffsetWidth = parentElement.offsetWidth;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    const toolbarSize = isDragAndDropEnabled ? 0 : $3717dbb6fe2829eb$var$getToolbarSize(tableRef);
    const lineOffset = isDragAndDropEnabled ? DRAG_LINE_OFFSET : LINE_OFFSET;
    return Math.min(offsetWidth + toolbarSize, parentOffsetWidth + toolbarSize - Math.max(scrollLeft - diff, 0)) + lineOffset + $3717dbb6fe2829eb$var$getNumberColumnWidth(tableRef, isDragAndDropEnabled);
};
const $3717dbb6fe2829eb$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $2CQVV.messages).insertRow : (0, $2CQVV.messages).insertColumn;
};
const $3717dbb6fe2829eb$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage(isRow ? (0, $2CQVV.messages).insertRowDrag : (0, $2CQVV.messages).insertColumnDrag),
            keymap: isRow ? (0, $hgeg8.addRowAfter) : (0, $hgeg8.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
                                fill: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $3717dbb6fe2829eb$var$getInsertLineWidth(tableRef, true, isChromelessEditor),
                        left: "var(--ds-space-150, 12px)"
                    } : {
                        height: $3717dbb6fe2829eb$var$getInsertLineHeight(tableRef, hasStickyHeaders, true) - 8,
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: '-3px'
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = isRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
const $3717dbb6fe2829eb$export$5e513603d391e3de = (0, $gmMgo.default)($3717dbb6fe2829eb$var$InsertButtonForDragAndDrop);
const $3717dbb6fe2829eb$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage($3717dbb6fe2829eb$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $hgeg8.addRowAfter) : (0, $hgeg8.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        "aria-label": (0, $1oCLl.expValEquals)('platform_editor_fix_button_name_violation_in_table', 'isEnabled', true) ? formatMessage($3717dbb6fe2829eb$var$tooltipMessageByType(type)) : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
                                fill: "currentColor",
                                fillRule: "evenodd"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $3717dbb6fe2829eb$var$getInsertLineWidth(tableRef)
                    } : {
                        height: $3717dbb6fe2829eb$var$getInsertLineHeight(tableRef, hasStickyHeaders)
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = type === 'column' ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
var $3717dbb6fe2829eb$export$2e2bcd8739ae039 = (0, $gmMgo.default)($3717dbb6fe2829eb$var$InsertButton);


class $008d5f85143ad358$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // TODO: ED-26961 - temporarily disable insert button for first column and row https://atlassian.slack.com/archives/C05U8HRQM50/p1698363744682219?thread_ts=1698209039.104909&cid=C05U8HRQM50
        if (isDragAndDropEnabled && (insertColumnButtonIndex === 0 || insertRowButtonIndex === 0)) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can’t display the insert button for row|colum index 0
        // when the header row|colum is enabled, this feature will be change on the future
        if (type === 'column' && isHeaderColumnEnabled && insertColumnButtonIndex === 0 || type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if (tr.selection instanceof (0, $7XFGZ.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        const tablePos = (0, $id9O1.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos?.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $8m4tT.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $d925B.ACTION).ERRORED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $d925B.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        error: error?.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $4vlwG.closestElement)(target, 'tr') : (0, $4vlwG.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $4vlwG.closestElement)(targetCellRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
        const tableWrapper = (0, $4vlwG.closestElement)(targetCellRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $bdb0299b531c40df$export$101f2696d8127fe0)(editorView.state.selection);
        // Fixed the 'add column button' not visible issue when sticky header is enabled
        // By setting the Popup z-index higher than the sticky header z-index ( common-styles.ts tr.sticky)
        // Only when inserting a column, otherwise set to undefined
        // Need to set z-index in the Popup, set z-index in the <InsertButton /> will not work
        const zIndex = (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') || type === 'column' ? (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) : undefined;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $1f4cdf22bfe2994c$export$2e2bcd8739ae039)(type, index, hasNumberedColumns, !!isDragAndDropEnabled, tableContainerWrapper),
            zIndex: zIndex,
            children: isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3717dbb6fe2829eb$export$5e513603d391e3de), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false,
                isChromelessEditor: isChromelessEditor
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3717dbb6fe2829eb$export$2e2bcd8739ae039), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false
            })
        });
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        const tableMap = (0, $LmqWp.TableMap).get(tableNode);
        if (type === 'column') {
            // This condition is to make typescript happy.
            // Previously insertColumnButtonIndex - 1 would produce NaN and return null anyway.
            if (insertColumnButtonIndex === undefined) return null;
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            // This condition is to make typescript happy.
            // Previously insertRowButtonIndex - 1 would produce NaN and return null anyway.
            if (insertRowButtonIndex === undefined) return null;
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
}
$008d5f85143ad358$export$e2c2386b8045af89.displayName = 'FloatingInsertButton';
var $008d5f85143ad358$export$2e2bcd8739ae039 = (0, $gmMgo.default)($008d5f85143ad358$export$e2c2386b8045af89);











const $3d5a4c7c037fbee4$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset,
        children: content
    });
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







const $4c3548cc318b5972$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags, isDragAndDropEnabledOption: isDragAndDropEnabledOption, api: api })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: (0, $93fa7bbbefe5a956$export$e938d6f191645a3e)({
            featureFlags: featureFlags,
            isDragAndDropEnabled: isDragAndDropEnabledOption && !isLivePageViewMode
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $hMaMb = parcelRequire("hMaMb");


const $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_COLS = 3;
const $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_ROWS = 3;
const $99b6a28c1e195b05$export$800b7d81026538f2 = ({ api: api, target: target, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    const closeSelectorPopup = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onSelection = (0, $42omo.useCallback)((rowsCount, colsCount)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.table.commands.insertTableWithSize(rowsCount, colsCount)({
                tr: tr
            });
            tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onUnmount = ()=>{
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hMaMb.default), {
        defaultSize: {
            row: $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_ROWS,
            col: $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_COLS
        },
        target: target,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        popupsBoundariesElement: popupsBoundariesElement,
        isOpenedByKeyboard: true,
        handleClickOutside: closeSelectorPopup,
        handleEscapeKeydown: closeSelectorPopup
    });
};





parcelRequire("42omo");










var $dcJ7R = parcelRequire("dcJ7R");



const $c8d2ef0836054c91$var$tableFullWidthLabelWrapperStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $c8d2ef0836054c91$var$tableFullWidthLabelStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $c8d2ef0836054c91$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $c8d2ef0836054c91$var$tableFullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            xcss: $c8d2ef0836054c91$var$tableFullWidthLabelStyles,
            children: formatMessage((0, $2CQVV.messages).fullWidthLabel)
        })
    });
};


const $9a7d1b7fff538a30$var$selector = (states)=>({
        resizingTableLocalId: states.tableState?.resizingTableLocalId,
        resizingTableRef: states.tableState?.resizingTableRef,
        isTableResizing: states.tableState?.isTableResizing,
        isResizing: states.tableState?.isResizing,
        widthToWidest: states.tableState?.widthToWidest,
        tableNode: states.tableState?.tableNode,
        targetCellPosition: states.tableState?.targetCellPosition,
        isContextualMenuOpen: states.tableState?.isContextualMenuOpen,
        tableRef: states.tableState?.tableRef,
        pluginConfig: states.tableState?.pluginConfig,
        insertColumnButtonIndex: states.tableState?.insertColumnButtonIndex,
        insertRowButtonIndex: states.tableState?.insertRowButtonIndex,
        isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
        isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
        isDragAndDropEnabled: states.tableState?.isDragAndDropEnabled,
        tableWrapperTarget: states.tableState?.tableWrapperTarget,
        isCellMenuOpenByKeyboard: states.tableState?.isCellMenuOpenByKeyboard,
        stickyHeader: states.tableState?.stickyHeader,
        dragMenuDirection: states.tableState?.dragMenuDirection,
        dragMenuIndex: states.tableState?.dragMenuIndex,
        isDragMenuOpen: states.tableState?.isDragMenuOpen,
        isSizeSelectorOpen: states.tableState?.isSizeSelectorOpen,
        sizeSelectorTargetRef: states.tableState?.sizeSelectorTargetRef,
        // IMPORTANT: hovered states are used by FloatingDragMenu component to render popup in the correct location
        hoveredRows: states.tableState?.hoveredRows,
        hoveredColumns: states.tableState?.hoveredColumns,
        hoveredCell: states.tableState?.hoveredCell
    });
const $9a7d1b7fff538a30$var$ContentComponentInternal = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const { resizingTableLocalId: resizingTableLocalId, resizingTableRef: resizingTableRef, isTableResizing: isTableResizing, isResizing: isResizing, widthToWidest: widthToWidest, tableNode: tableNode, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, stickyHeader: stickyHeader, dragMenuDirection: dragMenuDirection, dragMenuIndex: dragMenuIndex, isDragMenuOpen: isDragMenuOpen, isSizeSelectorOpen: isSizeSelectorOpen, sizeSelectorTargetRef: sizeSelectorTargetRef } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'table'
    ], $9a7d1b7fff538a30$var$selector);
    const { allowControls: allowControls } = pluginConfig ?? {};
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, $l998X.jsx)((0, $35f649121590a9ea$export$2e2bcd8739ae039), {
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorView: editorView,
                tableNode: tableNode,
                mountPoint: popupsMountPoint,
                targetCellPosition: targetCellPosition,
                scrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                isContextualMenuOpen: isContextualMenuOpen,
                stickyHeader: stickyHeader,
                tableWrapper: tableWrapperTarget,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isDragAndDropEnabled: isDragAndDropEnabled
            }),
            allowControls && /*#__PURE__*/ (0, $l998X.jsx)((0, $008d5f85143ad358$export$2e2bcd8739ae039), {
                tableNode: tableNode,
                tableRef: tableRef,
                insertColumnButtonIndex: insertColumnButtonIndex,
                insertRowButtonIndex: insertRowButtonIndex,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isDragAndDropEnabled: isDragAndDropEnabled,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isChromelessEditor: options?.isChromelessEditor,
                api: api,
                isCommentEditor: options?.isCommentEditor
            }),
            options?.allowContextualMenu && /*#__PURE__*/ (0, $l998X.jsx)((0, $b47da77c2d9945b4$export$2e2bcd8739ae039), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                targetCellPosition: targetCellPosition,
                isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                pluginConfig: pluginConfig,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isCommentEditor: options?.isCommentEditor,
                api: api,
                isDragMenuOpen: isDragMenuOpen
            }),
            isDragAndDropEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $efc91945e1888679$export$2e2bcd8739ae039), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                tableRef: tableRef,
                tableNode: tableNode,
                targetCellPosition: targetCellPosition,
                direction: dragMenuDirection,
                index: dragMenuIndex,
                isOpen: !!isDragMenuOpen && !isResizing,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                editorAnalyticsAPI: editorAnalyticsAPI,
                stickyHeaders: stickyHeader,
                pluginConfig: pluginConfig,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                ariaNotifyPlugin: ariaNotifyPlugin,
                api: api,
                isCommentEditor: options?.isCommentEditor,
                tableWrapper: tableWrapperTarget
            }),
            allowControls && !isDragAndDropEnabled && !isResizing && /*#__PURE__*/ (0, $l998X.jsx)((0, $deb8cdf2192525db$export$2e2bcd8739ae039), {
                editorView: editorView,
                selection: editorView.state.selection,
                tableRef: tableRef,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                stickyHeaders: stickyHeader,
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorAnalyticsAPI: editorAnalyticsAPI,
                api: api
            }),
            (options?.isTableScalingEnabled || options?.tableOptions.allowTableResizing && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d5a4c7c037fbee4$export$a60e1be3b6001ff3), {
                target: resizingTableRef,
                content: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7x0qS.ResizerBreakoutModeLabel), {
                    layout: "full-width"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $c8d2ef0836054c91$export$8bde7db5b2aba7d), {}),
                alignX: 'center',
                alignY: 'bottom',
                stick: true,
                forcePlacement: true,
                zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
                offset: [
                    0,
                    10
                ]
            }),
            isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $99b6a28c1e195b05$export$800b7d81026538f2), {
                api: api,
                isOpenedByKeyboard: false,
                popupsMountPoint: popupsMountPoint,
                target: sizeSelectorTargetRef ?? (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api?.analytics?.actions),
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            })
        ]
    });
};
const $9a7d1b7fff538a30$export$2dda1e4a1d1f6a81 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).TABLES_PLUGIN,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4c3548cc318b5972$export$cc5403d58ddfa812), {
                featureFlags: api?.featureFlags?.sharedState.currentState(),
                isDragAndDropEnabledOption: options?.dragAndDropEnabled,
                api: api
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($9a7d1b7fff538a30$var$ContentComponentInternal, {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                isTableSelectorEnabled: isTableSelectorEnabled,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags
            })
        ]
    });
};



const $b21157aa04a7535c$var$defaultGetEditorFeatureFlags = ()=>({});
// we want to calculate all the table widths (which causes reflows) after the editor has finished loading to mitigate performance impact
const $b21157aa04a7535c$var$TABLE_WIDTH_INFO_TIMEOUT = 10000;
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $b21157aa04a7535c$var$tablePlugin = ({ config: config, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const options = {
        ...config,
        tableOptions: config?.tableOptions ?? {},
        dragAndDropEnabled: config?.dragAndDropEnabled || (0, $dh538.fg)('platform_editor_enable_table_dnd'),
        isTableScalingEnabled: config?.isTableScalingEnabled || (0, $dh538.fg)('platform_editor_enable_table_scaling')
    };
    const defaultGetEditorContainerWidth = ()=>{
        return api?.width?.sharedState.currentState() ?? {
            width: document?.body?.offsetWidth ?? 500
        };
    };
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isTableFixedColumnWidthsOptionEnabled = (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption || false;
    const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
    options?.isCommentEditor);
    const isTableSelectorEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    !options?.isChromelessEditor && !options?.isCommentEditor && options?.getEditorFeatureFlags?.().tableSelector && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const tablePluginState = (0, $fedf15e5199146e8$export$18d4026d1ea86bb1).getState(editorState);
            const tableResizingPluginState = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(editorState);
            const tableWidthResizingPluginState = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeadersState = (0, $1562ea854f0ae047$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeader = stickyHeadersState ? (0, $894c3bb16e3b70ec$export$91d61a242b14c7fb)(stickyHeadersState, tablePluginState?.tablePos) : undefined;
            const dragAndDropState = (0, $c8432cced568eda6$export$18d4026d1ea86bb1).getState(editorState);
            const sizeSelectorPluginState = (0, $030f86662bf3c0ad$export$18d4026d1ea86bb1).getState(editorState);
            const editorContentAreaHeightPluginState = (0, $c80e8922e1b59353$export$18d4026d1ea86bb1).getState(editorState);
            const sharedStateInternal = {
                isFullWidthModeEnabled: !!options?.fullWidthEnabled,
                wasFullWidthModeEnabled: !!options?.wasFullWidthEnabled,
                isMaxWidthModeEnabled: !!options?.maxWidthEnabled,
                wasMaxWidthModeEnabled: !!options?.wasMaxWidthEnabled,
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState?.dragging || tableWidthResizingPluginState?.resizing),
                isTableResizing: tableWidthResizingPluginState?.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredColumns: tablePluginState.hoveredColumns,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest,
                resizingTableLocalId: tableWidthResizingPluginState?.tableLocalId,
                tableRef: tablePluginState?.tableRef ?? undefined,
                resizingTableRef: tableWidthResizingPluginState?.tableRef ?? undefined,
                tablePos: tablePluginState.tablePos,
                targetCellPosition: tablePluginState.targetCellPosition,
                isContextualMenuOpen: tablePluginState.isContextualMenuOpen,
                pluginConfig: tablePluginState.pluginConfig,
                insertColumnButtonIndex: tablePluginState.insertColumnButtonIndex,
                insertRowButtonIndex: tablePluginState.insertRowButtonIndex,
                isDragAndDropEnabled: tablePluginState.isDragAndDropEnabled,
                tableWrapperTarget: tablePluginState.tableWrapperTarget,
                isCellMenuOpenByKeyboard: tablePluginState.isCellMenuOpenByKeyboard,
                stickyHeader: stickyHeader,
                dragMenuDirection: dragAndDropState?.dragMenuDirection,
                dragMenuIndex: dragAndDropState?.dragMenuIndex,
                isDragMenuOpen: dragAndDropState?.isDragMenuOpen,
                isSizeSelectorOpen: sizeSelectorPluginState?.isSelectorOpen,
                sizeSelectorTargetRef: sizeSelectorPluginState?.targetRef,
                editorContentAreaHeight: (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? editorContentAreaHeightPluginState?.height : undefined
            };
            return sharedStateInternal;
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    if (options?.tableOptions?.allowNestedTables) return (0, $gmyMu.editorCommandToPMCommand)((0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                        isFullWidthModeEnabled: options?.fullWidthEnabled,
                        isMaxWidthModeEnabled: options?.maxWidthEnabled,
                        isCommentEditor: options?.isCommentEditor,
                        isChromelessEditor: options?.isChromelessEditor,
                        isTableResizingEnabled: options?.tableOptions.allowTableResizing
                    }, api, analyticsPayload))(state, dispatch);
                    else {
                        const node = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                            isTableScalingEnabled: options?.isTableScalingEnabled,
                            isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                            isFullWidthModeEnabled: options?.fullWidthEnabled,
                            isMaxWidthModeEnabled: options?.maxWidthEnabled,
                            isCommentEditor: options?.isCommentEditor,
                            isChromelessEditor: options?.isChromelessEditor,
                            isTableResizingEnabled: options?.tableOptions.allowTableResizing
                        })(state.schema);
                        return api?.contentInsertion?.actions?.insert({
                            state: state,
                            dispatch: dispatch,
                            node: node,
                            options: {
                                selectNodeInserted: false,
                                analyticsPayload: {
                                    ...analyticsPayload,
                                    attributes: {
                                        ...analyticsPayload.attributes,
                                        localId: node.attrs.localId
                                    }
                                }
                            }
                        }) ?? false;
                    }
                }
        },
        commands: {
            insertTableWithSize: (rowsCount, colsCount, inputMethod)=>(0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
                    isTableScalingEnabled: options?.isTableScalingEnabled,
                    isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                    isFullWidthModeEnabled: options?.fullWidthEnabled,
                    isMaxWidthModeEnabled: options?.maxWidthEnabled,
                    isCommentEditor: options?.isCommentEditor,
                    isChromelessEditor: options?.isChromelessEditor,
                    isTableResizingEnabled: options?.tableOptions.allowTableResizing,
                    createTableProps: {
                        rowsCount: rowsCount,
                        colsCount: colsCount
                    }
                }, api, {
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod ?? (0, $d925B.INPUT_METHOD).PICKER,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })
        },
        nodes () {
            const { allowColumnResizing: allowColumnResizing } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(options?.tableOptions);
            // TODO: ED-25901 - We need to move this into a plugin config option so we don't accidentally enable nested nodes in Jira
            const isNestingSupported = Boolean(options?.tableOptions?.allowNestedTables);
            const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            options?.isCommentEditor);
            const isTableScalingEnabled = options?.isTableScalingEnabled;
            const isCommentEditor = options?.isCommentEditor;
            const isChromelessEditor = options?.isChromelessEditor;
            return isNestingSupported ? [
                {
                    name: 'table',
                    node: (0, $da7b34fe5d676606$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableHeaderWithNestedTableWithLocalId) : (0, $63Ztt.tableHeaderWithNestedTable)
                },
                {
                    name: 'tableRow',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableRowWithNestedTableWithLocalId) : (0, $63Ztt.tableRowWithNestedTable)
                },
                {
                    name: 'tableCell',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableCellWithNestedTableWithLocalId) : (0, $63Ztt.tableCellWithNestedTable)
                }
            ] : [
                {
                    name: 'table',
                    node: (0, $da7b34fe5d676606$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableHeaderWithLocalId) : (0, $63Ztt.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableRowWithLocalId) : (0, $63Ztt.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableCellWithLocalId) : (0, $63Ztt.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = options || {};
                        return (0, $acc346d62149cd5a$export$ae829ec7b2625219)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $b21157aa04a7535c$var$defaultGetEditorFeatureFlags, getIntl, fullWidthEnabled, wasFullWidthEnabled, dragAndDropEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, options?.allowFixedColumnWidthOption);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(tableOptions);
                        return allowColumnResizing ? (0, $b3a746dda27eb371$export$ae829ec7b2625219)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $b21157aa04a7535c$var$defaultGetEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled || false, !!options?.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $de8398c45f744acc$export$ae829ec7b2625219)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { dragAndDropEnabled: dragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableOptions: tableOptions } = options || {};
                        return (0, $7b84646b01762248$export$e832373cff8dec22)(defaultGetEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, dragAndDropEnabled, isTableScalingEnabled, tableOptions?.allowTableAlignment, fullWidthEnabled, api, getIntl, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableOptions?.allowTableResizing);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $493109f8baa484ba$export$21439b5bf6b9c77f)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        const { dragAndDropEnabled: dragAndDropEnabled } = options || {};
                        return (0, $4bda0cf32d3d9590$export$e382fe3f780a6548)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $3824I.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                                })(tr);
                            },
                            dragAndDropEnabled: dragAndDropEnabled
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch })=>options && options.tableOptions.stickyHeaders ? (0, $def0041f08b1347a$export$ae829ec7b2625219)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return options?.dragAndDropEnabled ? (0, $58c44b411bfbf733$export$ae829ec7b2625219)(dispatch, editorAnalyticsAPI, options?.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor, api) : undefined;
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return api?.editorViewMode ? (0, $236c7224c8ab51a2$export$ae829ec7b2625219)(api, nodeViewPortalProviderAPI) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>!(0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $d5b05171647091ac$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options?.tableOptions.allowTableResizing ? (0, $e9b9e23609860f66$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options.fullWidthEnabled ?? false, options.maxWidthEnabled ?? false, options.isTableScalingEnabled ?? false, options.tableOptions.allowTableResizing ?? false, options.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options?.tableOptions.allowTableResizing && options?.isCommentEditor ? (0, $0a5bcf7050b8ed19$export$ae829ec7b2625219)(dispatch, options.tableOptions.allowTableAlignment ?? false) : undefined
                },
                // TODO: ED-26961 - should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $92e1eed7d2f10a77$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options?.tableOptions.allowTableResizing ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5ee9558e2724a8ab$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                let setTimeoutID;
                                let rafID;
                                let ricID;
                                if ((0, $1oCLl.expValEquals)('platform_editor_editor_width_analytics', 'isEnabled', true)) // send statistics about the widths of the tables on the page for alerting
                                // only send this event once, after the editorView is first initialised
                                setTimeoutID = setTimeout(()=>{
                                    const requestIdleCallbackFn = ()=>{
                                        const editorWidth = api?.width.sharedState.currentState()?.width;
                                        if (editorViewRef.current) {
                                            if (editorWidth) {
                                                const payload = (0, $d406f1b0c5d56902$export$208d2421b73f3f86)(editorViewRef.current, editorWidth);
                                                if (payload) dispatchAnalyticsEvent(payload);
                                            }
                                            if ((0, $dh538.fg)('platform_editor_table_height_analytics_event')) {
                                                const payloadHeight = (0, $d406f1b0c5d56902$export$34e5b28c67455a81)(editorViewRef.current);
                                                if (payloadHeight) dispatchAnalyticsEvent(payloadHeight);
                                            }
                                        }
                                    };
                                    if (window && typeof window.requestIdleCallback === 'function') ricID = window.requestIdleCallback(requestIdleCallbackFn);
                                    else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                                    rafID = window.requestAnimationFrame(requestIdleCallbackFn);
                                }, $b21157aa04a7535c$var$TABLE_WIDTH_INFO_TIMEOUT);
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                        if (setTimeoutID) clearTimeout(setTimeoutID);
                                        if (rafID) window.cancelAnimationFrame(rafID);
                                        if (ricID) window.cancelIdleCallback(ricID);
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'tableSizeSelectorPlugin',
                    plugin: ({ dispatch: dispatch })=>isTableSelectorEnabled ? (0, $030f86662bf3c0ad$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'editorContentAreaHeightPlugin',
                    plugin: ()=>(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? (0, $c80e8922e1b59353$export$ae829ec7b2625219)() : undefined
                }
            ];
            if (!(0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_2')) plugins.push({
                name: 'tableAnchorNames',
                plugin: ()=>(0, $8a4fbf3fe4f0ae86$export$ae829ec7b2625219)()
            });
            const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if (browser.safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $d6be50079e9249c7$export$ae829ec7b2625219)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a7d1b7fff538a30$export$2dda1e4a1d1f6a81), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: $b21157aa04a7535c$var$defaultGetEditorFeatureFlags,
                isTableSelectorEnabled: isTableSelectorEnabled
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'table',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).table),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).tableDescription),
                        keywords: [
                            'cell',
                            'table'
                        ],
                        priority: 600,
                        keyshortcut: (0, $hgeg8.tooltip)((0, $hgeg8.toggleTable)),
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cQMhV.IconTable), {}),
                        action (insert, state) {
                            if (isTableSelectorEnabled) {
                                const tr = insert('');
                                tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                                    isSelectorOpen: true
                                });
                                return tr;
                            }
                            // see comment on tablesPlugin.getSharedState on usage
                            const tableState = api?.table?.sharedState.currentState();
                            const tableNodeProps = {
                                isTableScalingEnabled: options?.isTableScalingEnabled,
                                isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                                isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
                                isMaxWidthModeEnabled: tableState?.isMaxWidthModeEnabled,
                                isCommentEditor: options?.isCommentEditor,
                                isChromelessEditor: options?.isChromelessEditor,
                                isTableResizingEnabled: options?.tableOptions.allowTableResizing
                            };
                            let tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)(tableNodeProps)(state.schema);
                            let { tr: tr } = state;
                            // If the cursor is inside a table
                            if ((0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options?.tableOptions?.allowNestedTables) {
                                // If the experiment is disabled, or we're trying to nest deeper than one level, we insert the table after the top table
                                if ((0, $iu6m9.editorExperiment)('nested-tables-in-tables', false, {
                                    exposure: true
                                }) || (0, $sxTNo.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
                                    // Nesting is too deep insert table after the top parent table
                                    const positionAfterTopTable = (0, $sxTNo.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
                                    tr = (0, $8m4tT.safeInsert)(tableNode, positionAfterTopTable)(tr);
                                    tr.scrollIntoView();
                                } else {
                                    // Table can be nested in parent table
                                    tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                                        ...tableNodeProps,
                                        isNestedTable: true
                                    })(state.schema);
                                    tr = insert(tableNode);
                                }
                            } else tr = insert(tableNode);
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                                    localId: tableNode.attrs.localId
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $b9cb78eca8ad2cf1$export$86ce8f8241c20a3)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(options?.tableOptions))
        },
        usePluginHook ({ editorView: editorView }) {
            const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'editorViewMode'
            ], (states)=>({
                    mode: states.editorViewModeState?.mode
                }));
            (0, $42omo.useEffect)(()=>{
                const { state: state, dispatch: dispatch } = editorView;
                const tr = state.tr;
                tr.setMeta('viewModeState', mode);
                if (dispatch) dispatch(tr);
            }, [
                editorView,
                mode
            ]);
        }
    };
};
var $b21157aa04a7535c$export$2e2bcd8739ae039 = $b21157aa04a7535c$var$tablePlugin;
module.exports["default"] = $b21157aa04a7535c$export$2e2bcd8739ae039;

});

parcelRegister("kEbNW", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");


var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $8usfh = parcelRequire("8usfh");


var $id9O1 = parcelRequire("id9O1");

const $4f55633bb70b189e$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $LmqWp.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $id9O1.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $4f55633bb70b189e$export$c2e8772deb1607ea = $4f55633bb70b189e$var$select('column');
const $4f55633bb70b189e$export$e247ed8cec4832f4 = $4f55633bb70b189e$var$select('row');
const $4f55633bb70b189e$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        };
const $4f55633bb70b189e$export$b5ba3b60192c7a8d = $4f55633bb70b189e$var$selectRowsOrColumns('rows');
const $4f55633bb70b189e$export$41a42e79fbe56d35 = $4f55633bb70b189e$var$selectRowsOrColumns('columns');
const $4f55633bb70b189e$export$625c5b9bf13f01a8 = (tr)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
const $4f55633bb70b189e$export$cec96519863940d = ($pos)=>{
    const table = (0, $id9O1.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = $pos.doc.resolve(head);
            const $anchor = $pos.doc.resolve(anchor);
            return new (0, $7XFGZ.CellSelection)($anchor, $head);
        }
    }
};
const $4f55633bb70b189e$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
        const tableSelection = $4f55633bb70b189e$export$cec96519863940d($pos);
        if (tableSelection) return (0, $8usfh.cloneTr)(tr.setSelection(tableSelection));
        return tr;
    }
    const table = (0, $id9O1.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
module.exports["selectColumn"] = $4f55633bb70b189e$export$c2e8772deb1607ea;
module.exports["selectRow"] = $4f55633bb70b189e$export$e247ed8cec4832f4;
module.exports["selectRows"] = $4f55633bb70b189e$export$b5ba3b60192c7a8d;
module.exports["selectColumns"] = $4f55633bb70b189e$export$41a42e79fbe56d35;
module.exports["selectTable"] = $4f55633bb70b189e$export$625c5b9bf13f01a8;
module.exports["getTableSelectionClosesToPos"] = $4f55633bb70b189e$export$cec96519863940d;
module.exports["selectTableClosestToPos"] = $4f55633bb70b189e$export$3e7c4d16b1cc1be3;

});

parcelRegister("1rJN9", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");


var $jl382 = parcelRequire("jl382");

const $d82c222672448203$var$EmptyCellNodeSize = 4;
function $d82c222672448203$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $d82c222672448203$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $jl382.removeColSpan)(cellNode.attrs, columns) : (0, $jl382.addColSpan)(cellNode.attrs, columns);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $d82c222672448203$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $d82c222672448203$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $d82c222672448203$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $d82c222672448203$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $d82c222672448203$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $d82c222672448203$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $d82c222672448203$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $d82c222672448203$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
	 * We need a correct map when a cell is added
	 * We need the normal map position minus the size of the cell you added it. Why?
	 * Having a table 3x3 and we add a new column at 2 creates this ranges
	 * [
	 *  10, 0, 4,
	 *  20, 0, 4,
	 *  30, 0, 4,
	 *  ]
	 *  Where:
	 *    * [10, 20, 30] are the original cell positions where we add the cells
	 *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
	 *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
	 *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
	 *  this is calculated in the given way
	 *    * Map the position using this step mapping function, this will return the cell in the next column
	 *    * Remove the diff (4 - 0 in this case) of the current position.
	 *  For a delete action this not happen, it will always return the right value
	 */ const offset = $d82c222672448203$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $d82c222672448203$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}



var $9b9Mr = parcelRequire("9b9Mr");

var $d1kIV = parcelRequire("d1kIV");

const $bbff9d1592bf1369$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $bbff9d1592bf1369$export$9854dd07bd861449(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $bbff9d1592bf1369$export$b17f150b6103459c(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $bbff9d1592bf1369$export$8575677d782d45d2(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $bbff9d1592bf1369$export$d119febc0282b034(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}


function* $195310467a879139$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $9b9Mr.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = (0, $bbff9d1592bf1369$export$858eb3bd69719bea)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $bbff9d1592bf1369$export$9854dd07bd861449)(rect.map, row, col) && (0, $bbff9d1592bf1369$export$8575677d782d45d2)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        const type = refColumn == null ? (0, $d1kIV.tableNodeTypes)(table.type.schema).cell : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        const cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}


function $3db3f34a32e2ec72$export$718b3d71c384ca05(columnInfo, rect) {
    /**
	 * Algorithm explained
	 * Given a table like this:
	 *    | 5  | 10      |
	 *    | 15      | 20 |
	 *    | 25 | 30 | 35 |
	 * Represented by a table map like this:
	 *   rect.map = [5, 10, 10,
	 *              15, 15, 20,
	 *              25, 30, 35]
	 * And a have this inputs:
	 *   columnInfo[].from = [10, 15, 30]
	 *
	 * Algorithm:
	 *    * Initial state
	 *      start = 0;
	 *      end = 2 (rect.width - 1 === 3 - 1)
	 *    * Iterate until find first cell position
	 *      start = 1
	 *      end = 2 (min(start column + colspan - 1, start column + end column))
	 *    * Iterate until find second cell position
	 *      start = 1
	 *      end = 1
	 *    * Start === end return 1
	 */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}



var $LmqWp = parcelRequire("LmqWp");

function $3dbecde1498474fb$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $LmqWp.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}



function $cc7957949c13c5ad$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $cc7957949c13c5ad$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $cc7957949c13c5ad$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $cc7957949c13c5ad$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $bbff9d1592bf1369$export$9854dd07bd861449)(rect.map, row, col);
}
function $cc7957949c13c5ad$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    const to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $cc7957949c13c5ad$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $cc7957949c13c5ad$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $cc7957949c13c5ad$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $cc7957949c13c5ad$export$6a87112aa04a9486 {
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $cc7957949c13c5ad$var$mergedRanges(ranges, rowRanges);
    }
    map(_mapping) {
        return [];
    }
    invert(_originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            const offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
    constructor(rowsSideEffect){
        this.rows = void 0;
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, _cell)=>{
                    if (!$cc7957949c13c5ad$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $cc7957949c13c5ad$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, _col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while(// Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    (nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $cc7957949c13c5ad$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, _col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    // Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    while(nextRow = this.rows[i]){
                        $cc7957949c13c5ad$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
}





class $9ba2978c7534d8fc$export$9d510b823609a5ac {
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $aXG5V.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $aXG5V.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
    constructor(tableSideEffect){
        this.table = void 0;
        if (tableSideEffect) this.table = tableSideEffect;
    }
}


class $faf5e1e5acefbc28$export$2e0f8a284a2635ac {
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $9ba2978c7534d8fc$export$9d510b823609a5ac).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $cc7957949c13c5ad$export$6a87112aa04a9486).fromJSON(schema, json.rows);
        return sideEffects;
    }
    constructor(sideEffects){
        this.table = void 0;
        this.rows = void 0;
        this.table = new (0, $9ba2978c7534d8fc$export$9d510b823609a5ac)(sideEffects && sideEffects.table);
        this.rows = new (0, $cc7957949c13c5ad$export$6a87112aa04a9486)(sideEffects && sideEffects.rows);
    }
}


const $37749854fe7ee835$var$ADD_COLUMN_STEP = 'ak-add-column';
function $37749854fe7ee835$var$printColumnInfo(columnInfo) {
    const cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $37749854fe7ee835$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $37749854fe7ee835$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $2XqLN.default)(()=>{
        const rect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, pos);
        const column = (0, $3db3f34a32e2ec72$export$718b3d71c384ca05)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $37749854fe7ee835$export$7f589f68a74fcd15 extends (0, $cO9ey.Step) {
    /**
   * Detect the column based on all the cells step in column info.
   * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
   * If isDelete
   *    Decrease colspan if one row has merged cell
   *    Remove all the cells using columnInfo.cellStep[].from
   * else
   *    Increase colspan if one row had merged cell
   *    Add all new cells at columnInfo.cellStep[].from,
   *      if there is columnInfo.cellStep[].newCell use it
   *      else create an empty cell
   *
   * @param doc Current document
   */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $aXG5V.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $aXG5V.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, tablePos);
        } catch (e) {
            return (0, $aXG5V.StepResult).fail(e.message);
        }
        const column = (0, $3db3f34a32e2ec72$export$718b3d71c384ca05)(this.columnInfo, tableRect);
        if (column === null) return (0, $aXG5V.StepResult).fail(`No column for this cells "${$37749854fe7ee835$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $aXG5V.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $aXG5V.StepResult).ok(tr.doc);
    }
    /**
   * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
   * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
   * if cellStep.length === 0 remove the step
   * Create a new step with all the position updated
   * @param mapping
   */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
   * if isDelete
   *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
   *    Create a copy of the node
   *    Create a new cellStep with the same positions but with the clone node as a content
   *    return new step inverted
   * else
   *    Remove the content from each columnInfo.cellStep[].content
   *    return new step inverted
   * @param originalDoc
   */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $37749854fe7ee835$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $d82c222672448203$export$1238fc51d97634a)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
   * StepMap is created based on columnInfo.
   * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
   * if isDelete
   *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
   * else
   *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
   *
   * Ranges in ProseMirror are represented by each 3 elements in an array.
   * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
   * pos: Position in the document
   * currentSize: Represent the affected range, this will be pos + currentSize
   * newSize: Represent the new values, pos + newSize
   */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $d82c222672448203$export$13a5db78deedf2bc)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $aXG5V.StepMap)(ranges);
    }
    /**
   * Try to merge this step with another one, to be applied directly
   * after it. Returns the merged step when possible, null if the
   * steps can't be merged.
   */ merge(_other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
   * Create a JSON-serializeable representation of this step. When
   * defining this for a custom subclass, make sure the result object
   * includes the step type's [JSON id](#transform.Step^jsonID) under
   * the `stepType` property.
   */ toJSON() {
        const addColumnStepJson = {
            stepType: $37749854fe7ee835$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
   * Deserialize a step from its JSON representation. Will call
   * through to the step class' own implementation of this method.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJSON(schema, json) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $faf5e1e5acefbc28$export$2e0f8a284a2635ac).fromJSON(schema, json.sideEffects);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $195310467a879139$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $d82c222672448203$export$e2625d4b6ce2d04b)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $37749854fe7ee835$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $195310467a879139$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $d82c222672448203$export$e2625d4b6ce2d04b)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $d82c222672448203$export$1e67a55385d21834)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = void 0;
        this.isDelete = void 0;
        this.columnInfo = void 0;
        this.sideEffectsHandler = void 0;
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $faf5e1e5acefbc28$export$2e0f8a284a2635ac)(addColumnStepInfo.sideEffects);
        this.columnInfo = $37749854fe7ee835$var$createColumnInfo(addColumnStepInfo.cells);
    }
}
(0, $cO9ey.Step).jsonID($37749854fe7ee835$var$ADD_COLUMN_STEP, $37749854fe7ee835$export$7f589f68a74fcd15);
module.exports["AddColumnStep"] = $37749854fe7ee835$export$7f589f68a74fcd15;

});

parcelRegister("9MzzS", function(module, exports) {

var $d1kIV = parcelRequire("d1kIV");

function $04a932cfc33b57bb$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $d1kIV.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $04a932cfc33b57bb$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($04a932cfc33b57bb$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $d1kIV.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background) attrs = {
                background: cell.attrs.background
            };
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $d1kIV.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}
module.exports["addRow"] = $04a932cfc33b57bb$export$40ed00dbc18f8b2f;

});

parcelRegister("5rHEx", function(module, exports) {
var $f46f6146aadd3e55$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});
module.exports["SortOrder"] = $f46f6146aadd3e55$export$7ae723045d45777a;

});

parcelRegister("9AGwg", function(module, exports) {

var $6SJAP = parcelRequire("6SJAP");

const $c384132222c1e261$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $6SJAP.pluginKey), action);
};
const $c384132222c1e261$export$2b7045d36e3e01d4 = (url)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $c384132222c1e261$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $c384132222c1e261$export$af5afab36c1f83f6 = (info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $c384132222c1e261$export$3301f76e6efaf85e = (info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $c384132222c1e261$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $c384132222c1e261$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $c384132222c1e261$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $c384132222c1e261$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $c384132222c1e261$export$c9a25858ed46807c = (layout)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $c384132222c1e261$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $c384132222c1e261$export$83c364d103479f90 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $c384132222c1e261$export$bd1cd60a9b31da5e = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $c384132222c1e261$export$2c79f54b873d04be = (modalType)=>(tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $c384132222c1e261$export$e545bc176b552938 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $c384132222c1e261$export$a2922c2e95ff48f7 = (tr)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $c384132222c1e261$export$53e36aa41bbce673 = (tr, datasourceStash)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $c384132222c1e261$export$4b1fde77584594b5 = (tr, url)=>$c384132222c1e261$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });
module.exports["resolveCard"] = $c384132222c1e261$export$2b7045d36e3e01d4;
module.exports["queueCards"] = $c384132222c1e261$export$5312e3a17c3f6d3;
module.exports["registerCard"] = $c384132222c1e261$export$af5afab36c1f83f6;
module.exports["removeCard"] = $c384132222c1e261$export$3301f76e6efaf85e;
module.exports["registerRemoveOverlay"] = $c384132222c1e261$export$a3d5a5cb818ce9d9;
module.exports["registerSmartCardEvents"] = $c384132222c1e261$export$55288255874724a1;
module.exports["setProvider"] = $c384132222c1e261$export$1572b3eade6662f9;
module.exports["setDatasourceTableRef"] = $c384132222c1e261$export$f9c5be16586d220a;
module.exports["setCardLayout"] = $c384132222c1e261$export$c9a25858ed46807c;
module.exports["setCardLayoutAndDatasourceTableRef"] = $c384132222c1e261$export$dd3435a1df9b2a3f;
module.exports["showLinkToolbar"] = $c384132222c1e261$export$83c364d103479f90;
module.exports["hideLinkToolbar"] = $c384132222c1e261$export$bd1cd60a9b31da5e;
module.exports["showDatasourceModal"] = $c384132222c1e261$export$2c79f54b873d04be;
module.exports["hideDatasourceModal"] = $c384132222c1e261$export$e545bc176b552938;
module.exports["clearOverlayCandidate"] = $c384132222c1e261$export$a2922c2e95ff48f7;
module.exports["setDatasourceStash"] = $c384132222c1e261$export$53e36aa41bbce673;
module.exports["removeDatasourceStash"] = $c384132222c1e261$export$4b1fde77584594b5;

});

parcelRegister("hrFA1", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $1xKpK = parcelRequire("1xKpK");


var $bEi27 = parcelRequire("bEi27");

var $jPEjP = parcelRequire("jPEjP");

var $iB8ko = parcelRequire("iB8ko");


var $6SJAP = parcelRequire("6SJAP");

const $4c917f5b4041cdb8$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $4c917f5b4041cdb8$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $ks2lK.NodeSelection)) return $4c917f5b4041cdb8$export$71376de76fa352d1(state.selection.node.type);
};
const $4c917f5b4041cdb8$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $4c917f5b4041cdb8$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $4c917f5b4041cdb8$export$a6fcef6250c64f76 = (node, info)=>$4c917f5b4041cdb8$export$fe497395c317d106($4c917f5b4041cdb8$export$15bc29504ff06986(node), info);
const $4c917f5b4041cdb8$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $6SJAP.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $4c917f5b4041cdb8$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $4c917f5b4041cdb8$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$4c917f5b4041cdb8$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $4c917f5b4041cdb8$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$4c917f5b4041cdb8$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $4c917f5b4041cdb8$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $1xKpK.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $4c917f5b4041cdb8$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $iB8ko.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $bEi27.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $jPEjP.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $4c917f5b4041cdb8$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $4c917f5b4041cdb8$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $4c917f5b4041cdb8$export$48ba7bd006cffb5e(node.attrs);
};
const $4c917f5b4041cdb8$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $4c917f5b4041cdb8$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $4c917f5b4041cdb8$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $4c917f5b4041cdb8$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $ks2lK.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};
module.exports["appearanceForNodeType"] = $4c917f5b4041cdb8$export$71376de76fa352d1;
module.exports["selectedCardAppearance"] = $4c917f5b4041cdb8$export$a5ff7aecd33e6813;
module.exports["titleUrlPairFromNode"] = $4c917f5b4041cdb8$export$15bc29504ff06986;
module.exports["displayInfoForCard"] = $4c917f5b4041cdb8$export$a6fcef6250c64f76;
module.exports["findCardInfo"] = $4c917f5b4041cdb8$export$f3f2332ef0853029;
module.exports["isEmbedSupportedAtPosition"] = $4c917f5b4041cdb8$export$b31d21baab1bb9f;
module.exports["isBlockSupportedAtPosition"] = $4c917f5b4041cdb8$export$290208dc31723a19;
module.exports["getResolvedAttributesFromStore"] = $4c917f5b4041cdb8$export$a0e5429851d8d8a9;
module.exports["isDatasourceConfigEditable"] = $4c917f5b4041cdb8$export$c677d64dd26b7aa2;
module.exports["isDatasourceNode"] = $4c917f5b4041cdb8$export$962cfe99b8da8614;
module.exports["focusEditorView"] = $4c917f5b4041cdb8$export$bab6ff782a349bd3;
module.exports["getAwarenessProps"] = $4c917f5b4041cdb8$export$ea8b03e32bcc0b2d;

});

parcelRegister("9Rg2N", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");

var $iGbqR = parcelRequire("iGbqR");


var $6xEOh = parcelRequire("6xEOh");

var $doRn8 = parcelRequire("doRn8");


var $i9vfM = parcelRequire("i9vfM");


var $ahUGI = parcelRequire("ahUGI");

var $3RxtY = parcelRequire("3RxtY");

var $61p3e = parcelRequire("61p3e");

var $fpEzC = parcelRequire("fpEzC");

var $ckqYV = parcelRequire("ckqYV");


var $0vvte = parcelRequire("0vvte");

var $gnMzP = parcelRequire("gnMzP");


var $iHzeA = parcelRequire("iHzeA");


var $16GCc = parcelRequire("16GCc");


var $91bcx = parcelRequire("91bcx");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $1yB28 = parcelRequire("1yB28");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $1Zr9M = parcelRequire("1Zr9M");


var $dZMVn = parcelRequire("dZMVn");


var $8tdj3 = parcelRequire("8tdj3");


var $fIcbd = parcelRequire("fIcbd");


var $iu6m9 = parcelRequire("iu6m9");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $hrFA1 = parcelRequire("hrFA1");


var $kXd3n = parcelRequire("kXd3n");


var $8eb8d = parcelRequire("8eb8d");


var $fezbA = parcelRequire("fezbA");


var $iDVNw = parcelRequire("iDVNw");


var $iVRHt = parcelRequire("iVRHt");


var $dzW6s = parcelRequire("dzW6s");


var $lB6pw = parcelRequire("lB6pw");


var $l1M3D = parcelRequire("l1M3D");


var $hh4Zj = parcelRequire("hh4Zj");

const $98c7df126d8bab2d$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $doRn8.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $d925B.ACTION).DELETED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $8m4tT.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $d925B.ACTION).DELETED
    });
const $98c7df126d8bab2d$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $98c7df126d8bab2d$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $98c7df126d8bab2d$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $6SJAP.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $ks2lK.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $hrFA1.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $0vvte.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $3RxtY.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $gnMzP.richMediaClassName)}`);
                    if (!(0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $98c7df126d8bab2d$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $8eb8d.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
        };
    };
};
const $98c7df126d8bab2d$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $d925B.ACTION).UNLINK
    });
    return ()=>false;
};
const $98c7df126d8bab2d$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $6xEOh.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $6xEOh.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $98c7df126d8bab2d$var$withToolbarMetadata = (command)=>(0, $doRn8.commandWithMetadata)(command, {
        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
    });
const $98c7df126d8bab2d$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $98c7df126d8bab2d$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $81OAa.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
        const currentAppearance = (0, $hrFA1.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $hrFA1.isDatasourceNode)(node);
        const pluginState = (0, $6SJAP.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $d925B.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $16GCc.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $8eb8d.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $98c7df126d8bab2d$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                    title: intl.formatMessage((0, $ahUGI.annotationMessages).createComment),
                    showTitle: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
                exposure: true
            }) ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l1M3D.OpenPreviewPanelToolbarButton), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ] : [];
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
                    onClick: $98c7df126d8bab2d$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
                    href: url,
                    target: '_blank'
                },
                {
                    type: 'separator'
                },
                ...$98c7df126d8bab2d$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $61p3e.default).remove),
                    onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$98c7df126d8bab2d$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
                    onClick: $98c7df126d8bab2d$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
                    href: url,
                    target: '_blank'
                },
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $98c7df126d8bab2d$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$98c7df126d8bab2d$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        }, "link-appearance")
                } : (0, $lB6pw.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                                    pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                                    label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $aFUXX.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $61p3e.default).delete),
                                onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                                    label: intl.formatMessage((0, $61p3e.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $98c7df126d8bab2d$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))),
            onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $98c7df126d8bab2d$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))),
        title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).settingsLink),
        onClick: $98c7df126d8bab2d$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $i9vfM.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $98c7df126d8bab2d$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $lB6pw.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $8eb8d.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        toolbarItems.push({
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $fpEzC.linkMessages).openLink),
            onClick: $98c7df126d8bab2d$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
            href: node.attrs.url,
            target: '_blank'
        });
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $61p3e.default).remove),
        onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $98c7df126d8bab2d$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                            pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $aFUXX.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                            label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $61p3e.default).delete),
                        onClick: $98c7df126d8bab2d$var$withToolbarMetadata($98c7df126d8bab2d$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                            label: intl.formatMessage((0, $61p3e.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $98c7df126d8bab2d$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $98c7df126d8bab2d$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fezbA.EditToolbarButton), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink),
                showTitle: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            const hyperlinkAppearance = [
                (0, $iVRHt.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $98c7df126d8bab2d$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hh4Zj.ToolbarViewedEvent), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iDVNw.HyperlinkToolbarAppearance), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $98c7df126d8bab2d$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) return [
            {
                type: 'separator'
            },
            $98c7df126d8bab2d$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };
module.exports["visitCardLinkAnalytics"] = $98c7df126d8bab2d$export$7ee76be08aa43a42;
module.exports["floatingToolbar"] = $98c7df126d8bab2d$export$4850df084251d287;
module.exports["shouldRenderToolbarPulse"] = $98c7df126d8bab2d$export$ddeab6943680f5be;
module.exports["getStartingToolbarItems"] = $98c7df126d8bab2d$export$bb790f15a666b7f0;
module.exports["getEndingToolbarItems"] = $98c7df126d8bab2d$export$d5ca70670b9f6b9;

});

parcelRegister("btzjy", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $81OAa = parcelRequire("81OAa");


var $d925B = parcelRequire("d925B");

var $eKaDU = parcelRequire("eKaDU");

var $iGbqR = parcelRequire("iGbqR");


var $doRn8 = parcelRequire("doRn8");


var $i9vfM = parcelRequire("i9vfM");


var $bYZ53 = parcelRequire("bYZ53");

var $b0F8r = parcelRequire("b0F8r");

var $2pjJ5 = parcelRequire("2pjJ5");

var $6tl2G = parcelRequire("6tl2G");


var $ks2lK = parcelRequire("ks2lK");


var $ke2AI = parcelRequire("ke2AI");


var $iu6m9 = parcelRequire("iu6m9");


var $9AGwg = parcelRequire("9AGwg");


var $6SJAP = parcelRequire("6SJAP");


var $1yFQS = parcelRequire("1yFQS");


var $hrFA1 = parcelRequire("hrFA1");

/**
 * Attempt to replace the link into the respective card.
 */ function $09c77129dcdfe9d0$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $81OAa.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $1yFQS.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $bYZ53.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $09c77129dcdfe9d0$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent)=>(editorState, dispatch)=>{
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        const cardAdf = (0, $6tl2G.processRawValue)(schema, cardData);
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$09c77129dcdfe9d0$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $b0F8r.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $doRn8.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $9AGwg.resolveCard)(url)((0, $ke2AI.closeHistory)(tr)));
        return true;
    };
const $09c77129dcdfe9d0$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $6SJAP.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $d925B.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $b0F8r.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $doRn8.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $9AGwg.resolveCard)(request.url)(tr));
        return true;
    };
const $09c77129dcdfe9d0$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $2pjJ5.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1yFQS.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    if (analyticsAction) (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $9AGwg.queueCards)(requests)(tr);
};
const $09c77129dcdfe9d0$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $2pjJ5.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1yFQS.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $9AGwg.queueCards)(requests)(tr);
};
const $09c77129dcdfe9d0$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $d925B.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $i9vfM.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $doRn8.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $d925B.ACTION).CHANGED_TYPE
    });
    return (0, $9AGwg.queueCards)(requests)(state.tr);
};
const $09c77129dcdfe9d0$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos) tr = $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href);
        $09c77129dcdfe9d0$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_TYPE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $eKaDU.SMART_LINK_TYPE).URL,
                    previousType: (0, $hrFA1.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $09c77129dcdfe9d0$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos) tr = $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $09c77129dcdfe9d0$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $hrFA1.selectedCardAppearance)(state);
        const tr = $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, href, href);
        $09c77129dcdfe9d0$export$717aabd99c4fc685(state, tr, (0, $d925B.INPUT_METHOD).MANUAL, (0, $d925B.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $09c77129dcdfe9d0$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $09c77129dcdfe9d0$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $09c77129dcdfe9d0$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $doRn8.addLinkMetadata)(state.selection, tr, {
                action: (0, $d925B.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.unlinkPayload)((0, $d925B.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $09c77129dcdfe9d0$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $ks2lK.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $09c77129dcdfe9d0$export$c8301558911030d4(state, (0, $d925B.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $doRn8.addLinkMetadata)(state.selection, tr, {
                    action: (0, $d925B.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $hrFA1.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? $09c77129dcdfe9d0$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock') : $09c77129dcdfe9d0$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $09c77129dcdfe9d0$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        $09c77129dcdfe9d0$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).CHANGED_TYPE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $hrFA1.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $doRn8.addLinkMetadata)(state.selection, tr, {
            action: (0, $d925B.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $09c77129dcdfe9d0$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $09c77129dcdfe9d0$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: (0, $d925B.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $9AGwg.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $9AGwg.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $09c77129dcdfe9d0$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $9AGwg.hideDatasourceModal)(tr);
    (0, $doRn8.addLinkMetadata)(state.selection, tr, {
        action: (0, $d925B.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $09c77129dcdfe9d0$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $hrFA1.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $09c77129dcdfe9d0$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $hrFA1.isDatasourceNode)(selectedNode) && !(0, $hrFA1.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $9AGwg.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};
module.exports["replaceQueuedUrlWithCard"] = $09c77129dcdfe9d0$export$78f5a0da64579d3e;
module.exports["handleFallbackWithAnalytics"] = $09c77129dcdfe9d0$export$2bb01cc4a12e0b44;
module.exports["queueCardsFromChangedTr"] = $09c77129dcdfe9d0$export$f17c48478174211e;
module.exports["changeSelectedCardToLink"] = $09c77129dcdfe9d0$export$3f14f692ecc2a0d9;
module.exports["changeSelectedCardToLinkFallback"] = $09c77129dcdfe9d0$export$56a04318a610dc7c;
module.exports["updateCard"] = $09c77129dcdfe9d0$export$884fcee347ca969b;
module.exports["changeSelectedCardToText"] = $09c77129dcdfe9d0$export$23c9e012c8c1ce24;
module.exports["setSelectedCardAppearance"] = $09c77129dcdfe9d0$export$a188ef61ddbb94f;
module.exports["updateCardViaDatasource"] = $09c77129dcdfe9d0$export$113cdaf1b279f308;
module.exports["insertDatasource"] = $09c77129dcdfe9d0$export$7f7b236478a618df;

});

parcelRegister("22wcR", function(module, exports) {

var $6SJAP = parcelRequire("6SJAP");

const $58f6534fac2913cc$export$f05434c51e3762e = (editorState)=>(0, $6SJAP.pluginKey).getState(editorState);
const $58f6534fac2913cc$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $58f6534fac2913cc$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$58f6534fac2913cc$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $58f6534fac2913cc$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;
module.exports["getPluginState"] = $58f6534fac2913cc$export$f05434c51e3762e;
module.exports["getPluginStateWithUpdatedPos"] = $58f6534fac2913cc$export$be237c815d2927d4;
module.exports["getNewRequests"] = $58f6534fac2913cc$export$cd9326e2f6dc42c0;

});

parcelRegister("aLPDZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $d27fb1bdf94e43d0$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $eIleF.useSmartCardContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children(cardContext)
    });
};
module.exports["WithCardContext"] = $d27fb1bdf94e43d0$export$722ea04dd4ef208e;

});

parcelRegister("6SJAP", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $0919fa9d22307ea8$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('cardPlugin');
module.exports["pluginKey"] = $0919fa9d22307ea8$export$18d4026d1ea86bb1;

});

parcelRegister("5v798", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");

const $76789ce241129de5$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $76789ce241129de5$export$4521957a9ae858f5 = 'discovered';
const $76789ce241129de5$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $76789ce241129de5$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $76789ce241129de5$export$2cf27d95188f1c13 = 86400000;
const $76789ce241129de5$var$storageClient = new (0, $kt8c2.default)($76789ce241129de5$export$c0fd7e3ed450d078);
const $76789ce241129de5$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $76789ce241129de5$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $76789ce241129de5$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $76789ce241129de5$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $76789ce241129de5$var$storageClient.setItemWithExpiry(key, $76789ce241129de5$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK"] = $76789ce241129de5$export$613f4cbb1d6327d6;
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR"] = $76789ce241129de5$export$b1ab83c904a5352e;
module.exports["ONE_DAY_IN_MILLISECONDS"] = $76789ce241129de5$export$2cf27d95188f1c13;
module.exports["isLocalStorageKeyDiscovered"] = $76789ce241129de5$export$f029a1bf9ca298da;
module.exports["markLocalStorageKeyDiscovered"] = $76789ce241129de5$export$6b9d1ae5ec92c88e;

});

parcelRegister("jqKkl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7dJ3M = parcelRequire("7dJ3M");


var $5v798 = parcelRequire("5v798");

const $e765d4b609cfc3b8$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $5v798.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $42omo.useCallback)(()=>{
        if (!discovered) (0, $5v798.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7dJ3M.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};
module.exports["DiscoveryPulse"] = $e765d4b609cfc3b8$export$1f5748a1623673d7;

});

parcelRegister("0vvte", function(module, exports) {
const $c37b3947c7842800$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $c37b3947c7842800$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
module.exports["DATASOURCE_INNER_CONTAINER_CLASSNAME"] = $c37b3947c7842800$export$32f80df830e375f6;
module.exports["FLOATING_TOOLBAR_LINKPICKER_CLASSNAME"] = $c37b3947c7842800$export$863ae87a9d233606;

});

parcelRegister("dQwlz", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $fBAKC = parcelRequire("fBAKC");


var $btzjy = parcelRequire("btzjy");

class $0f57150f8f286408$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $81OAa.isSafeUrl)(url)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fBAKC.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $btzjy.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $fBAKC.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}
module.exports["DatasourceErrorBoundary"] = $0f57150f8f286408$export$76664c71b9b1a689;

});

parcelRegister("aJdNi", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $lWghV = parcelRequire("lWghV");


var $22wcR = parcelRequire("22wcR");

const $00b58e153814f38c$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $22wcR.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $lWghV.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: analyticsData,
        children: children
    });
};
module.exports["EditorAnalyticsContext"] = $00b58e153814f38c$export$b49e513cc101a4b6;

});

parcelRegister("cOfDZ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $81OAa = parcelRequire("81OAa");


var $bYRk6 = parcelRequire("bYRk6");


var $eiA8Z = parcelRequire("eiA8Z");


var $lWghV = parcelRequire("lWghV");


var $2Nwuj = parcelRequire("2Nwuj");


var $dh538 = parcelRequire("dh538");


var $btzjy = parcelRequire("btzjy");


var $22wcR = parcelRequire("22wcR");


var $hrFA1 = parcelRequire("hrFA1");


var $aLPDZ = parcelRequire("aLPDZ");

const $c4e66116155c2679$var$fatalErrorPositionMap = new Map();
const $c4e66116155c2679$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        return {
            mode: states.editorViewModeState?.mode
        };
    });
    const onClick = (0, $42omo.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $c4e66116155c2679$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $81OAa.isSafeUrl)(url)) return /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__linking-platfo') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $l998X.jsx)("a", {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $l998X.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $22wcR.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $lWghV.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)($c4e66116155c2679$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aLPDZ.WithCardContext), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $l998X.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $hrFA1.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $c4e66116155c2679$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $btzjy.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                if (url && pos) $c4e66116155c2679$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}
module.exports["Card"] = $c4e66116155c2679$export$60332b2344f7fe41;

});

parcelRegister("9MZd8", function(module, exports) {
"use strict";
var $720813ee147e427f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $720813ee147e427f$var$__assign = module.exports && module.exports.__assign || function() {
    $720813ee147e427f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $720813ee147e427f$var$__assign.apply(this, arguments);
};
var $720813ee147e427f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $720813ee147e427f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $720813ee147e427f$var$React = $720813ee147e427f$var$__importStar((parcelRequire("42omo")));

var $9QE25 = parcelRequire("9QE25");


var $720813ee147e427f$var$fast_memoize_1 = $720813ee147e427f$var$__importDefault((parcelRequire("hdx2V")));
var $720813ee147e427f$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $720813ee147e427f$var$clamp = $720813ee147e427f$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $720813ee147e427f$var$snap = $720813ee147e427f$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $720813ee147e427f$var$hasDirection = $720813ee147e427f$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $720813ee147e427f$var$findClosestSnap = $720813ee147e427f$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $720813ee147e427f$var$endsWith = $720813ee147e427f$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $720813ee147e427f$var$getStringSize = $720813ee147e427f$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($720813ee147e427f$var$endsWith(n, 'px')) return n;
    if ($720813ee147e427f$var$endsWith(n, '%')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vh')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vw')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmax')) return n;
    if ($720813ee147e427f$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $720813ee147e427f$var$calculateNewMax = $720813ee147e427f$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $720813ee147e427f$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $720813ee147e427f$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $720813ee147e427f$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $720813ee147e427f$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $720813ee147e427f$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $720813ee147e427f$var$baseClassName = '__resizable_base__';
var $720813ee147e427f$var$Resizable = /** @class */ function(_super) {
    $720813ee147e427f$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $720813ee147e427f$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($720813ee147e427f$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $720813ee147e427f$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($720813ee147e427f$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $720813ee147e427f$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $720813ee147e427f$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($720813ee147e427f$var$baseClassName);
        else element.className += $720813ee147e427f$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($720813ee147e427f$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($720813ee147e427f$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($720813ee147e427f$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $720813ee147e427f$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $720813ee147e427f$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $720813ee147e427f$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $720813ee147e427f$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $720813ee147e427f$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $720813ee147e427f$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $720813ee147e427f$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $720813ee147e427f$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($720813ee147e427f$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($720813ee147e427f$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($720813ee147e427f$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($720813ee147e427f$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $720813ee147e427f$var$React.createElement($9QE25.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $720813ee147e427f$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($720813ee147e427f$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $720813ee147e427f$var$React.createElement("div", $720813ee147e427f$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $720813ee147e427f$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $720813ee147e427f$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($720813ee147e427f$var$React.PureComponent);
module.exports.Resizable = $720813ee147e427f$var$Resizable;

});

parcelRegister("8usfh", function(module, exports) {
const $476e04ad97820508$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());
module.exports["cloneTr"] = $476e04ad97820508$export$5add988076756575;

});

parcelRegister("9b9Mr", function(module, exports) {

var $jl382 = parcelRequire("jl382");


var $d1kIV = parcelRequire("d1kIV");

function $578be7a47ad1e1db$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $d1kIV.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $578be7a47ad1e1db$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col) {
    let refColumn = col > 0 ? -1 : 0;
    if ($578be7a47ad1e1db$export$c71ebdbebc3fa79b(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $jl382.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $jl382.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $d1kIV.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}
module.exports["columnIsHeader"] = $578be7a47ad1e1db$export$c71ebdbebc3fa79b;
module.exports["addColumn"] = $578be7a47ad1e1db$export$9e26b0bcc810b84c;

});

parcelRegister("kXd3n", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $3RxtY = parcelRequire("3RxtY");


var $3P0Cg = parcelRequire("3P0Cg");


var $16GCc = parcelRequire("16GCc");


var $ks2lK = parcelRequire("ks2lK");


var $4Z0ju = parcelRequire("4Z0ju");


var $eIleF = parcelRequire("eIleF");


var $1s5hv = parcelRequire("1s5hv");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $kAODm = parcelRequire("kAODm");


var $8dcLZ = parcelRequire("8dcLZ");

function $151e83dc333d8b97$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $151e83dc333d8b97$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $151e83dc333d8b97$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $42omo.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        const newAdf = (0, $4Z0ju.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $btzjy.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $16GCc.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
        css: $151e83dc333d8b97$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kAODm.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $151e83dc333d8b97$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)($151e83dc333d8b97$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["DatasourceAppearanceButton"] = $151e83dc333d8b97$export$76de8066d79563a4;

});

parcelRegister("8eb8d", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");

var $iGbqR = parcelRequire("iGbqR");


var $doRn8 = parcelRequire("doRn8");


var $6YpFi = parcelRequire("6YpFi");


var $ckqYV = parcelRequire("ckqYV");


var $9fPrY = parcelRequire("9fPrY");


var $ks2lK = parcelRequire("ks2lK");


var $9AGwg = parcelRequire("9AGwg");


var $btzjy = parcelRequire("btzjy");


var $hrFA1 = parcelRequire("hrFA1");

function $0f3dd242ddf2d35f$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6YpFi.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $0f3dd242ddf2d35f$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $9AGwg.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)($0f3dd242ddf2d35f$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $9AGwg.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $ckqYV.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $0f3dd242ddf2d35f$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $9AGwg.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $0f3dd242ddf2d35f$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $hrFA1.displayInfoForCard)(node, (0, $hrFA1.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, $l998X.jsx)($0f3dd242ddf2d35f$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $d925B.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $btzjy.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $0f3dd242ddf2d35f$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
    return showLinkingToolbar ? {
        height: lpLinkPicker ? (0, $9fPrY.LINKPICKER_HEIGHT_IN_PX) : (0, $9fPrY.RECENT_SEARCH_HEIGHT_IN_PX),
        width: (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX),
        forcePlacement: true
    } : {};
};
module.exports["getEditLinkCallback"] = $0f3dd242ddf2d35f$export$c389e1daeae312a9;
module.exports["buildEditLinkToolbar"] = $0f3dd242ddf2d35f$export$dec3901e38d4e7ff;
module.exports["editLinkToolbarConfig"] = $0f3dd242ddf2d35f$export$acaefd190fd8ff4d;

});

parcelRegister("fezbA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gtD4K = parcelRequire("gtD4K");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");


var $1s5hv = parcelRequire("1s5hv");


var $iu6m9 = parcelRequire("iu6m9");


var $hrFA1 = parcelRequire("hrFA1");


var $bzmKd = parcelRequire("bzmKd");


var $i88u2 = parcelRequire("i88u2");


var $8dcLZ = parcelRequire("8dcLZ");


var $ihjbA = parcelRequire("ihjbA");

const $7ef92b1c6084c116$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $7ef92b1c6084c116$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $42omo.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $42omo.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $42omo.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $bzmKd.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $ckqYV.linkToolbarMessages).editLink)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $ckqYV.linkToolbarMessages).editDatasourceStandalone)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                        css: $7ef92b1c6084c116$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: intl.formatMessage((0, $3RxtY.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownTriggerTitle)), !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $7ef92b1c6084c116$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $42omo.useMemo)(()=>{
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ihjbA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $7ef92b1c6084c116$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $42omo.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $i88u2.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $42omo.useMemo)(()=>{
        if (!datasourceId || !(0, $hrFA1.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ihjbA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $7ef92b1c6084c116$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)($7ef92b1c6084c116$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["EditToolbarButton"] = $7ef92b1c6084c116$export$4f24788e7d04736b;

});

parcelRegister("iDVNw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $iHzeA = parcelRequire("iHzeA");


var $faH35 = parcelRequire("faH35");


var $1s5hv = parcelRequire("1s5hv");


var $kXd3n = parcelRequire("kXd3n");


var $dzW6s = parcelRequire("dzW6s");

function $40a4b0a86667e298$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $42omo.useState)(new Map());
    const cardProvider = (0, $42omo.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $42omo.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dzW6s.LinkToolbarAppearance), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $l998X.jsx)((0, $kXd3n.DatasourceAppearanceButton), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        ]
    });
}
module.exports["HyperlinkToolbarAppearance"] = $40a4b0a86667e298$export$33d351e602b13f5c;

});

parcelRegister("iVRHt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cPDAt = parcelRequire("cPDAt");


var $iHzeA = parcelRequire("iHzeA");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $1s5hv = parcelRequire("1s5hv");


var $lB6pw = parcelRequire("lB6pw");

const $f704836bc583e15c$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $42omo.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const cardProvider = (0, $42omo.useRef)(undefined);
    const containerRef = (0, $42omo.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $42omo.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $cPDAt.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $l998X.jsx)((0, $3P0Cg.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: title
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                arrowKeyNavigationProviderOptions: {
                    type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lB6pw.LinkAppearanceMenu), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                })
            }),
            !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar))
            })
        ]
    });
};
const $f704836bc583e15c$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $l998X.jsx)($f704836bc583e15c$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};
module.exports["getCustomHyperlinkAppearanceDropdown"] = $f704836bc583e15c$export$5b48c4cfa5ad82e1;

});

parcelRegister("dzW6s", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $d925B = parcelRequire("d925B");


var $doRn8 = parcelRequire("doRn8");

var $cPDAt = parcelRequire("cPDAt");

var $eyrsK = parcelRequire("eyrsK");


var $3RxtY = parcelRequire("3RxtY");

var $61p3e = parcelRequire("61p3e");


var $7iE7T = parcelRequire("7iE7T");


var $5SAOw = parcelRequire("5SAOw");


var $btzjy = parcelRequire("btzjy");


var $hrFA1 = parcelRequire("hrFA1");


var $5v798 = parcelRequire("5v798");


var $jqKkl = parcelRequire("jqKkl");


var $9Rg2N = parcelRequire("9Rg2N");


var $aLPDZ = parcelRequire("aLPDZ");

class $e7d0a15e1573e816$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $aLPDZ.WithCardContext), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $3RxtY.messages).embed),
                onClick: (0, $btzjy.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $e7d0a15e1573e816$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $3RxtY.messages).block),
                onClick: (0, $btzjy.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $e7d0a15e1573e816$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $3RxtY.messages).url),
                    onClick: (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $d925B.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $3RxtY.messages).inline),
                    onClick: (0, $btzjy.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyrsK.LinkToolbarButtonGroup), {
                options: options.map((option)=>(0, $cPDAt.getButtonGroupOption)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $doRn8.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $9Rg2N.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $hrFA1.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jqKkl.DiscoveryPulse), {
                        localStorageKey: (0, $5v798.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                });
            }
            return LinkToolbarButtons;
        };
    }
}
const $e7d0a15e1573e816$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $61p3e.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $3RxtY.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        return intl.formatMessage((0, $3RxtY.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $61p3e.default).defaultBlockNode)
        });
    }
};
module.exports["LinkToolbarAppearance"] = $e7d0a15e1573e816$export$2a8c6fb42753b13e;
module.exports["getUnavailableMessage"] = $e7d0a15e1573e816$export$74e77d31eb18de27;

});

parcelRegister("lB6pw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $cPDAt = parcelRequire("cPDAt");

var $doRn8 = parcelRequire("doRn8");

var $72Ahd = parcelRequire("72Ahd");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $7iE7T = parcelRequire("7iE7T");


var $5SAOw = parcelRequire("5SAOw");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");

var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $iu6m9 = parcelRequire("iu6m9");


var $btzjy = parcelRequire("btzjy");


var $h8aIC = parcelRequire("h8aIC");


var $dzW6s = parcelRequire("dzW6s");

const $e531789fa6ee47a1$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $eIleF.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $7iE7T.isSupportedInParent)(editorState, (0, $5SAOw.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $3RxtY.messages).embed),
        onClick: (0, $btzjy.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $dzW6s.getUnavailableMessage)(editorState, intl),
        description: (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $3RxtY.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $3RxtY.messages).block),
        onClick: (0, $btzjy.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $dzW6s.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $3RxtY.messages).url),
            onClick: (0, $doRn8.commandWithMetadata)((0, $btzjy.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $d925B.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $3RxtY.messages).inline),
            onClick: (0, $btzjy.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $72Ahd.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $doRn8.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                            iconBefore: option.icon,
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            description: option.description,
                            shouldDescriptionWrap: true,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $h8aIC.DatasourceDropdownOption), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: 'href' in settingsConfig ? settingsConfig.href : undefined,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $ckqYV.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $e531789fa6ee47a1$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($e531789fa6ee47a1$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $h8aIC.datasourceDisplayInformation) : (0, $cPDAt.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};
module.exports["LinkAppearanceMenu"] = $e531789fa6ee47a1$export$6ce0ca681c51cdfb;
module.exports["getLinkAppearanceDropdown"] = $e531789fa6ee47a1$export$1faf5b64d0bbe935;

});

parcelRegister("l1M3D", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $fpEzC = parcelRequire("fpEzC");


var $3P0Cg = parcelRequire("3P0Cg");


var $jypE9 = parcelRequire("jypE9");


var $79vw2 = parcelRequire("79vw2");


var $eIleF = parcelRequire("eIleF");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");


var $226XV = parcelRequire("226XV");


var $1oCLl = parcelRequire("1oCLl");


var $hrFA1 = parcelRequire("hrFA1");


var $5YZhQ = parcelRequire("5YZhQ");

const $54948e9cec84ca0f$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $5YZhQ.appearanceForLink)(node);
    const cardState = store?.getState()[url];
    if (cardState) {
        const ari = (0, $226XV.getObjectAri)(cardState.details);
        const name = (0, $226XV.getObjectName)(cardState.details);
        const iconUrl = (0, $226XV.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && isPreviewPanelAvailable?.({
            ari: ari
        });
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) openPreviewPanel({
                url: url,
                ari: ari,
                name: name || '',
                iconUrl: iconUrl,
                panelData: {
                    embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $79vw2.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                }
            });
            editorAnalyticsApi?.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $hrFA1.getResolvedAttributesFromStore)(url, display, store)
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $fpEzC.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            as: "span",
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jypE9))), {
                    label: "",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                })
            ]
        });
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            gap: "space.050",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3P0Cg.default), {
                testId: "open-preview-panel-floating-toolbar-button",
                onClick: handleOpenGlancePanelClick,
                icon: icon,
                title: title,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        });
    }
    return null;
};
module.exports["OpenPreviewPanelToolbarButton"] = $54948e9cec84ca0f$export$9ed3225219cdbbe9;

});

parcelRegister("hh4Zj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $eIleF = parcelRequire("eIleF");


var $hrFA1 = parcelRequire("hrFA1");


var $aJdNi = parcelRequire("aJdNi");

/**
 * Handles firing the toolbar viewed event
 */ const $846dee625ed88da2$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...(0, $hrFA1.getResolvedAttributesFromStore)(url, display, store),
                display: display
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        display,
        url,
        store
    ]);
    return null;
};
const $846dee625ed88da2$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aJdNi.EditorAnalyticsContext), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $l998X.jsx)($846dee625ed88da2$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext
        }) : null
    });
};
module.exports["ToolbarViewedEvent"] = $846dee625ed88da2$export$998ac2a59a1547dd;

});

parcelRegister("1yFQS", function(module, exports) {

var $81OAa = parcelRequire("81OAa");


var $jvA0K = parcelRequire("jvA0K");

function $f05144695fcb9350$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $81OAa.normalizeUrl)((0, $jvA0K.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}
module.exports["shouldReplaceLink"] = $f05144695fcb9350$export$f85e921f66e987fa;

});

parcelRegister("7dJ3M", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $20b7533ed055ad0f$var$pulseKeyframes = null;
const $20b7533ed055ad0f$var$pulseStyles = null;
const $20b7533ed055ad0f$var$commonStyles = null;
const $20b7533ed055ad0f$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $42omo.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $gMc0m.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rkofajl _16qs1l47 _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
};
var $20b7533ed055ad0f$export$2e2bcd8739ae039 = $20b7533ed055ad0f$export$927d63e2511364c0;
module.exports["Pulse"] = $20b7533ed055ad0f$export$927d63e2511364c0;

});

parcelRegister("9QE25", function(module, exports) {
"use strict";
var $72b8060db0128555$var$__assign = module.exports && module.exports.__assign || function() {
    $72b8060db0128555$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72b8060db0128555$var$__assign.apply(this, arguments);
};
var $72b8060db0128555$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $72b8060db0128555$var$React = $72b8060db0128555$var$__importStar((parcelRequire("42omo")));
var $72b8060db0128555$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $72b8060db0128555$var$Resizer(props) {
    return $72b8060db0128555$var$React.createElement("div", {
        className: props.className || '',
        style: $72b8060db0128555$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $72b8060db0128555$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $72b8060db0128555$var$Resizer;

});

parcelRegister("kAODm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2g1PW = parcelRequire("2g1PW");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");

const $494cc9c19b2fcab3$var$wrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $494cc9c19b2fcab3$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
        xcss: $494cc9c19b2fcab3$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))), {
            label: props?.label
        })
    });
};
module.exports["DatasourceIcon"] = $494cc9c19b2fcab3$export$8819453811a57211;

});

parcelRegister("8dcLZ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");

const $8cceaee26ea01a76$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $42omo.useState)(undefined);
    const [parameters, setParameters] = (0, $42omo.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $42omo.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceInfo"] = $8cceaee26ea01a76$export$d01c44dffc996c80;

});

parcelRegister("bzmKd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $16GCc = parcelRequire("16GCc");


var $9AGwg = parcelRequire("9AGwg");

const $6c6198ca60f9b061$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $16GCc.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $9AGwg.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };
module.exports["editDatasource"] = $6c6198ca60f9b061$export$687401cc190b9ec3;

});

parcelRegister("i88u2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $655oj = parcelRequire("655oj");

const $3889f3bf0db7cc75$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $42omo.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $655oj.useDatasourceClientExtension)();
    (0, $42omo.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $655oj.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceDataInfo"] = $3889f3bf0db7cc75$export$25222ec28f4cbba5;

});

parcelRegister("ihjbA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gtD4K = parcelRequire("gtD4K");


var $3RxtY = parcelRequire("3RxtY");

var $ckqYV = parcelRequire("ckqYV");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");


var $1Zr9M = parcelRequire("1Zr9M");


var $56M4r = parcelRequire("56M4r");


var $1s5hv = parcelRequire("1s5hv");


var $hrFA1 = parcelRequire("hrFA1");


var $bzmKd = parcelRequire("bzmKd");

const $46168b6b87dd0065$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $46168b6b87dd0065$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $42omo.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $42omo.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $bzmKd.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $hrFA1.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $ckqYV.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $ckqYV.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ckqYV.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $ckqYV.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                        css: $46168b6b87dd0065$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: intl.formatMessage((0, $3RxtY.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2dkHo.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gtD4K.default), (0, $3RxtY.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $46168b6b87dd0065$export$2e2bcd8739ae039 = $46168b6b87dd0065$var$EditToolbarButtonPresentation;
module.exports["default"] = $46168b6b87dd0065$export$2e2bcd8739ae039;

});

parcelRegister("cPDAt", function(module, exports) {

var $5Yp2m = parcelRequire("5Yp2m");


var $65WMN = parcelRequire("65WMN");


var $99wB5 = parcelRequire("99wB5");


var $erzkB = parcelRequire("erzkB");


var $3RxtY = parcelRequire("3RxtY");

const $6055067c9b32987f$export$b5524c7a5a82630a = {
    url: {
        title: (0, $3RxtY.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Yp2m)))
    },
    inline: {
        title: (0, $3RxtY.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($erzkB)))
    },
    block: {
        title: (0, $3RxtY.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($65WMN)))
    },
    embed: {
        title: (0, $3RxtY.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($99wB5)))
    }
};
const $6055067c9b32987f$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = $6055067c9b32987f$export$b5524c7a5a82630a[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};
module.exports["appearancePropsMap"] = $6055067c9b32987f$export$b5524c7a5a82630a;
module.exports["getButtonGroupOption"] = $6055067c9b32987f$export$9de0d67eaa25f178;

});

parcelRegister("eyrsK", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $hArLp = parcelRequire("hArLp");


var $3P0Cg = parcelRequire("3P0Cg");

function $ae8d85fab1bee39d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $ae8d85fab1bee39d$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $ae8d85fab1bee39d$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $ae8d85fab1bee39d$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: disabled ? $ae8d85fab1bee39d$var$disallowedWrapperStyle : $ae8d85fab1bee39d$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $ae8d85fab1bee39d$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $ae8d85fab1bee39d$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $ae8d85fab1bee39d$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($ae8d85fab1bee39d$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            css: disabled ? $ae8d85fab1bee39d$var$buttonStyleNoneEvent : $ae8d85fab1bee39d$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};
module.exports["LinkToolbarButtonGroup"] = $ae8d85fab1bee39d$export$41ba5f90e13b0c51;

});

parcelRegister("72Ahd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cPDAt = parcelRequire("cPDAt");

const $b76944e9413775bf$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $cPDAt.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};
module.exports["getDropdownOption"] = $b76944e9413775bf$export$1405b80fcb4301ca;

});

parcelRegister("h8aIC", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3RxtY = parcelRequire("3RxtY");


var $ks2lK = parcelRequire("ks2lK");


var $2g1PW = parcelRequire("2g1PW");


var $4Z0ju = parcelRequire("4Z0ju");


var $eIleF = parcelRequire("eIleF");


var $56M4r = parcelRequire("56M4r");


var $btzjy = parcelRequire("btzjy");


var $6SJAP = parcelRequire("6SJAP");


var $8dcLZ = parcelRequire("8dcLZ");

const $f18919f30179225a$export$12f82ee4a2a1a1c9 = {
    title: (0, $3RxtY.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW)))
};
const $f18919f30179225a$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $eIleF.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $8dcLZ.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $6SJAP.pluginKey).getState(editorState);
        const newAdf = (0, $4Z0ju.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $ks2lK.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $btzjy.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW)))({
            label: intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle)
        }),
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $3RxtY.messages).datasourceAppearanceTitle));
};
module.exports["datasourceDisplayInformation"] = $f18919f30179225a$export$12f82ee4a2a1a1c9;
module.exports["DatasourceDropdownOption"] = $f18919f30179225a$export$b08a863b9d82986d;

});

parcelRegister("5YZhQ", function(module, exports) {

var $hrFA1 = parcelRequire("hrFA1");


var $h92Fd = parcelRequire("h92Fd");

function $71bdcf3b71e7ffc8$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $71bdcf3b71e7ffc8$export$26ada819291bd8df = (node)=>{
    if ($71bdcf3b71e7ffc8$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $hrFA1.appearanceForNodeType)(node.type)) return true;
    return $71bdcf3b71e7ffc8$var$hasLinkMark(node);
};
function $71bdcf3b71e7ffc8$export$d3d4c2526aede29a(node) {
    if ($71bdcf3b71e7ffc8$export$962cfe99b8da8614(node)) return (0, $h92Fd.EVENT_SUBJECT).DATASOURCE;
    if ($71bdcf3b71e7ffc8$export$26ada819291bd8df(node)) return (0, $h92Fd.EVENT_SUBJECT).LINK;
    return null;
}
function $71bdcf3b71e7ffc8$export$599e1b655555ab1d(node) {
    const appearance = (0, $hrFA1.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $71bdcf3b71e7ffc8$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $71bdcf3b71e7ffc8$var$hasLinkMark = (node)=>{
    return !!$71bdcf3b71e7ffc8$var$getLinkMark(node);
};
function $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $71bdcf3b71e7ffc8$var$getLinkMark(node)?.attrs?.href;
}
const $71bdcf3b71e7ffc8$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $71bdcf3b71e7ffc8$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $71bdcf3b71e7ffc8$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $71bdcf3b71e7ffc8$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(a.node) !== $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7(b.node) || $71bdcf3b71e7ffc8$export$599e1b655555ab1d(a.node) !== $71bdcf3b71e7ffc8$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};
module.exports["getNodeSubject"] = $71bdcf3b71e7ffc8$export$d3d4c2526aede29a;
module.exports["appearanceForLink"] = $71bdcf3b71e7ffc8$export$599e1b655555ab1d;
module.exports["getUrl"] = $71bdcf3b71e7ffc8$export$94df0e59ebebf4a7;
module.exports["getNodeContext"] = $71bdcf3b71e7ffc8$export$c63a892fcfc539bc;
module.exports["findAtPositions"] = $71bdcf3b71e7ffc8$export$7ea2145b3909e5c6;
module.exports["findInNodeRange"] = $71bdcf3b71e7ffc8$export$dbc52ec0d340ce50;
module.exports["areSameNodes"] = $71bdcf3b71e7ffc8$export$1f3592a520a7960d;

});

parcelRegister("h92Fd", function(module, exports) {
var $296e6e32869f313c$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $296e6e32869f313c$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});
module.exports["EVENT"] = $296e6e32869f313c$export$e39a34cfd532e15;
module.exports["EVENT_SUBJECT"] = $296e6e32869f313c$export$97c6cb64ce06a88a;

});


$parcel$global.rlb("dsd0q")
//# sourceMappingURL=FullPageEditorComponent.b911976f.js.map
